// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.8
//   protoc               unknown
// source: billing/v1/billing.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Empty } from "../../google/protobuf/empty";
import { Struct } from "../../google/protobuf/struct";
import { Timestamp } from "../../google/protobuf/timestamp";

export const protobufPackage = "elaccounts.billing.v1";

export enum PartyType {
  PARTY_TYPE_UNSPECIFIED = 0,
  PARTY_TYPE_CUSTOMER = 1,
  PARTY_TYPE_VENDOR = 2,
  PARTY_TYPE_BOTH = 3,
  UNRECOGNIZED = -1,
}

export function partyTypeFromJSON(object: any): PartyType {
  switch (object) {
    case 0:
    case "PARTY_TYPE_UNSPECIFIED":
      return PartyType.PARTY_TYPE_UNSPECIFIED;
    case 1:
    case "PARTY_TYPE_CUSTOMER":
      return PartyType.PARTY_TYPE_CUSTOMER;
    case 2:
    case "PARTY_TYPE_VENDOR":
      return PartyType.PARTY_TYPE_VENDOR;
    case 3:
    case "PARTY_TYPE_BOTH":
      return PartyType.PARTY_TYPE_BOTH;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PartyType.UNRECOGNIZED;
  }
}

export function partyTypeToJSON(object: PartyType): string {
  switch (object) {
    case PartyType.PARTY_TYPE_UNSPECIFIED:
      return "PARTY_TYPE_UNSPECIFIED";
    case PartyType.PARTY_TYPE_CUSTOMER:
      return "PARTY_TYPE_CUSTOMER";
    case PartyType.PARTY_TYPE_VENDOR:
      return "PARTY_TYPE_VENDOR";
    case PartyType.PARTY_TYPE_BOTH:
      return "PARTY_TYPE_BOTH";
    case PartyType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum GSTRegistrationType {
  GST_REGISTRATION_TYPE_UNSPECIFIED = 0,
  GST_REGISTRATION_TYPE_REGULAR = 1,
  GST_REGISTRATION_TYPE_COMPOSITION = 2,
  GST_REGISTRATION_TYPE_UNREGISTERED = 3,
  GST_REGISTRATION_TYPE_CONSUMER = 4,
  GST_REGISTRATION_TYPE_OVERSEAS = 5,
  GST_REGISTRATION_TYPE_SEZ = 6,
  UNRECOGNIZED = -1,
}

export function gSTRegistrationTypeFromJSON(object: any): GSTRegistrationType {
  switch (object) {
    case 0:
    case "GST_REGISTRATION_TYPE_UNSPECIFIED":
      return GSTRegistrationType.GST_REGISTRATION_TYPE_UNSPECIFIED;
    case 1:
    case "GST_REGISTRATION_TYPE_REGULAR":
      return GSTRegistrationType.GST_REGISTRATION_TYPE_REGULAR;
    case 2:
    case "GST_REGISTRATION_TYPE_COMPOSITION":
      return GSTRegistrationType.GST_REGISTRATION_TYPE_COMPOSITION;
    case 3:
    case "GST_REGISTRATION_TYPE_UNREGISTERED":
      return GSTRegistrationType.GST_REGISTRATION_TYPE_UNREGISTERED;
    case 4:
    case "GST_REGISTRATION_TYPE_CONSUMER":
      return GSTRegistrationType.GST_REGISTRATION_TYPE_CONSUMER;
    case 5:
    case "GST_REGISTRATION_TYPE_OVERSEAS":
      return GSTRegistrationType.GST_REGISTRATION_TYPE_OVERSEAS;
    case 6:
    case "GST_REGISTRATION_TYPE_SEZ":
      return GSTRegistrationType.GST_REGISTRATION_TYPE_SEZ;
    case -1:
    case "UNRECOGNIZED":
    default:
      return GSTRegistrationType.UNRECOGNIZED;
  }
}

export function gSTRegistrationTypeToJSON(object: GSTRegistrationType): string {
  switch (object) {
    case GSTRegistrationType.GST_REGISTRATION_TYPE_UNSPECIFIED:
      return "GST_REGISTRATION_TYPE_UNSPECIFIED";
    case GSTRegistrationType.GST_REGISTRATION_TYPE_REGULAR:
      return "GST_REGISTRATION_TYPE_REGULAR";
    case GSTRegistrationType.GST_REGISTRATION_TYPE_COMPOSITION:
      return "GST_REGISTRATION_TYPE_COMPOSITION";
    case GSTRegistrationType.GST_REGISTRATION_TYPE_UNREGISTERED:
      return "GST_REGISTRATION_TYPE_UNREGISTERED";
    case GSTRegistrationType.GST_REGISTRATION_TYPE_CONSUMER:
      return "GST_REGISTRATION_TYPE_CONSUMER";
    case GSTRegistrationType.GST_REGISTRATION_TYPE_OVERSEAS:
      return "GST_REGISTRATION_TYPE_OVERSEAS";
    case GSTRegistrationType.GST_REGISTRATION_TYPE_SEZ:
      return "GST_REGISTRATION_TYPE_SEZ";
    case GSTRegistrationType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum InvoiceType {
  INVOICE_TYPE_UNSPECIFIED = 0,
  INVOICE_TYPE_B2B = 1,
  INVOICE_TYPE_EXPORT = 2,
  INVOICE_TYPE_B2C = 3,
  INVOICE_TYPE_CREDIT_NOTE = 4,
  INVOICE_TYPE_DEBIT_NOTE = 5,
  INVOICE_TYPE_VENDOR_BILL = 6,
  INVOICE_TYPE_VENDOR_CREDIT_NOTE = 7,
  UNRECOGNIZED = -1,
}

export function invoiceTypeFromJSON(object: any): InvoiceType {
  switch (object) {
    case 0:
    case "INVOICE_TYPE_UNSPECIFIED":
      return InvoiceType.INVOICE_TYPE_UNSPECIFIED;
    case 1:
    case "INVOICE_TYPE_B2B":
      return InvoiceType.INVOICE_TYPE_B2B;
    case 2:
    case "INVOICE_TYPE_EXPORT":
      return InvoiceType.INVOICE_TYPE_EXPORT;
    case 3:
    case "INVOICE_TYPE_B2C":
      return InvoiceType.INVOICE_TYPE_B2C;
    case 4:
    case "INVOICE_TYPE_CREDIT_NOTE":
      return InvoiceType.INVOICE_TYPE_CREDIT_NOTE;
    case 5:
    case "INVOICE_TYPE_DEBIT_NOTE":
      return InvoiceType.INVOICE_TYPE_DEBIT_NOTE;
    case 6:
    case "INVOICE_TYPE_VENDOR_BILL":
      return InvoiceType.INVOICE_TYPE_VENDOR_BILL;
    case 7:
    case "INVOICE_TYPE_VENDOR_CREDIT_NOTE":
      return InvoiceType.INVOICE_TYPE_VENDOR_CREDIT_NOTE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return InvoiceType.UNRECOGNIZED;
  }
}

export function invoiceTypeToJSON(object: InvoiceType): string {
  switch (object) {
    case InvoiceType.INVOICE_TYPE_UNSPECIFIED:
      return "INVOICE_TYPE_UNSPECIFIED";
    case InvoiceType.INVOICE_TYPE_B2B:
      return "INVOICE_TYPE_B2B";
    case InvoiceType.INVOICE_TYPE_EXPORT:
      return "INVOICE_TYPE_EXPORT";
    case InvoiceType.INVOICE_TYPE_B2C:
      return "INVOICE_TYPE_B2C";
    case InvoiceType.INVOICE_TYPE_CREDIT_NOTE:
      return "INVOICE_TYPE_CREDIT_NOTE";
    case InvoiceType.INVOICE_TYPE_DEBIT_NOTE:
      return "INVOICE_TYPE_DEBIT_NOTE";
    case InvoiceType.INVOICE_TYPE_VENDOR_BILL:
      return "INVOICE_TYPE_VENDOR_BILL";
    case InvoiceType.INVOICE_TYPE_VENDOR_CREDIT_NOTE:
      return "INVOICE_TYPE_VENDOR_CREDIT_NOTE";
    case InvoiceType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum DocumentType {
  DOCUMENT_TYPE_UNSPECIFIED = 0,
  DOCUMENT_TYPE_TAX_INVOICE = 1,
  DOCUMENT_TYPE_BILL_OF_SUPPLY = 2,
  DOCUMENT_TYPE_EXPORT_INVOICE = 3,
  DOCUMENT_TYPE_CREDIT_NOTE = 4,
  DOCUMENT_TYPE_DEBIT_NOTE = 5,
  DOCUMENT_TYPE_PROFORMA = 6,
  UNRECOGNIZED = -1,
}

export function documentTypeFromJSON(object: any): DocumentType {
  switch (object) {
    case 0:
    case "DOCUMENT_TYPE_UNSPECIFIED":
      return DocumentType.DOCUMENT_TYPE_UNSPECIFIED;
    case 1:
    case "DOCUMENT_TYPE_TAX_INVOICE":
      return DocumentType.DOCUMENT_TYPE_TAX_INVOICE;
    case 2:
    case "DOCUMENT_TYPE_BILL_OF_SUPPLY":
      return DocumentType.DOCUMENT_TYPE_BILL_OF_SUPPLY;
    case 3:
    case "DOCUMENT_TYPE_EXPORT_INVOICE":
      return DocumentType.DOCUMENT_TYPE_EXPORT_INVOICE;
    case 4:
    case "DOCUMENT_TYPE_CREDIT_NOTE":
      return DocumentType.DOCUMENT_TYPE_CREDIT_NOTE;
    case 5:
    case "DOCUMENT_TYPE_DEBIT_NOTE":
      return DocumentType.DOCUMENT_TYPE_DEBIT_NOTE;
    case 6:
    case "DOCUMENT_TYPE_PROFORMA":
      return DocumentType.DOCUMENT_TYPE_PROFORMA;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DocumentType.UNRECOGNIZED;
  }
}

export function documentTypeToJSON(object: DocumentType): string {
  switch (object) {
    case DocumentType.DOCUMENT_TYPE_UNSPECIFIED:
      return "DOCUMENT_TYPE_UNSPECIFIED";
    case DocumentType.DOCUMENT_TYPE_TAX_INVOICE:
      return "DOCUMENT_TYPE_TAX_INVOICE";
    case DocumentType.DOCUMENT_TYPE_BILL_OF_SUPPLY:
      return "DOCUMENT_TYPE_BILL_OF_SUPPLY";
    case DocumentType.DOCUMENT_TYPE_EXPORT_INVOICE:
      return "DOCUMENT_TYPE_EXPORT_INVOICE";
    case DocumentType.DOCUMENT_TYPE_CREDIT_NOTE:
      return "DOCUMENT_TYPE_CREDIT_NOTE";
    case DocumentType.DOCUMENT_TYPE_DEBIT_NOTE:
      return "DOCUMENT_TYPE_DEBIT_NOTE";
    case DocumentType.DOCUMENT_TYPE_PROFORMA:
      return "DOCUMENT_TYPE_PROFORMA";
    case DocumentType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum SupplyType {
  SUPPLY_TYPE_UNSPECIFIED = 0,
  SUPPLY_TYPE_INTRASTATE = 1,
  SUPPLY_TYPE_INTERSTATE = 2,
  SUPPLY_TYPE_EXPORT = 3,
  SUPPLY_TYPE_SEZ = 4,
  UNRECOGNIZED = -1,
}

export function supplyTypeFromJSON(object: any): SupplyType {
  switch (object) {
    case 0:
    case "SUPPLY_TYPE_UNSPECIFIED":
      return SupplyType.SUPPLY_TYPE_UNSPECIFIED;
    case 1:
    case "SUPPLY_TYPE_INTRASTATE":
      return SupplyType.SUPPLY_TYPE_INTRASTATE;
    case 2:
    case "SUPPLY_TYPE_INTERSTATE":
      return SupplyType.SUPPLY_TYPE_INTERSTATE;
    case 3:
    case "SUPPLY_TYPE_EXPORT":
      return SupplyType.SUPPLY_TYPE_EXPORT;
    case 4:
    case "SUPPLY_TYPE_SEZ":
      return SupplyType.SUPPLY_TYPE_SEZ;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SupplyType.UNRECOGNIZED;
  }
}

export function supplyTypeToJSON(object: SupplyType): string {
  switch (object) {
    case SupplyType.SUPPLY_TYPE_UNSPECIFIED:
      return "SUPPLY_TYPE_UNSPECIFIED";
    case SupplyType.SUPPLY_TYPE_INTRASTATE:
      return "SUPPLY_TYPE_INTRASTATE";
    case SupplyType.SUPPLY_TYPE_INTERSTATE:
      return "SUPPLY_TYPE_INTERSTATE";
    case SupplyType.SUPPLY_TYPE_EXPORT:
      return "SUPPLY_TYPE_EXPORT";
    case SupplyType.SUPPLY_TYPE_SEZ:
      return "SUPPLY_TYPE_SEZ";
    case SupplyType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum InvoiceStatus {
  INVOICE_STATUS_UNSPECIFIED = 0,
  INVOICE_STATUS_DRAFT = 1,
  INVOICE_STATUS_POSTED = 2,
  INVOICE_STATUS_VOIDED = 3,
  INVOICE_STATUS_CANCELLED = 4,
  UNRECOGNIZED = -1,
}

export function invoiceStatusFromJSON(object: any): InvoiceStatus {
  switch (object) {
    case 0:
    case "INVOICE_STATUS_UNSPECIFIED":
      return InvoiceStatus.INVOICE_STATUS_UNSPECIFIED;
    case 1:
    case "INVOICE_STATUS_DRAFT":
      return InvoiceStatus.INVOICE_STATUS_DRAFT;
    case 2:
    case "INVOICE_STATUS_POSTED":
      return InvoiceStatus.INVOICE_STATUS_POSTED;
    case 3:
    case "INVOICE_STATUS_VOIDED":
      return InvoiceStatus.INVOICE_STATUS_VOIDED;
    case 4:
    case "INVOICE_STATUS_CANCELLED":
      return InvoiceStatus.INVOICE_STATUS_CANCELLED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return InvoiceStatus.UNRECOGNIZED;
  }
}

export function invoiceStatusToJSON(object: InvoiceStatus): string {
  switch (object) {
    case InvoiceStatus.INVOICE_STATUS_UNSPECIFIED:
      return "INVOICE_STATUS_UNSPECIFIED";
    case InvoiceStatus.INVOICE_STATUS_DRAFT:
      return "INVOICE_STATUS_DRAFT";
    case InvoiceStatus.INVOICE_STATUS_POSTED:
      return "INVOICE_STATUS_POSTED";
    case InvoiceStatus.INVOICE_STATUS_VOIDED:
      return "INVOICE_STATUS_VOIDED";
    case InvoiceStatus.INVOICE_STATUS_CANCELLED:
      return "INVOICE_STATUS_CANCELLED";
    case InvoiceStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum PaymentStatus {
  PAYMENT_STATUS_UNSPECIFIED = 0,
  PAYMENT_STATUS_UNPAID = 1,
  PAYMENT_STATUS_PARTIAL = 2,
  PAYMENT_STATUS_PAID = 3,
  PAYMENT_STATUS_OVERPAID = 4,
  PAYMENT_STATUS_WRITTEN_OFF = 5,
  UNRECOGNIZED = -1,
}

export function paymentStatusFromJSON(object: any): PaymentStatus {
  switch (object) {
    case 0:
    case "PAYMENT_STATUS_UNSPECIFIED":
      return PaymentStatus.PAYMENT_STATUS_UNSPECIFIED;
    case 1:
    case "PAYMENT_STATUS_UNPAID":
      return PaymentStatus.PAYMENT_STATUS_UNPAID;
    case 2:
    case "PAYMENT_STATUS_PARTIAL":
      return PaymentStatus.PAYMENT_STATUS_PARTIAL;
    case 3:
    case "PAYMENT_STATUS_PAID":
      return PaymentStatus.PAYMENT_STATUS_PAID;
    case 4:
    case "PAYMENT_STATUS_OVERPAID":
      return PaymentStatus.PAYMENT_STATUS_OVERPAID;
    case 5:
    case "PAYMENT_STATUS_WRITTEN_OFF":
      return PaymentStatus.PAYMENT_STATUS_WRITTEN_OFF;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PaymentStatus.UNRECOGNIZED;
  }
}

export function paymentStatusToJSON(object: PaymentStatus): string {
  switch (object) {
    case PaymentStatus.PAYMENT_STATUS_UNSPECIFIED:
      return "PAYMENT_STATUS_UNSPECIFIED";
    case PaymentStatus.PAYMENT_STATUS_UNPAID:
      return "PAYMENT_STATUS_UNPAID";
    case PaymentStatus.PAYMENT_STATUS_PARTIAL:
      return "PAYMENT_STATUS_PARTIAL";
    case PaymentStatus.PAYMENT_STATUS_PAID:
      return "PAYMENT_STATUS_PAID";
    case PaymentStatus.PAYMENT_STATUS_OVERPAID:
      return "PAYMENT_STATUS_OVERPAID";
    case PaymentStatus.PAYMENT_STATUS_WRITTEN_OFF:
      return "PAYMENT_STATUS_WRITTEN_OFF";
    case PaymentStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum DueStatus {
  DUE_STATUS_UNSPECIFIED = 0,
  DUE_STATUS_PENDING = 1,
  DUE_STATUS_DUE = 2,
  DUE_STATUS_OVERDUE = 3,
  UNRECOGNIZED = -1,
}

export function dueStatusFromJSON(object: any): DueStatus {
  switch (object) {
    case 0:
    case "DUE_STATUS_UNSPECIFIED":
      return DueStatus.DUE_STATUS_UNSPECIFIED;
    case 1:
    case "DUE_STATUS_PENDING":
      return DueStatus.DUE_STATUS_PENDING;
    case 2:
    case "DUE_STATUS_DUE":
      return DueStatus.DUE_STATUS_DUE;
    case 3:
    case "DUE_STATUS_OVERDUE":
      return DueStatus.DUE_STATUS_OVERDUE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DueStatus.UNRECOGNIZED;
  }
}

export function dueStatusToJSON(object: DueStatus): string {
  switch (object) {
    case DueStatus.DUE_STATUS_UNSPECIFIED:
      return "DUE_STATUS_UNSPECIFIED";
    case DueStatus.DUE_STATUS_PENDING:
      return "DUE_STATUS_PENDING";
    case DueStatus.DUE_STATUS_DUE:
      return "DUE_STATUS_DUE";
    case DueStatus.DUE_STATUS_OVERDUE:
      return "DUE_STATUS_OVERDUE";
    case DueStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum ResetFrequency {
  RESET_FREQUENCY_UNSPECIFIED = 0,
  RESET_FREQUENCY_NEVER = 1,
  RESET_FREQUENCY_MONTHLY = 2,
  RESET_FREQUENCY_QUARTERLY = 3,
  RESET_FREQUENCY_YEARLY = 4,
  UNRECOGNIZED = -1,
}

export function resetFrequencyFromJSON(object: any): ResetFrequency {
  switch (object) {
    case 0:
    case "RESET_FREQUENCY_UNSPECIFIED":
      return ResetFrequency.RESET_FREQUENCY_UNSPECIFIED;
    case 1:
    case "RESET_FREQUENCY_NEVER":
      return ResetFrequency.RESET_FREQUENCY_NEVER;
    case 2:
    case "RESET_FREQUENCY_MONTHLY":
      return ResetFrequency.RESET_FREQUENCY_MONTHLY;
    case 3:
    case "RESET_FREQUENCY_QUARTERLY":
      return ResetFrequency.RESET_FREQUENCY_QUARTERLY;
    case 4:
    case "RESET_FREQUENCY_YEARLY":
      return ResetFrequency.RESET_FREQUENCY_YEARLY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ResetFrequency.UNRECOGNIZED;
  }
}

export function resetFrequencyToJSON(object: ResetFrequency): string {
  switch (object) {
    case ResetFrequency.RESET_FREQUENCY_UNSPECIFIED:
      return "RESET_FREQUENCY_UNSPECIFIED";
    case ResetFrequency.RESET_FREQUENCY_NEVER:
      return "RESET_FREQUENCY_NEVER";
    case ResetFrequency.RESET_FREQUENCY_MONTHLY:
      return "RESET_FREQUENCY_MONTHLY";
    case ResetFrequency.RESET_FREQUENCY_QUARTERLY:
      return "RESET_FREQUENCY_QUARTERLY";
    case ResetFrequency.RESET_FREQUENCY_YEARLY:
      return "RESET_FREQUENCY_YEARLY";
    case ResetFrequency.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface Address {
  id: string;
  line1: string;
  line2: string;
  city: string;
  state: string;
  stateCode: string;
  postalCode: string;
  country: string;
  countryCode: string;
  gstin: string;
  label: string;
  type: string;
  isPrimary: boolean;
  companyCode: string;
}

export interface Contact {
  email: string;
  phone: string;
  mobile: string;
  website: string;
}

export interface BusinessIdentifier {
  type: string;
  value: string;
}

/**
 * Party stores ONLY ledger-specific data by default.
 * When enrich=true is used in requests, entity data is populated from entity service.
 */
export interface Party {
  id: string;
  orgId: string;
  ledgerId: string;
  /**
   * Entity Reference (MongoDB ObjectId from accounts-api)
   * Entity data (name, addresses, contacts, identifiers) loaded from entity service
   */
  entityId: string;
  /** Ledger-specific fields */
  code: string;
  /** Deprecated: use roles instead */
  partyType: PartyType;
  /** e.g. ["customer", "supplier"] */
  roles: string[];
  /** Payment Terms (Ledger-specific) */
  creditDays?: number | undefined;
  creditLimit: string;
  /** Linked GL Accounts (Ledger-specific) */
  receivableAccountId: string;
  payableAccountId: string;
  /** Default Settings (Ledger-specific) */
  defaultCurrency: string;
  /** Address References (Ledger-specific - references to entity service addresses) */
  billingAddressId: string;
  shippingAddressId: string;
  /** Customer-specific Fields */
  companyVendorCode: string;
  /** Status */
  isActive: boolean;
  /**
   * Entity data (populated only when enrich=true)
   * These fields are fetched from entity service and merged into response
   */
  name: string;
  tradeName: string;
  /** Contact information (grouped object) */
  contact?:
    | Contact
    | undefined;
  /** Business identifiers (country-agnostic array) */
  businessIdentifiers: BusinessIdentifier[];
  /** GST-specific fields (kept for India compatibility) */
  gstin: string;
  gstRegistrationType: GSTRegistrationType;
  billingAddress?: Address | undefined;
  shippingAddress?:
    | Address
    | undefined;
  /** Per-ledger assignments (populated when enrich=true or on detail requests) */
  ledgerAssignments: PartyLedgerAssignment[];
  /** Audit */
  createdAt?: Date | undefined;
  updatedAt?: Date | undefined;
  createdBy: string;
  updatedBy: string;
}

/**
 * PartyLedgerAssignment stores per-ledger configuration for a party.
 * The role is free-form (e.g., "customer", "vendor", "participant") —
 * the real type is determined by the ledger's control account position in the CoA.
 */
export interface PartyLedgerAssignment {
  id: string;
  partyId: string;
  ledgerId: string;
  role: string;
  creditDays?: number | undefined;
  creditLimit: string;
  receivableAccountId: string;
  payableAccountId: string;
  defaultCurrency: string;
  billingAddressId: string;
  shippingAddressId: string;
  companyVendorCode: string;
  isActive: boolean;
  createdAt?: Date | undefined;
  updatedAt?: Date | undefined;
}

/**
 * PartyWithEntity includes both ledger-specific and entity data in a single response.
 * This is the enriched response that combines data from both services for convenience.
 * Use this for frontend/API responses to avoid multiple service calls.
 */
export interface PartyWithEntity {
  /** Ledger-specific data (from Party table) */
  party?:
    | Party
    | undefined;
  /** Entity data (from entity service) - enriched fields */
  name: string;
  tradeName: string;
  email: string;
  phone: string;
  mobile: string;
  website: string;
  /** Addresses (from entity service) */
  billingAddress?: Address | undefined;
  shippingAddress?:
    | Address
    | undefined;
  /** Business identifiers (from entity service) */
  gstin: string;
  gstRegistrationType: GSTRegistrationType;
  pan: string;
}

export interface CreatePartyRequest {
  orgId: string;
  ledgerId: string;
  /** Entity Reference (MongoDB ObjectId from accounts-api) */
  entityId: string;
  code: string;
  name: string;
  tradeName: string;
  /** Deprecated: use roles instead */
  partyType: PartyType;
  /** e.g. ["customer", "supplier"] */
  roles: string[];
  gstin: string;
  gstRegistrationType: GSTRegistrationType;
  pan: string;
  /** Contact information (use Contact object for consistency with UpdatePartyRequest) */
  contact?:
    | Contact
    | undefined;
  /** Business identifiers */
  businessIdentifiers: BusinessIdentifier[];
  billingAddress?: Address | undefined;
  shippingAddress?: Address | undefined;
  creditDays?: number | undefined;
  creditLimit: string;
  receivableAccountId: string;
  payableAccountId: string;
  defaultCurrency: string;
  /** Address References (optional - if provided, links to existing addresses in entity) */
  billingAddressId: string;
  /** UUID of shipping address */
  shippingAddressId: string;
  /** Code assigned by customer to identify your organization (optional) */
  companyVendorCode: string;
}

/** Request the next available party code. Roles determine the prefix (C/V/P). */
export interface GetNextPartyCodeRequest {
  orgId: string;
  ledgerId: string;
  roles: string[];
}

export interface GetNextPartyCodeResponse {
  code: string;
}

export interface GetPartyRequest {
  orgId: string;
  partyId: string;
  /**
   * If true, enriches response with entity data (name, addresses, contacts)
   * from entity service. If false, returns only ledger-specific fields.
   */
  enrich: boolean;
}

/** GetPartyScoreRequest asks for a party's computed intelligence score. */
export interface GetPartyScoreRequest {
  orgId: string;
  partyId: string;
}

/**
 * PartyScore mirrors domain.PartyScore — the computed intelligence score for a
 * single party: overall total + tier, the weighted dimensions, and any risk
 * alerts. All numeric scores are 0-100 scale points (not percentages).
 */
export interface PartyScore {
  partyId: string;
  /** weighted sum of all dimensions, 0-100 */
  total: number;
  /** "A".."E" */
  tier: string;
  dimensions: PartyScoreDimension[];
  alerts: PartyScoreAlert[];
  computedAt?:
    | Date
    | undefined;
  /** null when unset */
  manualRating?: number | undefined;
}

/**
 * PartyScoreDimension is one scoring dimension (volume, discipline, frequency,
 * credit, growth, manual). Mirrors domain.DimensionScore.
 */
export interface PartyScoreDimension {
  key: string;
  /** raw score earned */
  score: number;
  /** maximum possible */
  max: number;
  /** null for manual dimension */
  percentile?:
    | number
    | undefined;
  /** human-readable explanation */
  detail: string;
}

/** PartyScoreAlert is a triggered risk flag. Mirrors domain.ScoreAlert. */
export interface PartyScoreAlert {
  /** "warning" | "info" */
  severity: string;
  code: string;
  message: string;
}

/**
 * UpdatePartyRequest updates both ledger-specific party fields AND entity data.
 * This is a unified API that updates both the party record and the associated entity.
 */
export interface UpdatePartyRequest {
  orgId: string;
  partyId: string;
  /** Ledger-specific fields that can be updated */
  creditDays?: number | undefined;
  creditLimit: string;
  isActive: boolean;
  /**
   * Address References (can be updated to point to different addresses)
   * NOTE: If addresses array is provided, these will be automatically populated
   * from the updated entity addresses by matching labels
   */
  billingAddressId?:
    | string
    | undefined;
  /** UUID of shipping address */
  shippingAddressId?:
    | string
    | undefined;
  /** Code assigned by customer to identify your organization (use empty to clear) */
  companyVendorCode?:
    | string
    | undefined;
  /** Entity fields (optional - if provided, entity service will be updated) */
  name: string;
  /** Trading name / DBA */
  tradeName: string;
  /** Full address data (with UUIDs for existing) */
  addresses: Address[];
  /** Contact information */
  contact?:
    | Contact
    | undefined;
  /** Business identifiers */
  businessIdentifiers: BusinessIdentifier[];
  /**
   * Default transaction currency. SET-ONCE: the server assigns this only when the
   * party currently has no currency (legacy/imported records); an established
   * currency is immutable because changing it would corrupt amounts on existing
   * transactions denominated in the old one. A blank value leaves currency untouched.
   */
  defaultCurrency: string;
}

export interface DeletePartyRequest {
  orgId: string;
  partyId: string;
}

export interface DeletePartyResponse {
  success: boolean;
  message: string;
  /** If deletion fails due to transactions, provides details */
  activeTransactionCount: number;
  voidTransactionCount: number;
}

export interface ListPartiesRequest {
  orgId: string;
  ledgerId: string;
  /** Deprecated: use role instead */
  partyType: PartyType;
  activeOnly: boolean;
  pageSize: number;
  pageToken: string;
  /**
   * If true, enriches all parties with entity data from entity service.
   * This reduces frontend requests from N+1 to 1.
   */
  enrich: boolean;
  /** Optional search query to filter parties by code */
  query: string;
  /** Filter by role (e.g. "customer", "supplier") */
  role: string;
}

export interface SearchPartiesRequest {
  orgId: string;
  query: string;
  /** Deprecated: use role instead */
  partyType: PartyType;
  pageSize: number;
  /** Filter by role */
  role: string;
}

export interface ListAllPartiesRequest {
  orgId: string;
  /** Deprecated: use role instead */
  partyType: PartyType;
  activeOnly: boolean;
  query: string;
  pageSize: number;
  pageToken: string;
  enrich: boolean;
  /** Filter by role */
  role: string;
}

export interface ListPartiesResponse {
  parties: Party[];
  nextPageToken: string;
  totalCount: number;
  /**
   * See elaccounts.common.PageInfo.remaining_count / remaining_is_exact for
   * semantics: a cheap "peek 3 pages ahead" signal computed from a single
   * widened LIMIT query, used to render "Showing x-y of z" or "of many"
   * without an unbounded COUNT(*).
   */
  remainingCount: number;
  remainingIsExact: boolean;
}

export interface Invoice {
  id: string;
  orgId: string;
  ledgerId: string;
  invoiceNumber: string;
  invoicePrefix: string;
  /** YYYY-MM-DD */
  invoiceDate: string;
  dueDate: string;
  /** Dual Numbering: Proforma (Draft) Number */
  proformaNumber: string;
  /** Prefix used for proforma number */
  proformaPrefix: string;
  invoiceType: InvoiceType;
  documentType: DocumentType;
  /** Party Details */
  partyId: string;
  partyName: string;
  partyGstin: string;
  /** Legacy full address (deprecated) */
  partyAddress: string;
  /** Party Structured Address (new standard - replaces flat fields) */
  partyBillingAddress?:
    | Address
    | undefined;
  /** Party Address Flat Fields (deprecated - kept for backward compatibility, use party_billing_address instead) */
  partyAddressLine1: string;
  partyAddressLine2: string;
  partyCity: string;
  partyState: string;
  partyStateCode: string;
  partyPostalCode: string;
  partyCountry: string;
  partyCountryCode: string;
  /**
   * Party role (e.g. "customer", "supplier", or a custom org-defined role)
   * this document's receivable/payable subledger posts under. Empty =
   * derived from the org's default sales/purchase role, falling back to the
   * built-in role implied by the document type.
   */
  partyRole?:
    | string
    | undefined;
  /** Supply */
  placeOfSupply: string;
  placeOfSupplyCode: string;
  supplyType: SupplyType;
  /** Purchase Order number */
  poNumber: string;
  /**
   * Supplier's own bill/invoice number on a vendor bill (their document number).
   * Our internal voucher number stays in invoice_number; this is recorded separately.
   */
  supplierBillNumber: string;
  /** Party vendor code (snapshot from party.company_vendor_code at invoice creation) */
  partyVendorCode: string;
  /** Seller Details */
  sellerName: string;
  sellerGstin: string;
  /** Legacy combined address field */
  sellerAddress: string;
  sellerState: string;
  sellerStateCode: string;
  /** Seller Structured Address (new standard) */
  sellerBillingAddress?:
    | Address
    | undefined;
  /** Seller Extended Details (snapshots from entity service) */
  sellerPan: string;
  sellerLogoUrl: string;
  sellerContactEmail: string;
  sellerContactPhone: string;
  sellerWebsite: string;
  /** Seller Address Flat Fields (deprecated - kept for backward compatibility, use seller_billing_address instead) */
  sellerAddressLine1: string;
  sellerAddressLine2: string;
  sellerCity: string;
  sellerPostalCode: string;
  sellerCountry: string;
  /** Currency */
  currency: string;
  exchangeRate: string;
  /** Amounts */
  subtotal: string;
  discountAmount: string;
  taxableAmount: string;
  /** Tax Amounts */
  cgstAmount: string;
  sgstAmount: string;
  igstAmount: string;
  cessAmount: string;
  totalTax: string;
  totalAmount: string;
  amountInWords: string;
  /** Base Currency */
  baseCurrency: string;
  baseSubtotal: string;
  baseTotalTax: string;
  baseTotalAmount: string;
  /** Payment */
  paymentTerms: string;
  bankDetails?:
    | BankDetails
    | undefined;
  /** Export */
  exportType: string;
  lutNumber: string;
  lutDate: string;
  countryOfDestination: string;
  countryOfDestinationCode: string;
  portOfLoading: string;
  portOfDischarge: string;
  portCode: string;
  /** 'sea', 'air', 'road', 'rail' */
  modeOfTransport: string;
  vesselFlightNumber: string;
  blAwbNumber: string;
  containerNumbers: string;
  shippingBillNumber: string;
  shippingBillDate: string;
  /** Export Address Snapshots */
  shipToAddress?: Address | undefined;
  consigneeAddress?: Address | undefined;
  notifyPartyAddress?:
    | Address
    | undefined;
  /** E-Way Bill */
  ewayBillNumber: string;
  ewayBillDate: string;
  vehicleNumber: string;
  transportMode: string;
  /** E-Invoice (IRN) */
  irn: string;
  irnDate: string;
  ackNumber: string;
  ackDate: string;
  signedQrCode: string;
  /** Notes */
  notes: string;
  termsConditions: string;
  status: InvoiceStatus;
  paymentStatus: PaymentStatus;
  dueStatus: DueStatus;
  daysOverdue: number;
  paymentsReceived: string;
  /** Rounding adjustment (smallest currency unit, e.g. paisa) */
  roundOffAmount: string;
  journalEntryId: string;
  /** Line Items */
  items: InvoiceItem[];
  /** Audit */
  createdAt?: Date | undefined;
  updatedAt?: Date | undefined;
  createdBy: string;
  updatedBy: string;
  postedAt?: Date | undefined;
  postedBy: string;
  voidedAt?: Date | undefined;
  voidedBy: string;
  voidReason: string;
  /** Walk-in / cash sale — no party account (AR/AP bypassed) */
  isWalkIn: boolean;
  cashAccountId: string;
}

export interface InvoiceItem {
  id: string;
  lineNumber: number;
  itemCode: string;
  description: string;
  hsnCode: string;
  sacCode: string;
  /** Decimal string */
  quantity: string;
  unit: string;
  unitPrice: string;
  grossAmount: string;
  discountPercent: string;
  discountAmount: string;
  taxableAmount: string;
  cgstRate: string;
  sgstRate: string;
  igstRate: string;
  cessRate: string;
  cgstAmount: string;
  sgstAmount: string;
  igstAmount: string;
  cessAmount: string;
  totalTax: string;
  totalAmount: string;
  /** Product reference (from goods-and-services app) */
  itemId?:
    | string
    | undefined;
  /**
   * Explicit GL account override for this line's journal-entry posting.
   * Takes priority over item-resolved and generic fallback accounts.
   */
  accountId?: string | undefined;
}

export interface BankDetails {
  bankName: string;
  accountName: string;
  accountNumber: string;
  ifsc: string;
  branch: string;
  swiftCode: string;
  iban: string;
  routingNumber: string;
  sortCode: string;
}

export interface CreateInvoiceRequest {
  orgId: string;
  ledgerId: string;
  invoiceType: InvoiceType;
  invoiceDate: string;
  dueDate: string;
  partyId: string;
  /**
   * Party role (e.g. "customer", "supplier", or a custom org-defined role)
   * to post the receivable/payable subledger under. Unset = derive from the
   * org's default sales/purchase role, falling back to the built-in role
   * implied by invoice_type.
   */
  partyRole?:
    | string
    | undefined;
  /** Party billing address (optional - if not provided, auto-fetched from entity service) */
  partyAddressId: string;
  /** Address snapshot */
  partyAddress?: Address | undefined;
  placeOfSupply: string;
  placeOfSupplyCode: string;
  /** Purchase Order number */
  poNumber: string;
  /** Supplier's bill number (vendor bills) */
  supplierBillNumber: string;
  /** Vendor code snapshot from party */
  partyVendorCode: string;
  currency: string;
  exchangeRate: string;
  /** Export fields */
  exportType: string;
  lutNumber: string;
  lutDate: string;
  countryOfDestination: string;
  countryOfDestinationCode: string;
  portOfLoading: string;
  portOfDischarge: string;
  portCode: string;
  /** 'sea', 'air', 'road', 'rail' */
  modeOfTransport: string;
  vesselFlightNumber: string;
  blAwbNumber: string;
  containerNumbers: string;
  shippingBillNumber: string;
  shippingBillDate: string;
  /** Export addresses (snapshot data) */
  shipToAddress?: Address | undefined;
  consigneeAddress?: Address | undefined;
  notifyPartyAddress?: Address | undefined;
  notes: string;
  termsConditions: string;
  paymentTerms: string;
  bankDetails?: BankDetails | undefined;
  items: CreateInvoiceItemRequest[];
  /** Rounding adjustment (smallest currency unit, e.g. paisa) */
  roundOffAmount: string;
  /** Optional manual invoice number override (skips auto-generation if provided, requires invoice:edit_number permission) */
  invoiceNumber?:
    | string
    | undefined;
  /** Walk-in / cash sale or cash purchase — party_id is not required when true */
  isWalkIn: boolean;
  /** Account to debit (sale) or credit (purchase) instead of AR/AP; defaults to cash_on_hand */
  cashAccountId: string;
  /**
   * Link this invoice to a sales order (customer-purchase-order in the DB).
   * When set, PostInvoice automatically updates the order's invoiced_amount
   * and the order auto-completes when its balance hits zero. Empty for
   * invoices that don't belong to a sales order.
   */
  salesOrderId: string;
}

export interface CreateInvoiceItemRequest {
  itemCode: string;
  description: string;
  hsnCode: string;
  sacCode: string;
  quantity: string;
  unit: string;
  unitPrice: string;
  discountPercent: string;
  discountAmount: string;
  cgstRate: string;
  sgstRate: string;
  igstRate: string;
  cessRate: string;
  /** Product reference (from goods-and-services app) */
  itemId?:
    | string
    | undefined;
  /**
   * Explicit GL account override for this line's journal-entry posting.
   * Takes priority over item-resolved and generic fallback accounts.
   */
  accountId?: string | undefined;
}

export interface GetInvoiceRequest {
  orgId: string;
  invoiceId: string;
}

export interface UpdateInvoiceRequest {
  orgId: string;
  invoiceId: string;
  invoiceDate: string;
  dueDate: string;
  partyId: string;
  /**
   * Party role to post the receivable/payable subledger under (draft
   * invoices only — immutable once posted). Unset = leave as-is / derive
   * per the same rule as CreateInvoiceRequest.party_role.
   */
  partyRole?:
    | string
    | undefined;
  /** Party billing address (optional - if not provided, auto-fetched from entity service) */
  partyAddressId: string;
  /** Address snapshot */
  partyAddress?: Address | undefined;
  placeOfSupply: string;
  placeOfSupplyCode: string;
  /** Purchase Order number */
  poNumber: string;
  /** Supplier's bill number (vendor bills) */
  supplierBillNumber: string;
  /** Vendor code snapshot from party */
  partyVendorCode: string;
  currency: string;
  exchangeRate: string;
  /** Export fields */
  exportType: string;
  lutNumber: string;
  lutDate: string;
  countryOfDestination: string;
  countryOfDestinationCode: string;
  portOfLoading: string;
  portOfDischarge: string;
  portCode: string;
  /** 'sea', 'air', 'road', 'rail' */
  modeOfTransport: string;
  vesselFlightNumber: string;
  blAwbNumber: string;
  containerNumbers: string;
  shippingBillNumber: string;
  shippingBillDate: string;
  /** Export addresses (snapshot data) */
  shipToAddress?: Address | undefined;
  consigneeAddress?: Address | undefined;
  notifyPartyAddress?: Address | undefined;
  notes: string;
  termsConditions: string;
  paymentTerms: string;
  bankDetails?: BankDetails | undefined;
  items: CreateInvoiceItemRequest[];
  /** Rounding adjustment (smallest currency unit, e.g. paisa) */
  roundOffAmount: string;
  /** Optional invoice number override (draft invoices only, requires invoice:edit_number permission) */
  invoiceNumber?:
    | string
    | undefined;
  /** Optional notes explaining what was changed in this edit (for version history) */
  changeNotes: string;
}

export interface PostInvoiceRequest {
  orgId: string;
  invoiceId: string;
  /** Optional final invoice number override (skips auto-generation if provided, requires invoice:edit_number permission) */
  invoiceNumber?:
    | string
    | undefined;
  /**
   * Optional invoice date override — allows setting the final invoice date at posting time
   * If not provided, the existing draft invoice date is used
   */
  invoiceDate: string;
}

export interface VoidInvoiceRequest {
  orgId: string;
  invoiceId: string;
  reason: string;
}

/**
 * EditPostedInvoiceRequest allows editing a posted invoice.
 * The old journal entry is voided and a new one is created.
 * Party details (party_id, party_address) are immutable on posted invoices.
 */
export interface EditPostedInvoiceRequest {
  orgId: string;
  invoiceId: string;
  invoiceDate: string;
  dueDate: string;
  placeOfSupply: string;
  placeOfSupplyCode: string;
  poNumber: string;
  currency: string;
  exchangeRate: string;
  /** Export fields */
  exportType: string;
  lutNumber: string;
  lutDate: string;
  countryOfDestination: string;
  countryOfDestinationCode: string;
  portOfLoading: string;
  portOfDischarge: string;
  portCode: string;
  modeOfTransport: string;
  vesselFlightNumber: string;
  blAwbNumber: string;
  containerNumbers: string;
  shippingBillNumber: string;
  shippingBillDate: string;
  /** Export addresses (snapshot data) */
  shipToAddress?: Address | undefined;
  consigneeAddress?: Address | undefined;
  notifyPartyAddress?: Address | undefined;
  notes: string;
  termsConditions: string;
  paymentTerms: string;
  bankDetails?: BankDetails | undefined;
  items: CreateInvoiceItemRequest[];
  roundOffAmount: string;
  /** Optional invoice number override (requires invoice:edit_number permission) */
  invoiceNumber?:
    | string
    | undefined;
  /** Supplier's own bill number on a vendor bill (our internal number is unchanged) */
  supplierBillNumber: string;
  /** Required: reason for editing a posted invoice (for audit trail) */
  changeNotes: string;
}

/**
 * CreateInvoiceFromSORequest creates a posted invoice that's linked back to
 * an active sales order. The caller supplies the full invoice item list
 * (with GST rates), because the sales order is a reference document only
 * and doesn't carry per-line tax information. The new invoice's
 * sales_order_id back-references the SO; on post, the SO's invoiced_amount
 * auto-updates and the SO auto-completes when balance hits zero.
 */
export interface CreateInvoiceFromSORequest {
  orgId: string;
  salesOrderId: string;
  /** Invoice date in YYYY-MM-DD. If empty, defaults to today. */
  invoiceDate: string;
  /** Due date in YYYY-MM-DD. If empty, defaults to invoice_date (immediate). */
  dueDate: string;
  /**
   * Full invoice line items with GST rates. Reuses the same shape as
   * CreateInvoice.items.
   */
  items: CreateInvoiceItemRequest[];
  /**
   * Optional supply / supply destination overrides. When empty, server
   * derives them from the customer's billing address (matches how
   * CreateInvoice behaves today).
   */
  placeOfSupply: string;
  placeOfSupplyCode: string;
  /**
   * Idempotency: re-sending the same key returns the original invoice +
   * adjustment, never duplicates either. Required for outbox-based callers.
   */
  idempotencyKey: string;
}

/**
 * CreateInvoiceFromSOResponse returns the new invoice and (when the
 * customer had a posted customer-advance balance) the adjustment journal
 * entry that moved part of that balance into AR.
 */
export interface CreateInvoiceFromSOResponse {
  invoice?:
    | Invoice
    | undefined;
  /**
   * Total advance amount applied to this invoice (smallest currency unit —
   * paisa). 0 if no advances were available. Capped at the invoice total —
   * any residual advance remains in the customer-advance account against
   * the customer's name for future invoices.
   */
  appliedAdvanceAmount: string;
  /**
   * ID of the adjustment journal entry (Dr customer advance, Cr trade
   * receivable). Empty when applied_advance_amount = 0.
   */
  adjustmentJournalEntryId: string;
}

export interface ListInvoicesRequest {
  orgId: string;
  ledgerId: string;
  invoiceType: InvoiceType;
  status: InvoiceStatus;
  partyId: string;
  startDate: string;
  endDate: string;
  pageSize: number;
  pageToken: string;
  /**
   * Offset paging: 1-based page number. When > 0 the server uses LIMIT/OFFSET
   * and ignores page_token. total_count in the response is the full match count.
   */
  page: number;
  /** Free-text search across invoice number, party name and GSTIN (case-insensitive). */
  search: string;
  /** Sort field (whitelist: invoiceDate, invoiceNumber, partyName, totalAmount) and direction (asc|desc). */
  sortField: string;
  sortDir: string;
  /** Payment status filter (unpaid|partial|paid|written_off) and currency filter. */
  paymentStatus: string;
  currency: string;
}

export interface ListInvoicesResponse {
  invoices: Invoice[];
  nextPageToken: string;
  totalCount: number;
  /** Aggregates across the full filtered set (not just the current page), in base currency. */
  sumTotalAmount: string;
  sumTaxAmount: string;
  /**
   * See elaccounts.common.PageInfo.remaining_count / remaining_is_exact for
   * semantics: a cheap "peek 3 pages ahead" signal computed from a single
   * widened LIMIT query, used to render "Showing x-y of z" or "of many"
   * without an unbounded COUNT(*).
   */
  remainingCount: number;
  remainingIsExact: boolean;
}

export interface ListInvoicesByPartyRequest {
  orgId: string;
  partyId: string;
  pageSize: number;
  pageToken: string;
}

export interface GenerateInvoicePDFRequest {
  orgId: string;
  invoiceId: string;
}

export interface GenerateInvoicePDFResponse {
  pdfContent: Uint8Array;
  filename: string;
  contentType: string;
}

export interface GetNextInvoiceNumberRequest {
  orgId: string;
  ledgerId: string;
  invoiceType: InvoiceType;
}

export interface GetNextInvoiceNumberResponse {
  invoiceNumber: string;
  prefix: string;
}

export interface CompanySettings {
  id: string;
  orgId: string;
  ledgerId: string;
  /** Company Branding */
  companyName: string;
  tradeName: string;
  logoPath: string;
  logoUrl: string;
  logoMimeType: string;
  /** Company Details */
  address: string;
  city: string;
  state: string;
  stateCode: string;
  postalCode: string;
  country: string;
  countryCode: string;
  /** Tax Details */
  gstin: string;
  pan: string;
  cin: string;
  tan: string;
  ieCode: string;
  lutNumber: string;
  lutDate: string;
  /** Contact Information */
  email: string;
  phone: string;
  website: string;
  /** Default Bank Details */
  defaultBankDetails?:
    | BankDetails
    | undefined;
  /** Invoice Settings */
  invoicePrefix: string;
  invoiceNumberFormat: string;
  invoiceFooterText: string;
  invoiceTerms: string;
  defaultPaymentTerms: string;
  defaultCreditDays: number;
  /** Currency Settings */
  baseCurrency: string;
  /** Audit */
  createdAt?: Date | undefined;
  updatedAt?: Date | undefined;
  createdBy: string;
  updatedBy: string;
}

export interface GetCompanySettingsRequest {
  orgId: string;
  ledgerId: string;
}

export interface UpdateCompanySettingsRequest {
  orgId: string;
  ledgerId: string;
  companyName: string;
  tradeName: string;
  address: string;
  city: string;
  state: string;
  stateCode: string;
  postalCode: string;
  country: string;
  countryCode: string;
  gstin: string;
  pan: string;
  cin: string;
  tan: string;
  ieCode: string;
  lutNumber: string;
  lutDate: string;
  email: string;
  phone: string;
  website: string;
  defaultBankDetails?: BankDetails | undefined;
  invoicePrefix: string;
  invoiceNumberFormat: string;
  invoiceFooterText: string;
  invoiceTerms: string;
  defaultPaymentTerms: string;
  defaultCreditDays: number;
  baseCurrency: string;
}

export interface UploadCompanyLogoRequest {
  orgId: string;
  ledgerId: string;
  logoData: Uint8Array;
  mimeType: string;
  filename: string;
}

export interface UploadCompanyLogoResponse {
  logoUrl: string;
  logoPath: string;
  message: string;
}

export interface DeleteCompanyLogoRequest {
  orgId: string;
  ledgerId: string;
}

export interface DeleteCompanyLogoResponse {
  message: string;
}

export interface NumberingSeries {
  id: string;
  orgId: string;
  ledgerId: string;
  seriesName: string;
  /** Configuration */
  documentType: InvoiceType;
  isDraft: boolean;
  /** Number Format */
  prefix: string;
  numberFormat: string;
  startingNumber: number;
  currentSequence: number;
  /** Reset Configuration */
  resetFrequency: ResetFrequency;
  /** YYYY-MM-DD (optional) */
  lastResetDate: string;
  /** Optional */
  lastResetFiscalYear: number;
  /** Optional (1-12) */
  lastResetMonth: number;
  /** Optional (1-4) */
  lastResetQuarter: number;
  /** Status */
  isActive: boolean;
  /** Audit */
  createdAt?: Date | undefined;
  updatedAt?: Date | undefined;
  createdBy: string;
  updatedBy: string;
}

export interface CreateNumberingSeriesRequest {
  orgId: string;
  ledgerId: string;
  seriesName: string;
  documentType: InvoiceType;
  isDraft: boolean;
  prefix: string;
  numberFormat: string;
  startingNumber: number;
  resetFrequency: ResetFrequency;
}

export interface GetNumberingSeriesRequest {
  orgId: string;
  seriesId: string;
}

export interface UpdateNumberingSeriesRequest {
  orgId: string;
  seriesId: string;
  seriesName: string;
  prefix: string;
  numberFormat: string;
  startingNumber: number;
  resetFrequency: ResetFrequency;
  isActive: boolean;
}

export interface SetCurrentSequenceRequest {
  orgId: string;
  seriesId: string;
  newSequence: number;
  /** Required: migration reason for audit trail */
  reason: string;
}

export interface ListNumberingSeriesRequest {
  orgId: string;
  ledgerId: string;
  /** Optional filter */
  documentType: InvoiceType;
  activeOnly: boolean;
}

export interface ListNumberingSeriesResponse {
  series: NumberingSeries[];
  totalCount: number;
}

/**
 * NumberingAssignment maps a (party_role, gst_category, doc_kind, is_draft)
 * selector to the numbering series that supplies its running number. Fields are
 * strings (not enums) so new party roles need no schema/proto change.
 *   party_role:   "customer" | "supplier" | (future)
 *   gst_category: "registered" | "unregistered" | "overseas"
 *   doc_kind:     "invoice" | "credit_note" | "debit_note"
 */
export interface NumberingAssignment {
  id: string;
  orgId: string;
  ledgerId: string;
  partyRole: string;
  gstCategory: string;
  docKind: string;
  isDraft: boolean;
  seriesId: string;
  createdAt?: Date | undefined;
  updatedAt?: Date | undefined;
  createdBy: string;
  updatedBy: string;
}

export interface ListNumberingAssignmentsRequest {
  orgId: string;
  ledgerId: string;
}

export interface ListNumberingAssignmentsResponse {
  assignments: NumberingAssignment[];
}

export interface UpsertNumberingAssignmentRequest {
  orgId: string;
  ledgerId: string;
  partyRole: string;
  gstCategory: string;
  docKind: string;
  isDraft: boolean;
  seriesId: string;
}

export interface RestoreDefaultNumberingSeriesRequest {
  orgId: string;
  ledgerId: string;
}

export interface RestoreDefaultNumberingSeriesResponse {
  /** Full list of series for the ledger after the restore. */
  series: NumberingSeries[];
  /** How many series were newly created (0 if everything already existed). */
  createdCount: number;
}

export interface QuickSetupRoleNumberingRequest {
  orgId: string;
  ledgerId: string;
  /**
   * Party role to create a full numbering set for (e.g. a custom role slug).
   * Direction (sales vs purchase) and display label are read from this
   * role's own definition, not passed by the caller.
   */
  partyRole: string;
  /**
   * Base prefix, e.g. "AB" -> series prefixes PAB/AB (invoice),
   * PABCN/ABCN (credit note), PABDN/ABDN (debit note, sales-direction only).
   */
  prefix: string;
}

export interface QuickSetupRoleNumberingResponse {
  /** The series created by this call (not the full ledger list). */
  series: NumberingSeries[];
  assignmentsCreated: number;
}

export interface PreviewNextNumberRequest {
  orgId: string;
  seriesId: string;
  /** YYYY-MM-DD (optional, defaults to today) */
  referenceDate: string;
}

export interface PreviewNextNumberResponse {
  nextNumber: string;
  nextSequence: number;
  fiscalYear: number;
  /** True if sequence will reset on next generation */
  willReset: boolean;
}

export interface DeleteNumberingSeriesRequest {
  orgId: string;
  seriesId: string;
  /**
   * When true, permanently removes the series instead of just deactivating it.
   * Only allowed when the series has never issued a number (current_sequence = 0).
   */
  hardDelete: boolean;
}

export interface DeleteNumberingSeriesResponse {
  success: boolean;
  message: string;
}

/** InvoiceVersion represents a complete snapshot of an invoice at a specific point in time */
export interface InvoiceVersion {
  id: string;
  invoiceId: string;
  versionNumber: number;
  /** Complete snapshots stored as JSONB */
  invoiceSnapshot?: { [key: string]: any } | undefined;
  itemsSnapshot: { [key: string]: any }[];
  /** Metadata */
  createdAt?: Date | undefined;
  createdBy: string;
  changeNotes: string;
}

export interface GetInvoiceVersionsRequest {
  orgId: string;
  invoiceId: string;
}

export interface GetInvoiceVersionsResponse {
  versions: InvoiceVersion[];
}

export interface GetInvoiceVersionRequest {
  orgId: string;
  invoiceId: string;
  versionNumber: number;
}

export interface GetInvoiceVersionResponse {
  version?: InvoiceVersion | undefined;
}

export interface NotifyInvoicePostRequestRequest {
  /** org_id of the elBooks organisation that owns the draft invoice. */
  orgId: string;
  /**
   * workspace_id of the elBooks workspace (accountant side) that should
   * receive the notification.
   */
  workspaceId: string;
  /** invoice_id is the elBooks draft invoice to be reviewed and posted. */
  invoiceId: string;
  /**
   * requested_by_workspace_id identifies the elPOS workspace that triggered
   * the request (stored in payload for audit).
   */
  requestedByWorkspaceId: string;
}

export interface NotifyAdvanceJEPostRequestRequest {
  /** org_id of the elBooks organisation that owns the draft JE. */
  orgId: string;
  /** je_id is the elBooks draft journal entry to be posted by the accountant. */
  jeId: string;
  /**
   * requested_by_workspace_id identifies the elPOS workspace that triggered
   * the request (stored for audit and reverse-notification on posting).
   */
  requestedByWorkspaceId: string;
}

function createBaseAddress(): Address {
  return {
    id: "",
    line1: "",
    line2: "",
    city: "",
    state: "",
    stateCode: "",
    postalCode: "",
    country: "",
    countryCode: "",
    gstin: "",
    label: "",
    type: "",
    isPrimary: false,
    companyCode: "",
  };
}

export const Address: MessageFns<Address> = {
  encode(message: Address, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.line1 !== "") {
      writer.uint32(18).string(message.line1);
    }
    if (message.line2 !== "") {
      writer.uint32(26).string(message.line2);
    }
    if (message.city !== "") {
      writer.uint32(34).string(message.city);
    }
    if (message.state !== "") {
      writer.uint32(42).string(message.state);
    }
    if (message.stateCode !== "") {
      writer.uint32(50).string(message.stateCode);
    }
    if (message.postalCode !== "") {
      writer.uint32(58).string(message.postalCode);
    }
    if (message.country !== "") {
      writer.uint32(66).string(message.country);
    }
    if (message.countryCode !== "") {
      writer.uint32(74).string(message.countryCode);
    }
    if (message.gstin !== "") {
      writer.uint32(82).string(message.gstin);
    }
    if (message.label !== "") {
      writer.uint32(90).string(message.label);
    }
    if (message.type !== "") {
      writer.uint32(98).string(message.type);
    }
    if (message.isPrimary !== false) {
      writer.uint32(104).bool(message.isPrimary);
    }
    if (message.companyCode !== "") {
      writer.uint32(114).string(message.companyCode);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Address {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddress();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.line1 = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.line2 = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.city = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.state = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.stateCode = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.postalCode = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.country = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.countryCode = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.gstin = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.label = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.type = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.isPrimary = reader.bool();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.companyCode = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Address {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      line1: isSet(object.line1) ? globalThis.String(object.line1) : "",
      line2: isSet(object.line2) ? globalThis.String(object.line2) : "",
      city: isSet(object.city) ? globalThis.String(object.city) : "",
      state: isSet(object.state) ? globalThis.String(object.state) : "",
      stateCode: isSet(object.stateCode)
        ? globalThis.String(object.stateCode)
        : isSet(object.state_code)
        ? globalThis.String(object.state_code)
        : "",
      postalCode: isSet(object.postalCode)
        ? globalThis.String(object.postalCode)
        : isSet(object.postal_code)
        ? globalThis.String(object.postal_code)
        : "",
      country: isSet(object.country) ? globalThis.String(object.country) : "",
      countryCode: isSet(object.countryCode)
        ? globalThis.String(object.countryCode)
        : isSet(object.country_code)
        ? globalThis.String(object.country_code)
        : "",
      gstin: isSet(object.gstin) ? globalThis.String(object.gstin) : "",
      label: isSet(object.label) ? globalThis.String(object.label) : "",
      type: isSet(object.type) ? globalThis.String(object.type) : "",
      isPrimary: isSet(object.isPrimary)
        ? globalThis.Boolean(object.isPrimary)
        : isSet(object.is_primary)
        ? globalThis.Boolean(object.is_primary)
        : false,
      companyCode: isSet(object.companyCode)
        ? globalThis.String(object.companyCode)
        : isSet(object.company_code)
        ? globalThis.String(object.company_code)
        : "",
    };
  },

  toJSON(message: Address): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.line1 !== "") {
      obj.line1 = message.line1;
    }
    if (message.line2 !== "") {
      obj.line2 = message.line2;
    }
    if (message.city !== "") {
      obj.city = message.city;
    }
    if (message.state !== "") {
      obj.state = message.state;
    }
    if (message.stateCode !== "") {
      obj.stateCode = message.stateCode;
    }
    if (message.postalCode !== "") {
      obj.postalCode = message.postalCode;
    }
    if (message.country !== "") {
      obj.country = message.country;
    }
    if (message.countryCode !== "") {
      obj.countryCode = message.countryCode;
    }
    if (message.gstin !== "") {
      obj.gstin = message.gstin;
    }
    if (message.label !== "") {
      obj.label = message.label;
    }
    if (message.type !== "") {
      obj.type = message.type;
    }
    if (message.isPrimary !== false) {
      obj.isPrimary = message.isPrimary;
    }
    if (message.companyCode !== "") {
      obj.companyCode = message.companyCode;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Address>, I>>(base?: I): Address {
    return Address.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Address>, I>>(object: I): Address {
    const message = createBaseAddress();
    message.id = object.id ?? "";
    message.line1 = object.line1 ?? "";
    message.line2 = object.line2 ?? "";
    message.city = object.city ?? "";
    message.state = object.state ?? "";
    message.stateCode = object.stateCode ?? "";
    message.postalCode = object.postalCode ?? "";
    message.country = object.country ?? "";
    message.countryCode = object.countryCode ?? "";
    message.gstin = object.gstin ?? "";
    message.label = object.label ?? "";
    message.type = object.type ?? "";
    message.isPrimary = object.isPrimary ?? false;
    message.companyCode = object.companyCode ?? "";
    return message;
  },
};

function createBaseContact(): Contact {
  return { email: "", phone: "", mobile: "", website: "" };
}

export const Contact: MessageFns<Contact> = {
  encode(message: Contact, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.email !== "") {
      writer.uint32(10).string(message.email);
    }
    if (message.phone !== "") {
      writer.uint32(18).string(message.phone);
    }
    if (message.mobile !== "") {
      writer.uint32(26).string(message.mobile);
    }
    if (message.website !== "") {
      writer.uint32(34).string(message.website);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Contact {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseContact();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.email = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.phone = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.mobile = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.website = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Contact {
    return {
      email: isSet(object.email) ? globalThis.String(object.email) : "",
      phone: isSet(object.phone) ? globalThis.String(object.phone) : "",
      mobile: isSet(object.mobile) ? globalThis.String(object.mobile) : "",
      website: isSet(object.website) ? globalThis.String(object.website) : "",
    };
  },

  toJSON(message: Contact): unknown {
    const obj: any = {};
    if (message.email !== "") {
      obj.email = message.email;
    }
    if (message.phone !== "") {
      obj.phone = message.phone;
    }
    if (message.mobile !== "") {
      obj.mobile = message.mobile;
    }
    if (message.website !== "") {
      obj.website = message.website;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Contact>, I>>(base?: I): Contact {
    return Contact.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Contact>, I>>(object: I): Contact {
    const message = createBaseContact();
    message.email = object.email ?? "";
    message.phone = object.phone ?? "";
    message.mobile = object.mobile ?? "";
    message.website = object.website ?? "";
    return message;
  },
};

function createBaseBusinessIdentifier(): BusinessIdentifier {
  return { type: "", value: "" };
}

export const BusinessIdentifier: MessageFns<BusinessIdentifier> = {
  encode(message: BusinessIdentifier, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== "") {
      writer.uint32(10).string(message.type);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BusinessIdentifier {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBusinessIdentifier();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.type = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BusinessIdentifier {
    return {
      type: isSet(object.type) ? globalThis.String(object.type) : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "",
    };
  },

  toJSON(message: BusinessIdentifier): unknown {
    const obj: any = {};
    if (message.type !== "") {
      obj.type = message.type;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BusinessIdentifier>, I>>(base?: I): BusinessIdentifier {
    return BusinessIdentifier.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BusinessIdentifier>, I>>(object: I): BusinessIdentifier {
    const message = createBaseBusinessIdentifier();
    message.type = object.type ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

function createBaseParty(): Party {
  return {
    id: "",
    orgId: "",
    ledgerId: "",
    entityId: "",
    code: "",
    partyType: 0,
    roles: [],
    creditDays: undefined,
    creditLimit: "0",
    receivableAccountId: "",
    payableAccountId: "",
    defaultCurrency: "",
    billingAddressId: "",
    shippingAddressId: "",
    companyVendorCode: "",
    isActive: false,
    name: "",
    tradeName: "",
    contact: undefined,
    businessIdentifiers: [],
    gstin: "",
    gstRegistrationType: 0,
    billingAddress: undefined,
    shippingAddress: undefined,
    ledgerAssignments: [],
    createdAt: undefined,
    updatedAt: undefined,
    createdBy: "",
    updatedBy: "",
  };
}

export const Party: MessageFns<Party> = {
  encode(message: Party, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.orgId !== "") {
      writer.uint32(18).string(message.orgId);
    }
    if (message.ledgerId !== "") {
      writer.uint32(26).string(message.ledgerId);
    }
    if (message.entityId !== "") {
      writer.uint32(34).string(message.entityId);
    }
    if (message.code !== "") {
      writer.uint32(42).string(message.code);
    }
    if (message.partyType !== 0) {
      writer.uint32(48).int32(message.partyType);
    }
    for (const v of message.roles) {
      writer.uint32(290).string(v!);
    }
    if (message.creditDays !== undefined) {
      writer.uint32(56).int32(message.creditDays);
    }
    if (message.creditLimit !== "0") {
      writer.uint32(64).int64(message.creditLimit);
    }
    if (message.receivableAccountId !== "") {
      writer.uint32(74).string(message.receivableAccountId);
    }
    if (message.payableAccountId !== "") {
      writer.uint32(82).string(message.payableAccountId);
    }
    if (message.defaultCurrency !== "") {
      writer.uint32(90).string(message.defaultCurrency);
    }
    if (message.billingAddressId !== "") {
      writer.uint32(234).string(message.billingAddressId);
    }
    if (message.shippingAddressId !== "") {
      writer.uint32(242).string(message.shippingAddressId);
    }
    if (message.companyVendorCode !== "") {
      writer.uint32(218).string(message.companyVendorCode);
    }
    if (message.isActive !== false) {
      writer.uint32(96).bool(message.isActive);
    }
    if (message.name !== "") {
      writer.uint32(106).string(message.name);
    }
    if (message.tradeName !== "") {
      writer.uint32(202).string(message.tradeName);
    }
    if (message.contact !== undefined) {
      Contact.encode(message.contact, writer.uint32(274).fork()).join();
    }
    for (const v of message.businessIdentifiers) {
      BusinessIdentifier.encode(v!, writer.uint32(266).fork()).join();
    }
    if (message.gstin !== "") {
      writer.uint32(138).string(message.gstin);
    }
    if (message.gstRegistrationType !== 0) {
      writer.uint32(224).int32(message.gstRegistrationType);
    }
    if (message.billingAddress !== undefined) {
      Address.encode(message.billingAddress, writer.uint32(154).fork()).join();
    }
    if (message.shippingAddress !== undefined) {
      Address.encode(message.shippingAddress, writer.uint32(194).fork()).join();
    }
    for (const v of message.ledgerAssignments) {
      PartyLedgerAssignment.encode(v!, writer.uint32(282).fork()).join();
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(162).fork()).join();
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(170).fork()).join();
    }
    if (message.createdBy !== "") {
      writer.uint32(178).string(message.createdBy);
    }
    if (message.updatedBy !== "") {
      writer.uint32(186).string(message.updatedBy);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Party {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseParty();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ledgerId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.entityId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.code = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.partyType = reader.int32() as any;
          continue;
        }
        case 36: {
          if (tag !== 290) {
            break;
          }

          message.roles.push(reader.string());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.creditDays = reader.int32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.creditLimit = reader.int64().toString();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.receivableAccountId = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.payableAccountId = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.defaultCurrency = reader.string();
          continue;
        }
        case 29: {
          if (tag !== 234) {
            break;
          }

          message.billingAddressId = reader.string();
          continue;
        }
        case 30: {
          if (tag !== 242) {
            break;
          }

          message.shippingAddressId = reader.string();
          continue;
        }
        case 27: {
          if (tag !== 218) {
            break;
          }

          message.companyVendorCode = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.isActive = reader.bool();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 25: {
          if (tag !== 202) {
            break;
          }

          message.tradeName = reader.string();
          continue;
        }
        case 34: {
          if (tag !== 274) {
            break;
          }

          message.contact = Contact.decode(reader, reader.uint32());
          continue;
        }
        case 33: {
          if (tag !== 266) {
            break;
          }

          message.businessIdentifiers.push(BusinessIdentifier.decode(reader, reader.uint32()));
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.gstin = reader.string();
          continue;
        }
        case 28: {
          if (tag !== 224) {
            break;
          }

          message.gstRegistrationType = reader.int32() as any;
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.billingAddress = Address.decode(reader, reader.uint32());
          continue;
        }
        case 24: {
          if (tag !== 194) {
            break;
          }

          message.shippingAddress = Address.decode(reader, reader.uint32());
          continue;
        }
        case 35: {
          if (tag !== 282) {
            break;
          }

          message.ledgerAssignments.push(PartyLedgerAssignment.decode(reader, reader.uint32()));
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 23: {
          if (tag !== 186) {
            break;
          }

          message.updatedBy = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Party {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      orgId: isSet(object.orgId)
        ? globalThis.String(object.orgId)
        : isSet(object.org_id)
        ? globalThis.String(object.org_id)
        : "",
      ledgerId: isSet(object.ledgerId)
        ? globalThis.String(object.ledgerId)
        : isSet(object.ledger_id)
        ? globalThis.String(object.ledger_id)
        : "",
      entityId: isSet(object.entityId)
        ? globalThis.String(object.entityId)
        : isSet(object.entity_id)
        ? globalThis.String(object.entity_id)
        : "",
      code: isSet(object.code) ? globalThis.String(object.code) : "",
      partyType: isSet(object.partyType)
        ? partyTypeFromJSON(object.partyType)
        : isSet(object.party_type)
        ? partyTypeFromJSON(object.party_type)
        : 0,
      roles: globalThis.Array.isArray(object?.roles)
        ? object.roles.map((e: any) => globalThis.String(e))
        : [],
      creditDays: isSet(object.creditDays)
        ? globalThis.Number(object.creditDays)
        : isSet(object.credit_days)
        ? globalThis.Number(object.credit_days)
        : undefined,
      creditLimit: isSet(object.creditLimit)
        ? globalThis.String(object.creditLimit)
        : isSet(object.credit_limit)
        ? globalThis.String(object.credit_limit)
        : "0",
      receivableAccountId: isSet(object.receivableAccountId)
        ? globalThis.String(object.receivableAccountId)
        : isSet(object.receivable_account_id)
        ? globalThis.String(object.receivable_account_id)
        : "",
      payableAccountId: isSet(object.payableAccountId)
        ? globalThis.String(object.payableAccountId)
        : isSet(object.payable_account_id)
        ? globalThis.String(object.payable_account_id)
        : "",
      defaultCurrency: isSet(object.defaultCurrency)
        ? globalThis.String(object.defaultCurrency)
        : isSet(object.default_currency)
        ? globalThis.String(object.default_currency)
        : "",
      billingAddressId: isSet(object.billingAddressId)
        ? globalThis.String(object.billingAddressId)
        : isSet(object.billing_address_id)
        ? globalThis.String(object.billing_address_id)
        : "",
      shippingAddressId: isSet(object.shippingAddressId)
        ? globalThis.String(object.shippingAddressId)
        : isSet(object.shipping_address_id)
        ? globalThis.String(object.shipping_address_id)
        : "",
      companyVendorCode: isSet(object.companyVendorCode)
        ? globalThis.String(object.companyVendorCode)
        : isSet(object.company_vendor_code)
        ? globalThis.String(object.company_vendor_code)
        : "",
      isActive: isSet(object.isActive)
        ? globalThis.Boolean(object.isActive)
        : isSet(object.is_active)
        ? globalThis.Boolean(object.is_active)
        : false,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      tradeName: isSet(object.tradeName)
        ? globalThis.String(object.tradeName)
        : isSet(object.trade_name)
        ? globalThis.String(object.trade_name)
        : "",
      contact: isSet(object.contact) ? Contact.fromJSON(object.contact) : undefined,
      businessIdentifiers: globalThis.Array.isArray(object?.businessIdentifiers)
        ? object.businessIdentifiers.map((e: any) => BusinessIdentifier.fromJSON(e))
        : globalThis.Array.isArray(object?.business_identifiers)
        ? object.business_identifiers.map((e: any) => BusinessIdentifier.fromJSON(e))
        : [],
      gstin: isSet(object.gstin) ? globalThis.String(object.gstin) : "",
      gstRegistrationType: isSet(object.gstRegistrationType)
        ? gSTRegistrationTypeFromJSON(object.gstRegistrationType)
        : isSet(object.gst_registration_type)
        ? gSTRegistrationTypeFromJSON(object.gst_registration_type)
        : 0,
      billingAddress: isSet(object.billingAddress)
        ? Address.fromJSON(object.billingAddress)
        : isSet(object.billing_address)
        ? Address.fromJSON(object.billing_address)
        : undefined,
      shippingAddress: isSet(object.shippingAddress)
        ? Address.fromJSON(object.shippingAddress)
        : isSet(object.shipping_address)
        ? Address.fromJSON(object.shipping_address)
        : undefined,
      ledgerAssignments: globalThis.Array.isArray(object?.ledgerAssignments)
        ? object.ledgerAssignments.map((e: any) => PartyLedgerAssignment.fromJSON(e))
        : globalThis.Array.isArray(object?.ledger_assignments)
        ? object.ledger_assignments.map((e: any) => PartyLedgerAssignment.fromJSON(e))
        : [],
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : "",
      updatedBy: isSet(object.updatedBy)
        ? globalThis.String(object.updatedBy)
        : isSet(object.updated_by)
        ? globalThis.String(object.updated_by)
        : "",
    };
  },

  toJSON(message: Party): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.ledgerId !== "") {
      obj.ledgerId = message.ledgerId;
    }
    if (message.entityId !== "") {
      obj.entityId = message.entityId;
    }
    if (message.code !== "") {
      obj.code = message.code;
    }
    if (message.partyType !== 0) {
      obj.partyType = partyTypeToJSON(message.partyType);
    }
    if (message.roles?.length) {
      obj.roles = message.roles;
    }
    if (message.creditDays !== undefined) {
      obj.creditDays = Math.round(message.creditDays);
    }
    if (message.creditLimit !== "0") {
      obj.creditLimit = message.creditLimit;
    }
    if (message.receivableAccountId !== "") {
      obj.receivableAccountId = message.receivableAccountId;
    }
    if (message.payableAccountId !== "") {
      obj.payableAccountId = message.payableAccountId;
    }
    if (message.defaultCurrency !== "") {
      obj.defaultCurrency = message.defaultCurrency;
    }
    if (message.billingAddressId !== "") {
      obj.billingAddressId = message.billingAddressId;
    }
    if (message.shippingAddressId !== "") {
      obj.shippingAddressId = message.shippingAddressId;
    }
    if (message.companyVendorCode !== "") {
      obj.companyVendorCode = message.companyVendorCode;
    }
    if (message.isActive !== false) {
      obj.isActive = message.isActive;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.tradeName !== "") {
      obj.tradeName = message.tradeName;
    }
    if (message.contact !== undefined) {
      obj.contact = Contact.toJSON(message.contact);
    }
    if (message.businessIdentifiers?.length) {
      obj.businessIdentifiers = message.businessIdentifiers.map((e) => BusinessIdentifier.toJSON(e));
    }
    if (message.gstin !== "") {
      obj.gstin = message.gstin;
    }
    if (message.gstRegistrationType !== 0) {
      obj.gstRegistrationType = gSTRegistrationTypeToJSON(message.gstRegistrationType);
    }
    if (message.billingAddress !== undefined) {
      obj.billingAddress = Address.toJSON(message.billingAddress);
    }
    if (message.shippingAddress !== undefined) {
      obj.shippingAddress = Address.toJSON(message.shippingAddress);
    }
    if (message.ledgerAssignments?.length) {
      obj.ledgerAssignments = message.ledgerAssignments.map((e) => PartyLedgerAssignment.toJSON(e));
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.updatedBy !== "") {
      obj.updatedBy = message.updatedBy;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Party>, I>>(base?: I): Party {
    return Party.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Party>, I>>(object: I): Party {
    const message = createBaseParty();
    message.id = object.id ?? "";
    message.orgId = object.orgId ?? "";
    message.ledgerId = object.ledgerId ?? "";
    message.entityId = object.entityId ?? "";
    message.code = object.code ?? "";
    message.partyType = object.partyType ?? 0;
    message.roles = object.roles?.map((e) => e) || [];
    message.creditDays = object.creditDays ?? undefined;
    message.creditLimit = object.creditLimit ?? "0";
    message.receivableAccountId = object.receivableAccountId ?? "";
    message.payableAccountId = object.payableAccountId ?? "";
    message.defaultCurrency = object.defaultCurrency ?? "";
    message.billingAddressId = object.billingAddressId ?? "";
    message.shippingAddressId = object.shippingAddressId ?? "";
    message.companyVendorCode = object.companyVendorCode ?? "";
    message.isActive = object.isActive ?? false;
    message.name = object.name ?? "";
    message.tradeName = object.tradeName ?? "";
    message.contact = (object.contact !== undefined && object.contact !== null)
      ? Contact.fromPartial(object.contact)
      : undefined;
    message.businessIdentifiers = object.businessIdentifiers?.map((e) => BusinessIdentifier.fromPartial(e)) || [];
    message.gstin = object.gstin ?? "";
    message.gstRegistrationType = object.gstRegistrationType ?? 0;
    message.billingAddress = (object.billingAddress !== undefined && object.billingAddress !== null)
      ? Address.fromPartial(object.billingAddress)
      : undefined;
    message.shippingAddress = (object.shippingAddress !== undefined && object.shippingAddress !== null)
      ? Address.fromPartial(object.shippingAddress)
      : undefined;
    message.ledgerAssignments = object.ledgerAssignments?.map((e) => PartyLedgerAssignment.fromPartial(e)) || [];
    message.createdAt = object.createdAt ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    message.createdBy = object.createdBy ?? "";
    message.updatedBy = object.updatedBy ?? "";
    return message;
  },
};

function createBasePartyLedgerAssignment(): PartyLedgerAssignment {
  return {
    id: "",
    partyId: "",
    ledgerId: "",
    role: "",
    creditDays: undefined,
    creditLimit: "0",
    receivableAccountId: "",
    payableAccountId: "",
    defaultCurrency: "",
    billingAddressId: "",
    shippingAddressId: "",
    companyVendorCode: "",
    isActive: false,
    createdAt: undefined,
    updatedAt: undefined,
  };
}

export const PartyLedgerAssignment: MessageFns<PartyLedgerAssignment> = {
  encode(message: PartyLedgerAssignment, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.partyId !== "") {
      writer.uint32(18).string(message.partyId);
    }
    if (message.ledgerId !== "") {
      writer.uint32(26).string(message.ledgerId);
    }
    if (message.role !== "") {
      writer.uint32(34).string(message.role);
    }
    if (message.creditDays !== undefined) {
      writer.uint32(40).int32(message.creditDays);
    }
    if (message.creditLimit !== "0") {
      writer.uint32(48).int64(message.creditLimit);
    }
    if (message.receivableAccountId !== "") {
      writer.uint32(58).string(message.receivableAccountId);
    }
    if (message.payableAccountId !== "") {
      writer.uint32(66).string(message.payableAccountId);
    }
    if (message.defaultCurrency !== "") {
      writer.uint32(74).string(message.defaultCurrency);
    }
    if (message.billingAddressId !== "") {
      writer.uint32(82).string(message.billingAddressId);
    }
    if (message.shippingAddressId !== "") {
      writer.uint32(90).string(message.shippingAddressId);
    }
    if (message.companyVendorCode !== "") {
      writer.uint32(98).string(message.companyVendorCode);
    }
    if (message.isActive !== false) {
      writer.uint32(104).bool(message.isActive);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(114).fork()).join();
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(122).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PartyLedgerAssignment {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePartyLedgerAssignment();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.partyId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ledgerId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.role = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.creditDays = reader.int32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.creditLimit = reader.int64().toString();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.receivableAccountId = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.payableAccountId = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.defaultCurrency = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.billingAddressId = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.shippingAddressId = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.companyVendorCode = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.isActive = reader.bool();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PartyLedgerAssignment {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      partyId: isSet(object.partyId)
        ? globalThis.String(object.partyId)
        : isSet(object.party_id)
        ? globalThis.String(object.party_id)
        : "",
      ledgerId: isSet(object.ledgerId)
        ? globalThis.String(object.ledgerId)
        : isSet(object.ledger_id)
        ? globalThis.String(object.ledger_id)
        : "",
      role: isSet(object.role) ? globalThis.String(object.role) : "",
      creditDays: isSet(object.creditDays)
        ? globalThis.Number(object.creditDays)
        : isSet(object.credit_days)
        ? globalThis.Number(object.credit_days)
        : undefined,
      creditLimit: isSet(object.creditLimit)
        ? globalThis.String(object.creditLimit)
        : isSet(object.credit_limit)
        ? globalThis.String(object.credit_limit)
        : "0",
      receivableAccountId: isSet(object.receivableAccountId)
        ? globalThis.String(object.receivableAccountId)
        : isSet(object.receivable_account_id)
        ? globalThis.String(object.receivable_account_id)
        : "",
      payableAccountId: isSet(object.payableAccountId)
        ? globalThis.String(object.payableAccountId)
        : isSet(object.payable_account_id)
        ? globalThis.String(object.payable_account_id)
        : "",
      defaultCurrency: isSet(object.defaultCurrency)
        ? globalThis.String(object.defaultCurrency)
        : isSet(object.default_currency)
        ? globalThis.String(object.default_currency)
        : "",
      billingAddressId: isSet(object.billingAddressId)
        ? globalThis.String(object.billingAddressId)
        : isSet(object.billing_address_id)
        ? globalThis.String(object.billing_address_id)
        : "",
      shippingAddressId: isSet(object.shippingAddressId)
        ? globalThis.String(object.shippingAddressId)
        : isSet(object.shipping_address_id)
        ? globalThis.String(object.shipping_address_id)
        : "",
      companyVendorCode: isSet(object.companyVendorCode)
        ? globalThis.String(object.companyVendorCode)
        : isSet(object.company_vendor_code)
        ? globalThis.String(object.company_vendor_code)
        : "",
      isActive: isSet(object.isActive)
        ? globalThis.Boolean(object.isActive)
        : isSet(object.is_active)
        ? globalThis.Boolean(object.is_active)
        : false,
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
    };
  },

  toJSON(message: PartyLedgerAssignment): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.partyId !== "") {
      obj.partyId = message.partyId;
    }
    if (message.ledgerId !== "") {
      obj.ledgerId = message.ledgerId;
    }
    if (message.role !== "") {
      obj.role = message.role;
    }
    if (message.creditDays !== undefined) {
      obj.creditDays = Math.round(message.creditDays);
    }
    if (message.creditLimit !== "0") {
      obj.creditLimit = message.creditLimit;
    }
    if (message.receivableAccountId !== "") {
      obj.receivableAccountId = message.receivableAccountId;
    }
    if (message.payableAccountId !== "") {
      obj.payableAccountId = message.payableAccountId;
    }
    if (message.defaultCurrency !== "") {
      obj.defaultCurrency = message.defaultCurrency;
    }
    if (message.billingAddressId !== "") {
      obj.billingAddressId = message.billingAddressId;
    }
    if (message.shippingAddressId !== "") {
      obj.shippingAddressId = message.shippingAddressId;
    }
    if (message.companyVendorCode !== "") {
      obj.companyVendorCode = message.companyVendorCode;
    }
    if (message.isActive !== false) {
      obj.isActive = message.isActive;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PartyLedgerAssignment>, I>>(base?: I): PartyLedgerAssignment {
    return PartyLedgerAssignment.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PartyLedgerAssignment>, I>>(object: I): PartyLedgerAssignment {
    const message = createBasePartyLedgerAssignment();
    message.id = object.id ?? "";
    message.partyId = object.partyId ?? "";
    message.ledgerId = object.ledgerId ?? "";
    message.role = object.role ?? "";
    message.creditDays = object.creditDays ?? undefined;
    message.creditLimit = object.creditLimit ?? "0";
    message.receivableAccountId = object.receivableAccountId ?? "";
    message.payableAccountId = object.payableAccountId ?? "";
    message.defaultCurrency = object.defaultCurrency ?? "";
    message.billingAddressId = object.billingAddressId ?? "";
    message.shippingAddressId = object.shippingAddressId ?? "";
    message.companyVendorCode = object.companyVendorCode ?? "";
    message.isActive = object.isActive ?? false;
    message.createdAt = object.createdAt ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    return message;
  },
};

function createBasePartyWithEntity(): PartyWithEntity {
  return {
    party: undefined,
    name: "",
    tradeName: "",
    email: "",
    phone: "",
    mobile: "",
    website: "",
    billingAddress: undefined,
    shippingAddress: undefined,
    gstin: "",
    gstRegistrationType: 0,
    pan: "",
  };
}

export const PartyWithEntity: MessageFns<PartyWithEntity> = {
  encode(message: PartyWithEntity, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.party !== undefined) {
      Party.encode(message.party, writer.uint32(10).fork()).join();
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.tradeName !== "") {
      writer.uint32(26).string(message.tradeName);
    }
    if (message.email !== "") {
      writer.uint32(34).string(message.email);
    }
    if (message.phone !== "") {
      writer.uint32(42).string(message.phone);
    }
    if (message.mobile !== "") {
      writer.uint32(50).string(message.mobile);
    }
    if (message.website !== "") {
      writer.uint32(58).string(message.website);
    }
    if (message.billingAddress !== undefined) {
      Address.encode(message.billingAddress, writer.uint32(66).fork()).join();
    }
    if (message.shippingAddress !== undefined) {
      Address.encode(message.shippingAddress, writer.uint32(74).fork()).join();
    }
    if (message.gstin !== "") {
      writer.uint32(82).string(message.gstin);
    }
    if (message.gstRegistrationType !== 0) {
      writer.uint32(88).int32(message.gstRegistrationType);
    }
    if (message.pan !== "") {
      writer.uint32(98).string(message.pan);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PartyWithEntity {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePartyWithEntity();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.party = Party.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.tradeName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.email = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.phone = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.mobile = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.website = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.billingAddress = Address.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.shippingAddress = Address.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.gstin = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.gstRegistrationType = reader.int32() as any;
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.pan = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PartyWithEntity {
    return {
      party: isSet(object.party) ? Party.fromJSON(object.party) : undefined,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      tradeName: isSet(object.tradeName)
        ? globalThis.String(object.tradeName)
        : isSet(object.trade_name)
        ? globalThis.String(object.trade_name)
        : "",
      email: isSet(object.email) ? globalThis.String(object.email) : "",
      phone: isSet(object.phone) ? globalThis.String(object.phone) : "",
      mobile: isSet(object.mobile) ? globalThis.String(object.mobile) : "",
      website: isSet(object.website) ? globalThis.String(object.website) : "",
      billingAddress: isSet(object.billingAddress)
        ? Address.fromJSON(object.billingAddress)
        : isSet(object.billing_address)
        ? Address.fromJSON(object.billing_address)
        : undefined,
      shippingAddress: isSet(object.shippingAddress)
        ? Address.fromJSON(object.shippingAddress)
        : isSet(object.shipping_address)
        ? Address.fromJSON(object.shipping_address)
        : undefined,
      gstin: isSet(object.gstin) ? globalThis.String(object.gstin) : "",
      gstRegistrationType: isSet(object.gstRegistrationType)
        ? gSTRegistrationTypeFromJSON(object.gstRegistrationType)
        : isSet(object.gst_registration_type)
        ? gSTRegistrationTypeFromJSON(object.gst_registration_type)
        : 0,
      pan: isSet(object.pan) ? globalThis.String(object.pan) : "",
    };
  },

  toJSON(message: PartyWithEntity): unknown {
    const obj: any = {};
    if (message.party !== undefined) {
      obj.party = Party.toJSON(message.party);
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.tradeName !== "") {
      obj.tradeName = message.tradeName;
    }
    if (message.email !== "") {
      obj.email = message.email;
    }
    if (message.phone !== "") {
      obj.phone = message.phone;
    }
    if (message.mobile !== "") {
      obj.mobile = message.mobile;
    }
    if (message.website !== "") {
      obj.website = message.website;
    }
    if (message.billingAddress !== undefined) {
      obj.billingAddress = Address.toJSON(message.billingAddress);
    }
    if (message.shippingAddress !== undefined) {
      obj.shippingAddress = Address.toJSON(message.shippingAddress);
    }
    if (message.gstin !== "") {
      obj.gstin = message.gstin;
    }
    if (message.gstRegistrationType !== 0) {
      obj.gstRegistrationType = gSTRegistrationTypeToJSON(message.gstRegistrationType);
    }
    if (message.pan !== "") {
      obj.pan = message.pan;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PartyWithEntity>, I>>(base?: I): PartyWithEntity {
    return PartyWithEntity.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PartyWithEntity>, I>>(object: I): PartyWithEntity {
    const message = createBasePartyWithEntity();
    message.party = (object.party !== undefined && object.party !== null) ? Party.fromPartial(object.party) : undefined;
    message.name = object.name ?? "";
    message.tradeName = object.tradeName ?? "";
    message.email = object.email ?? "";
    message.phone = object.phone ?? "";
    message.mobile = object.mobile ?? "";
    message.website = object.website ?? "";
    message.billingAddress = (object.billingAddress !== undefined && object.billingAddress !== null)
      ? Address.fromPartial(object.billingAddress)
      : undefined;
    message.shippingAddress = (object.shippingAddress !== undefined && object.shippingAddress !== null)
      ? Address.fromPartial(object.shippingAddress)
      : undefined;
    message.gstin = object.gstin ?? "";
    message.gstRegistrationType = object.gstRegistrationType ?? 0;
    message.pan = object.pan ?? "";
    return message;
  },
};

function createBaseCreatePartyRequest(): CreatePartyRequest {
  return {
    orgId: "",
    ledgerId: "",
    entityId: "",
    code: "",
    name: "",
    tradeName: "",
    partyType: 0,
    roles: [],
    gstin: "",
    gstRegistrationType: 0,
    pan: "",
    contact: undefined,
    businessIdentifiers: [],
    billingAddress: undefined,
    shippingAddress: undefined,
    creditDays: undefined,
    creditLimit: "0",
    receivableAccountId: "",
    payableAccountId: "",
    defaultCurrency: "",
    billingAddressId: "",
    shippingAddressId: "",
    companyVendorCode: "",
  };
}

export const CreatePartyRequest: MessageFns<CreatePartyRequest> = {
  encode(message: CreatePartyRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgId !== "") {
      writer.uint32(10).string(message.orgId);
    }
    if (message.ledgerId !== "") {
      writer.uint32(18).string(message.ledgerId);
    }
    if (message.entityId !== "") {
      writer.uint32(26).string(message.entityId);
    }
    if (message.code !== "") {
      writer.uint32(34).string(message.code);
    }
    if (message.name !== "") {
      writer.uint32(42).string(message.name);
    }
    if (message.tradeName !== "") {
      writer.uint32(50).string(message.tradeName);
    }
    if (message.partyType !== 0) {
      writer.uint32(56).int32(message.partyType);
    }
    for (const v of message.roles) {
      writer.uint32(218).string(v!);
    }
    if (message.gstin !== "") {
      writer.uint32(66).string(message.gstin);
    }
    if (message.gstRegistrationType !== 0) {
      writer.uint32(72).int32(message.gstRegistrationType);
    }
    if (message.pan !== "") {
      writer.uint32(82).string(message.pan);
    }
    if (message.contact !== undefined) {
      Contact.encode(message.contact, writer.uint32(90).fork()).join();
    }
    for (const v of message.businessIdentifiers) {
      BusinessIdentifier.encode(v!, writer.uint32(210).fork()).join();
    }
    if (message.billingAddress !== undefined) {
      Address.encode(message.billingAddress, writer.uint32(122).fork()).join();
    }
    if (message.shippingAddress !== undefined) {
      Address.encode(message.shippingAddress, writer.uint32(130).fork()).join();
    }
    if (message.creditDays !== undefined) {
      writer.uint32(136).int32(message.creditDays);
    }
    if (message.creditLimit !== "0") {
      writer.uint32(144).int64(message.creditLimit);
    }
    if (message.receivableAccountId !== "") {
      writer.uint32(154).string(message.receivableAccountId);
    }
    if (message.payableAccountId !== "") {
      writer.uint32(162).string(message.payableAccountId);
    }
    if (message.defaultCurrency !== "") {
      writer.uint32(170).string(message.defaultCurrency);
    }
    if (message.billingAddressId !== "") {
      writer.uint32(194).string(message.billingAddressId);
    }
    if (message.shippingAddressId !== "") {
      writer.uint32(202).string(message.shippingAddressId);
    }
    if (message.companyVendorCode !== "") {
      writer.uint32(178).string(message.companyVendorCode);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreatePartyRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreatePartyRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ledgerId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.entityId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.code = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.tradeName = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.partyType = reader.int32() as any;
          continue;
        }
        case 27: {
          if (tag !== 218) {
            break;
          }

          message.roles.push(reader.string());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.gstin = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.gstRegistrationType = reader.int32() as any;
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.pan = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.contact = Contact.decode(reader, reader.uint32());
          continue;
        }
        case 26: {
          if (tag !== 210) {
            break;
          }

          message.businessIdentifiers.push(BusinessIdentifier.decode(reader, reader.uint32()));
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.billingAddress = Address.decode(reader, reader.uint32());
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.shippingAddress = Address.decode(reader, reader.uint32());
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.creditDays = reader.int32();
          continue;
        }
        case 18: {
          if (tag !== 144) {
            break;
          }

          message.creditLimit = reader.int64().toString();
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.receivableAccountId = reader.string();
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.payableAccountId = reader.string();
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.defaultCurrency = reader.string();
          continue;
        }
        case 24: {
          if (tag !== 194) {
            break;
          }

          message.billingAddressId = reader.string();
          continue;
        }
        case 25: {
          if (tag !== 202) {
            break;
          }

          message.shippingAddressId = reader.string();
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.companyVendorCode = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreatePartyRequest {
    return {
      orgId: isSet(object.orgId)
        ? globalThis.String(object.orgId)
        : isSet(object.org_id)
        ? globalThis.String(object.org_id)
        : "",
      ledgerId: isSet(object.ledgerId)
        ? globalThis.String(object.ledgerId)
        : isSet(object.ledger_id)
        ? globalThis.String(object.ledger_id)
        : "",
      entityId: isSet(object.entityId)
        ? globalThis.String(object.entityId)
        : isSet(object.entity_id)
        ? globalThis.String(object.entity_id)
        : "",
      code: isSet(object.code) ? globalThis.String(object.code) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      tradeName: isSet(object.tradeName)
        ? globalThis.String(object.tradeName)
        : isSet(object.trade_name)
        ? globalThis.String(object.trade_name)
        : "",
      partyType: isSet(object.partyType)
        ? partyTypeFromJSON(object.partyType)
        : isSet(object.party_type)
        ? partyTypeFromJSON(object.party_type)
        : 0,
      roles: globalThis.Array.isArray(object?.roles)
        ? object.roles.map((e: any) => globalThis.String(e))
        : [],
      gstin: isSet(object.gstin) ? globalThis.String(object.gstin) : "",
      gstRegistrationType: isSet(object.gstRegistrationType)
        ? gSTRegistrationTypeFromJSON(object.gstRegistrationType)
        : isSet(object.gst_registration_type)
        ? gSTRegistrationTypeFromJSON(object.gst_registration_type)
        : 0,
      pan: isSet(object.pan) ? globalThis.String(object.pan) : "",
      contact: isSet(object.contact) ? Contact.fromJSON(object.contact) : undefined,
      businessIdentifiers: globalThis.Array.isArray(object?.businessIdentifiers)
        ? object.businessIdentifiers.map((e: any) => BusinessIdentifier.fromJSON(e))
        : globalThis.Array.isArray(object?.business_identifiers)
        ? object.business_identifiers.map((e: any) => BusinessIdentifier.fromJSON(e))
        : [],
      billingAddress: isSet(object.billingAddress)
        ? Address.fromJSON(object.billingAddress)
        : isSet(object.billing_address)
        ? Address.fromJSON(object.billing_address)
        : undefined,
      shippingAddress: isSet(object.shippingAddress)
        ? Address.fromJSON(object.shippingAddress)
        : isSet(object.shipping_address)
        ? Address.fromJSON(object.shipping_address)
        : undefined,
      creditDays: isSet(object.creditDays)
        ? globalThis.Number(object.creditDays)
        : isSet(object.credit_days)
        ? globalThis.Number(object.credit_days)
        : undefined,
      creditLimit: isSet(object.creditLimit)
        ? globalThis.String(object.creditLimit)
        : isSet(object.credit_limit)
        ? globalThis.String(object.credit_limit)
        : "0",
      receivableAccountId: isSet(object.receivableAccountId)
        ? globalThis.String(object.receivableAccountId)
        : isSet(object.receivable_account_id)
        ? globalThis.String(object.receivable_account_id)
        : "",
      payableAccountId: isSet(object.payableAccountId)
        ? globalThis.String(object.payableAccountId)
        : isSet(object.payable_account_id)
        ? globalThis.String(object.payable_account_id)
        : "",
      defaultCurrency: isSet(object.defaultCurrency)
        ? globalThis.String(object.defaultCurrency)
        : isSet(object.default_currency)
        ? globalThis.String(object.default_currency)
        : "",
      billingAddressId: isSet(object.billingAddressId)
        ? globalThis.String(object.billingAddressId)
        : isSet(object.billing_address_id)
        ? globalThis.String(object.billing_address_id)
        : "",
      shippingAddressId: isSet(object.shippingAddressId)
        ? globalThis.String(object.shippingAddressId)
        : isSet(object.shipping_address_id)
        ? globalThis.String(object.shipping_address_id)
        : "",
      companyVendorCode: isSet(object.companyVendorCode)
        ? globalThis.String(object.companyVendorCode)
        : isSet(object.company_vendor_code)
        ? globalThis.String(object.company_vendor_code)
        : "",
    };
  },

  toJSON(message: CreatePartyRequest): unknown {
    const obj: any = {};
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.ledgerId !== "") {
      obj.ledgerId = message.ledgerId;
    }
    if (message.entityId !== "") {
      obj.entityId = message.entityId;
    }
    if (message.code !== "") {
      obj.code = message.code;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.tradeName !== "") {
      obj.tradeName = message.tradeName;
    }
    if (message.partyType !== 0) {
      obj.partyType = partyTypeToJSON(message.partyType);
    }
    if (message.roles?.length) {
      obj.roles = message.roles;
    }
    if (message.gstin !== "") {
      obj.gstin = message.gstin;
    }
    if (message.gstRegistrationType !== 0) {
      obj.gstRegistrationType = gSTRegistrationTypeToJSON(message.gstRegistrationType);
    }
    if (message.pan !== "") {
      obj.pan = message.pan;
    }
    if (message.contact !== undefined) {
      obj.contact = Contact.toJSON(message.contact);
    }
    if (message.businessIdentifiers?.length) {
      obj.businessIdentifiers = message.businessIdentifiers.map((e) => BusinessIdentifier.toJSON(e));
    }
    if (message.billingAddress !== undefined) {
      obj.billingAddress = Address.toJSON(message.billingAddress);
    }
    if (message.shippingAddress !== undefined) {
      obj.shippingAddress = Address.toJSON(message.shippingAddress);
    }
    if (message.creditDays !== undefined) {
      obj.creditDays = Math.round(message.creditDays);
    }
    if (message.creditLimit !== "0") {
      obj.creditLimit = message.creditLimit;
    }
    if (message.receivableAccountId !== "") {
      obj.receivableAccountId = message.receivableAccountId;
    }
    if (message.payableAccountId !== "") {
      obj.payableAccountId = message.payableAccountId;
    }
    if (message.defaultCurrency !== "") {
      obj.defaultCurrency = message.defaultCurrency;
    }
    if (message.billingAddressId !== "") {
      obj.billingAddressId = message.billingAddressId;
    }
    if (message.shippingAddressId !== "") {
      obj.shippingAddressId = message.shippingAddressId;
    }
    if (message.companyVendorCode !== "") {
      obj.companyVendorCode = message.companyVendorCode;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreatePartyRequest>, I>>(base?: I): CreatePartyRequest {
    return CreatePartyRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreatePartyRequest>, I>>(object: I): CreatePartyRequest {
    const message = createBaseCreatePartyRequest();
    message.orgId = object.orgId ?? "";
    message.ledgerId = object.ledgerId ?? "";
    message.entityId = object.entityId ?? "";
    message.code = object.code ?? "";
    message.name = object.name ?? "";
    message.tradeName = object.tradeName ?? "";
    message.partyType = object.partyType ?? 0;
    message.roles = object.roles?.map((e) => e) || [];
    message.gstin = object.gstin ?? "";
    message.gstRegistrationType = object.gstRegistrationType ?? 0;
    message.pan = object.pan ?? "";
    message.contact = (object.contact !== undefined && object.contact !== null)
      ? Contact.fromPartial(object.contact)
      : undefined;
    message.businessIdentifiers = object.businessIdentifiers?.map((e) => BusinessIdentifier.fromPartial(e)) || [];
    message.billingAddress = (object.billingAddress !== undefined && object.billingAddress !== null)
      ? Address.fromPartial(object.billingAddress)
      : undefined;
    message.shippingAddress = (object.shippingAddress !== undefined && object.shippingAddress !== null)
      ? Address.fromPartial(object.shippingAddress)
      : undefined;
    message.creditDays = object.creditDays ?? undefined;
    message.creditLimit = object.creditLimit ?? "0";
    message.receivableAccountId = object.receivableAccountId ?? "";
    message.payableAccountId = object.payableAccountId ?? "";
    message.defaultCurrency = object.defaultCurrency ?? "";
    message.billingAddressId = object.billingAddressId ?? "";
    message.shippingAddressId = object.shippingAddressId ?? "";
    message.companyVendorCode = object.companyVendorCode ?? "";
    return message;
  },
};

function createBaseGetNextPartyCodeRequest(): GetNextPartyCodeRequest {
  return { orgId: "", ledgerId: "", roles: [] };
}

export const GetNextPartyCodeRequest: MessageFns<GetNextPartyCodeRequest> = {
  encode(message: GetNextPartyCodeRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgId !== "") {
      writer.uint32(10).string(message.orgId);
    }
    if (message.ledgerId !== "") {
      writer.uint32(18).string(message.ledgerId);
    }
    for (const v of message.roles) {
      writer.uint32(26).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetNextPartyCodeRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetNextPartyCodeRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ledgerId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.roles.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetNextPartyCodeRequest {
    return {
      orgId: isSet(object.orgId)
        ? globalThis.String(object.orgId)
        : isSet(object.org_id)
        ? globalThis.String(object.org_id)
        : "",
      ledgerId: isSet(object.ledgerId)
        ? globalThis.String(object.ledgerId)
        : isSet(object.ledger_id)
        ? globalThis.String(object.ledger_id)
        : "",
      roles: globalThis.Array.isArray(object?.roles) ? object.roles.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: GetNextPartyCodeRequest): unknown {
    const obj: any = {};
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.ledgerId !== "") {
      obj.ledgerId = message.ledgerId;
    }
    if (message.roles?.length) {
      obj.roles = message.roles;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetNextPartyCodeRequest>, I>>(base?: I): GetNextPartyCodeRequest {
    return GetNextPartyCodeRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetNextPartyCodeRequest>, I>>(object: I): GetNextPartyCodeRequest {
    const message = createBaseGetNextPartyCodeRequest();
    message.orgId = object.orgId ?? "";
    message.ledgerId = object.ledgerId ?? "";
    message.roles = object.roles?.map((e) => e) || [];
    return message;
  },
};

function createBaseGetNextPartyCodeResponse(): GetNextPartyCodeResponse {
  return { code: "" };
}

export const GetNextPartyCodeResponse: MessageFns<GetNextPartyCodeResponse> = {
  encode(message: GetNextPartyCodeResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.code !== "") {
      writer.uint32(10).string(message.code);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetNextPartyCodeResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetNextPartyCodeResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.code = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetNextPartyCodeResponse {
    return { code: isSet(object.code) ? globalThis.String(object.code) : "" };
  },

  toJSON(message: GetNextPartyCodeResponse): unknown {
    const obj: any = {};
    if (message.code !== "") {
      obj.code = message.code;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetNextPartyCodeResponse>, I>>(base?: I): GetNextPartyCodeResponse {
    return GetNextPartyCodeResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetNextPartyCodeResponse>, I>>(object: I): GetNextPartyCodeResponse {
    const message = createBaseGetNextPartyCodeResponse();
    message.code = object.code ?? "";
    return message;
  },
};

function createBaseGetPartyRequest(): GetPartyRequest {
  return { orgId: "", partyId: "", enrich: false };
}

export const GetPartyRequest: MessageFns<GetPartyRequest> = {
  encode(message: GetPartyRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgId !== "") {
      writer.uint32(10).string(message.orgId);
    }
    if (message.partyId !== "") {
      writer.uint32(18).string(message.partyId);
    }
    if (message.enrich !== false) {
      writer.uint32(24).bool(message.enrich);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetPartyRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetPartyRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.partyId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.enrich = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetPartyRequest {
    return {
      orgId: isSet(object.orgId)
        ? globalThis.String(object.orgId)
        : isSet(object.org_id)
        ? globalThis.String(object.org_id)
        : "",
      partyId: isSet(object.partyId)
        ? globalThis.String(object.partyId)
        : isSet(object.party_id)
        ? globalThis.String(object.party_id)
        : "",
      enrich: isSet(object.enrich) ? globalThis.Boolean(object.enrich) : false,
    };
  },

  toJSON(message: GetPartyRequest): unknown {
    const obj: any = {};
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.partyId !== "") {
      obj.partyId = message.partyId;
    }
    if (message.enrich !== false) {
      obj.enrich = message.enrich;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetPartyRequest>, I>>(base?: I): GetPartyRequest {
    return GetPartyRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetPartyRequest>, I>>(object: I): GetPartyRequest {
    const message = createBaseGetPartyRequest();
    message.orgId = object.orgId ?? "";
    message.partyId = object.partyId ?? "";
    message.enrich = object.enrich ?? false;
    return message;
  },
};

function createBaseGetPartyScoreRequest(): GetPartyScoreRequest {
  return { orgId: "", partyId: "" };
}

export const GetPartyScoreRequest: MessageFns<GetPartyScoreRequest> = {
  encode(message: GetPartyScoreRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgId !== "") {
      writer.uint32(10).string(message.orgId);
    }
    if (message.partyId !== "") {
      writer.uint32(18).string(message.partyId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetPartyScoreRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetPartyScoreRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.partyId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetPartyScoreRequest {
    return {
      orgId: isSet(object.orgId)
        ? globalThis.String(object.orgId)
        : isSet(object.org_id)
        ? globalThis.String(object.org_id)
        : "",
      partyId: isSet(object.partyId)
        ? globalThis.String(object.partyId)
        : isSet(object.party_id)
        ? globalThis.String(object.party_id)
        : "",
    };
  },

  toJSON(message: GetPartyScoreRequest): unknown {
    const obj: any = {};
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.partyId !== "") {
      obj.partyId = message.partyId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetPartyScoreRequest>, I>>(base?: I): GetPartyScoreRequest {
    return GetPartyScoreRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetPartyScoreRequest>, I>>(object: I): GetPartyScoreRequest {
    const message = createBaseGetPartyScoreRequest();
    message.orgId = object.orgId ?? "";
    message.partyId = object.partyId ?? "";
    return message;
  },
};

function createBasePartyScore(): PartyScore {
  return {
    partyId: "",
    total: 0,
    tier: "",
    dimensions: [],
    alerts: [],
    computedAt: undefined,
    manualRating: undefined,
  };
}

export const PartyScore: MessageFns<PartyScore> = {
  encode(message: PartyScore, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.partyId !== "") {
      writer.uint32(10).string(message.partyId);
    }
    if (message.total !== 0) {
      writer.uint32(17).double(message.total);
    }
    if (message.tier !== "") {
      writer.uint32(26).string(message.tier);
    }
    for (const v of message.dimensions) {
      PartyScoreDimension.encode(v!, writer.uint32(34).fork()).join();
    }
    for (const v of message.alerts) {
      PartyScoreAlert.encode(v!, writer.uint32(42).fork()).join();
    }
    if (message.computedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.computedAt), writer.uint32(50).fork()).join();
    }
    if (message.manualRating !== undefined) {
      writer.uint32(56).int32(message.manualRating);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PartyScore {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePartyScore();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.partyId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.total = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.tier = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.dimensions.push(PartyScoreDimension.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.alerts.push(PartyScoreAlert.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.computedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.manualRating = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PartyScore {
    return {
      partyId: isSet(object.partyId)
        ? globalThis.String(object.partyId)
        : isSet(object.party_id)
        ? globalThis.String(object.party_id)
        : "",
      total: isSet(object.total) ? globalThis.Number(object.total) : 0,
      tier: isSet(object.tier) ? globalThis.String(object.tier) : "",
      dimensions: globalThis.Array.isArray(object?.dimensions)
        ? object.dimensions.map((e: any) => PartyScoreDimension.fromJSON(e))
        : [],
      alerts: globalThis.Array.isArray(object?.alerts)
        ? object.alerts.map((e: any) => PartyScoreAlert.fromJSON(e))
        : [],
      computedAt: isSet(object.computedAt)
        ? fromJsonTimestamp(object.computedAt)
        : isSet(object.computed_at)
        ? fromJsonTimestamp(object.computed_at)
        : undefined,
      manualRating: isSet(object.manualRating)
        ? globalThis.Number(object.manualRating)
        : isSet(object.manual_rating)
        ? globalThis.Number(object.manual_rating)
        : undefined,
    };
  },

  toJSON(message: PartyScore): unknown {
    const obj: any = {};
    if (message.partyId !== "") {
      obj.partyId = message.partyId;
    }
    if (message.total !== 0) {
      obj.total = message.total;
    }
    if (message.tier !== "") {
      obj.tier = message.tier;
    }
    if (message.dimensions?.length) {
      obj.dimensions = message.dimensions.map((e) => PartyScoreDimension.toJSON(e));
    }
    if (message.alerts?.length) {
      obj.alerts = message.alerts.map((e) => PartyScoreAlert.toJSON(e));
    }
    if (message.computedAt !== undefined) {
      obj.computedAt = message.computedAt.toISOString();
    }
    if (message.manualRating !== undefined) {
      obj.manualRating = Math.round(message.manualRating);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PartyScore>, I>>(base?: I): PartyScore {
    return PartyScore.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PartyScore>, I>>(object: I): PartyScore {
    const message = createBasePartyScore();
    message.partyId = object.partyId ?? "";
    message.total = object.total ?? 0;
    message.tier = object.tier ?? "";
    message.dimensions = object.dimensions?.map((e) => PartyScoreDimension.fromPartial(e)) || [];
    message.alerts = object.alerts?.map((e) => PartyScoreAlert.fromPartial(e)) || [];
    message.computedAt = object.computedAt ?? undefined;
    message.manualRating = object.manualRating ?? undefined;
    return message;
  },
};

function createBasePartyScoreDimension(): PartyScoreDimension {
  return { key: "", score: 0, max: 0, percentile: undefined, detail: "" };
}

export const PartyScoreDimension: MessageFns<PartyScoreDimension> = {
  encode(message: PartyScoreDimension, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.score !== 0) {
      writer.uint32(17).double(message.score);
    }
    if (message.max !== 0) {
      writer.uint32(25).double(message.max);
    }
    if (message.percentile !== undefined) {
      writer.uint32(32).int32(message.percentile);
    }
    if (message.detail !== "") {
      writer.uint32(42).string(message.detail);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PartyScoreDimension {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePartyScoreDimension();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.score = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.max = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.percentile = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.detail = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PartyScoreDimension {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      score: isSet(object.score) ? globalThis.Number(object.score) : 0,
      max: isSet(object.max) ? globalThis.Number(object.max) : 0,
      percentile: isSet(object.percentile) ? globalThis.Number(object.percentile) : undefined,
      detail: isSet(object.detail) ? globalThis.String(object.detail) : "",
    };
  },

  toJSON(message: PartyScoreDimension): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.score !== 0) {
      obj.score = message.score;
    }
    if (message.max !== 0) {
      obj.max = message.max;
    }
    if (message.percentile !== undefined) {
      obj.percentile = Math.round(message.percentile);
    }
    if (message.detail !== "") {
      obj.detail = message.detail;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PartyScoreDimension>, I>>(base?: I): PartyScoreDimension {
    return PartyScoreDimension.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PartyScoreDimension>, I>>(object: I): PartyScoreDimension {
    const message = createBasePartyScoreDimension();
    message.key = object.key ?? "";
    message.score = object.score ?? 0;
    message.max = object.max ?? 0;
    message.percentile = object.percentile ?? undefined;
    message.detail = object.detail ?? "";
    return message;
  },
};

function createBasePartyScoreAlert(): PartyScoreAlert {
  return { severity: "", code: "", message: "" };
}

export const PartyScoreAlert: MessageFns<PartyScoreAlert> = {
  encode(message: PartyScoreAlert, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.severity !== "") {
      writer.uint32(10).string(message.severity);
    }
    if (message.code !== "") {
      writer.uint32(18).string(message.code);
    }
    if (message.message !== "") {
      writer.uint32(26).string(message.message);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PartyScoreAlert {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePartyScoreAlert();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.severity = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.code = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.message = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PartyScoreAlert {
    return {
      severity: isSet(object.severity) ? globalThis.String(object.severity) : "",
      code: isSet(object.code) ? globalThis.String(object.code) : "",
      message: isSet(object.message) ? globalThis.String(object.message) : "",
    };
  },

  toJSON(message: PartyScoreAlert): unknown {
    const obj: any = {};
    if (message.severity !== "") {
      obj.severity = message.severity;
    }
    if (message.code !== "") {
      obj.code = message.code;
    }
    if (message.message !== "") {
      obj.message = message.message;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PartyScoreAlert>, I>>(base?: I): PartyScoreAlert {
    return PartyScoreAlert.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PartyScoreAlert>, I>>(object: I): PartyScoreAlert {
    const message = createBasePartyScoreAlert();
    message.severity = object.severity ?? "";
    message.code = object.code ?? "";
    message.message = object.message ?? "";
    return message;
  },
};

function createBaseUpdatePartyRequest(): UpdatePartyRequest {
  return {
    orgId: "",
    partyId: "",
    creditDays: undefined,
    creditLimit: "0",
    isActive: false,
    billingAddressId: undefined,
    shippingAddressId: undefined,
    companyVendorCode: undefined,
    name: "",
    tradeName: "",
    addresses: [],
    contact: undefined,
    businessIdentifiers: [],
    defaultCurrency: "",
  };
}

export const UpdatePartyRequest: MessageFns<UpdatePartyRequest> = {
  encode(message: UpdatePartyRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgId !== "") {
      writer.uint32(10).string(message.orgId);
    }
    if (message.partyId !== "") {
      writer.uint32(18).string(message.partyId);
    }
    if (message.creditDays !== undefined) {
      writer.uint32(24).int32(message.creditDays);
    }
    if (message.creditLimit !== "0") {
      writer.uint32(32).int64(message.creditLimit);
    }
    if (message.isActive !== false) {
      writer.uint32(40).bool(message.isActive);
    }
    if (message.billingAddressId !== undefined) {
      writer.uint32(66).string(message.billingAddressId);
    }
    if (message.shippingAddressId !== undefined) {
      writer.uint32(74).string(message.shippingAddressId);
    }
    if (message.companyVendorCode !== undefined) {
      writer.uint32(50).string(message.companyVendorCode);
    }
    if (message.name !== "") {
      writer.uint32(82).string(message.name);
    }
    if (message.tradeName !== "") {
      writer.uint32(114).string(message.tradeName);
    }
    for (const v of message.addresses) {
      Address.encode(v!, writer.uint32(90).fork()).join();
    }
    if (message.contact !== undefined) {
      Contact.encode(message.contact, writer.uint32(98).fork()).join();
    }
    for (const v of message.businessIdentifiers) {
      BusinessIdentifier.encode(v!, writer.uint32(106).fork()).join();
    }
    if (message.defaultCurrency !== "") {
      writer.uint32(122).string(message.defaultCurrency);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdatePartyRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdatePartyRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.partyId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.creditDays = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.creditLimit = reader.int64().toString();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.isActive = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.billingAddressId = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.shippingAddressId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.companyVendorCode = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.tradeName = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.addresses.push(Address.decode(reader, reader.uint32()));
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.contact = Contact.decode(reader, reader.uint32());
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.businessIdentifiers.push(BusinessIdentifier.decode(reader, reader.uint32()));
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.defaultCurrency = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdatePartyRequest {
    return {
      orgId: isSet(object.orgId)
        ? globalThis.String(object.orgId)
        : isSet(object.org_id)
        ? globalThis.String(object.org_id)
        : "",
      partyId: isSet(object.partyId)
        ? globalThis.String(object.partyId)
        : isSet(object.party_id)
        ? globalThis.String(object.party_id)
        : "",
      creditDays: isSet(object.creditDays)
        ? globalThis.Number(object.creditDays)
        : isSet(object.credit_days)
        ? globalThis.Number(object.credit_days)
        : undefined,
      creditLimit: isSet(object.creditLimit)
        ? globalThis.String(object.creditLimit)
        : isSet(object.credit_limit)
        ? globalThis.String(object.credit_limit)
        : "0",
      isActive: isSet(object.isActive)
        ? globalThis.Boolean(object.isActive)
        : isSet(object.is_active)
        ? globalThis.Boolean(object.is_active)
        : false,
      billingAddressId: isSet(object.billingAddressId)
        ? globalThis.String(object.billingAddressId)
        : isSet(object.billing_address_id)
        ? globalThis.String(object.billing_address_id)
        : undefined,
      shippingAddressId: isSet(object.shippingAddressId)
        ? globalThis.String(object.shippingAddressId)
        : isSet(object.shipping_address_id)
        ? globalThis.String(object.shipping_address_id)
        : undefined,
      companyVendorCode: isSet(object.companyVendorCode)
        ? globalThis.String(object.companyVendorCode)
        : isSet(object.company_vendor_code)
        ? globalThis.String(object.company_vendor_code)
        : undefined,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      tradeName: isSet(object.tradeName)
        ? globalThis.String(object.tradeName)
        : isSet(object.trade_name)
        ? globalThis.String(object.trade_name)
        : "",
      addresses: globalThis.Array.isArray(object?.addresses)
        ? object.addresses.map((e: any) => Address.fromJSON(e))
        : [],
      contact: isSet(object.contact) ? Contact.fromJSON(object.contact) : undefined,
      businessIdentifiers: globalThis.Array.isArray(object?.businessIdentifiers)
        ? object.businessIdentifiers.map((e: any) => BusinessIdentifier.fromJSON(e))
        : globalThis.Array.isArray(object?.business_identifiers)
        ? object.business_identifiers.map((e: any) => BusinessIdentifier.fromJSON(e))
        : [],
      defaultCurrency: isSet(object.defaultCurrency)
        ? globalThis.String(object.defaultCurrency)
        : isSet(object.default_currency)
        ? globalThis.String(object.default_currency)
        : "",
    };
  },

  toJSON(message: UpdatePartyRequest): unknown {
    const obj: any = {};
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.partyId !== "") {
      obj.partyId = message.partyId;
    }
    if (message.creditDays !== undefined) {
      obj.creditDays = Math.round(message.creditDays);
    }
    if (message.creditLimit !== "0") {
      obj.creditLimit = message.creditLimit;
    }
    if (message.isActive !== false) {
      obj.isActive = message.isActive;
    }
    if (message.billingAddressId !== undefined) {
      obj.billingAddressId = message.billingAddressId;
    }
    if (message.shippingAddressId !== undefined) {
      obj.shippingAddressId = message.shippingAddressId;
    }
    if (message.companyVendorCode !== undefined) {
      obj.companyVendorCode = message.companyVendorCode;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.tradeName !== "") {
      obj.tradeName = message.tradeName;
    }
    if (message.addresses?.length) {
      obj.addresses = message.addresses.map((e) => Address.toJSON(e));
    }
    if (message.contact !== undefined) {
      obj.contact = Contact.toJSON(message.contact);
    }
    if (message.businessIdentifiers?.length) {
      obj.businessIdentifiers = message.businessIdentifiers.map((e) => BusinessIdentifier.toJSON(e));
    }
    if (message.defaultCurrency !== "") {
      obj.defaultCurrency = message.defaultCurrency;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdatePartyRequest>, I>>(base?: I): UpdatePartyRequest {
    return UpdatePartyRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdatePartyRequest>, I>>(object: I): UpdatePartyRequest {
    const message = createBaseUpdatePartyRequest();
    message.orgId = object.orgId ?? "";
    message.partyId = object.partyId ?? "";
    message.creditDays = object.creditDays ?? undefined;
    message.creditLimit = object.creditLimit ?? "0";
    message.isActive = object.isActive ?? false;
    message.billingAddressId = object.billingAddressId ?? undefined;
    message.shippingAddressId = object.shippingAddressId ?? undefined;
    message.companyVendorCode = object.companyVendorCode ?? undefined;
    message.name = object.name ?? "";
    message.tradeName = object.tradeName ?? "";
    message.addresses = object.addresses?.map((e) => Address.fromPartial(e)) || [];
    message.contact = (object.contact !== undefined && object.contact !== null)
      ? Contact.fromPartial(object.contact)
      : undefined;
    message.businessIdentifiers = object.businessIdentifiers?.map((e) => BusinessIdentifier.fromPartial(e)) || [];
    message.defaultCurrency = object.defaultCurrency ?? "";
    return message;
  },
};

function createBaseDeletePartyRequest(): DeletePartyRequest {
  return { orgId: "", partyId: "" };
}

export const DeletePartyRequest: MessageFns<DeletePartyRequest> = {
  encode(message: DeletePartyRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgId !== "") {
      writer.uint32(10).string(message.orgId);
    }
    if (message.partyId !== "") {
      writer.uint32(18).string(message.partyId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeletePartyRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeletePartyRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.partyId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeletePartyRequest {
    return {
      orgId: isSet(object.orgId)
        ? globalThis.String(object.orgId)
        : isSet(object.org_id)
        ? globalThis.String(object.org_id)
        : "",
      partyId: isSet(object.partyId)
        ? globalThis.String(object.partyId)
        : isSet(object.party_id)
        ? globalThis.String(object.party_id)
        : "",
    };
  },

  toJSON(message: DeletePartyRequest): unknown {
    const obj: any = {};
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.partyId !== "") {
      obj.partyId = message.partyId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeletePartyRequest>, I>>(base?: I): DeletePartyRequest {
    return DeletePartyRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeletePartyRequest>, I>>(object: I): DeletePartyRequest {
    const message = createBaseDeletePartyRequest();
    message.orgId = object.orgId ?? "";
    message.partyId = object.partyId ?? "";
    return message;
  },
};

function createBaseDeletePartyResponse(): DeletePartyResponse {
  return { success: false, message: "", activeTransactionCount: 0, voidTransactionCount: 0 };
}

export const DeletePartyResponse: MessageFns<DeletePartyResponse> = {
  encode(message: DeletePartyResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success);
    }
    if (message.message !== "") {
      writer.uint32(18).string(message.message);
    }
    if (message.activeTransactionCount !== 0) {
      writer.uint32(24).int32(message.activeTransactionCount);
    }
    if (message.voidTransactionCount !== 0) {
      writer.uint32(32).int32(message.voidTransactionCount);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeletePartyResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeletePartyResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.success = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.message = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.activeTransactionCount = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.voidTransactionCount = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeletePartyResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      message: isSet(object.message) ? globalThis.String(object.message) : "",
      activeTransactionCount: isSet(object.activeTransactionCount)
        ? globalThis.Number(object.activeTransactionCount)
        : isSet(object.active_transaction_count)
        ? globalThis.Number(object.active_transaction_count)
        : 0,
      voidTransactionCount: isSet(object.voidTransactionCount)
        ? globalThis.Number(object.voidTransactionCount)
        : isSet(object.void_transaction_count)
        ? globalThis.Number(object.void_transaction_count)
        : 0,
    };
  },

  toJSON(message: DeletePartyResponse): unknown {
    const obj: any = {};
    if (message.success !== false) {
      obj.success = message.success;
    }
    if (message.message !== "") {
      obj.message = message.message;
    }
    if (message.activeTransactionCount !== 0) {
      obj.activeTransactionCount = Math.round(message.activeTransactionCount);
    }
    if (message.voidTransactionCount !== 0) {
      obj.voidTransactionCount = Math.round(message.voidTransactionCount);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeletePartyResponse>, I>>(base?: I): DeletePartyResponse {
    return DeletePartyResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeletePartyResponse>, I>>(object: I): DeletePartyResponse {
    const message = createBaseDeletePartyResponse();
    message.success = object.success ?? false;
    message.message = object.message ?? "";
    message.activeTransactionCount = object.activeTransactionCount ?? 0;
    message.voidTransactionCount = object.voidTransactionCount ?? 0;
    return message;
  },
};

function createBaseListPartiesRequest(): ListPartiesRequest {
  return {
    orgId: "",
    ledgerId: "",
    partyType: 0,
    activeOnly: false,
    pageSize: 0,
    pageToken: "",
    enrich: false,
    query: "",
    role: "",
  };
}

export const ListPartiesRequest: MessageFns<ListPartiesRequest> = {
  encode(message: ListPartiesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgId !== "") {
      writer.uint32(10).string(message.orgId);
    }
    if (message.ledgerId !== "") {
      writer.uint32(18).string(message.ledgerId);
    }
    if (message.partyType !== 0) {
      writer.uint32(24).int32(message.partyType);
    }
    if (message.activeOnly !== false) {
      writer.uint32(32).bool(message.activeOnly);
    }
    if (message.pageSize !== 0) {
      writer.uint32(40).int32(message.pageSize);
    }
    if (message.pageToken !== "") {
      writer.uint32(50).string(message.pageToken);
    }
    if (message.enrich !== false) {
      writer.uint32(56).bool(message.enrich);
    }
    if (message.query !== "") {
      writer.uint32(66).string(message.query);
    }
    if (message.role !== "") {
      writer.uint32(74).string(message.role);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListPartiesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListPartiesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ledgerId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.partyType = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.activeOnly = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.pageSize = reader.int32();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.pageToken = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.enrich = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.query = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.role = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListPartiesRequest {
    return {
      orgId: isSet(object.orgId)
        ? globalThis.String(object.orgId)
        : isSet(object.org_id)
        ? globalThis.String(object.org_id)
        : "",
      ledgerId: isSet(object.ledgerId)
        ? globalThis.String(object.ledgerId)
        : isSet(object.ledger_id)
        ? globalThis.String(object.ledger_id)
        : "",
      partyType: isSet(object.partyType)
        ? partyTypeFromJSON(object.partyType)
        : isSet(object.party_type)
        ? partyTypeFromJSON(object.party_type)
        : 0,
      activeOnly: isSet(object.activeOnly)
        ? globalThis.Boolean(object.activeOnly)
        : isSet(object.active_only)
        ? globalThis.Boolean(object.active_only)
        : false,
      pageSize: isSet(object.pageSize)
        ? globalThis.Number(object.pageSize)
        : isSet(object.page_size)
        ? globalThis.Number(object.page_size)
        : 0,
      pageToken: isSet(object.pageToken)
        ? globalThis.String(object.pageToken)
        : isSet(object.page_token)
        ? globalThis.String(object.page_token)
        : "",
      enrich: isSet(object.enrich) ? globalThis.Boolean(object.enrich) : false,
      query: isSet(object.query) ? globalThis.String(object.query) : "",
      role: isSet(object.role) ? globalThis.String(object.role) : "",
    };
  },

  toJSON(message: ListPartiesRequest): unknown {
    const obj: any = {};
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.ledgerId !== "") {
      obj.ledgerId = message.ledgerId;
    }
    if (message.partyType !== 0) {
      obj.partyType = partyTypeToJSON(message.partyType);
    }
    if (message.activeOnly !== false) {
      obj.activeOnly = message.activeOnly;
    }
    if (message.pageSize !== 0) {
      obj.pageSize = Math.round(message.pageSize);
    }
    if (message.pageToken !== "") {
      obj.pageToken = message.pageToken;
    }
    if (message.enrich !== false) {
      obj.enrich = message.enrich;
    }
    if (message.query !== "") {
      obj.query = message.query;
    }
    if (message.role !== "") {
      obj.role = message.role;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListPartiesRequest>, I>>(base?: I): ListPartiesRequest {
    return ListPartiesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListPartiesRequest>, I>>(object: I): ListPartiesRequest {
    const message = createBaseListPartiesRequest();
    message.orgId = object.orgId ?? "";
    message.ledgerId = object.ledgerId ?? "";
    message.partyType = object.partyType ?? 0;
    message.activeOnly = object.activeOnly ?? false;
    message.pageSize = object.pageSize ?? 0;
    message.pageToken = object.pageToken ?? "";
    message.enrich = object.enrich ?? false;
    message.query = object.query ?? "";
    message.role = object.role ?? "";
    return message;
  },
};

function createBaseSearchPartiesRequest(): SearchPartiesRequest {
  return { orgId: "", query: "", partyType: 0, pageSize: 0, role: "" };
}

export const SearchPartiesRequest: MessageFns<SearchPartiesRequest> = {
  encode(message: SearchPartiesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgId !== "") {
      writer.uint32(10).string(message.orgId);
    }
    if (message.query !== "") {
      writer.uint32(18).string(message.query);
    }
    if (message.partyType !== 0) {
      writer.uint32(24).int32(message.partyType);
    }
    if (message.pageSize !== 0) {
      writer.uint32(32).int32(message.pageSize);
    }
    if (message.role !== "") {
      writer.uint32(42).string(message.role);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SearchPartiesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSearchPartiesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.query = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.partyType = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.pageSize = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.role = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SearchPartiesRequest {
    return {
      orgId: isSet(object.orgId)
        ? globalThis.String(object.orgId)
        : isSet(object.org_id)
        ? globalThis.String(object.org_id)
        : "",
      query: isSet(object.query) ? globalThis.String(object.query) : "",
      partyType: isSet(object.partyType)
        ? partyTypeFromJSON(object.partyType)
        : isSet(object.party_type)
        ? partyTypeFromJSON(object.party_type)
        : 0,
      pageSize: isSet(object.pageSize)
        ? globalThis.Number(object.pageSize)
        : isSet(object.page_size)
        ? globalThis.Number(object.page_size)
        : 0,
      role: isSet(object.role) ? globalThis.String(object.role) : "",
    };
  },

  toJSON(message: SearchPartiesRequest): unknown {
    const obj: any = {};
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.query !== "") {
      obj.query = message.query;
    }
    if (message.partyType !== 0) {
      obj.partyType = partyTypeToJSON(message.partyType);
    }
    if (message.pageSize !== 0) {
      obj.pageSize = Math.round(message.pageSize);
    }
    if (message.role !== "") {
      obj.role = message.role;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SearchPartiesRequest>, I>>(base?: I): SearchPartiesRequest {
    return SearchPartiesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SearchPartiesRequest>, I>>(object: I): SearchPartiesRequest {
    const message = createBaseSearchPartiesRequest();
    message.orgId = object.orgId ?? "";
    message.query = object.query ?? "";
    message.partyType = object.partyType ?? 0;
    message.pageSize = object.pageSize ?? 0;
    message.role = object.role ?? "";
    return message;
  },
};

function createBaseListAllPartiesRequest(): ListAllPartiesRequest {
  return { orgId: "", partyType: 0, activeOnly: false, query: "", pageSize: 0, pageToken: "", enrich: false, role: "" };
}

export const ListAllPartiesRequest: MessageFns<ListAllPartiesRequest> = {
  encode(message: ListAllPartiesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgId !== "") {
      writer.uint32(10).string(message.orgId);
    }
    if (message.partyType !== 0) {
      writer.uint32(16).int32(message.partyType);
    }
    if (message.activeOnly !== false) {
      writer.uint32(24).bool(message.activeOnly);
    }
    if (message.query !== "") {
      writer.uint32(34).string(message.query);
    }
    if (message.pageSize !== 0) {
      writer.uint32(40).int32(message.pageSize);
    }
    if (message.pageToken !== "") {
      writer.uint32(50).string(message.pageToken);
    }
    if (message.enrich !== false) {
      writer.uint32(56).bool(message.enrich);
    }
    if (message.role !== "") {
      writer.uint32(66).string(message.role);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListAllPartiesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListAllPartiesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.partyType = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.activeOnly = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.query = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.pageSize = reader.int32();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.pageToken = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.enrich = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.role = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListAllPartiesRequest {
    return {
      orgId: isSet(object.orgId)
        ? globalThis.String(object.orgId)
        : isSet(object.org_id)
        ? globalThis.String(object.org_id)
        : "",
      partyType: isSet(object.partyType)
        ? partyTypeFromJSON(object.partyType)
        : isSet(object.party_type)
        ? partyTypeFromJSON(object.party_type)
        : 0,
      activeOnly: isSet(object.activeOnly)
        ? globalThis.Boolean(object.activeOnly)
        : isSet(object.active_only)
        ? globalThis.Boolean(object.active_only)
        : false,
      query: isSet(object.query) ? globalThis.String(object.query) : "",
      pageSize: isSet(object.pageSize)
        ? globalThis.Number(object.pageSize)
        : isSet(object.page_size)
        ? globalThis.Number(object.page_size)
        : 0,
      pageToken: isSet(object.pageToken)
        ? globalThis.String(object.pageToken)
        : isSet(object.page_token)
        ? globalThis.String(object.page_token)
        : "",
      enrich: isSet(object.enrich) ? globalThis.Boolean(object.enrich) : false,
      role: isSet(object.role) ? globalThis.String(object.role) : "",
    };
  },

  toJSON(message: ListAllPartiesRequest): unknown {
    const obj: any = {};
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.partyType !== 0) {
      obj.partyType = partyTypeToJSON(message.partyType);
    }
    if (message.activeOnly !== false) {
      obj.activeOnly = message.activeOnly;
    }
    if (message.query !== "") {
      obj.query = message.query;
    }
    if (message.pageSize !== 0) {
      obj.pageSize = Math.round(message.pageSize);
    }
    if (message.pageToken !== "") {
      obj.pageToken = message.pageToken;
    }
    if (message.enrich !== false) {
      obj.enrich = message.enrich;
    }
    if (message.role !== "") {
      obj.role = message.role;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListAllPartiesRequest>, I>>(base?: I): ListAllPartiesRequest {
    return ListAllPartiesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListAllPartiesRequest>, I>>(object: I): ListAllPartiesRequest {
    const message = createBaseListAllPartiesRequest();
    message.orgId = object.orgId ?? "";
    message.partyType = object.partyType ?? 0;
    message.activeOnly = object.activeOnly ?? false;
    message.query = object.query ?? "";
    message.pageSize = object.pageSize ?? 0;
    message.pageToken = object.pageToken ?? "";
    message.enrich = object.enrich ?? false;
    message.role = object.role ?? "";
    return message;
  },
};

function createBaseListPartiesResponse(): ListPartiesResponse {
  return { parties: [], nextPageToken: "", totalCount: 0, remainingCount: 0, remainingIsExact: false };
}

export const ListPartiesResponse: MessageFns<ListPartiesResponse> = {
  encode(message: ListPartiesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.parties) {
      Party.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.nextPageToken !== "") {
      writer.uint32(18).string(message.nextPageToken);
    }
    if (message.totalCount !== 0) {
      writer.uint32(24).int32(message.totalCount);
    }
    if (message.remainingCount !== 0) {
      writer.uint32(32).int32(message.remainingCount);
    }
    if (message.remainingIsExact !== false) {
      writer.uint32(40).bool(message.remainingIsExact);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListPartiesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListPartiesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.parties.push(Party.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.nextPageToken = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.totalCount = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.remainingCount = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.remainingIsExact = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListPartiesResponse {
    return {
      parties: globalThis.Array.isArray(object?.parties) ? object.parties.map((e: any) => Party.fromJSON(e)) : [],
      nextPageToken: isSet(object.nextPageToken)
        ? globalThis.String(object.nextPageToken)
        : isSet(object.next_page_token)
        ? globalThis.String(object.next_page_token)
        : "",
      totalCount: isSet(object.totalCount)
        ? globalThis.Number(object.totalCount)
        : isSet(object.total_count)
        ? globalThis.Number(object.total_count)
        : 0,
      remainingCount: isSet(object.remainingCount)
        ? globalThis.Number(object.remainingCount)
        : isSet(object.remaining_count)
        ? globalThis.Number(object.remaining_count)
        : 0,
      remainingIsExact: isSet(object.remainingIsExact)
        ? globalThis.Boolean(object.remainingIsExact)
        : isSet(object.remaining_is_exact)
        ? globalThis.Boolean(object.remaining_is_exact)
        : false,
    };
  },

  toJSON(message: ListPartiesResponse): unknown {
    const obj: any = {};
    if (message.parties?.length) {
      obj.parties = message.parties.map((e) => Party.toJSON(e));
    }
    if (message.nextPageToken !== "") {
      obj.nextPageToken = message.nextPageToken;
    }
    if (message.totalCount !== 0) {
      obj.totalCount = Math.round(message.totalCount);
    }
    if (message.remainingCount !== 0) {
      obj.remainingCount = Math.round(message.remainingCount);
    }
    if (message.remainingIsExact !== false) {
      obj.remainingIsExact = message.remainingIsExact;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListPartiesResponse>, I>>(base?: I): ListPartiesResponse {
    return ListPartiesResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListPartiesResponse>, I>>(object: I): ListPartiesResponse {
    const message = createBaseListPartiesResponse();
    message.parties = object.parties?.map((e) => Party.fromPartial(e)) || [];
    message.nextPageToken = object.nextPageToken ?? "";
    message.totalCount = object.totalCount ?? 0;
    message.remainingCount = object.remainingCount ?? 0;
    message.remainingIsExact = object.remainingIsExact ?? false;
    return message;
  },
};

function createBaseInvoice(): Invoice {
  return {
    id: "",
    orgId: "",
    ledgerId: "",
    invoiceNumber: "",
    invoicePrefix: "",
    invoiceDate: "",
    dueDate: "",
    proformaNumber: "",
    proformaPrefix: "",
    invoiceType: 0,
    documentType: 0,
    partyId: "",
    partyName: "",
    partyGstin: "",
    partyAddress: "",
    partyBillingAddress: undefined,
    partyAddressLine1: "",
    partyAddressLine2: "",
    partyCity: "",
    partyState: "",
    partyStateCode: "",
    partyPostalCode: "",
    partyCountry: "",
    partyCountryCode: "",
    partyRole: undefined,
    placeOfSupply: "",
    placeOfSupplyCode: "",
    supplyType: 0,
    poNumber: "",
    supplierBillNumber: "",
    partyVendorCode: "",
    sellerName: "",
    sellerGstin: "",
    sellerAddress: "",
    sellerState: "",
    sellerStateCode: "",
    sellerBillingAddress: undefined,
    sellerPan: "",
    sellerLogoUrl: "",
    sellerContactEmail: "",
    sellerContactPhone: "",
    sellerWebsite: "",
    sellerAddressLine1: "",
    sellerAddressLine2: "",
    sellerCity: "",
    sellerPostalCode: "",
    sellerCountry: "",
    currency: "",
    exchangeRate: "",
    subtotal: "0",
    discountAmount: "0",
    taxableAmount: "0",
    cgstAmount: "0",
    sgstAmount: "0",
    igstAmount: "0",
    cessAmount: "0",
    totalTax: "0",
    totalAmount: "0",
    amountInWords: "",
    baseCurrency: "",
    baseSubtotal: "0",
    baseTotalTax: "0",
    baseTotalAmount: "0",
    paymentTerms: "",
    bankDetails: undefined,
    exportType: "",
    lutNumber: "",
    lutDate: "",
    countryOfDestination: "",
    countryOfDestinationCode: "",
    portOfLoading: "",
    portOfDischarge: "",
    portCode: "",
    modeOfTransport: "",
    vesselFlightNumber: "",
    blAwbNumber: "",
    containerNumbers: "",
    shippingBillNumber: "",
    shippingBillDate: "",
    shipToAddress: undefined,
    consigneeAddress: undefined,
    notifyPartyAddress: undefined,
    ewayBillNumber: "",
    ewayBillDate: "",
    vehicleNumber: "",
    transportMode: "",
    irn: "",
    irnDate: "",
    ackNumber: "",
    ackDate: "",
    signedQrCode: "",
    notes: "",
    termsConditions: "",
    status: 0,
    paymentStatus: 0,
    dueStatus: 0,
    daysOverdue: 0,
    paymentsReceived: "0",
    roundOffAmount: "0",
    journalEntryId: "",
    items: [],
    createdAt: undefined,
    updatedAt: undefined,
    createdBy: "",
    updatedBy: "",
    postedAt: undefined,
    postedBy: "",
    voidedAt: undefined,
    voidedBy: "",
    voidReason: "",
    isWalkIn: false,
    cashAccountId: "",
  };
}

export const Invoice: MessageFns<Invoice> = {
  encode(message: Invoice, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.orgId !== "") {
      writer.uint32(18).string(message.orgId);
    }
    if (message.ledgerId !== "") {
      writer.uint32(26).string(message.ledgerId);
    }
    if (message.invoiceNumber !== "") {
      writer.uint32(34).string(message.invoiceNumber);
    }
    if (message.invoicePrefix !== "") {
      writer.uint32(42).string(message.invoicePrefix);
    }
    if (message.invoiceDate !== "") {
      writer.uint32(50).string(message.invoiceDate);
    }
    if (message.dueDate !== "") {
      writer.uint32(58).string(message.dueDate);
    }
    if (message.proformaNumber !== "") {
      writer.uint32(810).string(message.proformaNumber);
    }
    if (message.proformaPrefix !== "") {
      writer.uint32(818).string(message.proformaPrefix);
    }
    if (message.invoiceType !== 0) {
      writer.uint32(64).int32(message.invoiceType);
    }
    if (message.documentType !== 0) {
      writer.uint32(72).int32(message.documentType);
    }
    if (message.partyId !== "") {
      writer.uint32(82).string(message.partyId);
    }
    if (message.partyName !== "") {
      writer.uint32(90).string(message.partyName);
    }
    if (message.partyGstin !== "") {
      writer.uint32(98).string(message.partyGstin);
    }
    if (message.partyAddress !== "") {
      writer.uint32(106).string(message.partyAddress);
    }
    if (message.partyBillingAddress !== undefined) {
      Address.encode(message.partyBillingAddress, writer.uint32(842).fork()).join();
    }
    if (message.partyAddressLine1 !== "") {
      writer.uint32(746).string(message.partyAddressLine1);
    }
    if (message.partyAddressLine2 !== "") {
      writer.uint32(754).string(message.partyAddressLine2);
    }
    if (message.partyCity !== "") {
      writer.uint32(762).string(message.partyCity);
    }
    if (message.partyState !== "") {
      writer.uint32(770).string(message.partyState);
    }
    if (message.partyStateCode !== "") {
      writer.uint32(778).string(message.partyStateCode);
    }
    if (message.partyPostalCode !== "") {
      writer.uint32(786).string(message.partyPostalCode);
    }
    if (message.partyCountry !== "") {
      writer.uint32(794).string(message.partyCountry);
    }
    if (message.partyCountryCode !== "") {
      writer.uint32(802).string(message.partyCountryCode);
    }
    if (message.partyRole !== undefined) {
      writer.uint32(986).string(message.partyRole);
    }
    if (message.placeOfSupply !== "") {
      writer.uint32(114).string(message.placeOfSupply);
    }
    if (message.placeOfSupplyCode !== "") {
      writer.uint32(122).string(message.placeOfSupplyCode);
    }
    if (message.supplyType !== 0) {
      writer.uint32(128).int32(message.supplyType);
    }
    if (message.poNumber !== "") {
      writer.uint32(730).string(message.poNumber);
    }
    if (message.supplierBillNumber !== "") {
      writer.uint32(978).string(message.supplierBillNumber);
    }
    if (message.partyVendorCode !== "") {
      writer.uint32(834).string(message.partyVendorCode);
    }
    if (message.sellerName !== "") {
      writer.uint32(138).string(message.sellerName);
    }
    if (message.sellerGstin !== "") {
      writer.uint32(146).string(message.sellerGstin);
    }
    if (message.sellerAddress !== "") {
      writer.uint32(154).string(message.sellerAddress);
    }
    if (message.sellerState !== "") {
      writer.uint32(162).string(message.sellerState);
    }
    if (message.sellerStateCode !== "") {
      writer.uint32(170).string(message.sellerStateCode);
    }
    if (message.sellerBillingAddress !== undefined) {
      Address.encode(message.sellerBillingAddress, writer.uint32(850).fork()).join();
    }
    if (message.sellerPan !== "") {
      writer.uint32(554).string(message.sellerPan);
    }
    if (message.sellerLogoUrl !== "") {
      writer.uint32(562).string(message.sellerLogoUrl);
    }
    if (message.sellerContactEmail !== "") {
      writer.uint32(570).string(message.sellerContactEmail);
    }
    if (message.sellerContactPhone !== "") {
      writer.uint32(578).string(message.sellerContactPhone);
    }
    if (message.sellerWebsite !== "") {
      writer.uint32(586).string(message.sellerWebsite);
    }
    if (message.sellerAddressLine1 !== "") {
      writer.uint32(594).string(message.sellerAddressLine1);
    }
    if (message.sellerAddressLine2 !== "") {
      writer.uint32(602).string(message.sellerAddressLine2);
    }
    if (message.sellerCity !== "") {
      writer.uint32(610).string(message.sellerCity);
    }
    if (message.sellerPostalCode !== "") {
      writer.uint32(618).string(message.sellerPostalCode);
    }
    if (message.sellerCountry !== "") {
      writer.uint32(626).string(message.sellerCountry);
    }
    if (message.currency !== "") {
      writer.uint32(178).string(message.currency);
    }
    if (message.exchangeRate !== "") {
      writer.uint32(186).string(message.exchangeRate);
    }
    if (message.subtotal !== "0") {
      writer.uint32(192).int64(message.subtotal);
    }
    if (message.discountAmount !== "0") {
      writer.uint32(200).int64(message.discountAmount);
    }
    if (message.taxableAmount !== "0") {
      writer.uint32(208).int64(message.taxableAmount);
    }
    if (message.cgstAmount !== "0") {
      writer.uint32(216).int64(message.cgstAmount);
    }
    if (message.sgstAmount !== "0") {
      writer.uint32(224).int64(message.sgstAmount);
    }
    if (message.igstAmount !== "0") {
      writer.uint32(232).int64(message.igstAmount);
    }
    if (message.cessAmount !== "0") {
      writer.uint32(240).int64(message.cessAmount);
    }
    if (message.totalTax !== "0") {
      writer.uint32(248).int64(message.totalTax);
    }
    if (message.totalAmount !== "0") {
      writer.uint32(256).int64(message.totalAmount);
    }
    if (message.amountInWords !== "") {
      writer.uint32(266).string(message.amountInWords);
    }
    if (message.baseCurrency !== "") {
      writer.uint32(274).string(message.baseCurrency);
    }
    if (message.baseSubtotal !== "0") {
      writer.uint32(280).int64(message.baseSubtotal);
    }
    if (message.baseTotalTax !== "0") {
      writer.uint32(288).int64(message.baseTotalTax);
    }
    if (message.baseTotalAmount !== "0") {
      writer.uint32(296).int64(message.baseTotalAmount);
    }
    if (message.paymentTerms !== "") {
      writer.uint32(306).string(message.paymentTerms);
    }
    if (message.bankDetails !== undefined) {
      BankDetails.encode(message.bankDetails, writer.uint32(314).fork()).join();
    }
    if (message.exportType !== "") {
      writer.uint32(322).string(message.exportType);
    }
    if (message.lutNumber !== "") {
      writer.uint32(330).string(message.lutNumber);
    }
    if (message.lutDate !== "") {
      writer.uint32(338).string(message.lutDate);
    }
    if (message.countryOfDestination !== "") {
      writer.uint32(346).string(message.countryOfDestination);
    }
    if (message.countryOfDestinationCode !== "") {
      writer.uint32(354).string(message.countryOfDestinationCode);
    }
    if (message.portOfLoading !== "") {
      writer.uint32(634).string(message.portOfLoading);
    }
    if (message.portOfDischarge !== "") {
      writer.uint32(642).string(message.portOfDischarge);
    }
    if (message.portCode !== "") {
      writer.uint32(650).string(message.portCode);
    }
    if (message.modeOfTransport !== "") {
      writer.uint32(658).string(message.modeOfTransport);
    }
    if (message.vesselFlightNumber !== "") {
      writer.uint32(666).string(message.vesselFlightNumber);
    }
    if (message.blAwbNumber !== "") {
      writer.uint32(674).string(message.blAwbNumber);
    }
    if (message.containerNumbers !== "") {
      writer.uint32(682).string(message.containerNumbers);
    }
    if (message.shippingBillNumber !== "") {
      writer.uint32(690).string(message.shippingBillNumber);
    }
    if (message.shippingBillDate !== "") {
      writer.uint32(698).string(message.shippingBillDate);
    }
    if (message.shipToAddress !== undefined) {
      Address.encode(message.shipToAddress, writer.uint32(706).fork()).join();
    }
    if (message.consigneeAddress !== undefined) {
      Address.encode(message.consigneeAddress, writer.uint32(714).fork()).join();
    }
    if (message.notifyPartyAddress !== undefined) {
      Address.encode(message.notifyPartyAddress, writer.uint32(722).fork()).join();
    }
    if (message.ewayBillNumber !== "") {
      writer.uint32(362).string(message.ewayBillNumber);
    }
    if (message.ewayBillDate !== "") {
      writer.uint32(370).string(message.ewayBillDate);
    }
    if (message.vehicleNumber !== "") {
      writer.uint32(378).string(message.vehicleNumber);
    }
    if (message.transportMode !== "") {
      writer.uint32(386).string(message.transportMode);
    }
    if (message.irn !== "") {
      writer.uint32(890).string(message.irn);
    }
    if (message.irnDate !== "") {
      writer.uint32(898).string(message.irnDate);
    }
    if (message.ackNumber !== "") {
      writer.uint32(906).string(message.ackNumber);
    }
    if (message.ackDate !== "") {
      writer.uint32(914).string(message.ackDate);
    }
    if (message.signedQrCode !== "") {
      writer.uint32(922).string(message.signedQrCode);
    }
    if (message.notes !== "") {
      writer.uint32(394).string(message.notes);
    }
    if (message.termsConditions !== "") {
      writer.uint32(402).string(message.termsConditions);
    }
    if (message.status !== 0) {
      writer.uint32(408).int32(message.status);
    }
    if (message.paymentStatus !== 0) {
      writer.uint32(824).int32(message.paymentStatus);
    }
    if (message.dueStatus !== 0) {
      writer.uint32(864).int32(message.dueStatus);
    }
    if (message.daysOverdue !== 0) {
      writer.uint32(872).int32(message.daysOverdue);
    }
    if (message.paymentsReceived !== "0") {
      writer.uint32(856).int64(message.paymentsReceived);
    }
    if (message.roundOffAmount !== "0") {
      writer.uint32(880).int64(message.roundOffAmount);
    }
    if (message.journalEntryId !== "") {
      writer.uint32(418).string(message.journalEntryId);
    }
    for (const v of message.items) {
      InvoiceItem.encode(v!, writer.uint32(426).fork()).join();
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(482).fork()).join();
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(490).fork()).join();
    }
    if (message.createdBy !== "") {
      writer.uint32(498).string(message.createdBy);
    }
    if (message.updatedBy !== "") {
      writer.uint32(506).string(message.updatedBy);
    }
    if (message.postedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.postedAt), writer.uint32(514).fork()).join();
    }
    if (message.postedBy !== "") {
      writer.uint32(522).string(message.postedBy);
    }
    if (message.voidedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.voidedAt), writer.uint32(530).fork()).join();
    }
    if (message.voidedBy !== "") {
      writer.uint32(538).string(message.voidedBy);
    }
    if (message.voidReason !== "") {
      writer.uint32(546).string(message.voidReason);
    }
    if (message.isWalkIn !== false) {
      writer.uint32(960).bool(message.isWalkIn);
    }
    if (message.cashAccountId !== "") {
      writer.uint32(970).string(message.cashAccountId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Invoice {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInvoice();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ledgerId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.invoiceNumber = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.invoicePrefix = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.invoiceDate = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.dueDate = reader.string();
          continue;
        }
        case 101: {
          if (tag !== 810) {
            break;
          }

          message.proformaNumber = reader.string();
          continue;
        }
        case 102: {
          if (tag !== 818) {
            break;
          }

          message.proformaPrefix = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.invoiceType = reader.int32() as any;
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.documentType = reader.int32() as any;
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.partyId = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.partyName = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.partyGstin = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.partyAddress = reader.string();
          continue;
        }
        case 105: {
          if (tag !== 842) {
            break;
          }

          message.partyBillingAddress = Address.decode(reader, reader.uint32());
          continue;
        }
        case 93: {
          if (tag !== 746) {
            break;
          }

          message.partyAddressLine1 = reader.string();
          continue;
        }
        case 94: {
          if (tag !== 754) {
            break;
          }

          message.partyAddressLine2 = reader.string();
          continue;
        }
        case 95: {
          if (tag !== 762) {
            break;
          }

          message.partyCity = reader.string();
          continue;
        }
        case 96: {
          if (tag !== 770) {
            break;
          }

          message.partyState = reader.string();
          continue;
        }
        case 97: {
          if (tag !== 778) {
            break;
          }

          message.partyStateCode = reader.string();
          continue;
        }
        case 98: {
          if (tag !== 786) {
            break;
          }

          message.partyPostalCode = reader.string();
          continue;
        }
        case 99: {
          if (tag !== 794) {
            break;
          }

          message.partyCountry = reader.string();
          continue;
        }
        case 100: {
          if (tag !== 802) {
            break;
          }

          message.partyCountryCode = reader.string();
          continue;
        }
        case 123: {
          if (tag !== 986) {
            break;
          }

          message.partyRole = reader.string();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.placeOfSupply = reader.string();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.placeOfSupplyCode = reader.string();
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.supplyType = reader.int32() as any;
          continue;
        }
        case 91: {
          if (tag !== 730) {
            break;
          }

          message.poNumber = reader.string();
          continue;
        }
        case 122: {
          if (tag !== 978) {
            break;
          }

          message.supplierBillNumber = reader.string();
          continue;
        }
        case 104: {
          if (tag !== 834) {
            break;
          }

          message.partyVendorCode = reader.string();
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.sellerName = reader.string();
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.sellerGstin = reader.string();
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.sellerAddress = reader.string();
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.sellerState = reader.string();
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.sellerStateCode = reader.string();
          continue;
        }
        case 106: {
          if (tag !== 850) {
            break;
          }

          message.sellerBillingAddress = Address.decode(reader, reader.uint32());
          continue;
        }
        case 69: {
          if (tag !== 554) {
            break;
          }

          message.sellerPan = reader.string();
          continue;
        }
        case 70: {
          if (tag !== 562) {
            break;
          }

          message.sellerLogoUrl = reader.string();
          continue;
        }
        case 71: {
          if (tag !== 570) {
            break;
          }

          message.sellerContactEmail = reader.string();
          continue;
        }
        case 72: {
          if (tag !== 578) {
            break;
          }

          message.sellerContactPhone = reader.string();
          continue;
        }
        case 73: {
          if (tag !== 586) {
            break;
          }

          message.sellerWebsite = reader.string();
          continue;
        }
        case 74: {
          if (tag !== 594) {
            break;
          }

          message.sellerAddressLine1 = reader.string();
          continue;
        }
        case 75: {
          if (tag !== 602) {
            break;
          }

          message.sellerAddressLine2 = reader.string();
          continue;
        }
        case 76: {
          if (tag !== 610) {
            break;
          }

          message.sellerCity = reader.string();
          continue;
        }
        case 77: {
          if (tag !== 618) {
            break;
          }

          message.sellerPostalCode = reader.string();
          continue;
        }
        case 78: {
          if (tag !== 626) {
            break;
          }

          message.sellerCountry = reader.string();
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.currency = reader.string();
          continue;
        }
        case 23: {
          if (tag !== 186) {
            break;
          }

          message.exchangeRate = reader.string();
          continue;
        }
        case 24: {
          if (tag !== 192) {
            break;
          }

          message.subtotal = reader.int64().toString();
          continue;
        }
        case 25: {
          if (tag !== 200) {
            break;
          }

          message.discountAmount = reader.int64().toString();
          continue;
        }
        case 26: {
          if (tag !== 208) {
            break;
          }

          message.taxableAmount = reader.int64().toString();
          continue;
        }
        case 27: {
          if (tag !== 216) {
            break;
          }

          message.cgstAmount = reader.int64().toString();
          continue;
        }
        case 28: {
          if (tag !== 224) {
            break;
          }

          message.sgstAmount = reader.int64().toString();
          continue;
        }
        case 29: {
          if (tag !== 232) {
            break;
          }

          message.igstAmount = reader.int64().toString();
          continue;
        }
        case 30: {
          if (tag !== 240) {
            break;
          }

          message.cessAmount = reader.int64().toString();
          continue;
        }
        case 31: {
          if (tag !== 248) {
            break;
          }

          message.totalTax = reader.int64().toString();
          continue;
        }
        case 32: {
          if (tag !== 256) {
            break;
          }

          message.totalAmount = reader.int64().toString();
          continue;
        }
        case 33: {
          if (tag !== 266) {
            break;
          }

          message.amountInWords = reader.string();
          continue;
        }
        case 34: {
          if (tag !== 274) {
            break;
          }

          message.baseCurrency = reader.string();
          continue;
        }
        case 35: {
          if (tag !== 280) {
            break;
          }

          message.baseSubtotal = reader.int64().toString();
          continue;
        }
        case 36: {
          if (tag !== 288) {
            break;
          }

          message.baseTotalTax = reader.int64().toString();
          continue;
        }
        case 37: {
          if (tag !== 296) {
            break;
          }

          message.baseTotalAmount = reader.int64().toString();
          continue;
        }
        case 38: {
          if (tag !== 306) {
            break;
          }

          message.paymentTerms = reader.string();
          continue;
        }
        case 39: {
          if (tag !== 314) {
            break;
          }

          message.bankDetails = BankDetails.decode(reader, reader.uint32());
          continue;
        }
        case 40: {
          if (tag !== 322) {
            break;
          }

          message.exportType = reader.string();
          continue;
        }
        case 41: {
          if (tag !== 330) {
            break;
          }

          message.lutNumber = reader.string();
          continue;
        }
        case 42: {
          if (tag !== 338) {
            break;
          }

          message.lutDate = reader.string();
          continue;
        }
        case 43: {
          if (tag !== 346) {
            break;
          }

          message.countryOfDestination = reader.string();
          continue;
        }
        case 44: {
          if (tag !== 354) {
            break;
          }

          message.countryOfDestinationCode = reader.string();
          continue;
        }
        case 79: {
          if (tag !== 634) {
            break;
          }

          message.portOfLoading = reader.string();
          continue;
        }
        case 80: {
          if (tag !== 642) {
            break;
          }

          message.portOfDischarge = reader.string();
          continue;
        }
        case 81: {
          if (tag !== 650) {
            break;
          }

          message.portCode = reader.string();
          continue;
        }
        case 82: {
          if (tag !== 658) {
            break;
          }

          message.modeOfTransport = reader.string();
          continue;
        }
        case 83: {
          if (tag !== 666) {
            break;
          }

          message.vesselFlightNumber = reader.string();
          continue;
        }
        case 84: {
          if (tag !== 674) {
            break;
          }

          message.blAwbNumber = reader.string();
          continue;
        }
        case 85: {
          if (tag !== 682) {
            break;
          }

          message.containerNumbers = reader.string();
          continue;
        }
        case 86: {
          if (tag !== 690) {
            break;
          }

          message.shippingBillNumber = reader.string();
          continue;
        }
        case 87: {
          if (tag !== 698) {
            break;
          }

          message.shippingBillDate = reader.string();
          continue;
        }
        case 88: {
          if (tag !== 706) {
            break;
          }

          message.shipToAddress = Address.decode(reader, reader.uint32());
          continue;
        }
        case 89: {
          if (tag !== 714) {
            break;
          }

          message.consigneeAddress = Address.decode(reader, reader.uint32());
          continue;
        }
        case 90: {
          if (tag !== 722) {
            break;
          }

          message.notifyPartyAddress = Address.decode(reader, reader.uint32());
          continue;
        }
        case 45: {
          if (tag !== 362) {
            break;
          }

          message.ewayBillNumber = reader.string();
          continue;
        }
        case 46: {
          if (tag !== 370) {
            break;
          }

          message.ewayBillDate = reader.string();
          continue;
        }
        case 47: {
          if (tag !== 378) {
            break;
          }

          message.vehicleNumber = reader.string();
          continue;
        }
        case 48: {
          if (tag !== 386) {
            break;
          }

          message.transportMode = reader.string();
          continue;
        }
        case 111: {
          if (tag !== 890) {
            break;
          }

          message.irn = reader.string();
          continue;
        }
        case 112: {
          if (tag !== 898) {
            break;
          }

          message.irnDate = reader.string();
          continue;
        }
        case 113: {
          if (tag !== 906) {
            break;
          }

          message.ackNumber = reader.string();
          continue;
        }
        case 114: {
          if (tag !== 914) {
            break;
          }

          message.ackDate = reader.string();
          continue;
        }
        case 115: {
          if (tag !== 922) {
            break;
          }

          message.signedQrCode = reader.string();
          continue;
        }
        case 49: {
          if (tag !== 394) {
            break;
          }

          message.notes = reader.string();
          continue;
        }
        case 50: {
          if (tag !== 402) {
            break;
          }

          message.termsConditions = reader.string();
          continue;
        }
        case 51: {
          if (tag !== 408) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 103: {
          if (tag !== 824) {
            break;
          }

          message.paymentStatus = reader.int32() as any;
          continue;
        }
        case 108: {
          if (tag !== 864) {
            break;
          }

          message.dueStatus = reader.int32() as any;
          continue;
        }
        case 109: {
          if (tag !== 872) {
            break;
          }

          message.daysOverdue = reader.int32();
          continue;
        }
        case 107: {
          if (tag !== 856) {
            break;
          }

          message.paymentsReceived = reader.int64().toString();
          continue;
        }
        case 110: {
          if (tag !== 880) {
            break;
          }

          message.roundOffAmount = reader.int64().toString();
          continue;
        }
        case 52: {
          if (tag !== 418) {
            break;
          }

          message.journalEntryId = reader.string();
          continue;
        }
        case 53: {
          if (tag !== 426) {
            break;
          }

          message.items.push(InvoiceItem.decode(reader, reader.uint32()));
          continue;
        }
        case 60: {
          if (tag !== 482) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 61: {
          if (tag !== 490) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 62: {
          if (tag !== 498) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 63: {
          if (tag !== 506) {
            break;
          }

          message.updatedBy = reader.string();
          continue;
        }
        case 64: {
          if (tag !== 514) {
            break;
          }

          message.postedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 65: {
          if (tag !== 522) {
            break;
          }

          message.postedBy = reader.string();
          continue;
        }
        case 66: {
          if (tag !== 530) {
            break;
          }

          message.voidedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 67: {
          if (tag !== 538) {
            break;
          }

          message.voidedBy = reader.string();
          continue;
        }
        case 68: {
          if (tag !== 546) {
            break;
          }

          message.voidReason = reader.string();
          continue;
        }
        case 120: {
          if (tag !== 960) {
            break;
          }

          message.isWalkIn = reader.bool();
          continue;
        }
        case 121: {
          if (tag !== 970) {
            break;
          }

          message.cashAccountId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Invoice {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      orgId: isSet(object.orgId)
        ? globalThis.String(object.orgId)
        : isSet(object.org_id)
        ? globalThis.String(object.org_id)
        : "",
      ledgerId: isSet(object.ledgerId)
        ? globalThis.String(object.ledgerId)
        : isSet(object.ledger_id)
        ? globalThis.String(object.ledger_id)
        : "",
      invoiceNumber: isSet(object.invoiceNumber)
        ? globalThis.String(object.invoiceNumber)
        : isSet(object.invoice_number)
        ? globalThis.String(object.invoice_number)
        : "",
      invoicePrefix: isSet(object.invoicePrefix)
        ? globalThis.String(object.invoicePrefix)
        : isSet(object.invoice_prefix)
        ? globalThis.String(object.invoice_prefix)
        : "",
      invoiceDate: isSet(object.invoiceDate)
        ? globalThis.String(object.invoiceDate)
        : isSet(object.invoice_date)
        ? globalThis.String(object.invoice_date)
        : "",
      dueDate: isSet(object.dueDate)
        ? globalThis.String(object.dueDate)
        : isSet(object.due_date)
        ? globalThis.String(object.due_date)
        : "",
      proformaNumber: isSet(object.proformaNumber)
        ? globalThis.String(object.proformaNumber)
        : isSet(object.proforma_number)
        ? globalThis.String(object.proforma_number)
        : "",
      proformaPrefix: isSet(object.proformaPrefix)
        ? globalThis.String(object.proformaPrefix)
        : isSet(object.proforma_prefix)
        ? globalThis.String(object.proforma_prefix)
        : "",
      invoiceType: isSet(object.invoiceType)
        ? invoiceTypeFromJSON(object.invoiceType)
        : isSet(object.invoice_type)
        ? invoiceTypeFromJSON(object.invoice_type)
        : 0,
      documentType: isSet(object.documentType)
        ? documentTypeFromJSON(object.documentType)
        : isSet(object.document_type)
        ? documentTypeFromJSON(object.document_type)
        : 0,
      partyId: isSet(object.partyId)
        ? globalThis.String(object.partyId)
        : isSet(object.party_id)
        ? globalThis.String(object.party_id)
        : "",
      partyName: isSet(object.partyName)
        ? globalThis.String(object.partyName)
        : isSet(object.party_name)
        ? globalThis.String(object.party_name)
        : "",
      partyGstin: isSet(object.partyGstin)
        ? globalThis.String(object.partyGstin)
        : isSet(object.party_gstin)
        ? globalThis.String(object.party_gstin)
        : "",
      partyAddress: isSet(object.partyAddress)
        ? globalThis.String(object.partyAddress)
        : isSet(object.party_address)
        ? globalThis.String(object.party_address)
        : "",
      partyBillingAddress: isSet(object.partyBillingAddress)
        ? Address.fromJSON(object.partyBillingAddress)
        : isSet(object.party_billing_address)
        ? Address.fromJSON(object.party_billing_address)
        : undefined,
      partyAddressLine1: isSet(object.partyAddressLine1)
        ? globalThis.String(object.partyAddressLine1)
        : isSet(object.party_address_line1)
        ? globalThis.String(object.party_address_line1)
        : "",
      partyAddressLine2: isSet(object.partyAddressLine2)
        ? globalThis.String(object.partyAddressLine2)
        : isSet(object.party_address_line2)
        ? globalThis.String(object.party_address_line2)
        : "",
      partyCity: isSet(object.partyCity)
        ? globalThis.String(object.partyCity)
        : isSet(object.party_city)
        ? globalThis.String(object.party_city)
        : "",
      partyState: isSet(object.partyState)
        ? globalThis.String(object.partyState)
        : isSet(object.party_state)
        ? globalThis.String(object.party_state)
        : "",
      partyStateCode: isSet(object.partyStateCode)
        ? globalThis.String(object.partyStateCode)
        : isSet(object.party_state_code)
        ? globalThis.String(object.party_state_code)
        : "",
      partyPostalCode: isSet(object.partyPostalCode)
        ? globalThis.String(object.partyPostalCode)
        : isSet(object.party_postal_code)
        ? globalThis.String(object.party_postal_code)
        : "",
      partyCountry: isSet(object.partyCountry)
        ? globalThis.String(object.partyCountry)
        : isSet(object.party_country)
        ? globalThis.String(object.party_country)
        : "",
      partyCountryCode: isSet(object.partyCountryCode)
        ? globalThis.String(object.partyCountryCode)
        : isSet(object.party_country_code)
        ? globalThis.String(object.party_country_code)
        : "",
      partyRole: isSet(object.partyRole)
        ? globalThis.String(object.partyRole)
        : isSet(object.party_role)
        ? globalThis.String(object.party_role)
        : undefined,
      placeOfSupply: isSet(object.placeOfSupply)
        ? globalThis.String(object.placeOfSupply)
        : isSet(object.place_of_supply)
        ? globalThis.String(object.place_of_supply)
        : "",
      placeOfSupplyCode: isSet(object.placeOfSupplyCode)
        ? globalThis.String(object.placeOfSupplyCode)
        : isSet(object.place_of_supply_code)
        ? globalThis.String(object.place_of_supply_code)
        : "",
      supplyType: isSet(object.supplyType)
        ? supplyTypeFromJSON(object.supplyType)
        : isSet(object.supply_type)
        ? supplyTypeFromJSON(object.supply_type)
        : 0,
      poNumber: isSet(object.poNumber)
        ? globalThis.String(object.poNumber)
        : isSet(object.po_number)
        ? globalThis.String(object.po_number)
        : "",
      supplierBillNumber: isSet(object.supplierBillNumber)
        ? globalThis.String(object.supplierBillNumber)
        : isSet(object.supplier_bill_number)
        ? globalThis.String(object.supplier_bill_number)
        : "",
      partyVendorCode: isSet(object.partyVendorCode)
        ? globalThis.String(object.partyVendorCode)
        : isSet(object.party_vendor_code)
        ? globalThis.String(object.party_vendor_code)
        : "",
      sellerName: isSet(object.sellerName)
        ? globalThis.String(object.sellerName)
        : isSet(object.seller_name)
        ? globalThis.String(object.seller_name)
        : "",
      sellerGstin: isSet(object.sellerGstin)
        ? globalThis.String(object.sellerGstin)
        : isSet(object.seller_gstin)
        ? globalThis.String(object.seller_gstin)
        : "",
      sellerAddress: isSet(object.sellerAddress)
        ? globalThis.String(object.sellerAddress)
        : isSet(object.seller_address)
        ? globalThis.String(object.seller_address)
        : "",
      sellerState: isSet(object.sellerState)
        ? globalThis.String(object.sellerState)
        : isSet(object.seller_state)
        ? globalThis.String(object.seller_state)
        : "",
      sellerStateCode: isSet(object.sellerStateCode)
        ? globalThis.String(object.sellerStateCode)
        : isSet(object.seller_state_code)
        ? globalThis.String(object.seller_state_code)
        : "",
      sellerBillingAddress: isSet(object.sellerBillingAddress)
        ? Address.fromJSON(object.sellerBillingAddress)
        : isSet(object.seller_billing_address)
        ? Address.fromJSON(object.seller_billing_address)
        : undefined,
      sellerPan: isSet(object.sellerPan)
        ? globalThis.String(object.sellerPan)
        : isSet(object.seller_pan)
        ? globalThis.String(object.seller_pan)
        : "",
      sellerLogoUrl: isSet(object.sellerLogoUrl)
        ? globalThis.String(object.sellerLogoUrl)
        : isSet(object.seller_logo_url)
        ? globalThis.String(object.seller_logo_url)
        : "",
      sellerContactEmail: isSet(object.sellerContactEmail)
        ? globalThis.String(object.sellerContactEmail)
        : isSet(object.seller_contact_email)
        ? globalThis.String(object.seller_contact_email)
        : "",
      sellerContactPhone: isSet(object.sellerContactPhone)
        ? globalThis.String(object.sellerContactPhone)
        : isSet(object.seller_contact_phone)
        ? globalThis.String(object.seller_contact_phone)
        : "",
      sellerWebsite: isSet(object.sellerWebsite)
        ? globalThis.String(object.sellerWebsite)
        : isSet(object.seller_website)
        ? globalThis.String(object.seller_website)
        : "",
      sellerAddressLine1: isSet(object.sellerAddressLine1)
        ? globalThis.String(object.sellerAddressLine1)
        : isSet(object.seller_address_line1)
        ? globalThis.String(object.seller_address_line1)
        : "",
      sellerAddressLine2: isSet(object.sellerAddressLine2)
        ? globalThis.String(object.sellerAddressLine2)
        : isSet(object.seller_address_line2)
        ? globalThis.String(object.seller_address_line2)
        : "",
      sellerCity: isSet(object.sellerCity)
        ? globalThis.String(object.sellerCity)
        : isSet(object.seller_city)
        ? globalThis.String(object.seller_city)
        : "",
      sellerPostalCode: isSet(object.sellerPostalCode)
        ? globalThis.String(object.sellerPostalCode)
        : isSet(object.seller_postal_code)
        ? globalThis.String(object.seller_postal_code)
        : "",
      sellerCountry: isSet(object.sellerCountry)
        ? globalThis.String(object.sellerCountry)
        : isSet(object.seller_country)
        ? globalThis.String(object.seller_country)
        : "",
      currency: isSet(object.currency) ? globalThis.String(object.currency) : "",
      exchangeRate: isSet(object.exchangeRate)
        ? globalThis.String(object.exchangeRate)
        : isSet(object.exchange_rate)
        ? globalThis.String(object.exchange_rate)
        : "",
      subtotal: isSet(object.subtotal) ? globalThis.String(object.subtotal) : "0",
      discountAmount: isSet(object.discountAmount)
        ? globalThis.String(object.discountAmount)
        : isSet(object.discount_amount)
        ? globalThis.String(object.discount_amount)
        : "0",
      taxableAmount: isSet(object.taxableAmount)
        ? globalThis.String(object.taxableAmount)
        : isSet(object.taxable_amount)
        ? globalThis.String(object.taxable_amount)
        : "0",
      cgstAmount: isSet(object.cgstAmount)
        ? globalThis.String(object.cgstAmount)
        : isSet(object.cgst_amount)
        ? globalThis.String(object.cgst_amount)
        : "0",
      sgstAmount: isSet(object.sgstAmount)
        ? globalThis.String(object.sgstAmount)
        : isSet(object.sgst_amount)
        ? globalThis.String(object.sgst_amount)
        : "0",
      igstAmount: isSet(object.igstAmount)
        ? globalThis.String(object.igstAmount)
        : isSet(object.igst_amount)
        ? globalThis.String(object.igst_amount)
        : "0",
      cessAmount: isSet(object.cessAmount)
        ? globalThis.String(object.cessAmount)
        : isSet(object.cess_amount)
        ? globalThis.String(object.cess_amount)
        : "0",
      totalTax: isSet(object.totalTax)
        ? globalThis.String(object.totalTax)
        : isSet(object.total_tax)
        ? globalThis.String(object.total_tax)
        : "0",
      totalAmount: isSet(object.totalAmount)
        ? globalThis.String(object.totalAmount)
        : isSet(object.total_amount)
        ? globalThis.String(object.total_amount)
        : "0",
      amountInWords: isSet(object.amountInWords)
        ? globalThis.String(object.amountInWords)
        : isSet(object.amount_in_words)
        ? globalThis.String(object.amount_in_words)
        : "",
      baseCurrency: isSet(object.baseCurrency)
        ? globalThis.String(object.baseCurrency)
        : isSet(object.base_currency)
        ? globalThis.String(object.base_currency)
        : "",
      baseSubtotal: isSet(object.baseSubtotal)
        ? globalThis.String(object.baseSubtotal)
        : isSet(object.base_subtotal)
        ? globalThis.String(object.base_subtotal)
        : "0",
      baseTotalTax: isSet(object.baseTotalTax)
        ? globalThis.String(object.baseTotalTax)
        : isSet(object.base_total_tax)
        ? globalThis.String(object.base_total_tax)
        : "0",
      baseTotalAmount: isSet(object.baseTotalAmount)
        ? globalThis.String(object.baseTotalAmount)
        : isSet(object.base_total_amount)
        ? globalThis.String(object.base_total_amount)
        : "0",
      paymentTerms: isSet(object.paymentTerms)
        ? globalThis.String(object.paymentTerms)
        : isSet(object.payment_terms)
        ? globalThis.String(object.payment_terms)
        : "",
      bankDetails: isSet(object.bankDetails)
        ? BankDetails.fromJSON(object.bankDetails)
        : isSet(object.bank_details)
        ? BankDetails.fromJSON(object.bank_details)
        : undefined,
      exportType: isSet(object.exportType)
        ? globalThis.String(object.exportType)
        : isSet(object.export_type)
        ? globalThis.String(object.export_type)
        : "",
      lutNumber: isSet(object.lutNumber)
        ? globalThis.String(object.lutNumber)
        : isSet(object.lut_number)
        ? globalThis.String(object.lut_number)
        : "",
      lutDate: isSet(object.lutDate)
        ? globalThis.String(object.lutDate)
        : isSet(object.lut_date)
        ? globalThis.String(object.lut_date)
        : "",
      countryOfDestination: isSet(object.countryOfDestination)
        ? globalThis.String(object.countryOfDestination)
        : isSet(object.country_of_destination)
        ? globalThis.String(object.country_of_destination)
        : "",
      countryOfDestinationCode: isSet(object.countryOfDestinationCode)
        ? globalThis.String(object.countryOfDestinationCode)
        : isSet(object.country_of_destination_code)
        ? globalThis.String(object.country_of_destination_code)
        : "",
      portOfLoading: isSet(object.portOfLoading)
        ? globalThis.String(object.portOfLoading)
        : isSet(object.port_of_loading)
        ? globalThis.String(object.port_of_loading)
        : "",
      portOfDischarge: isSet(object.portOfDischarge)
        ? globalThis.String(object.portOfDischarge)
        : isSet(object.port_of_discharge)
        ? globalThis.String(object.port_of_discharge)
        : "",
      portCode: isSet(object.portCode)
        ? globalThis.String(object.portCode)
        : isSet(object.port_code)
        ? globalThis.String(object.port_code)
        : "",
      modeOfTransport: isSet(object.modeOfTransport)
        ? globalThis.String(object.modeOfTransport)
        : isSet(object.mode_of_transport)
        ? globalThis.String(object.mode_of_transport)
        : "",
      vesselFlightNumber: isSet(object.vesselFlightNumber)
        ? globalThis.String(object.vesselFlightNumber)
        : isSet(object.vessel_flight_number)
        ? globalThis.String(object.vessel_flight_number)
        : "",
      blAwbNumber: isSet(object.blAwbNumber)
        ? globalThis.String(object.blAwbNumber)
        : isSet(object.bl_awb_number)
        ? globalThis.String(object.bl_awb_number)
        : "",
      containerNumbers: isSet(object.containerNumbers)
        ? globalThis.String(object.containerNumbers)
        : isSet(object.container_numbers)
        ? globalThis.String(object.container_numbers)
        : "",
      shippingBillNumber: isSet(object.shippingBillNumber)
        ? globalThis.String(object.shippingBillNumber)
        : isSet(object.shipping_bill_number)
        ? globalThis.String(object.shipping_bill_number)
        : "",
      shippingBillDate: isSet(object.shippingBillDate)
        ? globalThis.String(object.shippingBillDate)
        : isSet(object.shipping_bill_date)
        ? globalThis.String(object.shipping_bill_date)
        : "",
      shipToAddress: isSet(object.shipToAddress)
        ? Address.fromJSON(object.shipToAddress)
        : isSet(object.ship_to_address)
        ? Address.fromJSON(object.ship_to_address)
        : undefined,
      consigneeAddress: isSet(object.consigneeAddress)
        ? Address.fromJSON(object.consigneeAddress)
        : isSet(object.consignee_address)
        ? Address.fromJSON(object.consignee_address)
        : undefined,
      notifyPartyAddress: isSet(object.notifyPartyAddress)
        ? Address.fromJSON(object.notifyPartyAddress)
        : isSet(object.notify_party_address)
        ? Address.fromJSON(object.notify_party_address)
        : undefined,
      ewayBillNumber: isSet(object.ewayBillNumber)
        ? globalThis.String(object.ewayBillNumber)
        : isSet(object.eway_bill_number)
        ? globalThis.String(object.eway_bill_number)
        : "",
      ewayBillDate: isSet(object.ewayBillDate)
        ? globalThis.String(object.ewayBillDate)
        : isSet(object.eway_bill_date)
        ? globalThis.String(object.eway_bill_date)
        : "",
      vehicleNumber: isSet(object.vehicleNumber)
        ? globalThis.String(object.vehicleNumber)
        : isSet(object.vehicle_number)
        ? globalThis.String(object.vehicle_number)
        : "",
      transportMode: isSet(object.transportMode)
        ? globalThis.String(object.transportMode)
        : isSet(object.transport_mode)
        ? globalThis.String(object.transport_mode)
        : "",
      irn: isSet(object.irn) ? globalThis.String(object.irn) : "",
      irnDate: isSet(object.irnDate)
        ? globalThis.String(object.irnDate)
        : isSet(object.irn_date)
        ? globalThis.String(object.irn_date)
        : "",
      ackNumber: isSet(object.ackNumber)
        ? globalThis.String(object.ackNumber)
        : isSet(object.ack_number)
        ? globalThis.String(object.ack_number)
        : "",
      ackDate: isSet(object.ackDate)
        ? globalThis.String(object.ackDate)
        : isSet(object.ack_date)
        ? globalThis.String(object.ack_date)
        : "",
      signedQrCode: isSet(object.signedQrCode)
        ? globalThis.String(object.signedQrCode)
        : isSet(object.signed_qr_code)
        ? globalThis.String(object.signed_qr_code)
        : "",
      notes: isSet(object.notes) ? globalThis.String(object.notes) : "",
      termsConditions: isSet(object.termsConditions)
        ? globalThis.String(object.termsConditions)
        : isSet(object.terms_conditions)
        ? globalThis.String(object.terms_conditions)
        : "",
      status: isSet(object.status) ? invoiceStatusFromJSON(object.status) : 0,
      paymentStatus: isSet(object.paymentStatus)
        ? paymentStatusFromJSON(object.paymentStatus)
        : isSet(object.payment_status)
        ? paymentStatusFromJSON(object.payment_status)
        : 0,
      dueStatus: isSet(object.dueStatus)
        ? dueStatusFromJSON(object.dueStatus)
        : isSet(object.due_status)
        ? dueStatusFromJSON(object.due_status)
        : 0,
      daysOverdue: isSet(object.daysOverdue)
        ? globalThis.Number(object.daysOverdue)
        : isSet(object.days_overdue)
        ? globalThis.Number(object.days_overdue)
        : 0,
      paymentsReceived: isSet(object.paymentsReceived)
        ? globalThis.String(object.paymentsReceived)
        : isSet(object.payments_received)
        ? globalThis.String(object.payments_received)
        : "0",
      roundOffAmount: isSet(object.roundOffAmount)
        ? globalThis.String(object.roundOffAmount)
        : isSet(object.round_off_amount)
        ? globalThis.String(object.round_off_amount)
        : "0",
      journalEntryId: isSet(object.journalEntryId)
        ? globalThis.String(object.journalEntryId)
        : isSet(object.journal_entry_id)
        ? globalThis.String(object.journal_entry_id)
        : "",
      items: globalThis.Array.isArray(object?.items)
        ? object.items.map((e: any) => InvoiceItem.fromJSON(e))
        : [],
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : "",
      updatedBy: isSet(object.updatedBy)
        ? globalThis.String(object.updatedBy)
        : isSet(object.updated_by)
        ? globalThis.String(object.updated_by)
        : "",
      postedAt: isSet(object.postedAt)
        ? fromJsonTimestamp(object.postedAt)
        : isSet(object.posted_at)
        ? fromJsonTimestamp(object.posted_at)
        : undefined,
      postedBy: isSet(object.postedBy)
        ? globalThis.String(object.postedBy)
        : isSet(object.posted_by)
        ? globalThis.String(object.posted_by)
        : "",
      voidedAt: isSet(object.voidedAt)
        ? fromJsonTimestamp(object.voidedAt)
        : isSet(object.voided_at)
        ? fromJsonTimestamp(object.voided_at)
        : undefined,
      voidedBy: isSet(object.voidedBy)
        ? globalThis.String(object.voidedBy)
        : isSet(object.voided_by)
        ? globalThis.String(object.voided_by)
        : "",
      voidReason: isSet(object.voidReason)
        ? globalThis.String(object.voidReason)
        : isSet(object.void_reason)
        ? globalThis.String(object.void_reason)
        : "",
      isWalkIn: isSet(object.isWalkIn)
        ? globalThis.Boolean(object.isWalkIn)
        : isSet(object.is_walk_in)
        ? globalThis.Boolean(object.is_walk_in)
        : false,
      cashAccountId: isSet(object.cashAccountId)
        ? globalThis.String(object.cashAccountId)
        : isSet(object.cash_account_id)
        ? globalThis.String(object.cash_account_id)
        : "",
    };
  },

  toJSON(message: Invoice): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.ledgerId !== "") {
      obj.ledgerId = message.ledgerId;
    }
    if (message.invoiceNumber !== "") {
      obj.invoiceNumber = message.invoiceNumber;
    }
    if (message.invoicePrefix !== "") {
      obj.invoicePrefix = message.invoicePrefix;
    }
    if (message.invoiceDate !== "") {
      obj.invoiceDate = message.invoiceDate;
    }
    if (message.dueDate !== "") {
      obj.dueDate = message.dueDate;
    }
    if (message.proformaNumber !== "") {
      obj.proformaNumber = message.proformaNumber;
    }
    if (message.proformaPrefix !== "") {
      obj.proformaPrefix = message.proformaPrefix;
    }
    if (message.invoiceType !== 0) {
      obj.invoiceType = invoiceTypeToJSON(message.invoiceType);
    }
    if (message.documentType !== 0) {
      obj.documentType = documentTypeToJSON(message.documentType);
    }
    if (message.partyId !== "") {
      obj.partyId = message.partyId;
    }
    if (message.partyName !== "") {
      obj.partyName = message.partyName;
    }
    if (message.partyGstin !== "") {
      obj.partyGstin = message.partyGstin;
    }
    if (message.partyAddress !== "") {
      obj.partyAddress = message.partyAddress;
    }
    if (message.partyBillingAddress !== undefined) {
      obj.partyBillingAddress = Address.toJSON(message.partyBillingAddress);
    }
    if (message.partyAddressLine1 !== "") {
      obj.partyAddressLine1 = message.partyAddressLine1;
    }
    if (message.partyAddressLine2 !== "") {
      obj.partyAddressLine2 = message.partyAddressLine2;
    }
    if (message.partyCity !== "") {
      obj.partyCity = message.partyCity;
    }
    if (message.partyState !== "") {
      obj.partyState = message.partyState;
    }
    if (message.partyStateCode !== "") {
      obj.partyStateCode = message.partyStateCode;
    }
    if (message.partyPostalCode !== "") {
      obj.partyPostalCode = message.partyPostalCode;
    }
    if (message.partyCountry !== "") {
      obj.partyCountry = message.partyCountry;
    }
    if (message.partyCountryCode !== "") {
      obj.partyCountryCode = message.partyCountryCode;
    }
    if (message.partyRole !== undefined) {
      obj.partyRole = message.partyRole;
    }
    if (message.placeOfSupply !== "") {
      obj.placeOfSupply = message.placeOfSupply;
    }
    if (message.placeOfSupplyCode !== "") {
      obj.placeOfSupplyCode = message.placeOfSupplyCode;
    }
    if (message.supplyType !== 0) {
      obj.supplyType = supplyTypeToJSON(message.supplyType);
    }
    if (message.poNumber !== "") {
      obj.poNumber = message.poNumber;
    }
    if (message.supplierBillNumber !== "") {
      obj.supplierBillNumber = message.supplierBillNumber;
    }
    if (message.partyVendorCode !== "") {
      obj.partyVendorCode = message.partyVendorCode;
    }
    if (message.sellerName !== "") {
      obj.sellerName = message.sellerName;
    }
    if (message.sellerGstin !== "") {
      obj.sellerGstin = message.sellerGstin;
    }
    if (message.sellerAddress !== "") {
      obj.sellerAddress = message.sellerAddress;
    }
    if (message.sellerState !== "") {
      obj.sellerState = message.sellerState;
    }
    if (message.sellerStateCode !== "") {
      obj.sellerStateCode = message.sellerStateCode;
    }
    if (message.sellerBillingAddress !== undefined) {
      obj.sellerBillingAddress = Address.toJSON(message.sellerBillingAddress);
    }
    if (message.sellerPan !== "") {
      obj.sellerPan = message.sellerPan;
    }
    if (message.sellerLogoUrl !== "") {
      obj.sellerLogoUrl = message.sellerLogoUrl;
    }
    if (message.sellerContactEmail !== "") {
      obj.sellerContactEmail = message.sellerContactEmail;
    }
    if (message.sellerContactPhone !== "") {
      obj.sellerContactPhone = message.sellerContactPhone;
    }
    if (message.sellerWebsite !== "") {
      obj.sellerWebsite = message.sellerWebsite;
    }
    if (message.sellerAddressLine1 !== "") {
      obj.sellerAddressLine1 = message.sellerAddressLine1;
    }
    if (message.sellerAddressLine2 !== "") {
      obj.sellerAddressLine2 = message.sellerAddressLine2;
    }
    if (message.sellerCity !== "") {
      obj.sellerCity = message.sellerCity;
    }
    if (message.sellerPostalCode !== "") {
      obj.sellerPostalCode = message.sellerPostalCode;
    }
    if (message.sellerCountry !== "") {
      obj.sellerCountry = message.sellerCountry;
    }
    if (message.currency !== "") {
      obj.currency = message.currency;
    }
    if (message.exchangeRate !== "") {
      obj.exchangeRate = message.exchangeRate;
    }
    if (message.subtotal !== "0") {
      obj.subtotal = message.subtotal;
    }
    if (message.discountAmount !== "0") {
      obj.discountAmount = message.discountAmount;
    }
    if (message.taxableAmount !== "0") {
      obj.taxableAmount = message.taxableAmount;
    }
    if (message.cgstAmount !== "0") {
      obj.cgstAmount = message.cgstAmount;
    }
    if (message.sgstAmount !== "0") {
      obj.sgstAmount = message.sgstAmount;
    }
    if (message.igstAmount !== "0") {
      obj.igstAmount = message.igstAmount;
    }
    if (message.cessAmount !== "0") {
      obj.cessAmount = message.cessAmount;
    }
    if (message.totalTax !== "0") {
      obj.totalTax = message.totalTax;
    }
    if (message.totalAmount !== "0") {
      obj.totalAmount = message.totalAmount;
    }
    if (message.amountInWords !== "") {
      obj.amountInWords = message.amountInWords;
    }
    if (message.baseCurrency !== "") {
      obj.baseCurrency = message.baseCurrency;
    }
    if (message.baseSubtotal !== "0") {
      obj.baseSubtotal = message.baseSubtotal;
    }
    if (message.baseTotalTax !== "0") {
      obj.baseTotalTax = message.baseTotalTax;
    }
    if (message.baseTotalAmount !== "0") {
      obj.baseTotalAmount = message.baseTotalAmount;
    }
    if (message.paymentTerms !== "") {
      obj.paymentTerms = message.paymentTerms;
    }
    if (message.bankDetails !== undefined) {
      obj.bankDetails = BankDetails.toJSON(message.bankDetails);
    }
    if (message.exportType !== "") {
      obj.exportType = message.exportType;
    }
    if (message.lutNumber !== "") {
      obj.lutNumber = message.lutNumber;
    }
    if (message.lutDate !== "") {
      obj.lutDate = message.lutDate;
    }
    if (message.countryOfDestination !== "") {
      obj.countryOfDestination = message.countryOfDestination;
    }
    if (message.countryOfDestinationCode !== "") {
      obj.countryOfDestinationCode = message.countryOfDestinationCode;
    }
    if (message.portOfLoading !== "") {
      obj.portOfLoading = message.portOfLoading;
    }
    if (message.portOfDischarge !== "") {
      obj.portOfDischarge = message.portOfDischarge;
    }
    if (message.portCode !== "") {
      obj.portCode = message.portCode;
    }
    if (message.modeOfTransport !== "") {
      obj.modeOfTransport = message.modeOfTransport;
    }
    if (message.vesselFlightNumber !== "") {
      obj.vesselFlightNumber = message.vesselFlightNumber;
    }
    if (message.blAwbNumber !== "") {
      obj.blAwbNumber = message.blAwbNumber;
    }
    if (message.containerNumbers !== "") {
      obj.containerNumbers = message.containerNumbers;
    }
    if (message.shippingBillNumber !== "") {
      obj.shippingBillNumber = message.shippingBillNumber;
    }
    if (message.shippingBillDate !== "") {
      obj.shippingBillDate = message.shippingBillDate;
    }
    if (message.shipToAddress !== undefined) {
      obj.shipToAddress = Address.toJSON(message.shipToAddress);
    }
    if (message.consigneeAddress !== undefined) {
      obj.consigneeAddress = Address.toJSON(message.consigneeAddress);
    }
    if (message.notifyPartyAddress !== undefined) {
      obj.notifyPartyAddress = Address.toJSON(message.notifyPartyAddress);
    }
    if (message.ewayBillNumber !== "") {
      obj.ewayBillNumber = message.ewayBillNumber;
    }
    if (message.ewayBillDate !== "") {
      obj.ewayBillDate = message.ewayBillDate;
    }
    if (message.vehicleNumber !== "") {
      obj.vehicleNumber = message.vehicleNumber;
    }
    if (message.transportMode !== "") {
      obj.transportMode = message.transportMode;
    }
    if (message.irn !== "") {
      obj.irn = message.irn;
    }
    if (message.irnDate !== "") {
      obj.irnDate = message.irnDate;
    }
    if (message.ackNumber !== "") {
      obj.ackNumber = message.ackNumber;
    }
    if (message.ackDate !== "") {
      obj.ackDate = message.ackDate;
    }
    if (message.signedQrCode !== "") {
      obj.signedQrCode = message.signedQrCode;
    }
    if (message.notes !== "") {
      obj.notes = message.notes;
    }
    if (message.termsConditions !== "") {
      obj.termsConditions = message.termsConditions;
    }
    if (message.status !== 0) {
      obj.status = invoiceStatusToJSON(message.status);
    }
    if (message.paymentStatus !== 0) {
      obj.paymentStatus = paymentStatusToJSON(message.paymentStatus);
    }
    if (message.dueStatus !== 0) {
      obj.dueStatus = dueStatusToJSON(message.dueStatus);
    }
    if (message.daysOverdue !== 0) {
      obj.daysOverdue = Math.round(message.daysOverdue);
    }
    if (message.paymentsReceived !== "0") {
      obj.paymentsReceived = message.paymentsReceived;
    }
    if (message.roundOffAmount !== "0") {
      obj.roundOffAmount = message.roundOffAmount;
    }
    if (message.journalEntryId !== "") {
      obj.journalEntryId = message.journalEntryId;
    }
    if (message.items?.length) {
      obj.items = message.items.map((e) => InvoiceItem.toJSON(e));
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.updatedBy !== "") {
      obj.updatedBy = message.updatedBy;
    }
    if (message.postedAt !== undefined) {
      obj.postedAt = message.postedAt.toISOString();
    }
    if (message.postedBy !== "") {
      obj.postedBy = message.postedBy;
    }
    if (message.voidedAt !== undefined) {
      obj.voidedAt = message.voidedAt.toISOString();
    }
    if (message.voidedBy !== "") {
      obj.voidedBy = message.voidedBy;
    }
    if (message.voidReason !== "") {
      obj.voidReason = message.voidReason;
    }
    if (message.isWalkIn !== false) {
      obj.isWalkIn = message.isWalkIn;
    }
    if (message.cashAccountId !== "") {
      obj.cashAccountId = message.cashAccountId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Invoice>, I>>(base?: I): Invoice {
    return Invoice.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Invoice>, I>>(object: I): Invoice {
    const message = createBaseInvoice();
    message.id = object.id ?? "";
    message.orgId = object.orgId ?? "";
    message.ledgerId = object.ledgerId ?? "";
    message.invoiceNumber = object.invoiceNumber ?? "";
    message.invoicePrefix = object.invoicePrefix ?? "";
    message.invoiceDate = object.invoiceDate ?? "";
    message.dueDate = object.dueDate ?? "";
    message.proformaNumber = object.proformaNumber ?? "";
    message.proformaPrefix = object.proformaPrefix ?? "";
    message.invoiceType = object.invoiceType ?? 0;
    message.documentType = object.documentType ?? 0;
    message.partyId = object.partyId ?? "";
    message.partyName = object.partyName ?? "";
    message.partyGstin = object.partyGstin ?? "";
    message.partyAddress = object.partyAddress ?? "";
    message.partyBillingAddress = (object.partyBillingAddress !== undefined && object.partyBillingAddress !== null)
      ? Address.fromPartial(object.partyBillingAddress)
      : undefined;
    message.partyAddressLine1 = object.partyAddressLine1 ?? "";
    message.partyAddressLine2 = object.partyAddressLine2 ?? "";
    message.partyCity = object.partyCity ?? "";
    message.partyState = object.partyState ?? "";
    message.partyStateCode = object.partyStateCode ?? "";
    message.partyPostalCode = object.partyPostalCode ?? "";
    message.partyCountry = object.partyCountry ?? "";
    message.partyCountryCode = object.partyCountryCode ?? "";
    message.partyRole = object.partyRole ?? undefined;
    message.placeOfSupply = object.placeOfSupply ?? "";
    message.placeOfSupplyCode = object.placeOfSupplyCode ?? "";
    message.supplyType = object.supplyType ?? 0;
    message.poNumber = object.poNumber ?? "";
    message.supplierBillNumber = object.supplierBillNumber ?? "";
    message.partyVendorCode = object.partyVendorCode ?? "";
    message.sellerName = object.sellerName ?? "";
    message.sellerGstin = object.sellerGstin ?? "";
    message.sellerAddress = object.sellerAddress ?? "";
    message.sellerState = object.sellerState ?? "";
    message.sellerStateCode = object.sellerStateCode ?? "";
    message.sellerBillingAddress = (object.sellerBillingAddress !== undefined && object.sellerBillingAddress !== null)
      ? Address.fromPartial(object.sellerBillingAddress)
      : undefined;
    message.sellerPan = object.sellerPan ?? "";
    message.sellerLogoUrl = object.sellerLogoUrl ?? "";
    message.sellerContactEmail = object.sellerContactEmail ?? "";
    message.sellerContactPhone = object.sellerContactPhone ?? "";
    message.sellerWebsite = object.sellerWebsite ?? "";
    message.sellerAddressLine1 = object.sellerAddressLine1 ?? "";
    message.sellerAddressLine2 = object.sellerAddressLine2 ?? "";
    message.sellerCity = object.sellerCity ?? "";
    message.sellerPostalCode = object.sellerPostalCode ?? "";
    message.sellerCountry = object.sellerCountry ?? "";
    message.currency = object.currency ?? "";
    message.exchangeRate = object.exchangeRate ?? "";
    message.subtotal = object.subtotal ?? "0";
    message.discountAmount = object.discountAmount ?? "0";
    message.taxableAmount = object.taxableAmount ?? "0";
    message.cgstAmount = object.cgstAmount ?? "0";
    message.sgstAmount = object.sgstAmount ?? "0";
    message.igstAmount = object.igstAmount ?? "0";
    message.cessAmount = object.cessAmount ?? "0";
    message.totalTax = object.totalTax ?? "0";
    message.totalAmount = object.totalAmount ?? "0";
    message.amountInWords = object.amountInWords ?? "";
    message.baseCurrency = object.baseCurrency ?? "";
    message.baseSubtotal = object.baseSubtotal ?? "0";
    message.baseTotalTax = object.baseTotalTax ?? "0";
    message.baseTotalAmount = object.baseTotalAmount ?? "0";
    message.paymentTerms = object.paymentTerms ?? "";
    message.bankDetails = (object.bankDetails !== undefined && object.bankDetails !== null)
      ? BankDetails.fromPartial(object.bankDetails)
      : undefined;
    message.exportType = object.exportType ?? "";
    message.lutNumber = object.lutNumber ?? "";
    message.lutDate = object.lutDate ?? "";
    message.countryOfDestination = object.countryOfDestination ?? "";
    message.countryOfDestinationCode = object.countryOfDestinationCode ?? "";
    message.portOfLoading = object.portOfLoading ?? "";
    message.portOfDischarge = object.portOfDischarge ?? "";
    message.portCode = object.portCode ?? "";
    message.modeOfTransport = object.modeOfTransport ?? "";
    message.vesselFlightNumber = object.vesselFlightNumber ?? "";
    message.blAwbNumber = object.blAwbNumber ?? "";
    message.containerNumbers = object.containerNumbers ?? "";
    message.shippingBillNumber = object.shippingBillNumber ?? "";
    message.shippingBillDate = object.shippingBillDate ?? "";
    message.shipToAddress = (object.shipToAddress !== undefined && object.shipToAddress !== null)
      ? Address.fromPartial(object.shipToAddress)
      : undefined;
    message.consigneeAddress = (object.consigneeAddress !== undefined && object.consigneeAddress !== null)
      ? Address.fromPartial(object.consigneeAddress)
      : undefined;
    message.notifyPartyAddress = (object.notifyPartyAddress !== undefined && object.notifyPartyAddress !== null)
      ? Address.fromPartial(object.notifyPartyAddress)
      : undefined;
    message.ewayBillNumber = object.ewayBillNumber ?? "";
    message.ewayBillDate = object.ewayBillDate ?? "";
    message.vehicleNumber = object.vehicleNumber ?? "";
    message.transportMode = object.transportMode ?? "";
    message.irn = object.irn ?? "";
    message.irnDate = object.irnDate ?? "";
    message.ackNumber = object.ackNumber ?? "";
    message.ackDate = object.ackDate ?? "";
    message.signedQrCode = object.signedQrCode ?? "";
    message.notes = object.notes ?? "";
    message.termsConditions = object.termsConditions ?? "";
    message.status = object.status ?? 0;
    message.paymentStatus = object.paymentStatus ?? 0;
    message.dueStatus = object.dueStatus ?? 0;
    message.daysOverdue = object.daysOverdue ?? 0;
    message.paymentsReceived = object.paymentsReceived ?? "0";
    message.roundOffAmount = object.roundOffAmount ?? "0";
    message.journalEntryId = object.journalEntryId ?? "";
    message.items = object.items?.map((e) => InvoiceItem.fromPartial(e)) || [];
    message.createdAt = object.createdAt ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    message.createdBy = object.createdBy ?? "";
    message.updatedBy = object.updatedBy ?? "";
    message.postedAt = object.postedAt ?? undefined;
    message.postedBy = object.postedBy ?? "";
    message.voidedAt = object.voidedAt ?? undefined;
    message.voidedBy = object.voidedBy ?? "";
    message.voidReason = object.voidReason ?? "";
    message.isWalkIn = object.isWalkIn ?? false;
    message.cashAccountId = object.cashAccountId ?? "";
    return message;
  },
};

function createBaseInvoiceItem(): InvoiceItem {
  return {
    id: "",
    lineNumber: 0,
    itemCode: "",
    description: "",
    hsnCode: "",
    sacCode: "",
    quantity: "",
    unit: "",
    unitPrice: "0",
    grossAmount: "0",
    discountPercent: "",
    discountAmount: "0",
    taxableAmount: "0",
    cgstRate: "",
    sgstRate: "",
    igstRate: "",
    cessRate: "",
    cgstAmount: "0",
    sgstAmount: "0",
    igstAmount: "0",
    cessAmount: "0",
    totalTax: "0",
    totalAmount: "0",
    itemId: undefined,
    accountId: undefined,
  };
}

export const InvoiceItem: MessageFns<InvoiceItem> = {
  encode(message: InvoiceItem, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.lineNumber !== 0) {
      writer.uint32(16).int32(message.lineNumber);
    }
    if (message.itemCode !== "") {
      writer.uint32(26).string(message.itemCode);
    }
    if (message.description !== "") {
      writer.uint32(34).string(message.description);
    }
    if (message.hsnCode !== "") {
      writer.uint32(42).string(message.hsnCode);
    }
    if (message.sacCode !== "") {
      writer.uint32(50).string(message.sacCode);
    }
    if (message.quantity !== "") {
      writer.uint32(58).string(message.quantity);
    }
    if (message.unit !== "") {
      writer.uint32(66).string(message.unit);
    }
    if (message.unitPrice !== "0") {
      writer.uint32(72).int64(message.unitPrice);
    }
    if (message.grossAmount !== "0") {
      writer.uint32(80).int64(message.grossAmount);
    }
    if (message.discountPercent !== "") {
      writer.uint32(90).string(message.discountPercent);
    }
    if (message.discountAmount !== "0") {
      writer.uint32(96).int64(message.discountAmount);
    }
    if (message.taxableAmount !== "0") {
      writer.uint32(104).int64(message.taxableAmount);
    }
    if (message.cgstRate !== "") {
      writer.uint32(114).string(message.cgstRate);
    }
    if (message.sgstRate !== "") {
      writer.uint32(122).string(message.sgstRate);
    }
    if (message.igstRate !== "") {
      writer.uint32(130).string(message.igstRate);
    }
    if (message.cessRate !== "") {
      writer.uint32(138).string(message.cessRate);
    }
    if (message.cgstAmount !== "0") {
      writer.uint32(144).int64(message.cgstAmount);
    }
    if (message.sgstAmount !== "0") {
      writer.uint32(152).int64(message.sgstAmount);
    }
    if (message.igstAmount !== "0") {
      writer.uint32(160).int64(message.igstAmount);
    }
    if (message.cessAmount !== "0") {
      writer.uint32(168).int64(message.cessAmount);
    }
    if (message.totalTax !== "0") {
      writer.uint32(176).int64(message.totalTax);
    }
    if (message.totalAmount !== "0") {
      writer.uint32(184).int64(message.totalAmount);
    }
    if (message.itemId !== undefined) {
      writer.uint32(194).string(message.itemId);
    }
    if (message.accountId !== undefined) {
      writer.uint32(202).string(message.accountId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InvoiceItem {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInvoiceItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.lineNumber = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.itemCode = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.hsnCode = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.sacCode = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.quantity = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.unit = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.unitPrice = reader.int64().toString();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.grossAmount = reader.int64().toString();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.discountPercent = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.discountAmount = reader.int64().toString();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.taxableAmount = reader.int64().toString();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.cgstRate = reader.string();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.sgstRate = reader.string();
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.igstRate = reader.string();
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.cessRate = reader.string();
          continue;
        }
        case 18: {
          if (tag !== 144) {
            break;
          }

          message.cgstAmount = reader.int64().toString();
          continue;
        }
        case 19: {
          if (tag !== 152) {
            break;
          }

          message.sgstAmount = reader.int64().toString();
          continue;
        }
        case 20: {
          if (tag !== 160) {
            break;
          }

          message.igstAmount = reader.int64().toString();
          continue;
        }
        case 21: {
          if (tag !== 168) {
            break;
          }

          message.cessAmount = reader.int64().toString();
          continue;
        }
        case 22: {
          if (tag !== 176) {
            break;
          }

          message.totalTax = reader.int64().toString();
          continue;
        }
        case 23: {
          if (tag !== 184) {
            break;
          }

          message.totalAmount = reader.int64().toString();
          continue;
        }
        case 24: {
          if (tag !== 194) {
            break;
          }

          message.itemId = reader.string();
          continue;
        }
        case 25: {
          if (tag !== 202) {
            break;
          }

          message.accountId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InvoiceItem {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      lineNumber: isSet(object.lineNumber)
        ? globalThis.Number(object.lineNumber)
        : isSet(object.line_number)
        ? globalThis.Number(object.line_number)
        : 0,
      itemCode: isSet(object.itemCode)
        ? globalThis.String(object.itemCode)
        : isSet(object.item_code)
        ? globalThis.String(object.item_code)
        : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      hsnCode: isSet(object.hsnCode)
        ? globalThis.String(object.hsnCode)
        : isSet(object.hsn_code)
        ? globalThis.String(object.hsn_code)
        : "",
      sacCode: isSet(object.sacCode)
        ? globalThis.String(object.sacCode)
        : isSet(object.sac_code)
        ? globalThis.String(object.sac_code)
        : "",
      quantity: isSet(object.quantity) ? globalThis.String(object.quantity) : "",
      unit: isSet(object.unit) ? globalThis.String(object.unit) : "",
      unitPrice: isSet(object.unitPrice)
        ? globalThis.String(object.unitPrice)
        : isSet(object.unit_price)
        ? globalThis.String(object.unit_price)
        : "0",
      grossAmount: isSet(object.grossAmount)
        ? globalThis.String(object.grossAmount)
        : isSet(object.gross_amount)
        ? globalThis.String(object.gross_amount)
        : "0",
      discountPercent: isSet(object.discountPercent)
        ? globalThis.String(object.discountPercent)
        : isSet(object.discount_percent)
        ? globalThis.String(object.discount_percent)
        : "",
      discountAmount: isSet(object.discountAmount)
        ? globalThis.String(object.discountAmount)
        : isSet(object.discount_amount)
        ? globalThis.String(object.discount_amount)
        : "0",
      taxableAmount: isSet(object.taxableAmount)
        ? globalThis.String(object.taxableAmount)
        : isSet(object.taxable_amount)
        ? globalThis.String(object.taxable_amount)
        : "0",
      cgstRate: isSet(object.cgstRate)
        ? globalThis.String(object.cgstRate)
        : isSet(object.cgst_rate)
        ? globalThis.String(object.cgst_rate)
        : "",
      sgstRate: isSet(object.sgstRate)
        ? globalThis.String(object.sgstRate)
        : isSet(object.sgst_rate)
        ? globalThis.String(object.sgst_rate)
        : "",
      igstRate: isSet(object.igstRate)
        ? globalThis.String(object.igstRate)
        : isSet(object.igst_rate)
        ? globalThis.String(object.igst_rate)
        : "",
      cessRate: isSet(object.cessRate)
        ? globalThis.String(object.cessRate)
        : isSet(object.cess_rate)
        ? globalThis.String(object.cess_rate)
        : "",
      cgstAmount: isSet(object.cgstAmount)
        ? globalThis.String(object.cgstAmount)
        : isSet(object.cgst_amount)
        ? globalThis.String(object.cgst_amount)
        : "0",
      sgstAmount: isSet(object.sgstAmount)
        ? globalThis.String(object.sgstAmount)
        : isSet(object.sgst_amount)
        ? globalThis.String(object.sgst_amount)
        : "0",
      igstAmount: isSet(object.igstAmount)
        ? globalThis.String(object.igstAmount)
        : isSet(object.igst_amount)
        ? globalThis.String(object.igst_amount)
        : "0",
      cessAmount: isSet(object.cessAmount)
        ? globalThis.String(object.cessAmount)
        : isSet(object.cess_amount)
        ? globalThis.String(object.cess_amount)
        : "0",
      totalTax: isSet(object.totalTax)
        ? globalThis.String(object.totalTax)
        : isSet(object.total_tax)
        ? globalThis.String(object.total_tax)
        : "0",
      totalAmount: isSet(object.totalAmount)
        ? globalThis.String(object.totalAmount)
        : isSet(object.total_amount)
        ? globalThis.String(object.total_amount)
        : "0",
      itemId: isSet(object.itemId)
        ? globalThis.String(object.itemId)
        : isSet(object.item_id)
        ? globalThis.String(object.item_id)
        : undefined,
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
        ? globalThis.String(object.account_id)
        : undefined,
    };
  },

  toJSON(message: InvoiceItem): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.lineNumber !== 0) {
      obj.lineNumber = Math.round(message.lineNumber);
    }
    if (message.itemCode !== "") {
      obj.itemCode = message.itemCode;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.hsnCode !== "") {
      obj.hsnCode = message.hsnCode;
    }
    if (message.sacCode !== "") {
      obj.sacCode = message.sacCode;
    }
    if (message.quantity !== "") {
      obj.quantity = message.quantity;
    }
    if (message.unit !== "") {
      obj.unit = message.unit;
    }
    if (message.unitPrice !== "0") {
      obj.unitPrice = message.unitPrice;
    }
    if (message.grossAmount !== "0") {
      obj.grossAmount = message.grossAmount;
    }
    if (message.discountPercent !== "") {
      obj.discountPercent = message.discountPercent;
    }
    if (message.discountAmount !== "0") {
      obj.discountAmount = message.discountAmount;
    }
    if (message.taxableAmount !== "0") {
      obj.taxableAmount = message.taxableAmount;
    }
    if (message.cgstRate !== "") {
      obj.cgstRate = message.cgstRate;
    }
    if (message.sgstRate !== "") {
      obj.sgstRate = message.sgstRate;
    }
    if (message.igstRate !== "") {
      obj.igstRate = message.igstRate;
    }
    if (message.cessRate !== "") {
      obj.cessRate = message.cessRate;
    }
    if (message.cgstAmount !== "0") {
      obj.cgstAmount = message.cgstAmount;
    }
    if (message.sgstAmount !== "0") {
      obj.sgstAmount = message.sgstAmount;
    }
    if (message.igstAmount !== "0") {
      obj.igstAmount = message.igstAmount;
    }
    if (message.cessAmount !== "0") {
      obj.cessAmount = message.cessAmount;
    }
    if (message.totalTax !== "0") {
      obj.totalTax = message.totalTax;
    }
    if (message.totalAmount !== "0") {
      obj.totalAmount = message.totalAmount;
    }
    if (message.itemId !== undefined) {
      obj.itemId = message.itemId;
    }
    if (message.accountId !== undefined) {
      obj.accountId = message.accountId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<InvoiceItem>, I>>(base?: I): InvoiceItem {
    return InvoiceItem.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InvoiceItem>, I>>(object: I): InvoiceItem {
    const message = createBaseInvoiceItem();
    message.id = object.id ?? "";
    message.lineNumber = object.lineNumber ?? 0;
    message.itemCode = object.itemCode ?? "";
    message.description = object.description ?? "";
    message.hsnCode = object.hsnCode ?? "";
    message.sacCode = object.sacCode ?? "";
    message.quantity = object.quantity ?? "";
    message.unit = object.unit ?? "";
    message.unitPrice = object.unitPrice ?? "0";
    message.grossAmount = object.grossAmount ?? "0";
    message.discountPercent = object.discountPercent ?? "";
    message.discountAmount = object.discountAmount ?? "0";
    message.taxableAmount = object.taxableAmount ?? "0";
    message.cgstRate = object.cgstRate ?? "";
    message.sgstRate = object.sgstRate ?? "";
    message.igstRate = object.igstRate ?? "";
    message.cessRate = object.cessRate ?? "";
    message.cgstAmount = object.cgstAmount ?? "0";
    message.sgstAmount = object.sgstAmount ?? "0";
    message.igstAmount = object.igstAmount ?? "0";
    message.cessAmount = object.cessAmount ?? "0";
    message.totalTax = object.totalTax ?? "0";
    message.totalAmount = object.totalAmount ?? "0";
    message.itemId = object.itemId ?? undefined;
    message.accountId = object.accountId ?? undefined;
    return message;
  },
};

function createBaseBankDetails(): BankDetails {
  return {
    bankName: "",
    accountName: "",
    accountNumber: "",
    ifsc: "",
    branch: "",
    swiftCode: "",
    iban: "",
    routingNumber: "",
    sortCode: "",
  };
}

export const BankDetails: MessageFns<BankDetails> = {
  encode(message: BankDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.bankName !== "") {
      writer.uint32(10).string(message.bankName);
    }
    if (message.accountName !== "") {
      writer.uint32(18).string(message.accountName);
    }
    if (message.accountNumber !== "") {
      writer.uint32(26).string(message.accountNumber);
    }
    if (message.ifsc !== "") {
      writer.uint32(34).string(message.ifsc);
    }
    if (message.branch !== "") {
      writer.uint32(42).string(message.branch);
    }
    if (message.swiftCode !== "") {
      writer.uint32(50).string(message.swiftCode);
    }
    if (message.iban !== "") {
      writer.uint32(58).string(message.iban);
    }
    if (message.routingNumber !== "") {
      writer.uint32(66).string(message.routingNumber);
    }
    if (message.sortCode !== "") {
      writer.uint32(74).string(message.sortCode);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BankDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBankDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.bankName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.accountName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.accountNumber = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.ifsc = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.branch = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.swiftCode = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.iban = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.routingNumber = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.sortCode = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BankDetails {
    return {
      bankName: isSet(object.bankName)
        ? globalThis.String(object.bankName)
        : isSet(object.bank_name)
        ? globalThis.String(object.bank_name)
        : "",
      accountName: isSet(object.accountName)
        ? globalThis.String(object.accountName)
        : isSet(object.account_name)
        ? globalThis.String(object.account_name)
        : "",
      accountNumber: isSet(object.accountNumber)
        ? globalThis.String(object.accountNumber)
        : isSet(object.account_number)
        ? globalThis.String(object.account_number)
        : "",
      ifsc: isSet(object.ifsc) ? globalThis.String(object.ifsc) : "",
      branch: isSet(object.branch) ? globalThis.String(object.branch) : "",
      swiftCode: isSet(object.swiftCode)
        ? globalThis.String(object.swiftCode)
        : isSet(object.swift_code)
        ? globalThis.String(object.swift_code)
        : "",
      iban: isSet(object.iban) ? globalThis.String(object.iban) : "",
      routingNumber: isSet(object.routingNumber)
        ? globalThis.String(object.routingNumber)
        : isSet(object.routing_number)
        ? globalThis.String(object.routing_number)
        : "",
      sortCode: isSet(object.sortCode)
        ? globalThis.String(object.sortCode)
        : isSet(object.sort_code)
        ? globalThis.String(object.sort_code)
        : "",
    };
  },

  toJSON(message: BankDetails): unknown {
    const obj: any = {};
    if (message.bankName !== "") {
      obj.bankName = message.bankName;
    }
    if (message.accountName !== "") {
      obj.accountName = message.accountName;
    }
    if (message.accountNumber !== "") {
      obj.accountNumber = message.accountNumber;
    }
    if (message.ifsc !== "") {
      obj.ifsc = message.ifsc;
    }
    if (message.branch !== "") {
      obj.branch = message.branch;
    }
    if (message.swiftCode !== "") {
      obj.swiftCode = message.swiftCode;
    }
    if (message.iban !== "") {
      obj.iban = message.iban;
    }
    if (message.routingNumber !== "") {
      obj.routingNumber = message.routingNumber;
    }
    if (message.sortCode !== "") {
      obj.sortCode = message.sortCode;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BankDetails>, I>>(base?: I): BankDetails {
    return BankDetails.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BankDetails>, I>>(object: I): BankDetails {
    const message = createBaseBankDetails();
    message.bankName = object.bankName ?? "";
    message.accountName = object.accountName ?? "";
    message.accountNumber = object.accountNumber ?? "";
    message.ifsc = object.ifsc ?? "";
    message.branch = object.branch ?? "";
    message.swiftCode = object.swiftCode ?? "";
    message.iban = object.iban ?? "";
    message.routingNumber = object.routingNumber ?? "";
    message.sortCode = object.sortCode ?? "";
    return message;
  },
};

function createBaseCreateInvoiceRequest(): CreateInvoiceRequest {
  return {
    orgId: "",
    ledgerId: "",
    invoiceType: 0,
    invoiceDate: "",
    dueDate: "",
    partyId: "",
    partyRole: undefined,
    partyAddressId: "",
    partyAddress: undefined,
    placeOfSupply: "",
    placeOfSupplyCode: "",
    poNumber: "",
    supplierBillNumber: "",
    partyVendorCode: "",
    currency: "",
    exchangeRate: "",
    exportType: "",
    lutNumber: "",
    lutDate: "",
    countryOfDestination: "",
    countryOfDestinationCode: "",
    portOfLoading: "",
    portOfDischarge: "",
    portCode: "",
    modeOfTransport: "",
    vesselFlightNumber: "",
    blAwbNumber: "",
    containerNumbers: "",
    shippingBillNumber: "",
    shippingBillDate: "",
    shipToAddress: undefined,
    consigneeAddress: undefined,
    notifyPartyAddress: undefined,
    notes: "",
    termsConditions: "",
    paymentTerms: "",
    bankDetails: undefined,
    items: [],
    roundOffAmount: "0",
    invoiceNumber: undefined,
    isWalkIn: false,
    cashAccountId: "",
    salesOrderId: "",
  };
}

export const CreateInvoiceRequest: MessageFns<CreateInvoiceRequest> = {
  encode(message: CreateInvoiceRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgId !== "") {
      writer.uint32(10).string(message.orgId);
    }
    if (message.ledgerId !== "") {
      writer.uint32(18).string(message.ledgerId);
    }
    if (message.invoiceType !== 0) {
      writer.uint32(24).int32(message.invoiceType);
    }
    if (message.invoiceDate !== "") {
      writer.uint32(34).string(message.invoiceDate);
    }
    if (message.dueDate !== "") {
      writer.uint32(42).string(message.dueDate);
    }
    if (message.partyId !== "") {
      writer.uint32(50).string(message.partyId);
    }
    if (message.partyRole !== undefined) {
      writer.uint32(458).string(message.partyRole);
    }
    if (message.partyAddressId !== "") {
      writer.uint32(218).string(message.partyAddressId);
    }
    if (message.partyAddress !== undefined) {
      Address.encode(message.partyAddress, writer.uint32(226).fork()).join();
    }
    if (message.placeOfSupply !== "") {
      writer.uint32(58).string(message.placeOfSupply);
    }
    if (message.placeOfSupplyCode !== "") {
      writer.uint32(66).string(message.placeOfSupplyCode);
    }
    if (message.poNumber !== "") {
      writer.uint32(234).string(message.poNumber);
    }
    if (message.supplierBillNumber !== "") {
      writer.uint32(442).string(message.supplierBillNumber);
    }
    if (message.partyVendorCode !== "") {
      writer.uint32(402).string(message.partyVendorCode);
    }
    if (message.currency !== "") {
      writer.uint32(74).string(message.currency);
    }
    if (message.exchangeRate !== "") {
      writer.uint32(82).string(message.exchangeRate);
    }
    if (message.exportType !== "") {
      writer.uint32(90).string(message.exportType);
    }
    if (message.lutNumber !== "") {
      writer.uint32(98).string(message.lutNumber);
    }
    if (message.lutDate !== "") {
      writer.uint32(106).string(message.lutDate);
    }
    if (message.countryOfDestination !== "") {
      writer.uint32(114).string(message.countryOfDestination);
    }
    if (message.countryOfDestinationCode !== "") {
      writer.uint32(122).string(message.countryOfDestinationCode);
    }
    if (message.portOfLoading !== "") {
      writer.uint32(130).string(message.portOfLoading);
    }
    if (message.portOfDischarge !== "") {
      writer.uint32(138).string(message.portOfDischarge);
    }
    if (message.portCode !== "") {
      writer.uint32(146).string(message.portCode);
    }
    if (message.modeOfTransport !== "") {
      writer.uint32(154).string(message.modeOfTransport);
    }
    if (message.vesselFlightNumber !== "") {
      writer.uint32(170).string(message.vesselFlightNumber);
    }
    if (message.blAwbNumber !== "") {
      writer.uint32(178).string(message.blAwbNumber);
    }
    if (message.containerNumbers !== "") {
      writer.uint32(186).string(message.containerNumbers);
    }
    if (message.shippingBillNumber !== "") {
      writer.uint32(282).string(message.shippingBillNumber);
    }
    if (message.shippingBillDate !== "") {
      writer.uint32(290).string(message.shippingBillDate);
    }
    if (message.shipToAddress !== undefined) {
      Address.encode(message.shipToAddress, writer.uint32(194).fork()).join();
    }
    if (message.consigneeAddress !== undefined) {
      Address.encode(message.consigneeAddress, writer.uint32(202).fork()).join();
    }
    if (message.notifyPartyAddress !== undefined) {
      Address.encode(message.notifyPartyAddress, writer.uint32(210).fork()).join();
    }
    if (message.notes !== "") {
      writer.uint32(242).string(message.notes);
    }
    if (message.termsConditions !== "") {
      writer.uint32(250).string(message.termsConditions);
    }
    if (message.paymentTerms !== "") {
      writer.uint32(258).string(message.paymentTerms);
    }
    if (message.bankDetails !== undefined) {
      BankDetails.encode(message.bankDetails, writer.uint32(266).fork()).join();
    }
    for (const v of message.items) {
      CreateInvoiceItemRequest.encode(v!, writer.uint32(322).fork()).join();
    }
    if (message.roundOffAmount !== "0") {
      writer.uint32(408).int64(message.roundOffAmount);
    }
    if (message.invoiceNumber !== undefined) {
      writer.uint32(418).string(message.invoiceNumber);
    }
    if (message.isWalkIn !== false) {
      writer.uint32(424).bool(message.isWalkIn);
    }
    if (message.cashAccountId !== "") {
      writer.uint32(434).string(message.cashAccountId);
    }
    if (message.salesOrderId !== "") {
      writer.uint32(450).string(message.salesOrderId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateInvoiceRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateInvoiceRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ledgerId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.invoiceType = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.invoiceDate = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.dueDate = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.partyId = reader.string();
          continue;
        }
        case 57: {
          if (tag !== 458) {
            break;
          }

          message.partyRole = reader.string();
          continue;
        }
        case 27: {
          if (tag !== 218) {
            break;
          }

          message.partyAddressId = reader.string();
          continue;
        }
        case 28: {
          if (tag !== 226) {
            break;
          }

          message.partyAddress = Address.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.placeOfSupply = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.placeOfSupplyCode = reader.string();
          continue;
        }
        case 29: {
          if (tag !== 234) {
            break;
          }

          message.poNumber = reader.string();
          continue;
        }
        case 55: {
          if (tag !== 442) {
            break;
          }

          message.supplierBillNumber = reader.string();
          continue;
        }
        case 50: {
          if (tag !== 402) {
            break;
          }

          message.partyVendorCode = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.currency = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.exchangeRate = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.exportType = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.lutNumber = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.lutDate = reader.string();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.countryOfDestination = reader.string();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.countryOfDestinationCode = reader.string();
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.portOfLoading = reader.string();
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.portOfDischarge = reader.string();
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.portCode = reader.string();
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.modeOfTransport = reader.string();
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.vesselFlightNumber = reader.string();
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.blAwbNumber = reader.string();
          continue;
        }
        case 23: {
          if (tag !== 186) {
            break;
          }

          message.containerNumbers = reader.string();
          continue;
        }
        case 35: {
          if (tag !== 282) {
            break;
          }

          message.shippingBillNumber = reader.string();
          continue;
        }
        case 36: {
          if (tag !== 290) {
            break;
          }

          message.shippingBillDate = reader.string();
          continue;
        }
        case 24: {
          if (tag !== 194) {
            break;
          }

          message.shipToAddress = Address.decode(reader, reader.uint32());
          continue;
        }
        case 25: {
          if (tag !== 202) {
            break;
          }

          message.consigneeAddress = Address.decode(reader, reader.uint32());
          continue;
        }
        case 26: {
          if (tag !== 210) {
            break;
          }

          message.notifyPartyAddress = Address.decode(reader, reader.uint32());
          continue;
        }
        case 30: {
          if (tag !== 242) {
            break;
          }

          message.notes = reader.string();
          continue;
        }
        case 31: {
          if (tag !== 250) {
            break;
          }

          message.termsConditions = reader.string();
          continue;
        }
        case 32: {
          if (tag !== 258) {
            break;
          }

          message.paymentTerms = reader.string();
          continue;
        }
        case 33: {
          if (tag !== 266) {
            break;
          }

          message.bankDetails = BankDetails.decode(reader, reader.uint32());
          continue;
        }
        case 40: {
          if (tag !== 322) {
            break;
          }

          message.items.push(CreateInvoiceItemRequest.decode(reader, reader.uint32()));
          continue;
        }
        case 51: {
          if (tag !== 408) {
            break;
          }

          message.roundOffAmount = reader.int64().toString();
          continue;
        }
        case 52: {
          if (tag !== 418) {
            break;
          }

          message.invoiceNumber = reader.string();
          continue;
        }
        case 53: {
          if (tag !== 424) {
            break;
          }

          message.isWalkIn = reader.bool();
          continue;
        }
        case 54: {
          if (tag !== 434) {
            break;
          }

          message.cashAccountId = reader.string();
          continue;
        }
        case 56: {
          if (tag !== 450) {
            break;
          }

          message.salesOrderId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateInvoiceRequest {
    return {
      orgId: isSet(object.orgId)
        ? globalThis.String(object.orgId)
        : isSet(object.org_id)
        ? globalThis.String(object.org_id)
        : "",
      ledgerId: isSet(object.ledgerId)
        ? globalThis.String(object.ledgerId)
        : isSet(object.ledger_id)
        ? globalThis.String(object.ledger_id)
        : "",
      invoiceType: isSet(object.invoiceType)
        ? invoiceTypeFromJSON(object.invoiceType)
        : isSet(object.invoice_type)
        ? invoiceTypeFromJSON(object.invoice_type)
        : 0,
      invoiceDate: isSet(object.invoiceDate)
        ? globalThis.String(object.invoiceDate)
        : isSet(object.invoice_date)
        ? globalThis.String(object.invoice_date)
        : "",
      dueDate: isSet(object.dueDate)
        ? globalThis.String(object.dueDate)
        : isSet(object.due_date)
        ? globalThis.String(object.due_date)
        : "",
      partyId: isSet(object.partyId)
        ? globalThis.String(object.partyId)
        : isSet(object.party_id)
        ? globalThis.String(object.party_id)
        : "",
      partyRole: isSet(object.partyRole)
        ? globalThis.String(object.partyRole)
        : isSet(object.party_role)
        ? globalThis.String(object.party_role)
        : undefined,
      partyAddressId: isSet(object.partyAddressId)
        ? globalThis.String(object.partyAddressId)
        : isSet(object.party_address_id)
        ? globalThis.String(object.party_address_id)
        : "",
      partyAddress: isSet(object.partyAddress)
        ? Address.fromJSON(object.partyAddress)
        : isSet(object.party_address)
        ? Address.fromJSON(object.party_address)
        : undefined,
      placeOfSupply: isSet(object.placeOfSupply)
        ? globalThis.String(object.placeOfSupply)
        : isSet(object.place_of_supply)
        ? globalThis.String(object.place_of_supply)
        : "",
      placeOfSupplyCode: isSet(object.placeOfSupplyCode)
        ? globalThis.String(object.placeOfSupplyCode)
        : isSet(object.place_of_supply_code)
        ? globalThis.String(object.place_of_supply_code)
        : "",
      poNumber: isSet(object.poNumber)
        ? globalThis.String(object.poNumber)
        : isSet(object.po_number)
        ? globalThis.String(object.po_number)
        : "",
      supplierBillNumber: isSet(object.supplierBillNumber)
        ? globalThis.String(object.supplierBillNumber)
        : isSet(object.supplier_bill_number)
        ? globalThis.String(object.supplier_bill_number)
        : "",
      partyVendorCode: isSet(object.partyVendorCode)
        ? globalThis.String(object.partyVendorCode)
        : isSet(object.party_vendor_code)
        ? globalThis.String(object.party_vendor_code)
        : "",
      currency: isSet(object.currency) ? globalThis.String(object.currency) : "",
      exchangeRate: isSet(object.exchangeRate)
        ? globalThis.String(object.exchangeRate)
        : isSet(object.exchange_rate)
        ? globalThis.String(object.exchange_rate)
        : "",
      exportType: isSet(object.exportType)
        ? globalThis.String(object.exportType)
        : isSet(object.export_type)
        ? globalThis.String(object.export_type)
        : "",
      lutNumber: isSet(object.lutNumber)
        ? globalThis.String(object.lutNumber)
        : isSet(object.lut_number)
        ? globalThis.String(object.lut_number)
        : "",
      lutDate: isSet(object.lutDate)
        ? globalThis.String(object.lutDate)
        : isSet(object.lut_date)
        ? globalThis.String(object.lut_date)
        : "",
      countryOfDestination: isSet(object.countryOfDestination)
        ? globalThis.String(object.countryOfDestination)
        : isSet(object.country_of_destination)
        ? globalThis.String(object.country_of_destination)
        : "",
      countryOfDestinationCode: isSet(object.countryOfDestinationCode)
        ? globalThis.String(object.countryOfDestinationCode)
        : isSet(object.country_of_destination_code)
        ? globalThis.String(object.country_of_destination_code)
        : "",
      portOfLoading: isSet(object.portOfLoading)
        ? globalThis.String(object.portOfLoading)
        : isSet(object.port_of_loading)
        ? globalThis.String(object.port_of_loading)
        : "",
      portOfDischarge: isSet(object.portOfDischarge)
        ? globalThis.String(object.portOfDischarge)
        : isSet(object.port_of_discharge)
        ? globalThis.String(object.port_of_discharge)
        : "",
      portCode: isSet(object.portCode)
        ? globalThis.String(object.portCode)
        : isSet(object.port_code)
        ? globalThis.String(object.port_code)
        : "",
      modeOfTransport: isSet(object.modeOfTransport)
        ? globalThis.String(object.modeOfTransport)
        : isSet(object.mode_of_transport)
        ? globalThis.String(object.mode_of_transport)
        : "",
      vesselFlightNumber: isSet(object.vesselFlightNumber)
        ? globalThis.String(object.vesselFlightNumber)
        : isSet(object.vessel_flight_number)
        ? globalThis.String(object.vessel_flight_number)
        : "",
      blAwbNumber: isSet(object.blAwbNumber)
        ? globalThis.String(object.blAwbNumber)
        : isSet(object.bl_awb_number)
        ? globalThis.String(object.bl_awb_number)
        : "",
      containerNumbers: isSet(object.containerNumbers)
        ? globalThis.String(object.containerNumbers)
        : isSet(object.container_numbers)
        ? globalThis.String(object.container_numbers)
        : "",
      shippingBillNumber: isSet(object.shippingBillNumber)
        ? globalThis.String(object.shippingBillNumber)
        : isSet(object.shipping_bill_number)
        ? globalThis.String(object.shipping_bill_number)
        : "",
      shippingBillDate: isSet(object.shippingBillDate)
        ? globalThis.String(object.shippingBillDate)
        : isSet(object.shipping_bill_date)
        ? globalThis.String(object.shipping_bill_date)
        : "",
      shipToAddress: isSet(object.shipToAddress)
        ? Address.fromJSON(object.shipToAddress)
        : isSet(object.ship_to_address)
        ? Address.fromJSON(object.ship_to_address)
        : undefined,
      consigneeAddress: isSet(object.consigneeAddress)
        ? Address.fromJSON(object.consigneeAddress)
        : isSet(object.consignee_address)
        ? Address.fromJSON(object.consignee_address)
        : undefined,
      notifyPartyAddress: isSet(object.notifyPartyAddress)
        ? Address.fromJSON(object.notifyPartyAddress)
        : isSet(object.notify_party_address)
        ? Address.fromJSON(object.notify_party_address)
        : undefined,
      notes: isSet(object.notes) ? globalThis.String(object.notes) : "",
      termsConditions: isSet(object.termsConditions)
        ? globalThis.String(object.termsConditions)
        : isSet(object.terms_conditions)
        ? globalThis.String(object.terms_conditions)
        : "",
      paymentTerms: isSet(object.paymentTerms)
        ? globalThis.String(object.paymentTerms)
        : isSet(object.payment_terms)
        ? globalThis.String(object.payment_terms)
        : "",
      bankDetails: isSet(object.bankDetails)
        ? BankDetails.fromJSON(object.bankDetails)
        : isSet(object.bank_details)
        ? BankDetails.fromJSON(object.bank_details)
        : undefined,
      items: globalThis.Array.isArray(object?.items)
        ? object.items.map((e: any) => CreateInvoiceItemRequest.fromJSON(e))
        : [],
      roundOffAmount: isSet(object.roundOffAmount)
        ? globalThis.String(object.roundOffAmount)
        : isSet(object.round_off_amount)
        ? globalThis.String(object.round_off_amount)
        : "0",
      invoiceNumber: isSet(object.invoiceNumber)
        ? globalThis.String(object.invoiceNumber)
        : isSet(object.invoice_number)
        ? globalThis.String(object.invoice_number)
        : undefined,
      isWalkIn: isSet(object.isWalkIn)
        ? globalThis.Boolean(object.isWalkIn)
        : isSet(object.is_walk_in)
        ? globalThis.Boolean(object.is_walk_in)
        : false,
      cashAccountId: isSet(object.cashAccountId)
        ? globalThis.String(object.cashAccountId)
        : isSet(object.cash_account_id)
        ? globalThis.String(object.cash_account_id)
        : "",
      salesOrderId: isSet(object.salesOrderId)
        ? globalThis.String(object.salesOrderId)
        : isSet(object.sales_order_id)
        ? globalThis.String(object.sales_order_id)
        : "",
    };
  },

  toJSON(message: CreateInvoiceRequest): unknown {
    const obj: any = {};
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.ledgerId !== "") {
      obj.ledgerId = message.ledgerId;
    }
    if (message.invoiceType !== 0) {
      obj.invoiceType = invoiceTypeToJSON(message.invoiceType);
    }
    if (message.invoiceDate !== "") {
      obj.invoiceDate = message.invoiceDate;
    }
    if (message.dueDate !== "") {
      obj.dueDate = message.dueDate;
    }
    if (message.partyId !== "") {
      obj.partyId = message.partyId;
    }
    if (message.partyRole !== undefined) {
      obj.partyRole = message.partyRole;
    }
    if (message.partyAddressId !== "") {
      obj.partyAddressId = message.partyAddressId;
    }
    if (message.partyAddress !== undefined) {
      obj.partyAddress = Address.toJSON(message.partyAddress);
    }
    if (message.placeOfSupply !== "") {
      obj.placeOfSupply = message.placeOfSupply;
    }
    if (message.placeOfSupplyCode !== "") {
      obj.placeOfSupplyCode = message.placeOfSupplyCode;
    }
    if (message.poNumber !== "") {
      obj.poNumber = message.poNumber;
    }
    if (message.supplierBillNumber !== "") {
      obj.supplierBillNumber = message.supplierBillNumber;
    }
    if (message.partyVendorCode !== "") {
      obj.partyVendorCode = message.partyVendorCode;
    }
    if (message.currency !== "") {
      obj.currency = message.currency;
    }
    if (message.exchangeRate !== "") {
      obj.exchangeRate = message.exchangeRate;
    }
    if (message.exportType !== "") {
      obj.exportType = message.exportType;
    }
    if (message.lutNumber !== "") {
      obj.lutNumber = message.lutNumber;
    }
    if (message.lutDate !== "") {
      obj.lutDate = message.lutDate;
    }
    if (message.countryOfDestination !== "") {
      obj.countryOfDestination = message.countryOfDestination;
    }
    if (message.countryOfDestinationCode !== "") {
      obj.countryOfDestinationCode = message.countryOfDestinationCode;
    }
    if (message.portOfLoading !== "") {
      obj.portOfLoading = message.portOfLoading;
    }
    if (message.portOfDischarge !== "") {
      obj.portOfDischarge = message.portOfDischarge;
    }
    if (message.portCode !== "") {
      obj.portCode = message.portCode;
    }
    if (message.modeOfTransport !== "") {
      obj.modeOfTransport = message.modeOfTransport;
    }
    if (message.vesselFlightNumber !== "") {
      obj.vesselFlightNumber = message.vesselFlightNumber;
    }
    if (message.blAwbNumber !== "") {
      obj.blAwbNumber = message.blAwbNumber;
    }
    if (message.containerNumbers !== "") {
      obj.containerNumbers = message.containerNumbers;
    }
    if (message.shippingBillNumber !== "") {
      obj.shippingBillNumber = message.shippingBillNumber;
    }
    if (message.shippingBillDate !== "") {
      obj.shippingBillDate = message.shippingBillDate;
    }
    if (message.shipToAddress !== undefined) {
      obj.shipToAddress = Address.toJSON(message.shipToAddress);
    }
    if (message.consigneeAddress !== undefined) {
      obj.consigneeAddress = Address.toJSON(message.consigneeAddress);
    }
    if (message.notifyPartyAddress !== undefined) {
      obj.notifyPartyAddress = Address.toJSON(message.notifyPartyAddress);
    }
    if (message.notes !== "") {
      obj.notes = message.notes;
    }
    if (message.termsConditions !== "") {
      obj.termsConditions = message.termsConditions;
    }
    if (message.paymentTerms !== "") {
      obj.paymentTerms = message.paymentTerms;
    }
    if (message.bankDetails !== undefined) {
      obj.bankDetails = BankDetails.toJSON(message.bankDetails);
    }
    if (message.items?.length) {
      obj.items = message.items.map((e) => CreateInvoiceItemRequest.toJSON(e));
    }
    if (message.roundOffAmount !== "0") {
      obj.roundOffAmount = message.roundOffAmount;
    }
    if (message.invoiceNumber !== undefined) {
      obj.invoiceNumber = message.invoiceNumber;
    }
    if (message.isWalkIn !== false) {
      obj.isWalkIn = message.isWalkIn;
    }
    if (message.cashAccountId !== "") {
      obj.cashAccountId = message.cashAccountId;
    }
    if (message.salesOrderId !== "") {
      obj.salesOrderId = message.salesOrderId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateInvoiceRequest>, I>>(base?: I): CreateInvoiceRequest {
    return CreateInvoiceRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateInvoiceRequest>, I>>(object: I): CreateInvoiceRequest {
    const message = createBaseCreateInvoiceRequest();
    message.orgId = object.orgId ?? "";
    message.ledgerId = object.ledgerId ?? "";
    message.invoiceType = object.invoiceType ?? 0;
    message.invoiceDate = object.invoiceDate ?? "";
    message.dueDate = object.dueDate ?? "";
    message.partyId = object.partyId ?? "";
    message.partyRole = object.partyRole ?? undefined;
    message.partyAddressId = object.partyAddressId ?? "";
    message.partyAddress = (object.partyAddress !== undefined && object.partyAddress !== null)
      ? Address.fromPartial(object.partyAddress)
      : undefined;
    message.placeOfSupply = object.placeOfSupply ?? "";
    message.placeOfSupplyCode = object.placeOfSupplyCode ?? "";
    message.poNumber = object.poNumber ?? "";
    message.supplierBillNumber = object.supplierBillNumber ?? "";
    message.partyVendorCode = object.partyVendorCode ?? "";
    message.currency = object.currency ?? "";
    message.exchangeRate = object.exchangeRate ?? "";
    message.exportType = object.exportType ?? "";
    message.lutNumber = object.lutNumber ?? "";
    message.lutDate = object.lutDate ?? "";
    message.countryOfDestination = object.countryOfDestination ?? "";
    message.countryOfDestinationCode = object.countryOfDestinationCode ?? "";
    message.portOfLoading = object.portOfLoading ?? "";
    message.portOfDischarge = object.portOfDischarge ?? "";
    message.portCode = object.portCode ?? "";
    message.modeOfTransport = object.modeOfTransport ?? "";
    message.vesselFlightNumber = object.vesselFlightNumber ?? "";
    message.blAwbNumber = object.blAwbNumber ?? "";
    message.containerNumbers = object.containerNumbers ?? "";
    message.shippingBillNumber = object.shippingBillNumber ?? "";
    message.shippingBillDate = object.shippingBillDate ?? "";
    message.shipToAddress = (object.shipToAddress !== undefined && object.shipToAddress !== null)
      ? Address.fromPartial(object.shipToAddress)
      : undefined;
    message.consigneeAddress = (object.consigneeAddress !== undefined && object.consigneeAddress !== null)
      ? Address.fromPartial(object.consigneeAddress)
      : undefined;
    message.notifyPartyAddress = (object.notifyPartyAddress !== undefined && object.notifyPartyAddress !== null)
      ? Address.fromPartial(object.notifyPartyAddress)
      : undefined;
    message.notes = object.notes ?? "";
    message.termsConditions = object.termsConditions ?? "";
    message.paymentTerms = object.paymentTerms ?? "";
    message.bankDetails = (object.bankDetails !== undefined && object.bankDetails !== null)
      ? BankDetails.fromPartial(object.bankDetails)
      : undefined;
    message.items = object.items?.map((e) => CreateInvoiceItemRequest.fromPartial(e)) || [];
    message.roundOffAmount = object.roundOffAmount ?? "0";
    message.invoiceNumber = object.invoiceNumber ?? undefined;
    message.isWalkIn = object.isWalkIn ?? false;
    message.cashAccountId = object.cashAccountId ?? "";
    message.salesOrderId = object.salesOrderId ?? "";
    return message;
  },
};

function createBaseCreateInvoiceItemRequest(): CreateInvoiceItemRequest {
  return {
    itemCode: "",
    description: "",
    hsnCode: "",
    sacCode: "",
    quantity: "",
    unit: "",
    unitPrice: "0",
    discountPercent: "",
    discountAmount: "0",
    cgstRate: "",
    sgstRate: "",
    igstRate: "",
    cessRate: "",
    itemId: undefined,
    accountId: undefined,
  };
}

export const CreateInvoiceItemRequest: MessageFns<CreateInvoiceItemRequest> = {
  encode(message: CreateInvoiceItemRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.itemCode !== "") {
      writer.uint32(10).string(message.itemCode);
    }
    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }
    if (message.hsnCode !== "") {
      writer.uint32(26).string(message.hsnCode);
    }
    if (message.sacCode !== "") {
      writer.uint32(34).string(message.sacCode);
    }
    if (message.quantity !== "") {
      writer.uint32(42).string(message.quantity);
    }
    if (message.unit !== "") {
      writer.uint32(50).string(message.unit);
    }
    if (message.unitPrice !== "0") {
      writer.uint32(56).int64(message.unitPrice);
    }
    if (message.discountPercent !== "") {
      writer.uint32(66).string(message.discountPercent);
    }
    if (message.discountAmount !== "0") {
      writer.uint32(72).int64(message.discountAmount);
    }
    if (message.cgstRate !== "") {
      writer.uint32(82).string(message.cgstRate);
    }
    if (message.sgstRate !== "") {
      writer.uint32(90).string(message.sgstRate);
    }
    if (message.igstRate !== "") {
      writer.uint32(98).string(message.igstRate);
    }
    if (message.cessRate !== "") {
      writer.uint32(106).string(message.cessRate);
    }
    if (message.itemId !== undefined) {
      writer.uint32(114).string(message.itemId);
    }
    if (message.accountId !== undefined) {
      writer.uint32(122).string(message.accountId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateInvoiceItemRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateInvoiceItemRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.itemCode = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.hsnCode = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.sacCode = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.quantity = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.unit = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.unitPrice = reader.int64().toString();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.discountPercent = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.discountAmount = reader.int64().toString();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.cgstRate = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.sgstRate = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.igstRate = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.cessRate = reader.string();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.itemId = reader.string();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.accountId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateInvoiceItemRequest {
    return {
      itemCode: isSet(object.itemCode)
        ? globalThis.String(object.itemCode)
        : isSet(object.item_code)
        ? globalThis.String(object.item_code)
        : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      hsnCode: isSet(object.hsnCode)
        ? globalThis.String(object.hsnCode)
        : isSet(object.hsn_code)
        ? globalThis.String(object.hsn_code)
        : "",
      sacCode: isSet(object.sacCode)
        ? globalThis.String(object.sacCode)
        : isSet(object.sac_code)
        ? globalThis.String(object.sac_code)
        : "",
      quantity: isSet(object.quantity) ? globalThis.String(object.quantity) : "",
      unit: isSet(object.unit) ? globalThis.String(object.unit) : "",
      unitPrice: isSet(object.unitPrice)
        ? globalThis.String(object.unitPrice)
        : isSet(object.unit_price)
        ? globalThis.String(object.unit_price)
        : "0",
      discountPercent: isSet(object.discountPercent)
        ? globalThis.String(object.discountPercent)
        : isSet(object.discount_percent)
        ? globalThis.String(object.discount_percent)
        : "",
      discountAmount: isSet(object.discountAmount)
        ? globalThis.String(object.discountAmount)
        : isSet(object.discount_amount)
        ? globalThis.String(object.discount_amount)
        : "0",
      cgstRate: isSet(object.cgstRate)
        ? globalThis.String(object.cgstRate)
        : isSet(object.cgst_rate)
        ? globalThis.String(object.cgst_rate)
        : "",
      sgstRate: isSet(object.sgstRate)
        ? globalThis.String(object.sgstRate)
        : isSet(object.sgst_rate)
        ? globalThis.String(object.sgst_rate)
        : "",
      igstRate: isSet(object.igstRate)
        ? globalThis.String(object.igstRate)
        : isSet(object.igst_rate)
        ? globalThis.String(object.igst_rate)
        : "",
      cessRate: isSet(object.cessRate)
        ? globalThis.String(object.cessRate)
        : isSet(object.cess_rate)
        ? globalThis.String(object.cess_rate)
        : "",
      itemId: isSet(object.itemId)
        ? globalThis.String(object.itemId)
        : isSet(object.item_id)
        ? globalThis.String(object.item_id)
        : undefined,
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
        ? globalThis.String(object.account_id)
        : undefined,
    };
  },

  toJSON(message: CreateInvoiceItemRequest): unknown {
    const obj: any = {};
    if (message.itemCode !== "") {
      obj.itemCode = message.itemCode;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.hsnCode !== "") {
      obj.hsnCode = message.hsnCode;
    }
    if (message.sacCode !== "") {
      obj.sacCode = message.sacCode;
    }
    if (message.quantity !== "") {
      obj.quantity = message.quantity;
    }
    if (message.unit !== "") {
      obj.unit = message.unit;
    }
    if (message.unitPrice !== "0") {
      obj.unitPrice = message.unitPrice;
    }
    if (message.discountPercent !== "") {
      obj.discountPercent = message.discountPercent;
    }
    if (message.discountAmount !== "0") {
      obj.discountAmount = message.discountAmount;
    }
    if (message.cgstRate !== "") {
      obj.cgstRate = message.cgstRate;
    }
    if (message.sgstRate !== "") {
      obj.sgstRate = message.sgstRate;
    }
    if (message.igstRate !== "") {
      obj.igstRate = message.igstRate;
    }
    if (message.cessRate !== "") {
      obj.cessRate = message.cessRate;
    }
    if (message.itemId !== undefined) {
      obj.itemId = message.itemId;
    }
    if (message.accountId !== undefined) {
      obj.accountId = message.accountId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateInvoiceItemRequest>, I>>(base?: I): CreateInvoiceItemRequest {
    return CreateInvoiceItemRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateInvoiceItemRequest>, I>>(object: I): CreateInvoiceItemRequest {
    const message = createBaseCreateInvoiceItemRequest();
    message.itemCode = object.itemCode ?? "";
    message.description = object.description ?? "";
    message.hsnCode = object.hsnCode ?? "";
    message.sacCode = object.sacCode ?? "";
    message.quantity = object.quantity ?? "";
    message.unit = object.unit ?? "";
    message.unitPrice = object.unitPrice ?? "0";
    message.discountPercent = object.discountPercent ?? "";
    message.discountAmount = object.discountAmount ?? "0";
    message.cgstRate = object.cgstRate ?? "";
    message.sgstRate = object.sgstRate ?? "";
    message.igstRate = object.igstRate ?? "";
    message.cessRate = object.cessRate ?? "";
    message.itemId = object.itemId ?? undefined;
    message.accountId = object.accountId ?? undefined;
    return message;
  },
};

function createBaseGetInvoiceRequest(): GetInvoiceRequest {
  return { orgId: "", invoiceId: "" };
}

export const GetInvoiceRequest: MessageFns<GetInvoiceRequest> = {
  encode(message: GetInvoiceRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgId !== "") {
      writer.uint32(10).string(message.orgId);
    }
    if (message.invoiceId !== "") {
      writer.uint32(18).string(message.invoiceId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetInvoiceRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetInvoiceRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.invoiceId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetInvoiceRequest {
    return {
      orgId: isSet(object.orgId)
        ? globalThis.String(object.orgId)
        : isSet(object.org_id)
        ? globalThis.String(object.org_id)
        : "",
      invoiceId: isSet(object.invoiceId)
        ? globalThis.String(object.invoiceId)
        : isSet(object.invoice_id)
        ? globalThis.String(object.invoice_id)
        : "",
    };
  },

  toJSON(message: GetInvoiceRequest): unknown {
    const obj: any = {};
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.invoiceId !== "") {
      obj.invoiceId = message.invoiceId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetInvoiceRequest>, I>>(base?: I): GetInvoiceRequest {
    return GetInvoiceRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetInvoiceRequest>, I>>(object: I): GetInvoiceRequest {
    const message = createBaseGetInvoiceRequest();
    message.orgId = object.orgId ?? "";
    message.invoiceId = object.invoiceId ?? "";
    return message;
  },
};

function createBaseUpdateInvoiceRequest(): UpdateInvoiceRequest {
  return {
    orgId: "",
    invoiceId: "",
    invoiceDate: "",
    dueDate: "",
    partyId: "",
    partyRole: undefined,
    partyAddressId: "",
    partyAddress: undefined,
    placeOfSupply: "",
    placeOfSupplyCode: "",
    poNumber: "",
    supplierBillNumber: "",
    partyVendorCode: "",
    currency: "",
    exchangeRate: "",
    exportType: "",
    lutNumber: "",
    lutDate: "",
    countryOfDestination: "",
    countryOfDestinationCode: "",
    portOfLoading: "",
    portOfDischarge: "",
    portCode: "",
    modeOfTransport: "",
    vesselFlightNumber: "",
    blAwbNumber: "",
    containerNumbers: "",
    shippingBillNumber: "",
    shippingBillDate: "",
    shipToAddress: undefined,
    consigneeAddress: undefined,
    notifyPartyAddress: undefined,
    notes: "",
    termsConditions: "",
    paymentTerms: "",
    bankDetails: undefined,
    items: [],
    roundOffAmount: "0",
    invoiceNumber: undefined,
    changeNotes: "",
  };
}

export const UpdateInvoiceRequest: MessageFns<UpdateInvoiceRequest> = {
  encode(message: UpdateInvoiceRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgId !== "") {
      writer.uint32(10).string(message.orgId);
    }
    if (message.invoiceId !== "") {
      writer.uint32(18).string(message.invoiceId);
    }
    if (message.invoiceDate !== "") {
      writer.uint32(26).string(message.invoiceDate);
    }
    if (message.dueDate !== "") {
      writer.uint32(34).string(message.dueDate);
    }
    if (message.partyId !== "") {
      writer.uint32(42).string(message.partyId);
    }
    if (message.partyRole !== undefined) {
      writer.uint32(810).string(message.partyRole);
    }
    if (message.partyAddressId !== "") {
      writer.uint32(218).string(message.partyAddressId);
    }
    if (message.partyAddress !== undefined) {
      Address.encode(message.partyAddress, writer.uint32(226).fork()).join();
    }
    if (message.placeOfSupply !== "") {
      writer.uint32(50).string(message.placeOfSupply);
    }
    if (message.placeOfSupplyCode !== "") {
      writer.uint32(58).string(message.placeOfSupplyCode);
    }
    if (message.poNumber !== "") {
      writer.uint32(162).string(message.poNumber);
    }
    if (message.supplierBillNumber !== "") {
      writer.uint32(802).string(message.supplierBillNumber);
    }
    if (message.partyVendorCode !== "") {
      writer.uint32(402).string(message.partyVendorCode);
    }
    if (message.currency !== "") {
      writer.uint32(66).string(message.currency);
    }
    if (message.exchangeRate !== "") {
      writer.uint32(74).string(message.exchangeRate);
    }
    if (message.exportType !== "") {
      writer.uint32(82).string(message.exportType);
    }
    if (message.lutNumber !== "") {
      writer.uint32(90).string(message.lutNumber);
    }
    if (message.lutDate !== "") {
      writer.uint32(98).string(message.lutDate);
    }
    if (message.countryOfDestination !== "") {
      writer.uint32(106).string(message.countryOfDestination);
    }
    if (message.countryOfDestinationCode !== "") {
      writer.uint32(114).string(message.countryOfDestinationCode);
    }
    if (message.portOfLoading !== "") {
      writer.uint32(122).string(message.portOfLoading);
    }
    if (message.portOfDischarge !== "") {
      writer.uint32(130).string(message.portOfDischarge);
    }
    if (message.portCode !== "") {
      writer.uint32(138).string(message.portCode);
    }
    if (message.modeOfTransport !== "") {
      writer.uint32(146).string(message.modeOfTransport);
    }
    if (message.vesselFlightNumber !== "") {
      writer.uint32(154).string(message.vesselFlightNumber);
    }
    if (message.blAwbNumber !== "") {
      writer.uint32(170).string(message.blAwbNumber);
    }
    if (message.containerNumbers !== "") {
      writer.uint32(178).string(message.containerNumbers);
    }
    if (message.shippingBillNumber !== "") {
      writer.uint32(298).string(message.shippingBillNumber);
    }
    if (message.shippingBillDate !== "") {
      writer.uint32(306).string(message.shippingBillDate);
    }
    if (message.shipToAddress !== undefined) {
      Address.encode(message.shipToAddress, writer.uint32(186).fork()).join();
    }
    if (message.consigneeAddress !== undefined) {
      Address.encode(message.consigneeAddress, writer.uint32(194).fork()).join();
    }
    if (message.notifyPartyAddress !== undefined) {
      Address.encode(message.notifyPartyAddress, writer.uint32(202).fork()).join();
    }
    if (message.notes !== "") {
      writer.uint32(242).string(message.notes);
    }
    if (message.termsConditions !== "") {
      writer.uint32(250).string(message.termsConditions);
    }
    if (message.paymentTerms !== "") {
      writer.uint32(258).string(message.paymentTerms);
    }
    if (message.bankDetails !== undefined) {
      BankDetails.encode(message.bankDetails, writer.uint32(266).fork()).join();
    }
    for (const v of message.items) {
      CreateInvoiceItemRequest.encode(v!, writer.uint32(322).fork()).join();
    }
    if (message.roundOffAmount !== "0") {
      writer.uint32(408).int64(message.roundOffAmount);
    }
    if (message.invoiceNumber !== undefined) {
      writer.uint32(418).string(message.invoiceNumber);
    }
    if (message.changeNotes !== "") {
      writer.uint32(794).string(message.changeNotes);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateInvoiceRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateInvoiceRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.invoiceId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.invoiceDate = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.dueDate = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.partyId = reader.string();
          continue;
        }
        case 101: {
          if (tag !== 810) {
            break;
          }

          message.partyRole = reader.string();
          continue;
        }
        case 27: {
          if (tag !== 218) {
            break;
          }

          message.partyAddressId = reader.string();
          continue;
        }
        case 28: {
          if (tag !== 226) {
            break;
          }

          message.partyAddress = Address.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.placeOfSupply = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.placeOfSupplyCode = reader.string();
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.poNumber = reader.string();
          continue;
        }
        case 100: {
          if (tag !== 802) {
            break;
          }

          message.supplierBillNumber = reader.string();
          continue;
        }
        case 50: {
          if (tag !== 402) {
            break;
          }

          message.partyVendorCode = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.currency = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.exchangeRate = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.exportType = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.lutNumber = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.lutDate = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.countryOfDestination = reader.string();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.countryOfDestinationCode = reader.string();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.portOfLoading = reader.string();
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.portOfDischarge = reader.string();
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.portCode = reader.string();
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.modeOfTransport = reader.string();
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.vesselFlightNumber = reader.string();
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.blAwbNumber = reader.string();
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.containerNumbers = reader.string();
          continue;
        }
        case 37: {
          if (tag !== 298) {
            break;
          }

          message.shippingBillNumber = reader.string();
          continue;
        }
        case 38: {
          if (tag !== 306) {
            break;
          }

          message.shippingBillDate = reader.string();
          continue;
        }
        case 23: {
          if (tag !== 186) {
            break;
          }

          message.shipToAddress = Address.decode(reader, reader.uint32());
          continue;
        }
        case 24: {
          if (tag !== 194) {
            break;
          }

          message.consigneeAddress = Address.decode(reader, reader.uint32());
          continue;
        }
        case 25: {
          if (tag !== 202) {
            break;
          }

          message.notifyPartyAddress = Address.decode(reader, reader.uint32());
          continue;
        }
        case 30: {
          if (tag !== 242) {
            break;
          }

          message.notes = reader.string();
          continue;
        }
        case 31: {
          if (tag !== 250) {
            break;
          }

          message.termsConditions = reader.string();
          continue;
        }
        case 32: {
          if (tag !== 258) {
            break;
          }

          message.paymentTerms = reader.string();
          continue;
        }
        case 33: {
          if (tag !== 266) {
            break;
          }

          message.bankDetails = BankDetails.decode(reader, reader.uint32());
          continue;
        }
        case 40: {
          if (tag !== 322) {
            break;
          }

          message.items.push(CreateInvoiceItemRequest.decode(reader, reader.uint32()));
          continue;
        }
        case 51: {
          if (tag !== 408) {
            break;
          }

          message.roundOffAmount = reader.int64().toString();
          continue;
        }
        case 52: {
          if (tag !== 418) {
            break;
          }

          message.invoiceNumber = reader.string();
          continue;
        }
        case 99: {
          if (tag !== 794) {
            break;
          }

          message.changeNotes = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateInvoiceRequest {
    return {
      orgId: isSet(object.orgId)
        ? globalThis.String(object.orgId)
        : isSet(object.org_id)
        ? globalThis.String(object.org_id)
        : "",
      invoiceId: isSet(object.invoiceId)
        ? globalThis.String(object.invoiceId)
        : isSet(object.invoice_id)
        ? globalThis.String(object.invoice_id)
        : "",
      invoiceDate: isSet(object.invoiceDate)
        ? globalThis.String(object.invoiceDate)
        : isSet(object.invoice_date)
        ? globalThis.String(object.invoice_date)
        : "",
      dueDate: isSet(object.dueDate)
        ? globalThis.String(object.dueDate)
        : isSet(object.due_date)
        ? globalThis.String(object.due_date)
        : "",
      partyId: isSet(object.partyId)
        ? globalThis.String(object.partyId)
        : isSet(object.party_id)
        ? globalThis.String(object.party_id)
        : "",
      partyRole: isSet(object.partyRole)
        ? globalThis.String(object.partyRole)
        : isSet(object.party_role)
        ? globalThis.String(object.party_role)
        : undefined,
      partyAddressId: isSet(object.partyAddressId)
        ? globalThis.String(object.partyAddressId)
        : isSet(object.party_address_id)
        ? globalThis.String(object.party_address_id)
        : "",
      partyAddress: isSet(object.partyAddress)
        ? Address.fromJSON(object.partyAddress)
        : isSet(object.party_address)
        ? Address.fromJSON(object.party_address)
        : undefined,
      placeOfSupply: isSet(object.placeOfSupply)
        ? globalThis.String(object.placeOfSupply)
        : isSet(object.place_of_supply)
        ? globalThis.String(object.place_of_supply)
        : "",
      placeOfSupplyCode: isSet(object.placeOfSupplyCode)
        ? globalThis.String(object.placeOfSupplyCode)
        : isSet(object.place_of_supply_code)
        ? globalThis.String(object.place_of_supply_code)
        : "",
      poNumber: isSet(object.poNumber)
        ? globalThis.String(object.poNumber)
        : isSet(object.po_number)
        ? globalThis.String(object.po_number)
        : "",
      supplierBillNumber: isSet(object.supplierBillNumber)
        ? globalThis.String(object.supplierBillNumber)
        : isSet(object.supplier_bill_number)
        ? globalThis.String(object.supplier_bill_number)
        : "",
      partyVendorCode: isSet(object.partyVendorCode)
        ? globalThis.String(object.partyVendorCode)
        : isSet(object.party_vendor_code)
        ? globalThis.String(object.party_vendor_code)
        : "",
      currency: isSet(object.currency) ? globalThis.String(object.currency) : "",
      exchangeRate: isSet(object.exchangeRate)
        ? globalThis.String(object.exchangeRate)
        : isSet(object.exchange_rate)
        ? globalThis.String(object.exchange_rate)
        : "",
      exportType: isSet(object.exportType)
        ? globalThis.String(object.exportType)
        : isSet(object.export_type)
        ? globalThis.String(object.export_type)
        : "",
      lutNumber: isSet(object.lutNumber)
        ? globalThis.String(object.lutNumber)
        : isSet(object.lut_number)
        ? globalThis.String(object.lut_number)
        : "",
      lutDate: isSet(object.lutDate)
        ? globalThis.String(object.lutDate)
        : isSet(object.lut_date)
        ? globalThis.String(object.lut_date)
        : "",
      countryOfDestination: isSet(object.countryOfDestination)
        ? globalThis.String(object.countryOfDestination)
        : isSet(object.country_of_destination)
        ? globalThis.String(object.country_of_destination)
        : "",
      countryOfDestinationCode: isSet(object.countryOfDestinationCode)
        ? globalThis.String(object.countryOfDestinationCode)
        : isSet(object.country_of_destination_code)
        ? globalThis.String(object.country_of_destination_code)
        : "",
      portOfLoading: isSet(object.portOfLoading)
        ? globalThis.String(object.portOfLoading)
        : isSet(object.port_of_loading)
        ? globalThis.String(object.port_of_loading)
        : "",
      portOfDischarge: isSet(object.portOfDischarge)
        ? globalThis.String(object.portOfDischarge)
        : isSet(object.port_of_discharge)
        ? globalThis.String(object.port_of_discharge)
        : "",
      portCode: isSet(object.portCode)
        ? globalThis.String(object.portCode)
        : isSet(object.port_code)
        ? globalThis.String(object.port_code)
        : "",
      modeOfTransport: isSet(object.modeOfTransport)
        ? globalThis.String(object.modeOfTransport)
        : isSet(object.mode_of_transport)
        ? globalThis.String(object.mode_of_transport)
        : "",
      vesselFlightNumber: isSet(object.vesselFlightNumber)
        ? globalThis.String(object.vesselFlightNumber)
        : isSet(object.vessel_flight_number)
        ? globalThis.String(object.vessel_flight_number)
        : "",
      blAwbNumber: isSet(object.blAwbNumber)
        ? globalThis.String(object.blAwbNumber)
        : isSet(object.bl_awb_number)
        ? globalThis.String(object.bl_awb_number)
        : "",
      containerNumbers: isSet(object.containerNumbers)
        ? globalThis.String(object.containerNumbers)
        : isSet(object.container_numbers)
        ? globalThis.String(object.container_numbers)
        : "",
      shippingBillNumber: isSet(object.shippingBillNumber)
        ? globalThis.String(object.shippingBillNumber)
        : isSet(object.shipping_bill_number)
        ? globalThis.String(object.shipping_bill_number)
        : "",
      shippingBillDate: isSet(object.shippingBillDate)
        ? globalThis.String(object.shippingBillDate)
        : isSet(object.shipping_bill_date)
        ? globalThis.String(object.shipping_bill_date)
        : "",
      shipToAddress: isSet(object.shipToAddress)
        ? Address.fromJSON(object.shipToAddress)
        : isSet(object.ship_to_address)
        ? Address.fromJSON(object.ship_to_address)
        : undefined,
      consigneeAddress: isSet(object.consigneeAddress)
        ? Address.fromJSON(object.consigneeAddress)
        : isSet(object.consignee_address)
        ? Address.fromJSON(object.consignee_address)
        : undefined,
      notifyPartyAddress: isSet(object.notifyPartyAddress)
        ? Address.fromJSON(object.notifyPartyAddress)
        : isSet(object.notify_party_address)
        ? Address.fromJSON(object.notify_party_address)
        : undefined,
      notes: isSet(object.notes) ? globalThis.String(object.notes) : "",
      termsConditions: isSet(object.termsConditions)
        ? globalThis.String(object.termsConditions)
        : isSet(object.terms_conditions)
        ? globalThis.String(object.terms_conditions)
        : "",
      paymentTerms: isSet(object.paymentTerms)
        ? globalThis.String(object.paymentTerms)
        : isSet(object.payment_terms)
        ? globalThis.String(object.payment_terms)
        : "",
      bankDetails: isSet(object.bankDetails)
        ? BankDetails.fromJSON(object.bankDetails)
        : isSet(object.bank_details)
        ? BankDetails.fromJSON(object.bank_details)
        : undefined,
      items: globalThis.Array.isArray(object?.items)
        ? object.items.map((e: any) => CreateInvoiceItemRequest.fromJSON(e))
        : [],
      roundOffAmount: isSet(object.roundOffAmount)
        ? globalThis.String(object.roundOffAmount)
        : isSet(object.round_off_amount)
        ? globalThis.String(object.round_off_amount)
        : "0",
      invoiceNumber: isSet(object.invoiceNumber)
        ? globalThis.String(object.invoiceNumber)
        : isSet(object.invoice_number)
        ? globalThis.String(object.invoice_number)
        : undefined,
      changeNotes: isSet(object.changeNotes)
        ? globalThis.String(object.changeNotes)
        : isSet(object.change_notes)
        ? globalThis.String(object.change_notes)
        : "",
    };
  },

  toJSON(message: UpdateInvoiceRequest): unknown {
    const obj: any = {};
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.invoiceId !== "") {
      obj.invoiceId = message.invoiceId;
    }
    if (message.invoiceDate !== "") {
      obj.invoiceDate = message.invoiceDate;
    }
    if (message.dueDate !== "") {
      obj.dueDate = message.dueDate;
    }
    if (message.partyId !== "") {
      obj.partyId = message.partyId;
    }
    if (message.partyRole !== undefined) {
      obj.partyRole = message.partyRole;
    }
    if (message.partyAddressId !== "") {
      obj.partyAddressId = message.partyAddressId;
    }
    if (message.partyAddress !== undefined) {
      obj.partyAddress = Address.toJSON(message.partyAddress);
    }
    if (message.placeOfSupply !== "") {
      obj.placeOfSupply = message.placeOfSupply;
    }
    if (message.placeOfSupplyCode !== "") {
      obj.placeOfSupplyCode = message.placeOfSupplyCode;
    }
    if (message.poNumber !== "") {
      obj.poNumber = message.poNumber;
    }
    if (message.supplierBillNumber !== "") {
      obj.supplierBillNumber = message.supplierBillNumber;
    }
    if (message.partyVendorCode !== "") {
      obj.partyVendorCode = message.partyVendorCode;
    }
    if (message.currency !== "") {
      obj.currency = message.currency;
    }
    if (message.exchangeRate !== "") {
      obj.exchangeRate = message.exchangeRate;
    }
    if (message.exportType !== "") {
      obj.exportType = message.exportType;
    }
    if (message.lutNumber !== "") {
      obj.lutNumber = message.lutNumber;
    }
    if (message.lutDate !== "") {
      obj.lutDate = message.lutDate;
    }
    if (message.countryOfDestination !== "") {
      obj.countryOfDestination = message.countryOfDestination;
    }
    if (message.countryOfDestinationCode !== "") {
      obj.countryOfDestinationCode = message.countryOfDestinationCode;
    }
    if (message.portOfLoading !== "") {
      obj.portOfLoading = message.portOfLoading;
    }
    if (message.portOfDischarge !== "") {
      obj.portOfDischarge = message.portOfDischarge;
    }
    if (message.portCode !== "") {
      obj.portCode = message.portCode;
    }
    if (message.modeOfTransport !== "") {
      obj.modeOfTransport = message.modeOfTransport;
    }
    if (message.vesselFlightNumber !== "") {
      obj.vesselFlightNumber = message.vesselFlightNumber;
    }
    if (message.blAwbNumber !== "") {
      obj.blAwbNumber = message.blAwbNumber;
    }
    if (message.containerNumbers !== "") {
      obj.containerNumbers = message.containerNumbers;
    }
    if (message.shippingBillNumber !== "") {
      obj.shippingBillNumber = message.shippingBillNumber;
    }
    if (message.shippingBillDate !== "") {
      obj.shippingBillDate = message.shippingBillDate;
    }
    if (message.shipToAddress !== undefined) {
      obj.shipToAddress = Address.toJSON(message.shipToAddress);
    }
    if (message.consigneeAddress !== undefined) {
      obj.consigneeAddress = Address.toJSON(message.consigneeAddress);
    }
    if (message.notifyPartyAddress !== undefined) {
      obj.notifyPartyAddress = Address.toJSON(message.notifyPartyAddress);
    }
    if (message.notes !== "") {
      obj.notes = message.notes;
    }
    if (message.termsConditions !== "") {
      obj.termsConditions = message.termsConditions;
    }
    if (message.paymentTerms !== "") {
      obj.paymentTerms = message.paymentTerms;
    }
    if (message.bankDetails !== undefined) {
      obj.bankDetails = BankDetails.toJSON(message.bankDetails);
    }
    if (message.items?.length) {
      obj.items = message.items.map((e) => CreateInvoiceItemRequest.toJSON(e));
    }
    if (message.roundOffAmount !== "0") {
      obj.roundOffAmount = message.roundOffAmount;
    }
    if (message.invoiceNumber !== undefined) {
      obj.invoiceNumber = message.invoiceNumber;
    }
    if (message.changeNotes !== "") {
      obj.changeNotes = message.changeNotes;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateInvoiceRequest>, I>>(base?: I): UpdateInvoiceRequest {
    return UpdateInvoiceRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateInvoiceRequest>, I>>(object: I): UpdateInvoiceRequest {
    const message = createBaseUpdateInvoiceRequest();
    message.orgId = object.orgId ?? "";
    message.invoiceId = object.invoiceId ?? "";
    message.invoiceDate = object.invoiceDate ?? "";
    message.dueDate = object.dueDate ?? "";
    message.partyId = object.partyId ?? "";
    message.partyRole = object.partyRole ?? undefined;
    message.partyAddressId = object.partyAddressId ?? "";
    message.partyAddress = (object.partyAddress !== undefined && object.partyAddress !== null)
      ? Address.fromPartial(object.partyAddress)
      : undefined;
    message.placeOfSupply = object.placeOfSupply ?? "";
    message.placeOfSupplyCode = object.placeOfSupplyCode ?? "";
    message.poNumber = object.poNumber ?? "";
    message.supplierBillNumber = object.supplierBillNumber ?? "";
    message.partyVendorCode = object.partyVendorCode ?? "";
    message.currency = object.currency ?? "";
    message.exchangeRate = object.exchangeRate ?? "";
    message.exportType = object.exportType ?? "";
    message.lutNumber = object.lutNumber ?? "";
    message.lutDate = object.lutDate ?? "";
    message.countryOfDestination = object.countryOfDestination ?? "";
    message.countryOfDestinationCode = object.countryOfDestinationCode ?? "";
    message.portOfLoading = object.portOfLoading ?? "";
    message.portOfDischarge = object.portOfDischarge ?? "";
    message.portCode = object.portCode ?? "";
    message.modeOfTransport = object.modeOfTransport ?? "";
    message.vesselFlightNumber = object.vesselFlightNumber ?? "";
    message.blAwbNumber = object.blAwbNumber ?? "";
    message.containerNumbers = object.containerNumbers ?? "";
    message.shippingBillNumber = object.shippingBillNumber ?? "";
    message.shippingBillDate = object.shippingBillDate ?? "";
    message.shipToAddress = (object.shipToAddress !== undefined && object.shipToAddress !== null)
      ? Address.fromPartial(object.shipToAddress)
      : undefined;
    message.consigneeAddress = (object.consigneeAddress !== undefined && object.consigneeAddress !== null)
      ? Address.fromPartial(object.consigneeAddress)
      : undefined;
    message.notifyPartyAddress = (object.notifyPartyAddress !== undefined && object.notifyPartyAddress !== null)
      ? Address.fromPartial(object.notifyPartyAddress)
      : undefined;
    message.notes = object.notes ?? "";
    message.termsConditions = object.termsConditions ?? "";
    message.paymentTerms = object.paymentTerms ?? "";
    message.bankDetails = (object.bankDetails !== undefined && object.bankDetails !== null)
      ? BankDetails.fromPartial(object.bankDetails)
      : undefined;
    message.items = object.items?.map((e) => CreateInvoiceItemRequest.fromPartial(e)) || [];
    message.roundOffAmount = object.roundOffAmount ?? "0";
    message.invoiceNumber = object.invoiceNumber ?? undefined;
    message.changeNotes = object.changeNotes ?? "";
    return message;
  },
};

function createBasePostInvoiceRequest(): PostInvoiceRequest {
  return { orgId: "", invoiceId: "", invoiceNumber: undefined, invoiceDate: "" };
}

export const PostInvoiceRequest: MessageFns<PostInvoiceRequest> = {
  encode(message: PostInvoiceRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgId !== "") {
      writer.uint32(10).string(message.orgId);
    }
    if (message.invoiceId !== "") {
      writer.uint32(18).string(message.invoiceId);
    }
    if (message.invoiceNumber !== undefined) {
      writer.uint32(26).string(message.invoiceNumber);
    }
    if (message.invoiceDate !== "") {
      writer.uint32(34).string(message.invoiceDate);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PostInvoiceRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePostInvoiceRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.invoiceId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.invoiceNumber = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.invoiceDate = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PostInvoiceRequest {
    return {
      orgId: isSet(object.orgId)
        ? globalThis.String(object.orgId)
        : isSet(object.org_id)
        ? globalThis.String(object.org_id)
        : "",
      invoiceId: isSet(object.invoiceId)
        ? globalThis.String(object.invoiceId)
        : isSet(object.invoice_id)
        ? globalThis.String(object.invoice_id)
        : "",
      invoiceNumber: isSet(object.invoiceNumber)
        ? globalThis.String(object.invoiceNumber)
        : isSet(object.invoice_number)
        ? globalThis.String(object.invoice_number)
        : undefined,
      invoiceDate: isSet(object.invoiceDate)
        ? globalThis.String(object.invoiceDate)
        : isSet(object.invoice_date)
        ? globalThis.String(object.invoice_date)
        : "",
    };
  },

  toJSON(message: PostInvoiceRequest): unknown {
    const obj: any = {};
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.invoiceId !== "") {
      obj.invoiceId = message.invoiceId;
    }
    if (message.invoiceNumber !== undefined) {
      obj.invoiceNumber = message.invoiceNumber;
    }
    if (message.invoiceDate !== "") {
      obj.invoiceDate = message.invoiceDate;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PostInvoiceRequest>, I>>(base?: I): PostInvoiceRequest {
    return PostInvoiceRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PostInvoiceRequest>, I>>(object: I): PostInvoiceRequest {
    const message = createBasePostInvoiceRequest();
    message.orgId = object.orgId ?? "";
    message.invoiceId = object.invoiceId ?? "";
    message.invoiceNumber = object.invoiceNumber ?? undefined;
    message.invoiceDate = object.invoiceDate ?? "";
    return message;
  },
};

function createBaseVoidInvoiceRequest(): VoidInvoiceRequest {
  return { orgId: "", invoiceId: "", reason: "" };
}

export const VoidInvoiceRequest: MessageFns<VoidInvoiceRequest> = {
  encode(message: VoidInvoiceRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgId !== "") {
      writer.uint32(10).string(message.orgId);
    }
    if (message.invoiceId !== "") {
      writer.uint32(18).string(message.invoiceId);
    }
    if (message.reason !== "") {
      writer.uint32(26).string(message.reason);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VoidInvoiceRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVoidInvoiceRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.invoiceId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.reason = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VoidInvoiceRequest {
    return {
      orgId: isSet(object.orgId)
        ? globalThis.String(object.orgId)
        : isSet(object.org_id)
        ? globalThis.String(object.org_id)
        : "",
      invoiceId: isSet(object.invoiceId)
        ? globalThis.String(object.invoiceId)
        : isSet(object.invoice_id)
        ? globalThis.String(object.invoice_id)
        : "",
      reason: isSet(object.reason) ? globalThis.String(object.reason) : "",
    };
  },

  toJSON(message: VoidInvoiceRequest): unknown {
    const obj: any = {};
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.invoiceId !== "") {
      obj.invoiceId = message.invoiceId;
    }
    if (message.reason !== "") {
      obj.reason = message.reason;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VoidInvoiceRequest>, I>>(base?: I): VoidInvoiceRequest {
    return VoidInvoiceRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VoidInvoiceRequest>, I>>(object: I): VoidInvoiceRequest {
    const message = createBaseVoidInvoiceRequest();
    message.orgId = object.orgId ?? "";
    message.invoiceId = object.invoiceId ?? "";
    message.reason = object.reason ?? "";
    return message;
  },
};

function createBaseEditPostedInvoiceRequest(): EditPostedInvoiceRequest {
  return {
    orgId: "",
    invoiceId: "",
    invoiceDate: "",
    dueDate: "",
    placeOfSupply: "",
    placeOfSupplyCode: "",
    poNumber: "",
    currency: "",
    exchangeRate: "",
    exportType: "",
    lutNumber: "",
    lutDate: "",
    countryOfDestination: "",
    countryOfDestinationCode: "",
    portOfLoading: "",
    portOfDischarge: "",
    portCode: "",
    modeOfTransport: "",
    vesselFlightNumber: "",
    blAwbNumber: "",
    containerNumbers: "",
    shippingBillNumber: "",
    shippingBillDate: "",
    shipToAddress: undefined,
    consigneeAddress: undefined,
    notifyPartyAddress: undefined,
    notes: "",
    termsConditions: "",
    paymentTerms: "",
    bankDetails: undefined,
    items: [],
    roundOffAmount: "0",
    invoiceNumber: undefined,
    supplierBillNumber: "",
    changeNotes: "",
  };
}

export const EditPostedInvoiceRequest: MessageFns<EditPostedInvoiceRequest> = {
  encode(message: EditPostedInvoiceRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgId !== "") {
      writer.uint32(10).string(message.orgId);
    }
    if (message.invoiceId !== "") {
      writer.uint32(18).string(message.invoiceId);
    }
    if (message.invoiceDate !== "") {
      writer.uint32(26).string(message.invoiceDate);
    }
    if (message.dueDate !== "") {
      writer.uint32(34).string(message.dueDate);
    }
    if (message.placeOfSupply !== "") {
      writer.uint32(50).string(message.placeOfSupply);
    }
    if (message.placeOfSupplyCode !== "") {
      writer.uint32(58).string(message.placeOfSupplyCode);
    }
    if (message.poNumber !== "") {
      writer.uint32(162).string(message.poNumber);
    }
    if (message.currency !== "") {
      writer.uint32(66).string(message.currency);
    }
    if (message.exchangeRate !== "") {
      writer.uint32(74).string(message.exchangeRate);
    }
    if (message.exportType !== "") {
      writer.uint32(82).string(message.exportType);
    }
    if (message.lutNumber !== "") {
      writer.uint32(90).string(message.lutNumber);
    }
    if (message.lutDate !== "") {
      writer.uint32(98).string(message.lutDate);
    }
    if (message.countryOfDestination !== "") {
      writer.uint32(106).string(message.countryOfDestination);
    }
    if (message.countryOfDestinationCode !== "") {
      writer.uint32(114).string(message.countryOfDestinationCode);
    }
    if (message.portOfLoading !== "") {
      writer.uint32(122).string(message.portOfLoading);
    }
    if (message.portOfDischarge !== "") {
      writer.uint32(130).string(message.portOfDischarge);
    }
    if (message.portCode !== "") {
      writer.uint32(138).string(message.portCode);
    }
    if (message.modeOfTransport !== "") {
      writer.uint32(146).string(message.modeOfTransport);
    }
    if (message.vesselFlightNumber !== "") {
      writer.uint32(154).string(message.vesselFlightNumber);
    }
    if (message.blAwbNumber !== "") {
      writer.uint32(170).string(message.blAwbNumber);
    }
    if (message.containerNumbers !== "") {
      writer.uint32(178).string(message.containerNumbers);
    }
    if (message.shippingBillNumber !== "") {
      writer.uint32(298).string(message.shippingBillNumber);
    }
    if (message.shippingBillDate !== "") {
      writer.uint32(306).string(message.shippingBillDate);
    }
    if (message.shipToAddress !== undefined) {
      Address.encode(message.shipToAddress, writer.uint32(186).fork()).join();
    }
    if (message.consigneeAddress !== undefined) {
      Address.encode(message.consigneeAddress, writer.uint32(194).fork()).join();
    }
    if (message.notifyPartyAddress !== undefined) {
      Address.encode(message.notifyPartyAddress, writer.uint32(202).fork()).join();
    }
    if (message.notes !== "") {
      writer.uint32(242).string(message.notes);
    }
    if (message.termsConditions !== "") {
      writer.uint32(250).string(message.termsConditions);
    }
    if (message.paymentTerms !== "") {
      writer.uint32(258).string(message.paymentTerms);
    }
    if (message.bankDetails !== undefined) {
      BankDetails.encode(message.bankDetails, writer.uint32(266).fork()).join();
    }
    for (const v of message.items) {
      CreateInvoiceItemRequest.encode(v!, writer.uint32(322).fork()).join();
    }
    if (message.roundOffAmount !== "0") {
      writer.uint32(408).int64(message.roundOffAmount);
    }
    if (message.invoiceNumber !== undefined) {
      writer.uint32(418).string(message.invoiceNumber);
    }
    if (message.supplierBillNumber !== "") {
      writer.uint32(426).string(message.supplierBillNumber);
    }
    if (message.changeNotes !== "") {
      writer.uint32(794).string(message.changeNotes);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EditPostedInvoiceRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEditPostedInvoiceRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.invoiceId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.invoiceDate = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.dueDate = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.placeOfSupply = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.placeOfSupplyCode = reader.string();
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.poNumber = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.currency = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.exchangeRate = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.exportType = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.lutNumber = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.lutDate = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.countryOfDestination = reader.string();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.countryOfDestinationCode = reader.string();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.portOfLoading = reader.string();
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.portOfDischarge = reader.string();
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.portCode = reader.string();
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.modeOfTransport = reader.string();
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.vesselFlightNumber = reader.string();
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.blAwbNumber = reader.string();
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.containerNumbers = reader.string();
          continue;
        }
        case 37: {
          if (tag !== 298) {
            break;
          }

          message.shippingBillNumber = reader.string();
          continue;
        }
        case 38: {
          if (tag !== 306) {
            break;
          }

          message.shippingBillDate = reader.string();
          continue;
        }
        case 23: {
          if (tag !== 186) {
            break;
          }

          message.shipToAddress = Address.decode(reader, reader.uint32());
          continue;
        }
        case 24: {
          if (tag !== 194) {
            break;
          }

          message.consigneeAddress = Address.decode(reader, reader.uint32());
          continue;
        }
        case 25: {
          if (tag !== 202) {
            break;
          }

          message.notifyPartyAddress = Address.decode(reader, reader.uint32());
          continue;
        }
        case 30: {
          if (tag !== 242) {
            break;
          }

          message.notes = reader.string();
          continue;
        }
        case 31: {
          if (tag !== 250) {
            break;
          }

          message.termsConditions = reader.string();
          continue;
        }
        case 32: {
          if (tag !== 258) {
            break;
          }

          message.paymentTerms = reader.string();
          continue;
        }
        case 33: {
          if (tag !== 266) {
            break;
          }

          message.bankDetails = BankDetails.decode(reader, reader.uint32());
          continue;
        }
        case 40: {
          if (tag !== 322) {
            break;
          }

          message.items.push(CreateInvoiceItemRequest.decode(reader, reader.uint32()));
          continue;
        }
        case 51: {
          if (tag !== 408) {
            break;
          }

          message.roundOffAmount = reader.int64().toString();
          continue;
        }
        case 52: {
          if (tag !== 418) {
            break;
          }

          message.invoiceNumber = reader.string();
          continue;
        }
        case 53: {
          if (tag !== 426) {
            break;
          }

          message.supplierBillNumber = reader.string();
          continue;
        }
        case 99: {
          if (tag !== 794) {
            break;
          }

          message.changeNotes = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EditPostedInvoiceRequest {
    return {
      orgId: isSet(object.orgId)
        ? globalThis.String(object.orgId)
        : isSet(object.org_id)
        ? globalThis.String(object.org_id)
        : "",
      invoiceId: isSet(object.invoiceId)
        ? globalThis.String(object.invoiceId)
        : isSet(object.invoice_id)
        ? globalThis.String(object.invoice_id)
        : "",
      invoiceDate: isSet(object.invoiceDate)
        ? globalThis.String(object.invoiceDate)
        : isSet(object.invoice_date)
        ? globalThis.String(object.invoice_date)
        : "",
      dueDate: isSet(object.dueDate)
        ? globalThis.String(object.dueDate)
        : isSet(object.due_date)
        ? globalThis.String(object.due_date)
        : "",
      placeOfSupply: isSet(object.placeOfSupply)
        ? globalThis.String(object.placeOfSupply)
        : isSet(object.place_of_supply)
        ? globalThis.String(object.place_of_supply)
        : "",
      placeOfSupplyCode: isSet(object.placeOfSupplyCode)
        ? globalThis.String(object.placeOfSupplyCode)
        : isSet(object.place_of_supply_code)
        ? globalThis.String(object.place_of_supply_code)
        : "",
      poNumber: isSet(object.poNumber)
        ? globalThis.String(object.poNumber)
        : isSet(object.po_number)
        ? globalThis.String(object.po_number)
        : "",
      currency: isSet(object.currency) ? globalThis.String(object.currency) : "",
      exchangeRate: isSet(object.exchangeRate)
        ? globalThis.String(object.exchangeRate)
        : isSet(object.exchange_rate)
        ? globalThis.String(object.exchange_rate)
        : "",
      exportType: isSet(object.exportType)
        ? globalThis.String(object.exportType)
        : isSet(object.export_type)
        ? globalThis.String(object.export_type)
        : "",
      lutNumber: isSet(object.lutNumber)
        ? globalThis.String(object.lutNumber)
        : isSet(object.lut_number)
        ? globalThis.String(object.lut_number)
        : "",
      lutDate: isSet(object.lutDate)
        ? globalThis.String(object.lutDate)
        : isSet(object.lut_date)
        ? globalThis.String(object.lut_date)
        : "",
      countryOfDestination: isSet(object.countryOfDestination)
        ? globalThis.String(object.countryOfDestination)
        : isSet(object.country_of_destination)
        ? globalThis.String(object.country_of_destination)
        : "",
      countryOfDestinationCode: isSet(object.countryOfDestinationCode)
        ? globalThis.String(object.countryOfDestinationCode)
        : isSet(object.country_of_destination_code)
        ? globalThis.String(object.country_of_destination_code)
        : "",
      portOfLoading: isSet(object.portOfLoading)
        ? globalThis.String(object.portOfLoading)
        : isSet(object.port_of_loading)
        ? globalThis.String(object.port_of_loading)
        : "",
      portOfDischarge: isSet(object.portOfDischarge)
        ? globalThis.String(object.portOfDischarge)
        : isSet(object.port_of_discharge)
        ? globalThis.String(object.port_of_discharge)
        : "",
      portCode: isSet(object.portCode)
        ? globalThis.String(object.portCode)
        : isSet(object.port_code)
        ? globalThis.String(object.port_code)
        : "",
      modeOfTransport: isSet(object.modeOfTransport)
        ? globalThis.String(object.modeOfTransport)
        : isSet(object.mode_of_transport)
        ? globalThis.String(object.mode_of_transport)
        : "",
      vesselFlightNumber: isSet(object.vesselFlightNumber)
        ? globalThis.String(object.vesselFlightNumber)
        : isSet(object.vessel_flight_number)
        ? globalThis.String(object.vessel_flight_number)
        : "",
      blAwbNumber: isSet(object.blAwbNumber)
        ? globalThis.String(object.blAwbNumber)
        : isSet(object.bl_awb_number)
        ? globalThis.String(object.bl_awb_number)
        : "",
      containerNumbers: isSet(object.containerNumbers)
        ? globalThis.String(object.containerNumbers)
        : isSet(object.container_numbers)
        ? globalThis.String(object.container_numbers)
        : "",
      shippingBillNumber: isSet(object.shippingBillNumber)
        ? globalThis.String(object.shippingBillNumber)
        : isSet(object.shipping_bill_number)
        ? globalThis.String(object.shipping_bill_number)
        : "",
      shippingBillDate: isSet(object.shippingBillDate)
        ? globalThis.String(object.shippingBillDate)
        : isSet(object.shipping_bill_date)
        ? globalThis.String(object.shipping_bill_date)
        : "",
      shipToAddress: isSet(object.shipToAddress)
        ? Address.fromJSON(object.shipToAddress)
        : isSet(object.ship_to_address)
        ? Address.fromJSON(object.ship_to_address)
        : undefined,
      consigneeAddress: isSet(object.consigneeAddress)
        ? Address.fromJSON(object.consigneeAddress)
        : isSet(object.consignee_address)
        ? Address.fromJSON(object.consignee_address)
        : undefined,
      notifyPartyAddress: isSet(object.notifyPartyAddress)
        ? Address.fromJSON(object.notifyPartyAddress)
        : isSet(object.notify_party_address)
        ? Address.fromJSON(object.notify_party_address)
        : undefined,
      notes: isSet(object.notes) ? globalThis.String(object.notes) : "",
      termsConditions: isSet(object.termsConditions)
        ? globalThis.String(object.termsConditions)
        : isSet(object.terms_conditions)
        ? globalThis.String(object.terms_conditions)
        : "",
      paymentTerms: isSet(object.paymentTerms)
        ? globalThis.String(object.paymentTerms)
        : isSet(object.payment_terms)
        ? globalThis.String(object.payment_terms)
        : "",
      bankDetails: isSet(object.bankDetails)
        ? BankDetails.fromJSON(object.bankDetails)
        : isSet(object.bank_details)
        ? BankDetails.fromJSON(object.bank_details)
        : undefined,
      items: globalThis.Array.isArray(object?.items)
        ? object.items.map((e: any) => CreateInvoiceItemRequest.fromJSON(e))
        : [],
      roundOffAmount: isSet(object.roundOffAmount)
        ? globalThis.String(object.roundOffAmount)
        : isSet(object.round_off_amount)
        ? globalThis.String(object.round_off_amount)
        : "0",
      invoiceNumber: isSet(object.invoiceNumber)
        ? globalThis.String(object.invoiceNumber)
        : isSet(object.invoice_number)
        ? globalThis.String(object.invoice_number)
        : undefined,
      supplierBillNumber: isSet(object.supplierBillNumber)
        ? globalThis.String(object.supplierBillNumber)
        : isSet(object.supplier_bill_number)
        ? globalThis.String(object.supplier_bill_number)
        : "",
      changeNotes: isSet(object.changeNotes)
        ? globalThis.String(object.changeNotes)
        : isSet(object.change_notes)
        ? globalThis.String(object.change_notes)
        : "",
    };
  },

  toJSON(message: EditPostedInvoiceRequest): unknown {
    const obj: any = {};
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.invoiceId !== "") {
      obj.invoiceId = message.invoiceId;
    }
    if (message.invoiceDate !== "") {
      obj.invoiceDate = message.invoiceDate;
    }
    if (message.dueDate !== "") {
      obj.dueDate = message.dueDate;
    }
    if (message.placeOfSupply !== "") {
      obj.placeOfSupply = message.placeOfSupply;
    }
    if (message.placeOfSupplyCode !== "") {
      obj.placeOfSupplyCode = message.placeOfSupplyCode;
    }
    if (message.poNumber !== "") {
      obj.poNumber = message.poNumber;
    }
    if (message.currency !== "") {
      obj.currency = message.currency;
    }
    if (message.exchangeRate !== "") {
      obj.exchangeRate = message.exchangeRate;
    }
    if (message.exportType !== "") {
      obj.exportType = message.exportType;
    }
    if (message.lutNumber !== "") {
      obj.lutNumber = message.lutNumber;
    }
    if (message.lutDate !== "") {
      obj.lutDate = message.lutDate;
    }
    if (message.countryOfDestination !== "") {
      obj.countryOfDestination = message.countryOfDestination;
    }
    if (message.countryOfDestinationCode !== "") {
      obj.countryOfDestinationCode = message.countryOfDestinationCode;
    }
    if (message.portOfLoading !== "") {
      obj.portOfLoading = message.portOfLoading;
    }
    if (message.portOfDischarge !== "") {
      obj.portOfDischarge = message.portOfDischarge;
    }
    if (message.portCode !== "") {
      obj.portCode = message.portCode;
    }
    if (message.modeOfTransport !== "") {
      obj.modeOfTransport = message.modeOfTransport;
    }
    if (message.vesselFlightNumber !== "") {
      obj.vesselFlightNumber = message.vesselFlightNumber;
    }
    if (message.blAwbNumber !== "") {
      obj.blAwbNumber = message.blAwbNumber;
    }
    if (message.containerNumbers !== "") {
      obj.containerNumbers = message.containerNumbers;
    }
    if (message.shippingBillNumber !== "") {
      obj.shippingBillNumber = message.shippingBillNumber;
    }
    if (message.shippingBillDate !== "") {
      obj.shippingBillDate = message.shippingBillDate;
    }
    if (message.shipToAddress !== undefined) {
      obj.shipToAddress = Address.toJSON(message.shipToAddress);
    }
    if (message.consigneeAddress !== undefined) {
      obj.consigneeAddress = Address.toJSON(message.consigneeAddress);
    }
    if (message.notifyPartyAddress !== undefined) {
      obj.notifyPartyAddress = Address.toJSON(message.notifyPartyAddress);
    }
    if (message.notes !== "") {
      obj.notes = message.notes;
    }
    if (message.termsConditions !== "") {
      obj.termsConditions = message.termsConditions;
    }
    if (message.paymentTerms !== "") {
      obj.paymentTerms = message.paymentTerms;
    }
    if (message.bankDetails !== undefined) {
      obj.bankDetails = BankDetails.toJSON(message.bankDetails);
    }
    if (message.items?.length) {
      obj.items = message.items.map((e) => CreateInvoiceItemRequest.toJSON(e));
    }
    if (message.roundOffAmount !== "0") {
      obj.roundOffAmount = message.roundOffAmount;
    }
    if (message.invoiceNumber !== undefined) {
      obj.invoiceNumber = message.invoiceNumber;
    }
    if (message.supplierBillNumber !== "") {
      obj.supplierBillNumber = message.supplierBillNumber;
    }
    if (message.changeNotes !== "") {
      obj.changeNotes = message.changeNotes;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EditPostedInvoiceRequest>, I>>(base?: I): EditPostedInvoiceRequest {
    return EditPostedInvoiceRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EditPostedInvoiceRequest>, I>>(object: I): EditPostedInvoiceRequest {
    const message = createBaseEditPostedInvoiceRequest();
    message.orgId = object.orgId ?? "";
    message.invoiceId = object.invoiceId ?? "";
    message.invoiceDate = object.invoiceDate ?? "";
    message.dueDate = object.dueDate ?? "";
    message.placeOfSupply = object.placeOfSupply ?? "";
    message.placeOfSupplyCode = object.placeOfSupplyCode ?? "";
    message.poNumber = object.poNumber ?? "";
    message.currency = object.currency ?? "";
    message.exchangeRate = object.exchangeRate ?? "";
    message.exportType = object.exportType ?? "";
    message.lutNumber = object.lutNumber ?? "";
    message.lutDate = object.lutDate ?? "";
    message.countryOfDestination = object.countryOfDestination ?? "";
    message.countryOfDestinationCode = object.countryOfDestinationCode ?? "";
    message.portOfLoading = object.portOfLoading ?? "";
    message.portOfDischarge = object.portOfDischarge ?? "";
    message.portCode = object.portCode ?? "";
    message.modeOfTransport = object.modeOfTransport ?? "";
    message.vesselFlightNumber = object.vesselFlightNumber ?? "";
    message.blAwbNumber = object.blAwbNumber ?? "";
    message.containerNumbers = object.containerNumbers ?? "";
    message.shippingBillNumber = object.shippingBillNumber ?? "";
    message.shippingBillDate = object.shippingBillDate ?? "";
    message.shipToAddress = (object.shipToAddress !== undefined && object.shipToAddress !== null)
      ? Address.fromPartial(object.shipToAddress)
      : undefined;
    message.consigneeAddress = (object.consigneeAddress !== undefined && object.consigneeAddress !== null)
      ? Address.fromPartial(object.consigneeAddress)
      : undefined;
    message.notifyPartyAddress = (object.notifyPartyAddress !== undefined && object.notifyPartyAddress !== null)
      ? Address.fromPartial(object.notifyPartyAddress)
      : undefined;
    message.notes = object.notes ?? "";
    message.termsConditions = object.termsConditions ?? "";
    message.paymentTerms = object.paymentTerms ?? "";
    message.bankDetails = (object.bankDetails !== undefined && object.bankDetails !== null)
      ? BankDetails.fromPartial(object.bankDetails)
      : undefined;
    message.items = object.items?.map((e) => CreateInvoiceItemRequest.fromPartial(e)) || [];
    message.roundOffAmount = object.roundOffAmount ?? "0";
    message.invoiceNumber = object.invoiceNumber ?? undefined;
    message.supplierBillNumber = object.supplierBillNumber ?? "";
    message.changeNotes = object.changeNotes ?? "";
    return message;
  },
};

function createBaseCreateInvoiceFromSORequest(): CreateInvoiceFromSORequest {
  return {
    orgId: "",
    salesOrderId: "",
    invoiceDate: "",
    dueDate: "",
    items: [],
    placeOfSupply: "",
    placeOfSupplyCode: "",
    idempotencyKey: "",
  };
}

export const CreateInvoiceFromSORequest: MessageFns<CreateInvoiceFromSORequest> = {
  encode(message: CreateInvoiceFromSORequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgId !== "") {
      writer.uint32(10).string(message.orgId);
    }
    if (message.salesOrderId !== "") {
      writer.uint32(18).string(message.salesOrderId);
    }
    if (message.invoiceDate !== "") {
      writer.uint32(26).string(message.invoiceDate);
    }
    if (message.dueDate !== "") {
      writer.uint32(34).string(message.dueDate);
    }
    for (const v of message.items) {
      CreateInvoiceItemRequest.encode(v!, writer.uint32(42).fork()).join();
    }
    if (message.placeOfSupply !== "") {
      writer.uint32(50).string(message.placeOfSupply);
    }
    if (message.placeOfSupplyCode !== "") {
      writer.uint32(58).string(message.placeOfSupplyCode);
    }
    if (message.idempotencyKey !== "") {
      writer.uint32(722).string(message.idempotencyKey);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateInvoiceFromSORequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateInvoiceFromSORequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.salesOrderId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.invoiceDate = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.dueDate = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.items.push(CreateInvoiceItemRequest.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.placeOfSupply = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.placeOfSupplyCode = reader.string();
          continue;
        }
        case 90: {
          if (tag !== 722) {
            break;
          }

          message.idempotencyKey = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateInvoiceFromSORequest {
    return {
      orgId: isSet(object.orgId)
        ? globalThis.String(object.orgId)
        : isSet(object.org_id)
        ? globalThis.String(object.org_id)
        : "",
      salesOrderId: isSet(object.salesOrderId)
        ? globalThis.String(object.salesOrderId)
        : isSet(object.sales_order_id)
        ? globalThis.String(object.sales_order_id)
        : "",
      invoiceDate: isSet(object.invoiceDate)
        ? globalThis.String(object.invoiceDate)
        : isSet(object.invoice_date)
        ? globalThis.String(object.invoice_date)
        : "",
      dueDate: isSet(object.dueDate)
        ? globalThis.String(object.dueDate)
        : isSet(object.due_date)
        ? globalThis.String(object.due_date)
        : "",
      items: globalThis.Array.isArray(object?.items)
        ? object.items.map((e: any) => CreateInvoiceItemRequest.fromJSON(e))
        : [],
      placeOfSupply: isSet(object.placeOfSupply)
        ? globalThis.String(object.placeOfSupply)
        : isSet(object.place_of_supply)
        ? globalThis.String(object.place_of_supply)
        : "",
      placeOfSupplyCode: isSet(object.placeOfSupplyCode)
        ? globalThis.String(object.placeOfSupplyCode)
        : isSet(object.place_of_supply_code)
        ? globalThis.String(object.place_of_supply_code)
        : "",
      idempotencyKey: isSet(object.idempotencyKey)
        ? globalThis.String(object.idempotencyKey)
        : isSet(object.idempotency_key)
        ? globalThis.String(object.idempotency_key)
        : "",
    };
  },

  toJSON(message: CreateInvoiceFromSORequest): unknown {
    const obj: any = {};
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.salesOrderId !== "") {
      obj.salesOrderId = message.salesOrderId;
    }
    if (message.invoiceDate !== "") {
      obj.invoiceDate = message.invoiceDate;
    }
    if (message.dueDate !== "") {
      obj.dueDate = message.dueDate;
    }
    if (message.items?.length) {
      obj.items = message.items.map((e) => CreateInvoiceItemRequest.toJSON(e));
    }
    if (message.placeOfSupply !== "") {
      obj.placeOfSupply = message.placeOfSupply;
    }
    if (message.placeOfSupplyCode !== "") {
      obj.placeOfSupplyCode = message.placeOfSupplyCode;
    }
    if (message.idempotencyKey !== "") {
      obj.idempotencyKey = message.idempotencyKey;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateInvoiceFromSORequest>, I>>(base?: I): CreateInvoiceFromSORequest {
    return CreateInvoiceFromSORequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateInvoiceFromSORequest>, I>>(object: I): CreateInvoiceFromSORequest {
    const message = createBaseCreateInvoiceFromSORequest();
    message.orgId = object.orgId ?? "";
    message.salesOrderId = object.salesOrderId ?? "";
    message.invoiceDate = object.invoiceDate ?? "";
    message.dueDate = object.dueDate ?? "";
    message.items = object.items?.map((e) => CreateInvoiceItemRequest.fromPartial(e)) || [];
    message.placeOfSupply = object.placeOfSupply ?? "";
    message.placeOfSupplyCode = object.placeOfSupplyCode ?? "";
    message.idempotencyKey = object.idempotencyKey ?? "";
    return message;
  },
};

function createBaseCreateInvoiceFromSOResponse(): CreateInvoiceFromSOResponse {
  return { invoice: undefined, appliedAdvanceAmount: "0", adjustmentJournalEntryId: "" };
}

export const CreateInvoiceFromSOResponse: MessageFns<CreateInvoiceFromSOResponse> = {
  encode(message: CreateInvoiceFromSOResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.invoice !== undefined) {
      Invoice.encode(message.invoice, writer.uint32(10).fork()).join();
    }
    if (message.appliedAdvanceAmount !== "0") {
      writer.uint32(16).int64(message.appliedAdvanceAmount);
    }
    if (message.adjustmentJournalEntryId !== "") {
      writer.uint32(26).string(message.adjustmentJournalEntryId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateInvoiceFromSOResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateInvoiceFromSOResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.invoice = Invoice.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.appliedAdvanceAmount = reader.int64().toString();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.adjustmentJournalEntryId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateInvoiceFromSOResponse {
    return {
      invoice: isSet(object.invoice) ? Invoice.fromJSON(object.invoice) : undefined,
      appliedAdvanceAmount: isSet(object.appliedAdvanceAmount)
        ? globalThis.String(object.appliedAdvanceAmount)
        : isSet(object.applied_advance_amount)
        ? globalThis.String(object.applied_advance_amount)
        : "0",
      adjustmentJournalEntryId: isSet(object.adjustmentJournalEntryId)
        ? globalThis.String(object.adjustmentJournalEntryId)
        : isSet(object.adjustment_journal_entry_id)
        ? globalThis.String(object.adjustment_journal_entry_id)
        : "",
    };
  },

  toJSON(message: CreateInvoiceFromSOResponse): unknown {
    const obj: any = {};
    if (message.invoice !== undefined) {
      obj.invoice = Invoice.toJSON(message.invoice);
    }
    if (message.appliedAdvanceAmount !== "0") {
      obj.appliedAdvanceAmount = message.appliedAdvanceAmount;
    }
    if (message.adjustmentJournalEntryId !== "") {
      obj.adjustmentJournalEntryId = message.adjustmentJournalEntryId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateInvoiceFromSOResponse>, I>>(base?: I): CreateInvoiceFromSOResponse {
    return CreateInvoiceFromSOResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateInvoiceFromSOResponse>, I>>(object: I): CreateInvoiceFromSOResponse {
    const message = createBaseCreateInvoiceFromSOResponse();
    message.invoice = (object.invoice !== undefined && object.invoice !== null)
      ? Invoice.fromPartial(object.invoice)
      : undefined;
    message.appliedAdvanceAmount = object.appliedAdvanceAmount ?? "0";
    message.adjustmentJournalEntryId = object.adjustmentJournalEntryId ?? "";
    return message;
  },
};

function createBaseListInvoicesRequest(): ListInvoicesRequest {
  return {
    orgId: "",
    ledgerId: "",
    invoiceType: 0,
    status: 0,
    partyId: "",
    startDate: "",
    endDate: "",
    pageSize: 0,
    pageToken: "",
    page: 0,
    search: "",
    sortField: "",
    sortDir: "",
    paymentStatus: "",
    currency: "",
  };
}

export const ListInvoicesRequest: MessageFns<ListInvoicesRequest> = {
  encode(message: ListInvoicesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgId !== "") {
      writer.uint32(10).string(message.orgId);
    }
    if (message.ledgerId !== "") {
      writer.uint32(18).string(message.ledgerId);
    }
    if (message.invoiceType !== 0) {
      writer.uint32(24).int32(message.invoiceType);
    }
    if (message.status !== 0) {
      writer.uint32(32).int32(message.status);
    }
    if (message.partyId !== "") {
      writer.uint32(42).string(message.partyId);
    }
    if (message.startDate !== "") {
      writer.uint32(50).string(message.startDate);
    }
    if (message.endDate !== "") {
      writer.uint32(58).string(message.endDate);
    }
    if (message.pageSize !== 0) {
      writer.uint32(64).int32(message.pageSize);
    }
    if (message.pageToken !== "") {
      writer.uint32(74).string(message.pageToken);
    }
    if (message.page !== 0) {
      writer.uint32(80).int32(message.page);
    }
    if (message.search !== "") {
      writer.uint32(90).string(message.search);
    }
    if (message.sortField !== "") {
      writer.uint32(98).string(message.sortField);
    }
    if (message.sortDir !== "") {
      writer.uint32(106).string(message.sortDir);
    }
    if (message.paymentStatus !== "") {
      writer.uint32(114).string(message.paymentStatus);
    }
    if (message.currency !== "") {
      writer.uint32(122).string(message.currency);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListInvoicesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListInvoicesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ledgerId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.invoiceType = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.partyId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.startDate = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.endDate = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.pageSize = reader.int32();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.pageToken = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.page = reader.int32();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.search = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.sortField = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.sortDir = reader.string();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.paymentStatus = reader.string();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.currency = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListInvoicesRequest {
    return {
      orgId: isSet(object.orgId)
        ? globalThis.String(object.orgId)
        : isSet(object.org_id)
        ? globalThis.String(object.org_id)
        : "",
      ledgerId: isSet(object.ledgerId)
        ? globalThis.String(object.ledgerId)
        : isSet(object.ledger_id)
        ? globalThis.String(object.ledger_id)
        : "",
      invoiceType: isSet(object.invoiceType)
        ? invoiceTypeFromJSON(object.invoiceType)
        : isSet(object.invoice_type)
        ? invoiceTypeFromJSON(object.invoice_type)
        : 0,
      status: isSet(object.status) ? invoiceStatusFromJSON(object.status) : 0,
      partyId: isSet(object.partyId)
        ? globalThis.String(object.partyId)
        : isSet(object.party_id)
        ? globalThis.String(object.party_id)
        : "",
      startDate: isSet(object.startDate)
        ? globalThis.String(object.startDate)
        : isSet(object.start_date)
        ? globalThis.String(object.start_date)
        : "",
      endDate: isSet(object.endDate)
        ? globalThis.String(object.endDate)
        : isSet(object.end_date)
        ? globalThis.String(object.end_date)
        : "",
      pageSize: isSet(object.pageSize)
        ? globalThis.Number(object.pageSize)
        : isSet(object.page_size)
        ? globalThis.Number(object.page_size)
        : 0,
      pageToken: isSet(object.pageToken)
        ? globalThis.String(object.pageToken)
        : isSet(object.page_token)
        ? globalThis.String(object.page_token)
        : "",
      page: isSet(object.page) ? globalThis.Number(object.page) : 0,
      search: isSet(object.search) ? globalThis.String(object.search) : "",
      sortField: isSet(object.sortField)
        ? globalThis.String(object.sortField)
        : isSet(object.sort_field)
        ? globalThis.String(object.sort_field)
        : "",
      sortDir: isSet(object.sortDir)
        ? globalThis.String(object.sortDir)
        : isSet(object.sort_dir)
        ? globalThis.String(object.sort_dir)
        : "",
      paymentStatus: isSet(object.paymentStatus)
        ? globalThis.String(object.paymentStatus)
        : isSet(object.payment_status)
        ? globalThis.String(object.payment_status)
        : "",
      currency: isSet(object.currency) ? globalThis.String(object.currency) : "",
    };
  },

  toJSON(message: ListInvoicesRequest): unknown {
    const obj: any = {};
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.ledgerId !== "") {
      obj.ledgerId = message.ledgerId;
    }
    if (message.invoiceType !== 0) {
      obj.invoiceType = invoiceTypeToJSON(message.invoiceType);
    }
    if (message.status !== 0) {
      obj.status = invoiceStatusToJSON(message.status);
    }
    if (message.partyId !== "") {
      obj.partyId = message.partyId;
    }
    if (message.startDate !== "") {
      obj.startDate = message.startDate;
    }
    if (message.endDate !== "") {
      obj.endDate = message.endDate;
    }
    if (message.pageSize !== 0) {
      obj.pageSize = Math.round(message.pageSize);
    }
    if (message.pageToken !== "") {
      obj.pageToken = message.pageToken;
    }
    if (message.page !== 0) {
      obj.page = Math.round(message.page);
    }
    if (message.search !== "") {
      obj.search = message.search;
    }
    if (message.sortField !== "") {
      obj.sortField = message.sortField;
    }
    if (message.sortDir !== "") {
      obj.sortDir = message.sortDir;
    }
    if (message.paymentStatus !== "") {
      obj.paymentStatus = message.paymentStatus;
    }
    if (message.currency !== "") {
      obj.currency = message.currency;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListInvoicesRequest>, I>>(base?: I): ListInvoicesRequest {
    return ListInvoicesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListInvoicesRequest>, I>>(object: I): ListInvoicesRequest {
    const message = createBaseListInvoicesRequest();
    message.orgId = object.orgId ?? "";
    message.ledgerId = object.ledgerId ?? "";
    message.invoiceType = object.invoiceType ?? 0;
    message.status = object.status ?? 0;
    message.partyId = object.partyId ?? "";
    message.startDate = object.startDate ?? "";
    message.endDate = object.endDate ?? "";
    message.pageSize = object.pageSize ?? 0;
    message.pageToken = object.pageToken ?? "";
    message.page = object.page ?? 0;
    message.search = object.search ?? "";
    message.sortField = object.sortField ?? "";
    message.sortDir = object.sortDir ?? "";
    message.paymentStatus = object.paymentStatus ?? "";
    message.currency = object.currency ?? "";
    return message;
  },
};

function createBaseListInvoicesResponse(): ListInvoicesResponse {
  return {
    invoices: [],
    nextPageToken: "",
    totalCount: 0,
    sumTotalAmount: "0",
    sumTaxAmount: "0",
    remainingCount: 0,
    remainingIsExact: false,
  };
}

export const ListInvoicesResponse: MessageFns<ListInvoicesResponse> = {
  encode(message: ListInvoicesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.invoices) {
      Invoice.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.nextPageToken !== "") {
      writer.uint32(18).string(message.nextPageToken);
    }
    if (message.totalCount !== 0) {
      writer.uint32(24).int32(message.totalCount);
    }
    if (message.sumTotalAmount !== "0") {
      writer.uint32(32).int64(message.sumTotalAmount);
    }
    if (message.sumTaxAmount !== "0") {
      writer.uint32(40).int64(message.sumTaxAmount);
    }
    if (message.remainingCount !== 0) {
      writer.uint32(48).int32(message.remainingCount);
    }
    if (message.remainingIsExact !== false) {
      writer.uint32(56).bool(message.remainingIsExact);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListInvoicesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListInvoicesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.invoices.push(Invoice.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.nextPageToken = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.totalCount = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.sumTotalAmount = reader.int64().toString();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.sumTaxAmount = reader.int64().toString();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.remainingCount = reader.int32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.remainingIsExact = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListInvoicesResponse {
    return {
      invoices: globalThis.Array.isArray(object?.invoices) ? object.invoices.map((e: any) => Invoice.fromJSON(e)) : [],
      nextPageToken: isSet(object.nextPageToken)
        ? globalThis.String(object.nextPageToken)
        : isSet(object.next_page_token)
        ? globalThis.String(object.next_page_token)
        : "",
      totalCount: isSet(object.totalCount)
        ? globalThis.Number(object.totalCount)
        : isSet(object.total_count)
        ? globalThis.Number(object.total_count)
        : 0,
      sumTotalAmount: isSet(object.sumTotalAmount)
        ? globalThis.String(object.sumTotalAmount)
        : isSet(object.sum_total_amount)
        ? globalThis.String(object.sum_total_amount)
        : "0",
      sumTaxAmount: isSet(object.sumTaxAmount)
        ? globalThis.String(object.sumTaxAmount)
        : isSet(object.sum_tax_amount)
        ? globalThis.String(object.sum_tax_amount)
        : "0",
      remainingCount: isSet(object.remainingCount)
        ? globalThis.Number(object.remainingCount)
        : isSet(object.remaining_count)
        ? globalThis.Number(object.remaining_count)
        : 0,
      remainingIsExact: isSet(object.remainingIsExact)
        ? globalThis.Boolean(object.remainingIsExact)
        : isSet(object.remaining_is_exact)
        ? globalThis.Boolean(object.remaining_is_exact)
        : false,
    };
  },

  toJSON(message: ListInvoicesResponse): unknown {
    const obj: any = {};
    if (message.invoices?.length) {
      obj.invoices = message.invoices.map((e) => Invoice.toJSON(e));
    }
    if (message.nextPageToken !== "") {
      obj.nextPageToken = message.nextPageToken;
    }
    if (message.totalCount !== 0) {
      obj.totalCount = Math.round(message.totalCount);
    }
    if (message.sumTotalAmount !== "0") {
      obj.sumTotalAmount = message.sumTotalAmount;
    }
    if (message.sumTaxAmount !== "0") {
      obj.sumTaxAmount = message.sumTaxAmount;
    }
    if (message.remainingCount !== 0) {
      obj.remainingCount = Math.round(message.remainingCount);
    }
    if (message.remainingIsExact !== false) {
      obj.remainingIsExact = message.remainingIsExact;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListInvoicesResponse>, I>>(base?: I): ListInvoicesResponse {
    return ListInvoicesResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListInvoicesResponse>, I>>(object: I): ListInvoicesResponse {
    const message = createBaseListInvoicesResponse();
    message.invoices = object.invoices?.map((e) => Invoice.fromPartial(e)) || [];
    message.nextPageToken = object.nextPageToken ?? "";
    message.totalCount = object.totalCount ?? 0;
    message.sumTotalAmount = object.sumTotalAmount ?? "0";
    message.sumTaxAmount = object.sumTaxAmount ?? "0";
    message.remainingCount = object.remainingCount ?? 0;
    message.remainingIsExact = object.remainingIsExact ?? false;
    return message;
  },
};

function createBaseListInvoicesByPartyRequest(): ListInvoicesByPartyRequest {
  return { orgId: "", partyId: "", pageSize: 0, pageToken: "" };
}

export const ListInvoicesByPartyRequest: MessageFns<ListInvoicesByPartyRequest> = {
  encode(message: ListInvoicesByPartyRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgId !== "") {
      writer.uint32(10).string(message.orgId);
    }
    if (message.partyId !== "") {
      writer.uint32(18).string(message.partyId);
    }
    if (message.pageSize !== 0) {
      writer.uint32(24).int32(message.pageSize);
    }
    if (message.pageToken !== "") {
      writer.uint32(34).string(message.pageToken);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListInvoicesByPartyRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListInvoicesByPartyRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.partyId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.pageSize = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.pageToken = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListInvoicesByPartyRequest {
    return {
      orgId: isSet(object.orgId)
        ? globalThis.String(object.orgId)
        : isSet(object.org_id)
        ? globalThis.String(object.org_id)
        : "",
      partyId: isSet(object.partyId)
        ? globalThis.String(object.partyId)
        : isSet(object.party_id)
        ? globalThis.String(object.party_id)
        : "",
      pageSize: isSet(object.pageSize)
        ? globalThis.Number(object.pageSize)
        : isSet(object.page_size)
        ? globalThis.Number(object.page_size)
        : 0,
      pageToken: isSet(object.pageToken)
        ? globalThis.String(object.pageToken)
        : isSet(object.page_token)
        ? globalThis.String(object.page_token)
        : "",
    };
  },

  toJSON(message: ListInvoicesByPartyRequest): unknown {
    const obj: any = {};
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.partyId !== "") {
      obj.partyId = message.partyId;
    }
    if (message.pageSize !== 0) {
      obj.pageSize = Math.round(message.pageSize);
    }
    if (message.pageToken !== "") {
      obj.pageToken = message.pageToken;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListInvoicesByPartyRequest>, I>>(base?: I): ListInvoicesByPartyRequest {
    return ListInvoicesByPartyRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListInvoicesByPartyRequest>, I>>(object: I): ListInvoicesByPartyRequest {
    const message = createBaseListInvoicesByPartyRequest();
    message.orgId = object.orgId ?? "";
    message.partyId = object.partyId ?? "";
    message.pageSize = object.pageSize ?? 0;
    message.pageToken = object.pageToken ?? "";
    return message;
  },
};

function createBaseGenerateInvoicePDFRequest(): GenerateInvoicePDFRequest {
  return { orgId: "", invoiceId: "" };
}

export const GenerateInvoicePDFRequest: MessageFns<GenerateInvoicePDFRequest> = {
  encode(message: GenerateInvoicePDFRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgId !== "") {
      writer.uint32(10).string(message.orgId);
    }
    if (message.invoiceId !== "") {
      writer.uint32(18).string(message.invoiceId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GenerateInvoicePDFRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGenerateInvoicePDFRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.invoiceId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GenerateInvoicePDFRequest {
    return {
      orgId: isSet(object.orgId)
        ? globalThis.String(object.orgId)
        : isSet(object.org_id)
        ? globalThis.String(object.org_id)
        : "",
      invoiceId: isSet(object.invoiceId)
        ? globalThis.String(object.invoiceId)
        : isSet(object.invoice_id)
        ? globalThis.String(object.invoice_id)
        : "",
    };
  },

  toJSON(message: GenerateInvoicePDFRequest): unknown {
    const obj: any = {};
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.invoiceId !== "") {
      obj.invoiceId = message.invoiceId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GenerateInvoicePDFRequest>, I>>(base?: I): GenerateInvoicePDFRequest {
    return GenerateInvoicePDFRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GenerateInvoicePDFRequest>, I>>(object: I): GenerateInvoicePDFRequest {
    const message = createBaseGenerateInvoicePDFRequest();
    message.orgId = object.orgId ?? "";
    message.invoiceId = object.invoiceId ?? "";
    return message;
  },
};

function createBaseGenerateInvoicePDFResponse(): GenerateInvoicePDFResponse {
  return { pdfContent: new Uint8Array(0), filename: "", contentType: "" };
}

export const GenerateInvoicePDFResponse: MessageFns<GenerateInvoicePDFResponse> = {
  encode(message: GenerateInvoicePDFResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pdfContent.length !== 0) {
      writer.uint32(10).bytes(message.pdfContent);
    }
    if (message.filename !== "") {
      writer.uint32(18).string(message.filename);
    }
    if (message.contentType !== "") {
      writer.uint32(26).string(message.contentType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GenerateInvoicePDFResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGenerateInvoicePDFResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.pdfContent = reader.bytes();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.filename = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.contentType = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GenerateInvoicePDFResponse {
    return {
      pdfContent: isSet(object.pdfContent)
        ? bytesFromBase64(object.pdfContent)
        : isSet(object.pdf_content)
        ? bytesFromBase64(object.pdf_content)
        : new Uint8Array(0),
      filename: isSet(object.filename) ? globalThis.String(object.filename) : "",
      contentType: isSet(object.contentType)
        ? globalThis.String(object.contentType)
        : isSet(object.content_type)
        ? globalThis.String(object.content_type)
        : "",
    };
  },

  toJSON(message: GenerateInvoicePDFResponse): unknown {
    const obj: any = {};
    if (message.pdfContent.length !== 0) {
      obj.pdfContent = base64FromBytes(message.pdfContent);
    }
    if (message.filename !== "") {
      obj.filename = message.filename;
    }
    if (message.contentType !== "") {
      obj.contentType = message.contentType;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GenerateInvoicePDFResponse>, I>>(base?: I): GenerateInvoicePDFResponse {
    return GenerateInvoicePDFResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GenerateInvoicePDFResponse>, I>>(object: I): GenerateInvoicePDFResponse {
    const message = createBaseGenerateInvoicePDFResponse();
    message.pdfContent = object.pdfContent ?? new Uint8Array(0);
    message.filename = object.filename ?? "";
    message.contentType = object.contentType ?? "";
    return message;
  },
};

function createBaseGetNextInvoiceNumberRequest(): GetNextInvoiceNumberRequest {
  return { orgId: "", ledgerId: "", invoiceType: 0 };
}

export const GetNextInvoiceNumberRequest: MessageFns<GetNextInvoiceNumberRequest> = {
  encode(message: GetNextInvoiceNumberRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgId !== "") {
      writer.uint32(10).string(message.orgId);
    }
    if (message.ledgerId !== "") {
      writer.uint32(18).string(message.ledgerId);
    }
    if (message.invoiceType !== 0) {
      writer.uint32(24).int32(message.invoiceType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetNextInvoiceNumberRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetNextInvoiceNumberRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ledgerId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.invoiceType = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetNextInvoiceNumberRequest {
    return {
      orgId: isSet(object.orgId)
        ? globalThis.String(object.orgId)
        : isSet(object.org_id)
        ? globalThis.String(object.org_id)
        : "",
      ledgerId: isSet(object.ledgerId)
        ? globalThis.String(object.ledgerId)
        : isSet(object.ledger_id)
        ? globalThis.String(object.ledger_id)
        : "",
      invoiceType: isSet(object.invoiceType)
        ? invoiceTypeFromJSON(object.invoiceType)
        : isSet(object.invoice_type)
        ? invoiceTypeFromJSON(object.invoice_type)
        : 0,
    };
  },

  toJSON(message: GetNextInvoiceNumberRequest): unknown {
    const obj: any = {};
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.ledgerId !== "") {
      obj.ledgerId = message.ledgerId;
    }
    if (message.invoiceType !== 0) {
      obj.invoiceType = invoiceTypeToJSON(message.invoiceType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetNextInvoiceNumberRequest>, I>>(base?: I): GetNextInvoiceNumberRequest {
    return GetNextInvoiceNumberRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetNextInvoiceNumberRequest>, I>>(object: I): GetNextInvoiceNumberRequest {
    const message = createBaseGetNextInvoiceNumberRequest();
    message.orgId = object.orgId ?? "";
    message.ledgerId = object.ledgerId ?? "";
    message.invoiceType = object.invoiceType ?? 0;
    return message;
  },
};

function createBaseGetNextInvoiceNumberResponse(): GetNextInvoiceNumberResponse {
  return { invoiceNumber: "", prefix: "" };
}

export const GetNextInvoiceNumberResponse: MessageFns<GetNextInvoiceNumberResponse> = {
  encode(message: GetNextInvoiceNumberResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.invoiceNumber !== "") {
      writer.uint32(10).string(message.invoiceNumber);
    }
    if (message.prefix !== "") {
      writer.uint32(18).string(message.prefix);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetNextInvoiceNumberResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetNextInvoiceNumberResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.invoiceNumber = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.prefix = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetNextInvoiceNumberResponse {
    return {
      invoiceNumber: isSet(object.invoiceNumber)
        ? globalThis.String(object.invoiceNumber)
        : isSet(object.invoice_number)
        ? globalThis.String(object.invoice_number)
        : "",
      prefix: isSet(object.prefix) ? globalThis.String(object.prefix) : "",
    };
  },

  toJSON(message: GetNextInvoiceNumberResponse): unknown {
    const obj: any = {};
    if (message.invoiceNumber !== "") {
      obj.invoiceNumber = message.invoiceNumber;
    }
    if (message.prefix !== "") {
      obj.prefix = message.prefix;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetNextInvoiceNumberResponse>, I>>(base?: I): GetNextInvoiceNumberResponse {
    return GetNextInvoiceNumberResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetNextInvoiceNumberResponse>, I>>(object: I): GetNextInvoiceNumberResponse {
    const message = createBaseGetNextInvoiceNumberResponse();
    message.invoiceNumber = object.invoiceNumber ?? "";
    message.prefix = object.prefix ?? "";
    return message;
  },
};

function createBaseCompanySettings(): CompanySettings {
  return {
    id: "",
    orgId: "",
    ledgerId: "",
    companyName: "",
    tradeName: "",
    logoPath: "",
    logoUrl: "",
    logoMimeType: "",
    address: "",
    city: "",
    state: "",
    stateCode: "",
    postalCode: "",
    country: "",
    countryCode: "",
    gstin: "",
    pan: "",
    cin: "",
    tan: "",
    ieCode: "",
    lutNumber: "",
    lutDate: "",
    email: "",
    phone: "",
    website: "",
    defaultBankDetails: undefined,
    invoicePrefix: "",
    invoiceNumberFormat: "",
    invoiceFooterText: "",
    invoiceTerms: "",
    defaultPaymentTerms: "",
    defaultCreditDays: 0,
    baseCurrency: "",
    createdAt: undefined,
    updatedAt: undefined,
    createdBy: "",
    updatedBy: "",
  };
}

export const CompanySettings: MessageFns<CompanySettings> = {
  encode(message: CompanySettings, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.orgId !== "") {
      writer.uint32(18).string(message.orgId);
    }
    if (message.ledgerId !== "") {
      writer.uint32(26).string(message.ledgerId);
    }
    if (message.companyName !== "") {
      writer.uint32(34).string(message.companyName);
    }
    if (message.tradeName !== "") {
      writer.uint32(42).string(message.tradeName);
    }
    if (message.logoPath !== "") {
      writer.uint32(50).string(message.logoPath);
    }
    if (message.logoUrl !== "") {
      writer.uint32(58).string(message.logoUrl);
    }
    if (message.logoMimeType !== "") {
      writer.uint32(66).string(message.logoMimeType);
    }
    if (message.address !== "") {
      writer.uint32(74).string(message.address);
    }
    if (message.city !== "") {
      writer.uint32(82).string(message.city);
    }
    if (message.state !== "") {
      writer.uint32(90).string(message.state);
    }
    if (message.stateCode !== "") {
      writer.uint32(98).string(message.stateCode);
    }
    if (message.postalCode !== "") {
      writer.uint32(106).string(message.postalCode);
    }
    if (message.country !== "") {
      writer.uint32(114).string(message.country);
    }
    if (message.countryCode !== "") {
      writer.uint32(122).string(message.countryCode);
    }
    if (message.gstin !== "") {
      writer.uint32(130).string(message.gstin);
    }
    if (message.pan !== "") {
      writer.uint32(138).string(message.pan);
    }
    if (message.cin !== "") {
      writer.uint32(146).string(message.cin);
    }
    if (message.tan !== "") {
      writer.uint32(154).string(message.tan);
    }
    if (message.ieCode !== "") {
      writer.uint32(162).string(message.ieCode);
    }
    if (message.lutNumber !== "") {
      writer.uint32(170).string(message.lutNumber);
    }
    if (message.lutDate !== "") {
      writer.uint32(178).string(message.lutDate);
    }
    if (message.email !== "") {
      writer.uint32(186).string(message.email);
    }
    if (message.phone !== "") {
      writer.uint32(194).string(message.phone);
    }
    if (message.website !== "") {
      writer.uint32(202).string(message.website);
    }
    if (message.defaultBankDetails !== undefined) {
      BankDetails.encode(message.defaultBankDetails, writer.uint32(210).fork()).join();
    }
    if (message.invoicePrefix !== "") {
      writer.uint32(218).string(message.invoicePrefix);
    }
    if (message.invoiceNumberFormat !== "") {
      writer.uint32(226).string(message.invoiceNumberFormat);
    }
    if (message.invoiceFooterText !== "") {
      writer.uint32(234).string(message.invoiceFooterText);
    }
    if (message.invoiceTerms !== "") {
      writer.uint32(242).string(message.invoiceTerms);
    }
    if (message.defaultPaymentTerms !== "") {
      writer.uint32(250).string(message.defaultPaymentTerms);
    }
    if (message.defaultCreditDays !== 0) {
      writer.uint32(256).int32(message.defaultCreditDays);
    }
    if (message.baseCurrency !== "") {
      writer.uint32(266).string(message.baseCurrency);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(322).fork()).join();
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(330).fork()).join();
    }
    if (message.createdBy !== "") {
      writer.uint32(338).string(message.createdBy);
    }
    if (message.updatedBy !== "") {
      writer.uint32(346).string(message.updatedBy);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CompanySettings {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompanySettings();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ledgerId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.companyName = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.tradeName = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.logoPath = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.logoUrl = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.logoMimeType = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.address = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.city = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.state = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.stateCode = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.postalCode = reader.string();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.country = reader.string();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.countryCode = reader.string();
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.gstin = reader.string();
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.pan = reader.string();
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.cin = reader.string();
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.tan = reader.string();
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.ieCode = reader.string();
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.lutNumber = reader.string();
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.lutDate = reader.string();
          continue;
        }
        case 23: {
          if (tag !== 186) {
            break;
          }

          message.email = reader.string();
          continue;
        }
        case 24: {
          if (tag !== 194) {
            break;
          }

          message.phone = reader.string();
          continue;
        }
        case 25: {
          if (tag !== 202) {
            break;
          }

          message.website = reader.string();
          continue;
        }
        case 26: {
          if (tag !== 210) {
            break;
          }

          message.defaultBankDetails = BankDetails.decode(reader, reader.uint32());
          continue;
        }
        case 27: {
          if (tag !== 218) {
            break;
          }

          message.invoicePrefix = reader.string();
          continue;
        }
        case 28: {
          if (tag !== 226) {
            break;
          }

          message.invoiceNumberFormat = reader.string();
          continue;
        }
        case 29: {
          if (tag !== 234) {
            break;
          }

          message.invoiceFooterText = reader.string();
          continue;
        }
        case 30: {
          if (tag !== 242) {
            break;
          }

          message.invoiceTerms = reader.string();
          continue;
        }
        case 31: {
          if (tag !== 250) {
            break;
          }

          message.defaultPaymentTerms = reader.string();
          continue;
        }
        case 32: {
          if (tag !== 256) {
            break;
          }

          message.defaultCreditDays = reader.int32();
          continue;
        }
        case 33: {
          if (tag !== 266) {
            break;
          }

          message.baseCurrency = reader.string();
          continue;
        }
        case 40: {
          if (tag !== 322) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 41: {
          if (tag !== 330) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 42: {
          if (tag !== 338) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 43: {
          if (tag !== 346) {
            break;
          }

          message.updatedBy = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CompanySettings {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      orgId: isSet(object.orgId)
        ? globalThis.String(object.orgId)
        : isSet(object.org_id)
        ? globalThis.String(object.org_id)
        : "",
      ledgerId: isSet(object.ledgerId)
        ? globalThis.String(object.ledgerId)
        : isSet(object.ledger_id)
        ? globalThis.String(object.ledger_id)
        : "",
      companyName: isSet(object.companyName)
        ? globalThis.String(object.companyName)
        : isSet(object.company_name)
        ? globalThis.String(object.company_name)
        : "",
      tradeName: isSet(object.tradeName)
        ? globalThis.String(object.tradeName)
        : isSet(object.trade_name)
        ? globalThis.String(object.trade_name)
        : "",
      logoPath: isSet(object.logoPath)
        ? globalThis.String(object.logoPath)
        : isSet(object.logo_path)
        ? globalThis.String(object.logo_path)
        : "",
      logoUrl: isSet(object.logoUrl)
        ? globalThis.String(object.logoUrl)
        : isSet(object.logo_url)
        ? globalThis.String(object.logo_url)
        : "",
      logoMimeType: isSet(object.logoMimeType)
        ? globalThis.String(object.logoMimeType)
        : isSet(object.logo_mime_type)
        ? globalThis.String(object.logo_mime_type)
        : "",
      address: isSet(object.address) ? globalThis.String(object.address) : "",
      city: isSet(object.city) ? globalThis.String(object.city) : "",
      state: isSet(object.state) ? globalThis.String(object.state) : "",
      stateCode: isSet(object.stateCode)
        ? globalThis.String(object.stateCode)
        : isSet(object.state_code)
        ? globalThis.String(object.state_code)
        : "",
      postalCode: isSet(object.postalCode)
        ? globalThis.String(object.postalCode)
        : isSet(object.postal_code)
        ? globalThis.String(object.postal_code)
        : "",
      country: isSet(object.country) ? globalThis.String(object.country) : "",
      countryCode: isSet(object.countryCode)
        ? globalThis.String(object.countryCode)
        : isSet(object.country_code)
        ? globalThis.String(object.country_code)
        : "",
      gstin: isSet(object.gstin) ? globalThis.String(object.gstin) : "",
      pan: isSet(object.pan) ? globalThis.String(object.pan) : "",
      cin: isSet(object.cin) ? globalThis.String(object.cin) : "",
      tan: isSet(object.tan) ? globalThis.String(object.tan) : "",
      ieCode: isSet(object.ieCode)
        ? globalThis.String(object.ieCode)
        : isSet(object.ie_code)
        ? globalThis.String(object.ie_code)
        : "",
      lutNumber: isSet(object.lutNumber)
        ? globalThis.String(object.lutNumber)
        : isSet(object.lut_number)
        ? globalThis.String(object.lut_number)
        : "",
      lutDate: isSet(object.lutDate)
        ? globalThis.String(object.lutDate)
        : isSet(object.lut_date)
        ? globalThis.String(object.lut_date)
        : "",
      email: isSet(object.email) ? globalThis.String(object.email) : "",
      phone: isSet(object.phone) ? globalThis.String(object.phone) : "",
      website: isSet(object.website) ? globalThis.String(object.website) : "",
      defaultBankDetails: isSet(object.defaultBankDetails)
        ? BankDetails.fromJSON(object.defaultBankDetails)
        : isSet(object.default_bank_details)
        ? BankDetails.fromJSON(object.default_bank_details)
        : undefined,
      invoicePrefix: isSet(object.invoicePrefix)
        ? globalThis.String(object.invoicePrefix)
        : isSet(object.invoice_prefix)
        ? globalThis.String(object.invoice_prefix)
        : "",
      invoiceNumberFormat: isSet(object.invoiceNumberFormat)
        ? globalThis.String(object.invoiceNumberFormat)
        : isSet(object.invoice_number_format)
        ? globalThis.String(object.invoice_number_format)
        : "",
      invoiceFooterText: isSet(object.invoiceFooterText)
        ? globalThis.String(object.invoiceFooterText)
        : isSet(object.invoice_footer_text)
        ? globalThis.String(object.invoice_footer_text)
        : "",
      invoiceTerms: isSet(object.invoiceTerms)
        ? globalThis.String(object.invoiceTerms)
        : isSet(object.invoice_terms)
        ? globalThis.String(object.invoice_terms)
        : "",
      defaultPaymentTerms: isSet(object.defaultPaymentTerms)
        ? globalThis.String(object.defaultPaymentTerms)
        : isSet(object.default_payment_terms)
        ? globalThis.String(object.default_payment_terms)
        : "",
      defaultCreditDays: isSet(object.defaultCreditDays)
        ? globalThis.Number(object.defaultCreditDays)
        : isSet(object.default_credit_days)
        ? globalThis.Number(object.default_credit_days)
        : 0,
      baseCurrency: isSet(object.baseCurrency)
        ? globalThis.String(object.baseCurrency)
        : isSet(object.base_currency)
        ? globalThis.String(object.base_currency)
        : "",
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : "",
      updatedBy: isSet(object.updatedBy)
        ? globalThis.String(object.updatedBy)
        : isSet(object.updated_by)
        ? globalThis.String(object.updated_by)
        : "",
    };
  },

  toJSON(message: CompanySettings): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.ledgerId !== "") {
      obj.ledgerId = message.ledgerId;
    }
    if (message.companyName !== "") {
      obj.companyName = message.companyName;
    }
    if (message.tradeName !== "") {
      obj.tradeName = message.tradeName;
    }
    if (message.logoPath !== "") {
      obj.logoPath = message.logoPath;
    }
    if (message.logoUrl !== "") {
      obj.logoUrl = message.logoUrl;
    }
    if (message.logoMimeType !== "") {
      obj.logoMimeType = message.logoMimeType;
    }
    if (message.address !== "") {
      obj.address = message.address;
    }
    if (message.city !== "") {
      obj.city = message.city;
    }
    if (message.state !== "") {
      obj.state = message.state;
    }
    if (message.stateCode !== "") {
      obj.stateCode = message.stateCode;
    }
    if (message.postalCode !== "") {
      obj.postalCode = message.postalCode;
    }
    if (message.country !== "") {
      obj.country = message.country;
    }
    if (message.countryCode !== "") {
      obj.countryCode = message.countryCode;
    }
    if (message.gstin !== "") {
      obj.gstin = message.gstin;
    }
    if (message.pan !== "") {
      obj.pan = message.pan;
    }
    if (message.cin !== "") {
      obj.cin = message.cin;
    }
    if (message.tan !== "") {
      obj.tan = message.tan;
    }
    if (message.ieCode !== "") {
      obj.ieCode = message.ieCode;
    }
    if (message.lutNumber !== "") {
      obj.lutNumber = message.lutNumber;
    }
    if (message.lutDate !== "") {
      obj.lutDate = message.lutDate;
    }
    if (message.email !== "") {
      obj.email = message.email;
    }
    if (message.phone !== "") {
      obj.phone = message.phone;
    }
    if (message.website !== "") {
      obj.website = message.website;
    }
    if (message.defaultBankDetails !== undefined) {
      obj.defaultBankDetails = BankDetails.toJSON(message.defaultBankDetails);
    }
    if (message.invoicePrefix !== "") {
      obj.invoicePrefix = message.invoicePrefix;
    }
    if (message.invoiceNumberFormat !== "") {
      obj.invoiceNumberFormat = message.invoiceNumberFormat;
    }
    if (message.invoiceFooterText !== "") {
      obj.invoiceFooterText = message.invoiceFooterText;
    }
    if (message.invoiceTerms !== "") {
      obj.invoiceTerms = message.invoiceTerms;
    }
    if (message.defaultPaymentTerms !== "") {
      obj.defaultPaymentTerms = message.defaultPaymentTerms;
    }
    if (message.defaultCreditDays !== 0) {
      obj.defaultCreditDays = Math.round(message.defaultCreditDays);
    }
    if (message.baseCurrency !== "") {
      obj.baseCurrency = message.baseCurrency;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.updatedBy !== "") {
      obj.updatedBy = message.updatedBy;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CompanySettings>, I>>(base?: I): CompanySettings {
    return CompanySettings.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CompanySettings>, I>>(object: I): CompanySettings {
    const message = createBaseCompanySettings();
    message.id = object.id ?? "";
    message.orgId = object.orgId ?? "";
    message.ledgerId = object.ledgerId ?? "";
    message.companyName = object.companyName ?? "";
    message.tradeName = object.tradeName ?? "";
    message.logoPath = object.logoPath ?? "";
    message.logoUrl = object.logoUrl ?? "";
    message.logoMimeType = object.logoMimeType ?? "";
    message.address = object.address ?? "";
    message.city = object.city ?? "";
    message.state = object.state ?? "";
    message.stateCode = object.stateCode ?? "";
    message.postalCode = object.postalCode ?? "";
    message.country = object.country ?? "";
    message.countryCode = object.countryCode ?? "";
    message.gstin = object.gstin ?? "";
    message.pan = object.pan ?? "";
    message.cin = object.cin ?? "";
    message.tan = object.tan ?? "";
    message.ieCode = object.ieCode ?? "";
    message.lutNumber = object.lutNumber ?? "";
    message.lutDate = object.lutDate ?? "";
    message.email = object.email ?? "";
    message.phone = object.phone ?? "";
    message.website = object.website ?? "";
    message.defaultBankDetails = (object.defaultBankDetails !== undefined && object.defaultBankDetails !== null)
      ? BankDetails.fromPartial(object.defaultBankDetails)
      : undefined;
    message.invoicePrefix = object.invoicePrefix ?? "";
    message.invoiceNumberFormat = object.invoiceNumberFormat ?? "";
    message.invoiceFooterText = object.invoiceFooterText ?? "";
    message.invoiceTerms = object.invoiceTerms ?? "";
    message.defaultPaymentTerms = object.defaultPaymentTerms ?? "";
    message.defaultCreditDays = object.defaultCreditDays ?? 0;
    message.baseCurrency = object.baseCurrency ?? "";
    message.createdAt = object.createdAt ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    message.createdBy = object.createdBy ?? "";
    message.updatedBy = object.updatedBy ?? "";
    return message;
  },
};

function createBaseGetCompanySettingsRequest(): GetCompanySettingsRequest {
  return { orgId: "", ledgerId: "" };
}

export const GetCompanySettingsRequest: MessageFns<GetCompanySettingsRequest> = {
  encode(message: GetCompanySettingsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgId !== "") {
      writer.uint32(10).string(message.orgId);
    }
    if (message.ledgerId !== "") {
      writer.uint32(18).string(message.ledgerId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCompanySettingsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCompanySettingsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ledgerId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCompanySettingsRequest {
    return {
      orgId: isSet(object.orgId)
        ? globalThis.String(object.orgId)
        : isSet(object.org_id)
        ? globalThis.String(object.org_id)
        : "",
      ledgerId: isSet(object.ledgerId)
        ? globalThis.String(object.ledgerId)
        : isSet(object.ledger_id)
        ? globalThis.String(object.ledger_id)
        : "",
    };
  },

  toJSON(message: GetCompanySettingsRequest): unknown {
    const obj: any = {};
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.ledgerId !== "") {
      obj.ledgerId = message.ledgerId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCompanySettingsRequest>, I>>(base?: I): GetCompanySettingsRequest {
    return GetCompanySettingsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCompanySettingsRequest>, I>>(object: I): GetCompanySettingsRequest {
    const message = createBaseGetCompanySettingsRequest();
    message.orgId = object.orgId ?? "";
    message.ledgerId = object.ledgerId ?? "";
    return message;
  },
};

function createBaseUpdateCompanySettingsRequest(): UpdateCompanySettingsRequest {
  return {
    orgId: "",
    ledgerId: "",
    companyName: "",
    tradeName: "",
    address: "",
    city: "",
    state: "",
    stateCode: "",
    postalCode: "",
    country: "",
    countryCode: "",
    gstin: "",
    pan: "",
    cin: "",
    tan: "",
    ieCode: "",
    lutNumber: "",
    lutDate: "",
    email: "",
    phone: "",
    website: "",
    defaultBankDetails: undefined,
    invoicePrefix: "",
    invoiceNumberFormat: "",
    invoiceFooterText: "",
    invoiceTerms: "",
    defaultPaymentTerms: "",
    defaultCreditDays: 0,
    baseCurrency: "",
  };
}

export const UpdateCompanySettingsRequest: MessageFns<UpdateCompanySettingsRequest> = {
  encode(message: UpdateCompanySettingsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgId !== "") {
      writer.uint32(10).string(message.orgId);
    }
    if (message.ledgerId !== "") {
      writer.uint32(18).string(message.ledgerId);
    }
    if (message.companyName !== "") {
      writer.uint32(26).string(message.companyName);
    }
    if (message.tradeName !== "") {
      writer.uint32(34).string(message.tradeName);
    }
    if (message.address !== "") {
      writer.uint32(42).string(message.address);
    }
    if (message.city !== "") {
      writer.uint32(50).string(message.city);
    }
    if (message.state !== "") {
      writer.uint32(58).string(message.state);
    }
    if (message.stateCode !== "") {
      writer.uint32(66).string(message.stateCode);
    }
    if (message.postalCode !== "") {
      writer.uint32(74).string(message.postalCode);
    }
    if (message.country !== "") {
      writer.uint32(82).string(message.country);
    }
    if (message.countryCode !== "") {
      writer.uint32(90).string(message.countryCode);
    }
    if (message.gstin !== "") {
      writer.uint32(98).string(message.gstin);
    }
    if (message.pan !== "") {
      writer.uint32(106).string(message.pan);
    }
    if (message.cin !== "") {
      writer.uint32(114).string(message.cin);
    }
    if (message.tan !== "") {
      writer.uint32(122).string(message.tan);
    }
    if (message.ieCode !== "") {
      writer.uint32(130).string(message.ieCode);
    }
    if (message.lutNumber !== "") {
      writer.uint32(138).string(message.lutNumber);
    }
    if (message.lutDate !== "") {
      writer.uint32(146).string(message.lutDate);
    }
    if (message.email !== "") {
      writer.uint32(154).string(message.email);
    }
    if (message.phone !== "") {
      writer.uint32(162).string(message.phone);
    }
    if (message.website !== "") {
      writer.uint32(170).string(message.website);
    }
    if (message.defaultBankDetails !== undefined) {
      BankDetails.encode(message.defaultBankDetails, writer.uint32(178).fork()).join();
    }
    if (message.invoicePrefix !== "") {
      writer.uint32(186).string(message.invoicePrefix);
    }
    if (message.invoiceNumberFormat !== "") {
      writer.uint32(194).string(message.invoiceNumberFormat);
    }
    if (message.invoiceFooterText !== "") {
      writer.uint32(202).string(message.invoiceFooterText);
    }
    if (message.invoiceTerms !== "") {
      writer.uint32(210).string(message.invoiceTerms);
    }
    if (message.defaultPaymentTerms !== "") {
      writer.uint32(218).string(message.defaultPaymentTerms);
    }
    if (message.defaultCreditDays !== 0) {
      writer.uint32(224).int32(message.defaultCreditDays);
    }
    if (message.baseCurrency !== "") {
      writer.uint32(234).string(message.baseCurrency);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateCompanySettingsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateCompanySettingsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ledgerId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.companyName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.tradeName = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.address = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.city = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.state = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.stateCode = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.postalCode = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.country = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.countryCode = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.gstin = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.pan = reader.string();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.cin = reader.string();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.tan = reader.string();
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.ieCode = reader.string();
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.lutNumber = reader.string();
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.lutDate = reader.string();
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.email = reader.string();
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.phone = reader.string();
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.website = reader.string();
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.defaultBankDetails = BankDetails.decode(reader, reader.uint32());
          continue;
        }
        case 23: {
          if (tag !== 186) {
            break;
          }

          message.invoicePrefix = reader.string();
          continue;
        }
        case 24: {
          if (tag !== 194) {
            break;
          }

          message.invoiceNumberFormat = reader.string();
          continue;
        }
        case 25: {
          if (tag !== 202) {
            break;
          }

          message.invoiceFooterText = reader.string();
          continue;
        }
        case 26: {
          if (tag !== 210) {
            break;
          }

          message.invoiceTerms = reader.string();
          continue;
        }
        case 27: {
          if (tag !== 218) {
            break;
          }

          message.defaultPaymentTerms = reader.string();
          continue;
        }
        case 28: {
          if (tag !== 224) {
            break;
          }

          message.defaultCreditDays = reader.int32();
          continue;
        }
        case 29: {
          if (tag !== 234) {
            break;
          }

          message.baseCurrency = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateCompanySettingsRequest {
    return {
      orgId: isSet(object.orgId)
        ? globalThis.String(object.orgId)
        : isSet(object.org_id)
        ? globalThis.String(object.org_id)
        : "",
      ledgerId: isSet(object.ledgerId)
        ? globalThis.String(object.ledgerId)
        : isSet(object.ledger_id)
        ? globalThis.String(object.ledger_id)
        : "",
      companyName: isSet(object.companyName)
        ? globalThis.String(object.companyName)
        : isSet(object.company_name)
        ? globalThis.String(object.company_name)
        : "",
      tradeName: isSet(object.tradeName)
        ? globalThis.String(object.tradeName)
        : isSet(object.trade_name)
        ? globalThis.String(object.trade_name)
        : "",
      address: isSet(object.address) ? globalThis.String(object.address) : "",
      city: isSet(object.city) ? globalThis.String(object.city) : "",
      state: isSet(object.state) ? globalThis.String(object.state) : "",
      stateCode: isSet(object.stateCode)
        ? globalThis.String(object.stateCode)
        : isSet(object.state_code)
        ? globalThis.String(object.state_code)
        : "",
      postalCode: isSet(object.postalCode)
        ? globalThis.String(object.postalCode)
        : isSet(object.postal_code)
        ? globalThis.String(object.postal_code)
        : "",
      country: isSet(object.country) ? globalThis.String(object.country) : "",
      countryCode: isSet(object.countryCode)
        ? globalThis.String(object.countryCode)
        : isSet(object.country_code)
        ? globalThis.String(object.country_code)
        : "",
      gstin: isSet(object.gstin) ? globalThis.String(object.gstin) : "",
      pan: isSet(object.pan) ? globalThis.String(object.pan) : "",
      cin: isSet(object.cin) ? globalThis.String(object.cin) : "",
      tan: isSet(object.tan) ? globalThis.String(object.tan) : "",
      ieCode: isSet(object.ieCode)
        ? globalThis.String(object.ieCode)
        : isSet(object.ie_code)
        ? globalThis.String(object.ie_code)
        : "",
      lutNumber: isSet(object.lutNumber)
        ? globalThis.String(object.lutNumber)
        : isSet(object.lut_number)
        ? globalThis.String(object.lut_number)
        : "",
      lutDate: isSet(object.lutDate)
        ? globalThis.String(object.lutDate)
        : isSet(object.lut_date)
        ? globalThis.String(object.lut_date)
        : "",
      email: isSet(object.email) ? globalThis.String(object.email) : "",
      phone: isSet(object.phone) ? globalThis.String(object.phone) : "",
      website: isSet(object.website) ? globalThis.String(object.website) : "",
      defaultBankDetails: isSet(object.defaultBankDetails)
        ? BankDetails.fromJSON(object.defaultBankDetails)
        : isSet(object.default_bank_details)
        ? BankDetails.fromJSON(object.default_bank_details)
        : undefined,
      invoicePrefix: isSet(object.invoicePrefix)
        ? globalThis.String(object.invoicePrefix)
        : isSet(object.invoice_prefix)
        ? globalThis.String(object.invoice_prefix)
        : "",
      invoiceNumberFormat: isSet(object.invoiceNumberFormat)
        ? globalThis.String(object.invoiceNumberFormat)
        : isSet(object.invoice_number_format)
        ? globalThis.String(object.invoice_number_format)
        : "",
      invoiceFooterText: isSet(object.invoiceFooterText)
        ? globalThis.String(object.invoiceFooterText)
        : isSet(object.invoice_footer_text)
        ? globalThis.String(object.invoice_footer_text)
        : "",
      invoiceTerms: isSet(object.invoiceTerms)
        ? globalThis.String(object.invoiceTerms)
        : isSet(object.invoice_terms)
        ? globalThis.String(object.invoice_terms)
        : "",
      defaultPaymentTerms: isSet(object.defaultPaymentTerms)
        ? globalThis.String(object.defaultPaymentTerms)
        : isSet(object.default_payment_terms)
        ? globalThis.String(object.default_payment_terms)
        : "",
      defaultCreditDays: isSet(object.defaultCreditDays)
        ? globalThis.Number(object.defaultCreditDays)
        : isSet(object.default_credit_days)
        ? globalThis.Number(object.default_credit_days)
        : 0,
      baseCurrency: isSet(object.baseCurrency)
        ? globalThis.String(object.baseCurrency)
        : isSet(object.base_currency)
        ? globalThis.String(object.base_currency)
        : "",
    };
  },

  toJSON(message: UpdateCompanySettingsRequest): unknown {
    const obj: any = {};
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.ledgerId !== "") {
      obj.ledgerId = message.ledgerId;
    }
    if (message.companyName !== "") {
      obj.companyName = message.companyName;
    }
    if (message.tradeName !== "") {
      obj.tradeName = message.tradeName;
    }
    if (message.address !== "") {
      obj.address = message.address;
    }
    if (message.city !== "") {
      obj.city = message.city;
    }
    if (message.state !== "") {
      obj.state = message.state;
    }
    if (message.stateCode !== "") {
      obj.stateCode = message.stateCode;
    }
    if (message.postalCode !== "") {
      obj.postalCode = message.postalCode;
    }
    if (message.country !== "") {
      obj.country = message.country;
    }
    if (message.countryCode !== "") {
      obj.countryCode = message.countryCode;
    }
    if (message.gstin !== "") {
      obj.gstin = message.gstin;
    }
    if (message.pan !== "") {
      obj.pan = message.pan;
    }
    if (message.cin !== "") {
      obj.cin = message.cin;
    }
    if (message.tan !== "") {
      obj.tan = message.tan;
    }
    if (message.ieCode !== "") {
      obj.ieCode = message.ieCode;
    }
    if (message.lutNumber !== "") {
      obj.lutNumber = message.lutNumber;
    }
    if (message.lutDate !== "") {
      obj.lutDate = message.lutDate;
    }
    if (message.email !== "") {
      obj.email = message.email;
    }
    if (message.phone !== "") {
      obj.phone = message.phone;
    }
    if (message.website !== "") {
      obj.website = message.website;
    }
    if (message.defaultBankDetails !== undefined) {
      obj.defaultBankDetails = BankDetails.toJSON(message.defaultBankDetails);
    }
    if (message.invoicePrefix !== "") {
      obj.invoicePrefix = message.invoicePrefix;
    }
    if (message.invoiceNumberFormat !== "") {
      obj.invoiceNumberFormat = message.invoiceNumberFormat;
    }
    if (message.invoiceFooterText !== "") {
      obj.invoiceFooterText = message.invoiceFooterText;
    }
    if (message.invoiceTerms !== "") {
      obj.invoiceTerms = message.invoiceTerms;
    }
    if (message.defaultPaymentTerms !== "") {
      obj.defaultPaymentTerms = message.defaultPaymentTerms;
    }
    if (message.defaultCreditDays !== 0) {
      obj.defaultCreditDays = Math.round(message.defaultCreditDays);
    }
    if (message.baseCurrency !== "") {
      obj.baseCurrency = message.baseCurrency;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateCompanySettingsRequest>, I>>(base?: I): UpdateCompanySettingsRequest {
    return UpdateCompanySettingsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateCompanySettingsRequest>, I>>(object: I): UpdateCompanySettingsRequest {
    const message = createBaseUpdateCompanySettingsRequest();
    message.orgId = object.orgId ?? "";
    message.ledgerId = object.ledgerId ?? "";
    message.companyName = object.companyName ?? "";
    message.tradeName = object.tradeName ?? "";
    message.address = object.address ?? "";
    message.city = object.city ?? "";
    message.state = object.state ?? "";
    message.stateCode = object.stateCode ?? "";
    message.postalCode = object.postalCode ?? "";
    message.country = object.country ?? "";
    message.countryCode = object.countryCode ?? "";
    message.gstin = object.gstin ?? "";
    message.pan = object.pan ?? "";
    message.cin = object.cin ?? "";
    message.tan = object.tan ?? "";
    message.ieCode = object.ieCode ?? "";
    message.lutNumber = object.lutNumber ?? "";
    message.lutDate = object.lutDate ?? "";
    message.email = object.email ?? "";
    message.phone = object.phone ?? "";
    message.website = object.website ?? "";
    message.defaultBankDetails = (object.defaultBankDetails !== undefined && object.defaultBankDetails !== null)
      ? BankDetails.fromPartial(object.defaultBankDetails)
      : undefined;
    message.invoicePrefix = object.invoicePrefix ?? "";
    message.invoiceNumberFormat = object.invoiceNumberFormat ?? "";
    message.invoiceFooterText = object.invoiceFooterText ?? "";
    message.invoiceTerms = object.invoiceTerms ?? "";
    message.defaultPaymentTerms = object.defaultPaymentTerms ?? "";
    message.defaultCreditDays = object.defaultCreditDays ?? 0;
    message.baseCurrency = object.baseCurrency ?? "";
    return message;
  },
};

function createBaseUploadCompanyLogoRequest(): UploadCompanyLogoRequest {
  return { orgId: "", ledgerId: "", logoData: new Uint8Array(0), mimeType: "", filename: "" };
}

export const UploadCompanyLogoRequest: MessageFns<UploadCompanyLogoRequest> = {
  encode(message: UploadCompanyLogoRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgId !== "") {
      writer.uint32(10).string(message.orgId);
    }
    if (message.ledgerId !== "") {
      writer.uint32(18).string(message.ledgerId);
    }
    if (message.logoData.length !== 0) {
      writer.uint32(26).bytes(message.logoData);
    }
    if (message.mimeType !== "") {
      writer.uint32(34).string(message.mimeType);
    }
    if (message.filename !== "") {
      writer.uint32(42).string(message.filename);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UploadCompanyLogoRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUploadCompanyLogoRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ledgerId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.logoData = reader.bytes();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.mimeType = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.filename = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UploadCompanyLogoRequest {
    return {
      orgId: isSet(object.orgId)
        ? globalThis.String(object.orgId)
        : isSet(object.org_id)
        ? globalThis.String(object.org_id)
        : "",
      ledgerId: isSet(object.ledgerId)
        ? globalThis.String(object.ledgerId)
        : isSet(object.ledger_id)
        ? globalThis.String(object.ledger_id)
        : "",
      logoData: isSet(object.logoData)
        ? bytesFromBase64(object.logoData)
        : isSet(object.logo_data)
        ? bytesFromBase64(object.logo_data)
        : new Uint8Array(0),
      mimeType: isSet(object.mimeType)
        ? globalThis.String(object.mimeType)
        : isSet(object.mime_type)
        ? globalThis.String(object.mime_type)
        : "",
      filename: isSet(object.filename) ? globalThis.String(object.filename) : "",
    };
  },

  toJSON(message: UploadCompanyLogoRequest): unknown {
    const obj: any = {};
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.ledgerId !== "") {
      obj.ledgerId = message.ledgerId;
    }
    if (message.logoData.length !== 0) {
      obj.logoData = base64FromBytes(message.logoData);
    }
    if (message.mimeType !== "") {
      obj.mimeType = message.mimeType;
    }
    if (message.filename !== "") {
      obj.filename = message.filename;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UploadCompanyLogoRequest>, I>>(base?: I): UploadCompanyLogoRequest {
    return UploadCompanyLogoRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UploadCompanyLogoRequest>, I>>(object: I): UploadCompanyLogoRequest {
    const message = createBaseUploadCompanyLogoRequest();
    message.orgId = object.orgId ?? "";
    message.ledgerId = object.ledgerId ?? "";
    message.logoData = object.logoData ?? new Uint8Array(0);
    message.mimeType = object.mimeType ?? "";
    message.filename = object.filename ?? "";
    return message;
  },
};

function createBaseUploadCompanyLogoResponse(): UploadCompanyLogoResponse {
  return { logoUrl: "", logoPath: "", message: "" };
}

export const UploadCompanyLogoResponse: MessageFns<UploadCompanyLogoResponse> = {
  encode(message: UploadCompanyLogoResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.logoUrl !== "") {
      writer.uint32(10).string(message.logoUrl);
    }
    if (message.logoPath !== "") {
      writer.uint32(18).string(message.logoPath);
    }
    if (message.message !== "") {
      writer.uint32(26).string(message.message);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UploadCompanyLogoResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUploadCompanyLogoResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.logoUrl = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.logoPath = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.message = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UploadCompanyLogoResponse {
    return {
      logoUrl: isSet(object.logoUrl)
        ? globalThis.String(object.logoUrl)
        : isSet(object.logo_url)
        ? globalThis.String(object.logo_url)
        : "",
      logoPath: isSet(object.logoPath)
        ? globalThis.String(object.logoPath)
        : isSet(object.logo_path)
        ? globalThis.String(object.logo_path)
        : "",
      message: isSet(object.message) ? globalThis.String(object.message) : "",
    };
  },

  toJSON(message: UploadCompanyLogoResponse): unknown {
    const obj: any = {};
    if (message.logoUrl !== "") {
      obj.logoUrl = message.logoUrl;
    }
    if (message.logoPath !== "") {
      obj.logoPath = message.logoPath;
    }
    if (message.message !== "") {
      obj.message = message.message;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UploadCompanyLogoResponse>, I>>(base?: I): UploadCompanyLogoResponse {
    return UploadCompanyLogoResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UploadCompanyLogoResponse>, I>>(object: I): UploadCompanyLogoResponse {
    const message = createBaseUploadCompanyLogoResponse();
    message.logoUrl = object.logoUrl ?? "";
    message.logoPath = object.logoPath ?? "";
    message.message = object.message ?? "";
    return message;
  },
};

function createBaseDeleteCompanyLogoRequest(): DeleteCompanyLogoRequest {
  return { orgId: "", ledgerId: "" };
}

export const DeleteCompanyLogoRequest: MessageFns<DeleteCompanyLogoRequest> = {
  encode(message: DeleteCompanyLogoRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgId !== "") {
      writer.uint32(10).string(message.orgId);
    }
    if (message.ledgerId !== "") {
      writer.uint32(18).string(message.ledgerId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteCompanyLogoRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteCompanyLogoRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ledgerId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteCompanyLogoRequest {
    return {
      orgId: isSet(object.orgId)
        ? globalThis.String(object.orgId)
        : isSet(object.org_id)
        ? globalThis.String(object.org_id)
        : "",
      ledgerId: isSet(object.ledgerId)
        ? globalThis.String(object.ledgerId)
        : isSet(object.ledger_id)
        ? globalThis.String(object.ledger_id)
        : "",
    };
  },

  toJSON(message: DeleteCompanyLogoRequest): unknown {
    const obj: any = {};
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.ledgerId !== "") {
      obj.ledgerId = message.ledgerId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteCompanyLogoRequest>, I>>(base?: I): DeleteCompanyLogoRequest {
    return DeleteCompanyLogoRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteCompanyLogoRequest>, I>>(object: I): DeleteCompanyLogoRequest {
    const message = createBaseDeleteCompanyLogoRequest();
    message.orgId = object.orgId ?? "";
    message.ledgerId = object.ledgerId ?? "";
    return message;
  },
};

function createBaseDeleteCompanyLogoResponse(): DeleteCompanyLogoResponse {
  return { message: "" };
}

export const DeleteCompanyLogoResponse: MessageFns<DeleteCompanyLogoResponse> = {
  encode(message: DeleteCompanyLogoResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.message !== "") {
      writer.uint32(10).string(message.message);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteCompanyLogoResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteCompanyLogoResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.message = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteCompanyLogoResponse {
    return { message: isSet(object.message) ? globalThis.String(object.message) : "" };
  },

  toJSON(message: DeleteCompanyLogoResponse): unknown {
    const obj: any = {};
    if (message.message !== "") {
      obj.message = message.message;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteCompanyLogoResponse>, I>>(base?: I): DeleteCompanyLogoResponse {
    return DeleteCompanyLogoResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteCompanyLogoResponse>, I>>(object: I): DeleteCompanyLogoResponse {
    const message = createBaseDeleteCompanyLogoResponse();
    message.message = object.message ?? "";
    return message;
  },
};

function createBaseNumberingSeries(): NumberingSeries {
  return {
    id: "",
    orgId: "",
    ledgerId: "",
    seriesName: "",
    documentType: 0,
    isDraft: false,
    prefix: "",
    numberFormat: "",
    startingNumber: 0,
    currentSequence: 0,
    resetFrequency: 0,
    lastResetDate: "",
    lastResetFiscalYear: 0,
    lastResetMonth: 0,
    lastResetQuarter: 0,
    isActive: false,
    createdAt: undefined,
    updatedAt: undefined,
    createdBy: "",
    updatedBy: "",
  };
}

export const NumberingSeries: MessageFns<NumberingSeries> = {
  encode(message: NumberingSeries, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.orgId !== "") {
      writer.uint32(18).string(message.orgId);
    }
    if (message.ledgerId !== "") {
      writer.uint32(26).string(message.ledgerId);
    }
    if (message.seriesName !== "") {
      writer.uint32(34).string(message.seriesName);
    }
    if (message.documentType !== 0) {
      writer.uint32(40).int32(message.documentType);
    }
    if (message.isDraft !== false) {
      writer.uint32(48).bool(message.isDraft);
    }
    if (message.prefix !== "") {
      writer.uint32(58).string(message.prefix);
    }
    if (message.numberFormat !== "") {
      writer.uint32(66).string(message.numberFormat);
    }
    if (message.startingNumber !== 0) {
      writer.uint32(72).int32(message.startingNumber);
    }
    if (message.currentSequence !== 0) {
      writer.uint32(80).int32(message.currentSequence);
    }
    if (message.resetFrequency !== 0) {
      writer.uint32(88).int32(message.resetFrequency);
    }
    if (message.lastResetDate !== "") {
      writer.uint32(98).string(message.lastResetDate);
    }
    if (message.lastResetFiscalYear !== 0) {
      writer.uint32(104).int32(message.lastResetFiscalYear);
    }
    if (message.lastResetMonth !== 0) {
      writer.uint32(112).int32(message.lastResetMonth);
    }
    if (message.lastResetQuarter !== 0) {
      writer.uint32(120).int32(message.lastResetQuarter);
    }
    if (message.isActive !== false) {
      writer.uint32(128).bool(message.isActive);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(162).fork()).join();
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(170).fork()).join();
    }
    if (message.createdBy !== "") {
      writer.uint32(178).string(message.createdBy);
    }
    if (message.updatedBy !== "") {
      writer.uint32(186).string(message.updatedBy);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NumberingSeries {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNumberingSeries();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ledgerId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.seriesName = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.documentType = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.isDraft = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.prefix = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.numberFormat = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.startingNumber = reader.int32();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.currentSequence = reader.int32();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.resetFrequency = reader.int32() as any;
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.lastResetDate = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.lastResetFiscalYear = reader.int32();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.lastResetMonth = reader.int32();
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.lastResetQuarter = reader.int32();
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.isActive = reader.bool();
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 23: {
          if (tag !== 186) {
            break;
          }

          message.updatedBy = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NumberingSeries {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      orgId: isSet(object.orgId)
        ? globalThis.String(object.orgId)
        : isSet(object.org_id)
        ? globalThis.String(object.org_id)
        : "",
      ledgerId: isSet(object.ledgerId)
        ? globalThis.String(object.ledgerId)
        : isSet(object.ledger_id)
        ? globalThis.String(object.ledger_id)
        : "",
      seriesName: isSet(object.seriesName)
        ? globalThis.String(object.seriesName)
        : isSet(object.series_name)
        ? globalThis.String(object.series_name)
        : "",
      documentType: isSet(object.documentType)
        ? invoiceTypeFromJSON(object.documentType)
        : isSet(object.document_type)
        ? invoiceTypeFromJSON(object.document_type)
        : 0,
      isDraft: isSet(object.isDraft)
        ? globalThis.Boolean(object.isDraft)
        : isSet(object.is_draft)
        ? globalThis.Boolean(object.is_draft)
        : false,
      prefix: isSet(object.prefix) ? globalThis.String(object.prefix) : "",
      numberFormat: isSet(object.numberFormat)
        ? globalThis.String(object.numberFormat)
        : isSet(object.number_format)
        ? globalThis.String(object.number_format)
        : "",
      startingNumber: isSet(object.startingNumber)
        ? globalThis.Number(object.startingNumber)
        : isSet(object.starting_number)
        ? globalThis.Number(object.starting_number)
        : 0,
      currentSequence: isSet(object.currentSequence)
        ? globalThis.Number(object.currentSequence)
        : isSet(object.current_sequence)
        ? globalThis.Number(object.current_sequence)
        : 0,
      resetFrequency: isSet(object.resetFrequency)
        ? resetFrequencyFromJSON(object.resetFrequency)
        : isSet(object.reset_frequency)
        ? resetFrequencyFromJSON(object.reset_frequency)
        : 0,
      lastResetDate: isSet(object.lastResetDate)
        ? globalThis.String(object.lastResetDate)
        : isSet(object.last_reset_date)
        ? globalThis.String(object.last_reset_date)
        : "",
      lastResetFiscalYear: isSet(object.lastResetFiscalYear)
        ? globalThis.Number(object.lastResetFiscalYear)
        : isSet(object.last_reset_fiscal_year)
        ? globalThis.Number(object.last_reset_fiscal_year)
        : 0,
      lastResetMonth: isSet(object.lastResetMonth)
        ? globalThis.Number(object.lastResetMonth)
        : isSet(object.last_reset_month)
        ? globalThis.Number(object.last_reset_month)
        : 0,
      lastResetQuarter: isSet(object.lastResetQuarter)
        ? globalThis.Number(object.lastResetQuarter)
        : isSet(object.last_reset_quarter)
        ? globalThis.Number(object.last_reset_quarter)
        : 0,
      isActive: isSet(object.isActive)
        ? globalThis.Boolean(object.isActive)
        : isSet(object.is_active)
        ? globalThis.Boolean(object.is_active)
        : false,
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : "",
      updatedBy: isSet(object.updatedBy)
        ? globalThis.String(object.updatedBy)
        : isSet(object.updated_by)
        ? globalThis.String(object.updated_by)
        : "",
    };
  },

  toJSON(message: NumberingSeries): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.ledgerId !== "") {
      obj.ledgerId = message.ledgerId;
    }
    if (message.seriesName !== "") {
      obj.seriesName = message.seriesName;
    }
    if (message.documentType !== 0) {
      obj.documentType = invoiceTypeToJSON(message.documentType);
    }
    if (message.isDraft !== false) {
      obj.isDraft = message.isDraft;
    }
    if (message.prefix !== "") {
      obj.prefix = message.prefix;
    }
    if (message.numberFormat !== "") {
      obj.numberFormat = message.numberFormat;
    }
    if (message.startingNumber !== 0) {
      obj.startingNumber = Math.round(message.startingNumber);
    }
    if (message.currentSequence !== 0) {
      obj.currentSequence = Math.round(message.currentSequence);
    }
    if (message.resetFrequency !== 0) {
      obj.resetFrequency = resetFrequencyToJSON(message.resetFrequency);
    }
    if (message.lastResetDate !== "") {
      obj.lastResetDate = message.lastResetDate;
    }
    if (message.lastResetFiscalYear !== 0) {
      obj.lastResetFiscalYear = Math.round(message.lastResetFiscalYear);
    }
    if (message.lastResetMonth !== 0) {
      obj.lastResetMonth = Math.round(message.lastResetMonth);
    }
    if (message.lastResetQuarter !== 0) {
      obj.lastResetQuarter = Math.round(message.lastResetQuarter);
    }
    if (message.isActive !== false) {
      obj.isActive = message.isActive;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.updatedBy !== "") {
      obj.updatedBy = message.updatedBy;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NumberingSeries>, I>>(base?: I): NumberingSeries {
    return NumberingSeries.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NumberingSeries>, I>>(object: I): NumberingSeries {
    const message = createBaseNumberingSeries();
    message.id = object.id ?? "";
    message.orgId = object.orgId ?? "";
    message.ledgerId = object.ledgerId ?? "";
    message.seriesName = object.seriesName ?? "";
    message.documentType = object.documentType ?? 0;
    message.isDraft = object.isDraft ?? false;
    message.prefix = object.prefix ?? "";
    message.numberFormat = object.numberFormat ?? "";
    message.startingNumber = object.startingNumber ?? 0;
    message.currentSequence = object.currentSequence ?? 0;
    message.resetFrequency = object.resetFrequency ?? 0;
    message.lastResetDate = object.lastResetDate ?? "";
    message.lastResetFiscalYear = object.lastResetFiscalYear ?? 0;
    message.lastResetMonth = object.lastResetMonth ?? 0;
    message.lastResetQuarter = object.lastResetQuarter ?? 0;
    message.isActive = object.isActive ?? false;
    message.createdAt = object.createdAt ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    message.createdBy = object.createdBy ?? "";
    message.updatedBy = object.updatedBy ?? "";
    return message;
  },
};

function createBaseCreateNumberingSeriesRequest(): CreateNumberingSeriesRequest {
  return {
    orgId: "",
    ledgerId: "",
    seriesName: "",
    documentType: 0,
    isDraft: false,
    prefix: "",
    numberFormat: "",
    startingNumber: 0,
    resetFrequency: 0,
  };
}

export const CreateNumberingSeriesRequest: MessageFns<CreateNumberingSeriesRequest> = {
  encode(message: CreateNumberingSeriesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgId !== "") {
      writer.uint32(10).string(message.orgId);
    }
    if (message.ledgerId !== "") {
      writer.uint32(18).string(message.ledgerId);
    }
    if (message.seriesName !== "") {
      writer.uint32(26).string(message.seriesName);
    }
    if (message.documentType !== 0) {
      writer.uint32(32).int32(message.documentType);
    }
    if (message.isDraft !== false) {
      writer.uint32(40).bool(message.isDraft);
    }
    if (message.prefix !== "") {
      writer.uint32(50).string(message.prefix);
    }
    if (message.numberFormat !== "") {
      writer.uint32(58).string(message.numberFormat);
    }
    if (message.startingNumber !== 0) {
      writer.uint32(64).int32(message.startingNumber);
    }
    if (message.resetFrequency !== 0) {
      writer.uint32(72).int32(message.resetFrequency);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateNumberingSeriesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateNumberingSeriesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ledgerId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.seriesName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.documentType = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.isDraft = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.prefix = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.numberFormat = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.startingNumber = reader.int32();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.resetFrequency = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateNumberingSeriesRequest {
    return {
      orgId: isSet(object.orgId)
        ? globalThis.String(object.orgId)
        : isSet(object.org_id)
        ? globalThis.String(object.org_id)
        : "",
      ledgerId: isSet(object.ledgerId)
        ? globalThis.String(object.ledgerId)
        : isSet(object.ledger_id)
        ? globalThis.String(object.ledger_id)
        : "",
      seriesName: isSet(object.seriesName)
        ? globalThis.String(object.seriesName)
        : isSet(object.series_name)
        ? globalThis.String(object.series_name)
        : "",
      documentType: isSet(object.documentType)
        ? invoiceTypeFromJSON(object.documentType)
        : isSet(object.document_type)
        ? invoiceTypeFromJSON(object.document_type)
        : 0,
      isDraft: isSet(object.isDraft)
        ? globalThis.Boolean(object.isDraft)
        : isSet(object.is_draft)
        ? globalThis.Boolean(object.is_draft)
        : false,
      prefix: isSet(object.prefix) ? globalThis.String(object.prefix) : "",
      numberFormat: isSet(object.numberFormat)
        ? globalThis.String(object.numberFormat)
        : isSet(object.number_format)
        ? globalThis.String(object.number_format)
        : "",
      startingNumber: isSet(object.startingNumber)
        ? globalThis.Number(object.startingNumber)
        : isSet(object.starting_number)
        ? globalThis.Number(object.starting_number)
        : 0,
      resetFrequency: isSet(object.resetFrequency)
        ? resetFrequencyFromJSON(object.resetFrequency)
        : isSet(object.reset_frequency)
        ? resetFrequencyFromJSON(object.reset_frequency)
        : 0,
    };
  },

  toJSON(message: CreateNumberingSeriesRequest): unknown {
    const obj: any = {};
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.ledgerId !== "") {
      obj.ledgerId = message.ledgerId;
    }
    if (message.seriesName !== "") {
      obj.seriesName = message.seriesName;
    }
    if (message.documentType !== 0) {
      obj.documentType = invoiceTypeToJSON(message.documentType);
    }
    if (message.isDraft !== false) {
      obj.isDraft = message.isDraft;
    }
    if (message.prefix !== "") {
      obj.prefix = message.prefix;
    }
    if (message.numberFormat !== "") {
      obj.numberFormat = message.numberFormat;
    }
    if (message.startingNumber !== 0) {
      obj.startingNumber = Math.round(message.startingNumber);
    }
    if (message.resetFrequency !== 0) {
      obj.resetFrequency = resetFrequencyToJSON(message.resetFrequency);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateNumberingSeriesRequest>, I>>(base?: I): CreateNumberingSeriesRequest {
    return CreateNumberingSeriesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateNumberingSeriesRequest>, I>>(object: I): CreateNumberingSeriesRequest {
    const message = createBaseCreateNumberingSeriesRequest();
    message.orgId = object.orgId ?? "";
    message.ledgerId = object.ledgerId ?? "";
    message.seriesName = object.seriesName ?? "";
    message.documentType = object.documentType ?? 0;
    message.isDraft = object.isDraft ?? false;
    message.prefix = object.prefix ?? "";
    message.numberFormat = object.numberFormat ?? "";
    message.startingNumber = object.startingNumber ?? 0;
    message.resetFrequency = object.resetFrequency ?? 0;
    return message;
  },
};

function createBaseGetNumberingSeriesRequest(): GetNumberingSeriesRequest {
  return { orgId: "", seriesId: "" };
}

export const GetNumberingSeriesRequest: MessageFns<GetNumberingSeriesRequest> = {
  encode(message: GetNumberingSeriesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgId !== "") {
      writer.uint32(10).string(message.orgId);
    }
    if (message.seriesId !== "") {
      writer.uint32(18).string(message.seriesId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetNumberingSeriesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetNumberingSeriesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.seriesId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetNumberingSeriesRequest {
    return {
      orgId: isSet(object.orgId)
        ? globalThis.String(object.orgId)
        : isSet(object.org_id)
        ? globalThis.String(object.org_id)
        : "",
      seriesId: isSet(object.seriesId)
        ? globalThis.String(object.seriesId)
        : isSet(object.series_id)
        ? globalThis.String(object.series_id)
        : "",
    };
  },

  toJSON(message: GetNumberingSeriesRequest): unknown {
    const obj: any = {};
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.seriesId !== "") {
      obj.seriesId = message.seriesId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetNumberingSeriesRequest>, I>>(base?: I): GetNumberingSeriesRequest {
    return GetNumberingSeriesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetNumberingSeriesRequest>, I>>(object: I): GetNumberingSeriesRequest {
    const message = createBaseGetNumberingSeriesRequest();
    message.orgId = object.orgId ?? "";
    message.seriesId = object.seriesId ?? "";
    return message;
  },
};

function createBaseUpdateNumberingSeriesRequest(): UpdateNumberingSeriesRequest {
  return {
    orgId: "",
    seriesId: "",
    seriesName: "",
    prefix: "",
    numberFormat: "",
    startingNumber: 0,
    resetFrequency: 0,
    isActive: false,
  };
}

export const UpdateNumberingSeriesRequest: MessageFns<UpdateNumberingSeriesRequest> = {
  encode(message: UpdateNumberingSeriesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgId !== "") {
      writer.uint32(10).string(message.orgId);
    }
    if (message.seriesId !== "") {
      writer.uint32(18).string(message.seriesId);
    }
    if (message.seriesName !== "") {
      writer.uint32(26).string(message.seriesName);
    }
    if (message.prefix !== "") {
      writer.uint32(34).string(message.prefix);
    }
    if (message.numberFormat !== "") {
      writer.uint32(42).string(message.numberFormat);
    }
    if (message.startingNumber !== 0) {
      writer.uint32(48).int32(message.startingNumber);
    }
    if (message.resetFrequency !== 0) {
      writer.uint32(56).int32(message.resetFrequency);
    }
    if (message.isActive !== false) {
      writer.uint32(64).bool(message.isActive);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateNumberingSeriesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateNumberingSeriesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.seriesId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.seriesName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.prefix = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.numberFormat = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.startingNumber = reader.int32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.resetFrequency = reader.int32() as any;
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.isActive = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateNumberingSeriesRequest {
    return {
      orgId: isSet(object.orgId)
        ? globalThis.String(object.orgId)
        : isSet(object.org_id)
        ? globalThis.String(object.org_id)
        : "",
      seriesId: isSet(object.seriesId)
        ? globalThis.String(object.seriesId)
        : isSet(object.series_id)
        ? globalThis.String(object.series_id)
        : "",
      seriesName: isSet(object.seriesName)
        ? globalThis.String(object.seriesName)
        : isSet(object.series_name)
        ? globalThis.String(object.series_name)
        : "",
      prefix: isSet(object.prefix) ? globalThis.String(object.prefix) : "",
      numberFormat: isSet(object.numberFormat)
        ? globalThis.String(object.numberFormat)
        : isSet(object.number_format)
        ? globalThis.String(object.number_format)
        : "",
      startingNumber: isSet(object.startingNumber)
        ? globalThis.Number(object.startingNumber)
        : isSet(object.starting_number)
        ? globalThis.Number(object.starting_number)
        : 0,
      resetFrequency: isSet(object.resetFrequency)
        ? resetFrequencyFromJSON(object.resetFrequency)
        : isSet(object.reset_frequency)
        ? resetFrequencyFromJSON(object.reset_frequency)
        : 0,
      isActive: isSet(object.isActive)
        ? globalThis.Boolean(object.isActive)
        : isSet(object.is_active)
        ? globalThis.Boolean(object.is_active)
        : false,
    };
  },

  toJSON(message: UpdateNumberingSeriesRequest): unknown {
    const obj: any = {};
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.seriesId !== "") {
      obj.seriesId = message.seriesId;
    }
    if (message.seriesName !== "") {
      obj.seriesName = message.seriesName;
    }
    if (message.prefix !== "") {
      obj.prefix = message.prefix;
    }
    if (message.numberFormat !== "") {
      obj.numberFormat = message.numberFormat;
    }
    if (message.startingNumber !== 0) {
      obj.startingNumber = Math.round(message.startingNumber);
    }
    if (message.resetFrequency !== 0) {
      obj.resetFrequency = resetFrequencyToJSON(message.resetFrequency);
    }
    if (message.isActive !== false) {
      obj.isActive = message.isActive;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateNumberingSeriesRequest>, I>>(base?: I): UpdateNumberingSeriesRequest {
    return UpdateNumberingSeriesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateNumberingSeriesRequest>, I>>(object: I): UpdateNumberingSeriesRequest {
    const message = createBaseUpdateNumberingSeriesRequest();
    message.orgId = object.orgId ?? "";
    message.seriesId = object.seriesId ?? "";
    message.seriesName = object.seriesName ?? "";
    message.prefix = object.prefix ?? "";
    message.numberFormat = object.numberFormat ?? "";
    message.startingNumber = object.startingNumber ?? 0;
    message.resetFrequency = object.resetFrequency ?? 0;
    message.isActive = object.isActive ?? false;
    return message;
  },
};

function createBaseSetCurrentSequenceRequest(): SetCurrentSequenceRequest {
  return { orgId: "", seriesId: "", newSequence: 0, reason: "" };
}

export const SetCurrentSequenceRequest: MessageFns<SetCurrentSequenceRequest> = {
  encode(message: SetCurrentSequenceRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgId !== "") {
      writer.uint32(10).string(message.orgId);
    }
    if (message.seriesId !== "") {
      writer.uint32(18).string(message.seriesId);
    }
    if (message.newSequence !== 0) {
      writer.uint32(24).int32(message.newSequence);
    }
    if (message.reason !== "") {
      writer.uint32(34).string(message.reason);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetCurrentSequenceRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetCurrentSequenceRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.seriesId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.newSequence = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.reason = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetCurrentSequenceRequest {
    return {
      orgId: isSet(object.orgId)
        ? globalThis.String(object.orgId)
        : isSet(object.org_id)
        ? globalThis.String(object.org_id)
        : "",
      seriesId: isSet(object.seriesId)
        ? globalThis.String(object.seriesId)
        : isSet(object.series_id)
        ? globalThis.String(object.series_id)
        : "",
      newSequence: isSet(object.newSequence)
        ? globalThis.Number(object.newSequence)
        : isSet(object.new_sequence)
        ? globalThis.Number(object.new_sequence)
        : 0,
      reason: isSet(object.reason) ? globalThis.String(object.reason) : "",
    };
  },

  toJSON(message: SetCurrentSequenceRequest): unknown {
    const obj: any = {};
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.seriesId !== "") {
      obj.seriesId = message.seriesId;
    }
    if (message.newSequence !== 0) {
      obj.newSequence = Math.round(message.newSequence);
    }
    if (message.reason !== "") {
      obj.reason = message.reason;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetCurrentSequenceRequest>, I>>(base?: I): SetCurrentSequenceRequest {
    return SetCurrentSequenceRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetCurrentSequenceRequest>, I>>(object: I): SetCurrentSequenceRequest {
    const message = createBaseSetCurrentSequenceRequest();
    message.orgId = object.orgId ?? "";
    message.seriesId = object.seriesId ?? "";
    message.newSequence = object.newSequence ?? 0;
    message.reason = object.reason ?? "";
    return message;
  },
};

function createBaseListNumberingSeriesRequest(): ListNumberingSeriesRequest {
  return { orgId: "", ledgerId: "", documentType: 0, activeOnly: false };
}

export const ListNumberingSeriesRequest: MessageFns<ListNumberingSeriesRequest> = {
  encode(message: ListNumberingSeriesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgId !== "") {
      writer.uint32(10).string(message.orgId);
    }
    if (message.ledgerId !== "") {
      writer.uint32(18).string(message.ledgerId);
    }
    if (message.documentType !== 0) {
      writer.uint32(24).int32(message.documentType);
    }
    if (message.activeOnly !== false) {
      writer.uint32(32).bool(message.activeOnly);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListNumberingSeriesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListNumberingSeriesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ledgerId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.documentType = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.activeOnly = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListNumberingSeriesRequest {
    return {
      orgId: isSet(object.orgId)
        ? globalThis.String(object.orgId)
        : isSet(object.org_id)
        ? globalThis.String(object.org_id)
        : "",
      ledgerId: isSet(object.ledgerId)
        ? globalThis.String(object.ledgerId)
        : isSet(object.ledger_id)
        ? globalThis.String(object.ledger_id)
        : "",
      documentType: isSet(object.documentType)
        ? invoiceTypeFromJSON(object.documentType)
        : isSet(object.document_type)
        ? invoiceTypeFromJSON(object.document_type)
        : 0,
      activeOnly: isSet(object.activeOnly)
        ? globalThis.Boolean(object.activeOnly)
        : isSet(object.active_only)
        ? globalThis.Boolean(object.active_only)
        : false,
    };
  },

  toJSON(message: ListNumberingSeriesRequest): unknown {
    const obj: any = {};
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.ledgerId !== "") {
      obj.ledgerId = message.ledgerId;
    }
    if (message.documentType !== 0) {
      obj.documentType = invoiceTypeToJSON(message.documentType);
    }
    if (message.activeOnly !== false) {
      obj.activeOnly = message.activeOnly;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListNumberingSeriesRequest>, I>>(base?: I): ListNumberingSeriesRequest {
    return ListNumberingSeriesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListNumberingSeriesRequest>, I>>(object: I): ListNumberingSeriesRequest {
    const message = createBaseListNumberingSeriesRequest();
    message.orgId = object.orgId ?? "";
    message.ledgerId = object.ledgerId ?? "";
    message.documentType = object.documentType ?? 0;
    message.activeOnly = object.activeOnly ?? false;
    return message;
  },
};

function createBaseListNumberingSeriesResponse(): ListNumberingSeriesResponse {
  return { series: [], totalCount: 0 };
}

export const ListNumberingSeriesResponse: MessageFns<ListNumberingSeriesResponse> = {
  encode(message: ListNumberingSeriesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.series) {
      NumberingSeries.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.totalCount !== 0) {
      writer.uint32(16).int32(message.totalCount);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListNumberingSeriesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListNumberingSeriesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.series.push(NumberingSeries.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.totalCount = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListNumberingSeriesResponse {
    return {
      series: globalThis.Array.isArray(object?.series)
        ? object.series.map((e: any) => NumberingSeries.fromJSON(e))
        : [],
      totalCount: isSet(object.totalCount)
        ? globalThis.Number(object.totalCount)
        : isSet(object.total_count)
        ? globalThis.Number(object.total_count)
        : 0,
    };
  },

  toJSON(message: ListNumberingSeriesResponse): unknown {
    const obj: any = {};
    if (message.series?.length) {
      obj.series = message.series.map((e) => NumberingSeries.toJSON(e));
    }
    if (message.totalCount !== 0) {
      obj.totalCount = Math.round(message.totalCount);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListNumberingSeriesResponse>, I>>(base?: I): ListNumberingSeriesResponse {
    return ListNumberingSeriesResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListNumberingSeriesResponse>, I>>(object: I): ListNumberingSeriesResponse {
    const message = createBaseListNumberingSeriesResponse();
    message.series = object.series?.map((e) => NumberingSeries.fromPartial(e)) || [];
    message.totalCount = object.totalCount ?? 0;
    return message;
  },
};

function createBaseNumberingAssignment(): NumberingAssignment {
  return {
    id: "",
    orgId: "",
    ledgerId: "",
    partyRole: "",
    gstCategory: "",
    docKind: "",
    isDraft: false,
    seriesId: "",
    createdAt: undefined,
    updatedAt: undefined,
    createdBy: "",
    updatedBy: "",
  };
}

export const NumberingAssignment: MessageFns<NumberingAssignment> = {
  encode(message: NumberingAssignment, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.orgId !== "") {
      writer.uint32(18).string(message.orgId);
    }
    if (message.ledgerId !== "") {
      writer.uint32(26).string(message.ledgerId);
    }
    if (message.partyRole !== "") {
      writer.uint32(34).string(message.partyRole);
    }
    if (message.gstCategory !== "") {
      writer.uint32(42).string(message.gstCategory);
    }
    if (message.docKind !== "") {
      writer.uint32(50).string(message.docKind);
    }
    if (message.isDraft !== false) {
      writer.uint32(56).bool(message.isDraft);
    }
    if (message.seriesId !== "") {
      writer.uint32(66).string(message.seriesId);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(162).fork()).join();
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(170).fork()).join();
    }
    if (message.createdBy !== "") {
      writer.uint32(178).string(message.createdBy);
    }
    if (message.updatedBy !== "") {
      writer.uint32(186).string(message.updatedBy);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NumberingAssignment {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNumberingAssignment();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ledgerId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.partyRole = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.gstCategory = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.docKind = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.isDraft = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.seriesId = reader.string();
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 23: {
          if (tag !== 186) {
            break;
          }

          message.updatedBy = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NumberingAssignment {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      orgId: isSet(object.orgId)
        ? globalThis.String(object.orgId)
        : isSet(object.org_id)
        ? globalThis.String(object.org_id)
        : "",
      ledgerId: isSet(object.ledgerId)
        ? globalThis.String(object.ledgerId)
        : isSet(object.ledger_id)
        ? globalThis.String(object.ledger_id)
        : "",
      partyRole: isSet(object.partyRole)
        ? globalThis.String(object.partyRole)
        : isSet(object.party_role)
        ? globalThis.String(object.party_role)
        : "",
      gstCategory: isSet(object.gstCategory)
        ? globalThis.String(object.gstCategory)
        : isSet(object.gst_category)
        ? globalThis.String(object.gst_category)
        : "",
      docKind: isSet(object.docKind)
        ? globalThis.String(object.docKind)
        : isSet(object.doc_kind)
        ? globalThis.String(object.doc_kind)
        : "",
      isDraft: isSet(object.isDraft)
        ? globalThis.Boolean(object.isDraft)
        : isSet(object.is_draft)
        ? globalThis.Boolean(object.is_draft)
        : false,
      seriesId: isSet(object.seriesId)
        ? globalThis.String(object.seriesId)
        : isSet(object.series_id)
        ? globalThis.String(object.series_id)
        : "",
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : "",
      updatedBy: isSet(object.updatedBy)
        ? globalThis.String(object.updatedBy)
        : isSet(object.updated_by)
        ? globalThis.String(object.updated_by)
        : "",
    };
  },

  toJSON(message: NumberingAssignment): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.ledgerId !== "") {
      obj.ledgerId = message.ledgerId;
    }
    if (message.partyRole !== "") {
      obj.partyRole = message.partyRole;
    }
    if (message.gstCategory !== "") {
      obj.gstCategory = message.gstCategory;
    }
    if (message.docKind !== "") {
      obj.docKind = message.docKind;
    }
    if (message.isDraft !== false) {
      obj.isDraft = message.isDraft;
    }
    if (message.seriesId !== "") {
      obj.seriesId = message.seriesId;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.updatedBy !== "") {
      obj.updatedBy = message.updatedBy;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NumberingAssignment>, I>>(base?: I): NumberingAssignment {
    return NumberingAssignment.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NumberingAssignment>, I>>(object: I): NumberingAssignment {
    const message = createBaseNumberingAssignment();
    message.id = object.id ?? "";
    message.orgId = object.orgId ?? "";
    message.ledgerId = object.ledgerId ?? "";
    message.partyRole = object.partyRole ?? "";
    message.gstCategory = object.gstCategory ?? "";
    message.docKind = object.docKind ?? "";
    message.isDraft = object.isDraft ?? false;
    message.seriesId = object.seriesId ?? "";
    message.createdAt = object.createdAt ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    message.createdBy = object.createdBy ?? "";
    message.updatedBy = object.updatedBy ?? "";
    return message;
  },
};

function createBaseListNumberingAssignmentsRequest(): ListNumberingAssignmentsRequest {
  return { orgId: "", ledgerId: "" };
}

export const ListNumberingAssignmentsRequest: MessageFns<ListNumberingAssignmentsRequest> = {
  encode(message: ListNumberingAssignmentsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgId !== "") {
      writer.uint32(10).string(message.orgId);
    }
    if (message.ledgerId !== "") {
      writer.uint32(18).string(message.ledgerId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListNumberingAssignmentsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListNumberingAssignmentsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ledgerId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListNumberingAssignmentsRequest {
    return {
      orgId: isSet(object.orgId)
        ? globalThis.String(object.orgId)
        : isSet(object.org_id)
        ? globalThis.String(object.org_id)
        : "",
      ledgerId: isSet(object.ledgerId)
        ? globalThis.String(object.ledgerId)
        : isSet(object.ledger_id)
        ? globalThis.String(object.ledger_id)
        : "",
    };
  },

  toJSON(message: ListNumberingAssignmentsRequest): unknown {
    const obj: any = {};
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.ledgerId !== "") {
      obj.ledgerId = message.ledgerId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListNumberingAssignmentsRequest>, I>>(base?: I): ListNumberingAssignmentsRequest {
    return ListNumberingAssignmentsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListNumberingAssignmentsRequest>, I>>(
    object: I,
  ): ListNumberingAssignmentsRequest {
    const message = createBaseListNumberingAssignmentsRequest();
    message.orgId = object.orgId ?? "";
    message.ledgerId = object.ledgerId ?? "";
    return message;
  },
};

function createBaseListNumberingAssignmentsResponse(): ListNumberingAssignmentsResponse {
  return { assignments: [] };
}

export const ListNumberingAssignmentsResponse: MessageFns<ListNumberingAssignmentsResponse> = {
  encode(message: ListNumberingAssignmentsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.assignments) {
      NumberingAssignment.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListNumberingAssignmentsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListNumberingAssignmentsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.assignments.push(NumberingAssignment.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListNumberingAssignmentsResponse {
    return {
      assignments: globalThis.Array.isArray(object?.assignments)
        ? object.assignments.map((e: any) => NumberingAssignment.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ListNumberingAssignmentsResponse): unknown {
    const obj: any = {};
    if (message.assignments?.length) {
      obj.assignments = message.assignments.map((e) => NumberingAssignment.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListNumberingAssignmentsResponse>, I>>(
    base?: I,
  ): ListNumberingAssignmentsResponse {
    return ListNumberingAssignmentsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListNumberingAssignmentsResponse>, I>>(
    object: I,
  ): ListNumberingAssignmentsResponse {
    const message = createBaseListNumberingAssignmentsResponse();
    message.assignments = object.assignments?.map((e) => NumberingAssignment.fromPartial(e)) || [];
    return message;
  },
};

function createBaseUpsertNumberingAssignmentRequest(): UpsertNumberingAssignmentRequest {
  return { orgId: "", ledgerId: "", partyRole: "", gstCategory: "", docKind: "", isDraft: false, seriesId: "" };
}

export const UpsertNumberingAssignmentRequest: MessageFns<UpsertNumberingAssignmentRequest> = {
  encode(message: UpsertNumberingAssignmentRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgId !== "") {
      writer.uint32(10).string(message.orgId);
    }
    if (message.ledgerId !== "") {
      writer.uint32(18).string(message.ledgerId);
    }
    if (message.partyRole !== "") {
      writer.uint32(26).string(message.partyRole);
    }
    if (message.gstCategory !== "") {
      writer.uint32(34).string(message.gstCategory);
    }
    if (message.docKind !== "") {
      writer.uint32(42).string(message.docKind);
    }
    if (message.isDraft !== false) {
      writer.uint32(48).bool(message.isDraft);
    }
    if (message.seriesId !== "") {
      writer.uint32(58).string(message.seriesId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpsertNumberingAssignmentRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpsertNumberingAssignmentRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ledgerId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.partyRole = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.gstCategory = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.docKind = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.isDraft = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.seriesId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpsertNumberingAssignmentRequest {
    return {
      orgId: isSet(object.orgId)
        ? globalThis.String(object.orgId)
        : isSet(object.org_id)
        ? globalThis.String(object.org_id)
        : "",
      ledgerId: isSet(object.ledgerId)
        ? globalThis.String(object.ledgerId)
        : isSet(object.ledger_id)
        ? globalThis.String(object.ledger_id)
        : "",
      partyRole: isSet(object.partyRole)
        ? globalThis.String(object.partyRole)
        : isSet(object.party_role)
        ? globalThis.String(object.party_role)
        : "",
      gstCategory: isSet(object.gstCategory)
        ? globalThis.String(object.gstCategory)
        : isSet(object.gst_category)
        ? globalThis.String(object.gst_category)
        : "",
      docKind: isSet(object.docKind)
        ? globalThis.String(object.docKind)
        : isSet(object.doc_kind)
        ? globalThis.String(object.doc_kind)
        : "",
      isDraft: isSet(object.isDraft)
        ? globalThis.Boolean(object.isDraft)
        : isSet(object.is_draft)
        ? globalThis.Boolean(object.is_draft)
        : false,
      seriesId: isSet(object.seriesId)
        ? globalThis.String(object.seriesId)
        : isSet(object.series_id)
        ? globalThis.String(object.series_id)
        : "",
    };
  },

  toJSON(message: UpsertNumberingAssignmentRequest): unknown {
    const obj: any = {};
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.ledgerId !== "") {
      obj.ledgerId = message.ledgerId;
    }
    if (message.partyRole !== "") {
      obj.partyRole = message.partyRole;
    }
    if (message.gstCategory !== "") {
      obj.gstCategory = message.gstCategory;
    }
    if (message.docKind !== "") {
      obj.docKind = message.docKind;
    }
    if (message.isDraft !== false) {
      obj.isDraft = message.isDraft;
    }
    if (message.seriesId !== "") {
      obj.seriesId = message.seriesId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpsertNumberingAssignmentRequest>, I>>(
    base?: I,
  ): UpsertNumberingAssignmentRequest {
    return UpsertNumberingAssignmentRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpsertNumberingAssignmentRequest>, I>>(
    object: I,
  ): UpsertNumberingAssignmentRequest {
    const message = createBaseUpsertNumberingAssignmentRequest();
    message.orgId = object.orgId ?? "";
    message.ledgerId = object.ledgerId ?? "";
    message.partyRole = object.partyRole ?? "";
    message.gstCategory = object.gstCategory ?? "";
    message.docKind = object.docKind ?? "";
    message.isDraft = object.isDraft ?? false;
    message.seriesId = object.seriesId ?? "";
    return message;
  },
};

function createBaseRestoreDefaultNumberingSeriesRequest(): RestoreDefaultNumberingSeriesRequest {
  return { orgId: "", ledgerId: "" };
}

export const RestoreDefaultNumberingSeriesRequest: MessageFns<RestoreDefaultNumberingSeriesRequest> = {
  encode(message: RestoreDefaultNumberingSeriesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgId !== "") {
      writer.uint32(10).string(message.orgId);
    }
    if (message.ledgerId !== "") {
      writer.uint32(18).string(message.ledgerId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RestoreDefaultNumberingSeriesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRestoreDefaultNumberingSeriesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ledgerId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RestoreDefaultNumberingSeriesRequest {
    return {
      orgId: isSet(object.orgId)
        ? globalThis.String(object.orgId)
        : isSet(object.org_id)
        ? globalThis.String(object.org_id)
        : "",
      ledgerId: isSet(object.ledgerId)
        ? globalThis.String(object.ledgerId)
        : isSet(object.ledger_id)
        ? globalThis.String(object.ledger_id)
        : "",
    };
  },

  toJSON(message: RestoreDefaultNumberingSeriesRequest): unknown {
    const obj: any = {};
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.ledgerId !== "") {
      obj.ledgerId = message.ledgerId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RestoreDefaultNumberingSeriesRequest>, I>>(
    base?: I,
  ): RestoreDefaultNumberingSeriesRequest {
    return RestoreDefaultNumberingSeriesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RestoreDefaultNumberingSeriesRequest>, I>>(
    object: I,
  ): RestoreDefaultNumberingSeriesRequest {
    const message = createBaseRestoreDefaultNumberingSeriesRequest();
    message.orgId = object.orgId ?? "";
    message.ledgerId = object.ledgerId ?? "";
    return message;
  },
};

function createBaseRestoreDefaultNumberingSeriesResponse(): RestoreDefaultNumberingSeriesResponse {
  return { series: [], createdCount: 0 };
}

export const RestoreDefaultNumberingSeriesResponse: MessageFns<RestoreDefaultNumberingSeriesResponse> = {
  encode(message: RestoreDefaultNumberingSeriesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.series) {
      NumberingSeries.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.createdCount !== 0) {
      writer.uint32(16).int32(message.createdCount);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RestoreDefaultNumberingSeriesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRestoreDefaultNumberingSeriesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.series.push(NumberingSeries.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.createdCount = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RestoreDefaultNumberingSeriesResponse {
    return {
      series: globalThis.Array.isArray(object?.series)
        ? object.series.map((e: any) => NumberingSeries.fromJSON(e))
        : [],
      createdCount: isSet(object.createdCount)
        ? globalThis.Number(object.createdCount)
        : isSet(object.created_count)
        ? globalThis.Number(object.created_count)
        : 0,
    };
  },

  toJSON(message: RestoreDefaultNumberingSeriesResponse): unknown {
    const obj: any = {};
    if (message.series?.length) {
      obj.series = message.series.map((e) => NumberingSeries.toJSON(e));
    }
    if (message.createdCount !== 0) {
      obj.createdCount = Math.round(message.createdCount);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RestoreDefaultNumberingSeriesResponse>, I>>(
    base?: I,
  ): RestoreDefaultNumberingSeriesResponse {
    return RestoreDefaultNumberingSeriesResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RestoreDefaultNumberingSeriesResponse>, I>>(
    object: I,
  ): RestoreDefaultNumberingSeriesResponse {
    const message = createBaseRestoreDefaultNumberingSeriesResponse();
    message.series = object.series?.map((e) => NumberingSeries.fromPartial(e)) || [];
    message.createdCount = object.createdCount ?? 0;
    return message;
  },
};

function createBaseQuickSetupRoleNumberingRequest(): QuickSetupRoleNumberingRequest {
  return { orgId: "", ledgerId: "", partyRole: "", prefix: "" };
}

export const QuickSetupRoleNumberingRequest: MessageFns<QuickSetupRoleNumberingRequest> = {
  encode(message: QuickSetupRoleNumberingRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgId !== "") {
      writer.uint32(10).string(message.orgId);
    }
    if (message.ledgerId !== "") {
      writer.uint32(18).string(message.ledgerId);
    }
    if (message.partyRole !== "") {
      writer.uint32(26).string(message.partyRole);
    }
    if (message.prefix !== "") {
      writer.uint32(34).string(message.prefix);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): QuickSetupRoleNumberingRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQuickSetupRoleNumberingRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ledgerId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.partyRole = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.prefix = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): QuickSetupRoleNumberingRequest {
    return {
      orgId: isSet(object.orgId)
        ? globalThis.String(object.orgId)
        : isSet(object.org_id)
        ? globalThis.String(object.org_id)
        : "",
      ledgerId: isSet(object.ledgerId)
        ? globalThis.String(object.ledgerId)
        : isSet(object.ledger_id)
        ? globalThis.String(object.ledger_id)
        : "",
      partyRole: isSet(object.partyRole)
        ? globalThis.String(object.partyRole)
        : isSet(object.party_role)
        ? globalThis.String(object.party_role)
        : "",
      prefix: isSet(object.prefix) ? globalThis.String(object.prefix) : "",
    };
  },

  toJSON(message: QuickSetupRoleNumberingRequest): unknown {
    const obj: any = {};
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.ledgerId !== "") {
      obj.ledgerId = message.ledgerId;
    }
    if (message.partyRole !== "") {
      obj.partyRole = message.partyRole;
    }
    if (message.prefix !== "") {
      obj.prefix = message.prefix;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<QuickSetupRoleNumberingRequest>, I>>(base?: I): QuickSetupRoleNumberingRequest {
    return QuickSetupRoleNumberingRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<QuickSetupRoleNumberingRequest>, I>>(
    object: I,
  ): QuickSetupRoleNumberingRequest {
    const message = createBaseQuickSetupRoleNumberingRequest();
    message.orgId = object.orgId ?? "";
    message.ledgerId = object.ledgerId ?? "";
    message.partyRole = object.partyRole ?? "";
    message.prefix = object.prefix ?? "";
    return message;
  },
};

function createBaseQuickSetupRoleNumberingResponse(): QuickSetupRoleNumberingResponse {
  return { series: [], assignmentsCreated: 0 };
}

export const QuickSetupRoleNumberingResponse: MessageFns<QuickSetupRoleNumberingResponse> = {
  encode(message: QuickSetupRoleNumberingResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.series) {
      NumberingSeries.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.assignmentsCreated !== 0) {
      writer.uint32(16).int32(message.assignmentsCreated);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): QuickSetupRoleNumberingResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQuickSetupRoleNumberingResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.series.push(NumberingSeries.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.assignmentsCreated = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): QuickSetupRoleNumberingResponse {
    return {
      series: globalThis.Array.isArray(object?.series)
        ? object.series.map((e: any) => NumberingSeries.fromJSON(e))
        : [],
      assignmentsCreated: isSet(object.assignmentsCreated)
        ? globalThis.Number(object.assignmentsCreated)
        : isSet(object.assignments_created)
        ? globalThis.Number(object.assignments_created)
        : 0,
    };
  },

  toJSON(message: QuickSetupRoleNumberingResponse): unknown {
    const obj: any = {};
    if (message.series?.length) {
      obj.series = message.series.map((e) => NumberingSeries.toJSON(e));
    }
    if (message.assignmentsCreated !== 0) {
      obj.assignmentsCreated = Math.round(message.assignmentsCreated);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<QuickSetupRoleNumberingResponse>, I>>(base?: I): QuickSetupRoleNumberingResponse {
    return QuickSetupRoleNumberingResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<QuickSetupRoleNumberingResponse>, I>>(
    object: I,
  ): QuickSetupRoleNumberingResponse {
    const message = createBaseQuickSetupRoleNumberingResponse();
    message.series = object.series?.map((e) => NumberingSeries.fromPartial(e)) || [];
    message.assignmentsCreated = object.assignmentsCreated ?? 0;
    return message;
  },
};

function createBasePreviewNextNumberRequest(): PreviewNextNumberRequest {
  return { orgId: "", seriesId: "", referenceDate: "" };
}

export const PreviewNextNumberRequest: MessageFns<PreviewNextNumberRequest> = {
  encode(message: PreviewNextNumberRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgId !== "") {
      writer.uint32(10).string(message.orgId);
    }
    if (message.seriesId !== "") {
      writer.uint32(18).string(message.seriesId);
    }
    if (message.referenceDate !== "") {
      writer.uint32(26).string(message.referenceDate);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PreviewNextNumberRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePreviewNextNumberRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.seriesId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.referenceDate = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PreviewNextNumberRequest {
    return {
      orgId: isSet(object.orgId)
        ? globalThis.String(object.orgId)
        : isSet(object.org_id)
        ? globalThis.String(object.org_id)
        : "",
      seriesId: isSet(object.seriesId)
        ? globalThis.String(object.seriesId)
        : isSet(object.series_id)
        ? globalThis.String(object.series_id)
        : "",
      referenceDate: isSet(object.referenceDate)
        ? globalThis.String(object.referenceDate)
        : isSet(object.reference_date)
        ? globalThis.String(object.reference_date)
        : "",
    };
  },

  toJSON(message: PreviewNextNumberRequest): unknown {
    const obj: any = {};
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.seriesId !== "") {
      obj.seriesId = message.seriesId;
    }
    if (message.referenceDate !== "") {
      obj.referenceDate = message.referenceDate;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PreviewNextNumberRequest>, I>>(base?: I): PreviewNextNumberRequest {
    return PreviewNextNumberRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PreviewNextNumberRequest>, I>>(object: I): PreviewNextNumberRequest {
    const message = createBasePreviewNextNumberRequest();
    message.orgId = object.orgId ?? "";
    message.seriesId = object.seriesId ?? "";
    message.referenceDate = object.referenceDate ?? "";
    return message;
  },
};

function createBasePreviewNextNumberResponse(): PreviewNextNumberResponse {
  return { nextNumber: "", nextSequence: 0, fiscalYear: 0, willReset: false };
}

export const PreviewNextNumberResponse: MessageFns<PreviewNextNumberResponse> = {
  encode(message: PreviewNextNumberResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.nextNumber !== "") {
      writer.uint32(10).string(message.nextNumber);
    }
    if (message.nextSequence !== 0) {
      writer.uint32(16).int32(message.nextSequence);
    }
    if (message.fiscalYear !== 0) {
      writer.uint32(24).int32(message.fiscalYear);
    }
    if (message.willReset !== false) {
      writer.uint32(32).bool(message.willReset);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PreviewNextNumberResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePreviewNextNumberResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.nextNumber = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.nextSequence = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.fiscalYear = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.willReset = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PreviewNextNumberResponse {
    return {
      nextNumber: isSet(object.nextNumber)
        ? globalThis.String(object.nextNumber)
        : isSet(object.next_number)
        ? globalThis.String(object.next_number)
        : "",
      nextSequence: isSet(object.nextSequence)
        ? globalThis.Number(object.nextSequence)
        : isSet(object.next_sequence)
        ? globalThis.Number(object.next_sequence)
        : 0,
      fiscalYear: isSet(object.fiscalYear)
        ? globalThis.Number(object.fiscalYear)
        : isSet(object.fiscal_year)
        ? globalThis.Number(object.fiscal_year)
        : 0,
      willReset: isSet(object.willReset)
        ? globalThis.Boolean(object.willReset)
        : isSet(object.will_reset)
        ? globalThis.Boolean(object.will_reset)
        : false,
    };
  },

  toJSON(message: PreviewNextNumberResponse): unknown {
    const obj: any = {};
    if (message.nextNumber !== "") {
      obj.nextNumber = message.nextNumber;
    }
    if (message.nextSequence !== 0) {
      obj.nextSequence = Math.round(message.nextSequence);
    }
    if (message.fiscalYear !== 0) {
      obj.fiscalYear = Math.round(message.fiscalYear);
    }
    if (message.willReset !== false) {
      obj.willReset = message.willReset;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PreviewNextNumberResponse>, I>>(base?: I): PreviewNextNumberResponse {
    return PreviewNextNumberResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PreviewNextNumberResponse>, I>>(object: I): PreviewNextNumberResponse {
    const message = createBasePreviewNextNumberResponse();
    message.nextNumber = object.nextNumber ?? "";
    message.nextSequence = object.nextSequence ?? 0;
    message.fiscalYear = object.fiscalYear ?? 0;
    message.willReset = object.willReset ?? false;
    return message;
  },
};

function createBaseDeleteNumberingSeriesRequest(): DeleteNumberingSeriesRequest {
  return { orgId: "", seriesId: "", hardDelete: false };
}

export const DeleteNumberingSeriesRequest: MessageFns<DeleteNumberingSeriesRequest> = {
  encode(message: DeleteNumberingSeriesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgId !== "") {
      writer.uint32(10).string(message.orgId);
    }
    if (message.seriesId !== "") {
      writer.uint32(18).string(message.seriesId);
    }
    if (message.hardDelete !== false) {
      writer.uint32(24).bool(message.hardDelete);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteNumberingSeriesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteNumberingSeriesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.seriesId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.hardDelete = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteNumberingSeriesRequest {
    return {
      orgId: isSet(object.orgId)
        ? globalThis.String(object.orgId)
        : isSet(object.org_id)
        ? globalThis.String(object.org_id)
        : "",
      seriesId: isSet(object.seriesId)
        ? globalThis.String(object.seriesId)
        : isSet(object.series_id)
        ? globalThis.String(object.series_id)
        : "",
      hardDelete: isSet(object.hardDelete)
        ? globalThis.Boolean(object.hardDelete)
        : isSet(object.hard_delete)
        ? globalThis.Boolean(object.hard_delete)
        : false,
    };
  },

  toJSON(message: DeleteNumberingSeriesRequest): unknown {
    const obj: any = {};
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.seriesId !== "") {
      obj.seriesId = message.seriesId;
    }
    if (message.hardDelete !== false) {
      obj.hardDelete = message.hardDelete;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteNumberingSeriesRequest>, I>>(base?: I): DeleteNumberingSeriesRequest {
    return DeleteNumberingSeriesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteNumberingSeriesRequest>, I>>(object: I): DeleteNumberingSeriesRequest {
    const message = createBaseDeleteNumberingSeriesRequest();
    message.orgId = object.orgId ?? "";
    message.seriesId = object.seriesId ?? "";
    message.hardDelete = object.hardDelete ?? false;
    return message;
  },
};

function createBaseDeleteNumberingSeriesResponse(): DeleteNumberingSeriesResponse {
  return { success: false, message: "" };
}

export const DeleteNumberingSeriesResponse: MessageFns<DeleteNumberingSeriesResponse> = {
  encode(message: DeleteNumberingSeriesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success);
    }
    if (message.message !== "") {
      writer.uint32(18).string(message.message);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteNumberingSeriesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteNumberingSeriesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.success = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.message = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteNumberingSeriesResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      message: isSet(object.message) ? globalThis.String(object.message) : "",
    };
  },

  toJSON(message: DeleteNumberingSeriesResponse): unknown {
    const obj: any = {};
    if (message.success !== false) {
      obj.success = message.success;
    }
    if (message.message !== "") {
      obj.message = message.message;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteNumberingSeriesResponse>, I>>(base?: I): DeleteNumberingSeriesResponse {
    return DeleteNumberingSeriesResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteNumberingSeriesResponse>, I>>(
    object: I,
  ): DeleteNumberingSeriesResponse {
    const message = createBaseDeleteNumberingSeriesResponse();
    message.success = object.success ?? false;
    message.message = object.message ?? "";
    return message;
  },
};

function createBaseInvoiceVersion(): InvoiceVersion {
  return {
    id: "",
    invoiceId: "",
    versionNumber: 0,
    invoiceSnapshot: undefined,
    itemsSnapshot: [],
    createdAt: undefined,
    createdBy: "",
    changeNotes: "",
  };
}

export const InvoiceVersion: MessageFns<InvoiceVersion> = {
  encode(message: InvoiceVersion, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.invoiceId !== "") {
      writer.uint32(18).string(message.invoiceId);
    }
    if (message.versionNumber !== 0) {
      writer.uint32(24).int32(message.versionNumber);
    }
    if (message.invoiceSnapshot !== undefined) {
      Struct.encode(Struct.wrap(message.invoiceSnapshot), writer.uint32(34).fork()).join();
    }
    for (const v of message.itemsSnapshot) {
      Struct.encode(Struct.wrap(v!), writer.uint32(42).fork()).join();
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(50).fork()).join();
    }
    if (message.createdBy !== "") {
      writer.uint32(58).string(message.createdBy);
    }
    if (message.changeNotes !== "") {
      writer.uint32(66).string(message.changeNotes);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InvoiceVersion {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInvoiceVersion();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.invoiceId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.versionNumber = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.invoiceSnapshot = Struct.unwrap(Struct.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.itemsSnapshot.push(Struct.unwrap(Struct.decode(reader, reader.uint32())));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.changeNotes = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InvoiceVersion {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      invoiceId: isSet(object.invoiceId)
        ? globalThis.String(object.invoiceId)
        : isSet(object.invoice_id)
        ? globalThis.String(object.invoice_id)
        : "",
      versionNumber: isSet(object.versionNumber)
        ? globalThis.Number(object.versionNumber)
        : isSet(object.version_number)
        ? globalThis.Number(object.version_number)
        : 0,
      invoiceSnapshot: isObject(object.invoiceSnapshot)
        ? object.invoiceSnapshot
        : isObject(object.invoice_snapshot)
        ? object.invoice_snapshot
        : undefined,
      itemsSnapshot: globalThis.Array.isArray(object?.itemsSnapshot)
        ? [...object.itemsSnapshot]
        : globalThis.Array.isArray(object?.items_snapshot)
        ? [...object.items_snapshot]
        : [],
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : "",
      changeNotes: isSet(object.changeNotes)
        ? globalThis.String(object.changeNotes)
        : isSet(object.change_notes)
        ? globalThis.String(object.change_notes)
        : "",
    };
  },

  toJSON(message: InvoiceVersion): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.invoiceId !== "") {
      obj.invoiceId = message.invoiceId;
    }
    if (message.versionNumber !== 0) {
      obj.versionNumber = Math.round(message.versionNumber);
    }
    if (message.invoiceSnapshot !== undefined) {
      obj.invoiceSnapshot = message.invoiceSnapshot;
    }
    if (message.itemsSnapshot?.length) {
      obj.itemsSnapshot = message.itemsSnapshot;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.changeNotes !== "") {
      obj.changeNotes = message.changeNotes;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<InvoiceVersion>, I>>(base?: I): InvoiceVersion {
    return InvoiceVersion.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InvoiceVersion>, I>>(object: I): InvoiceVersion {
    const message = createBaseInvoiceVersion();
    message.id = object.id ?? "";
    message.invoiceId = object.invoiceId ?? "";
    message.versionNumber = object.versionNumber ?? 0;
    message.invoiceSnapshot = object.invoiceSnapshot ?? undefined;
    message.itemsSnapshot = object.itemsSnapshot?.map((e) => e) || [];
    message.createdAt = object.createdAt ?? undefined;
    message.createdBy = object.createdBy ?? "";
    message.changeNotes = object.changeNotes ?? "";
    return message;
  },
};

function createBaseGetInvoiceVersionsRequest(): GetInvoiceVersionsRequest {
  return { orgId: "", invoiceId: "" };
}

export const GetInvoiceVersionsRequest: MessageFns<GetInvoiceVersionsRequest> = {
  encode(message: GetInvoiceVersionsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgId !== "") {
      writer.uint32(10).string(message.orgId);
    }
    if (message.invoiceId !== "") {
      writer.uint32(18).string(message.invoiceId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetInvoiceVersionsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetInvoiceVersionsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.invoiceId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetInvoiceVersionsRequest {
    return {
      orgId: isSet(object.orgId)
        ? globalThis.String(object.orgId)
        : isSet(object.org_id)
        ? globalThis.String(object.org_id)
        : "",
      invoiceId: isSet(object.invoiceId)
        ? globalThis.String(object.invoiceId)
        : isSet(object.invoice_id)
        ? globalThis.String(object.invoice_id)
        : "",
    };
  },

  toJSON(message: GetInvoiceVersionsRequest): unknown {
    const obj: any = {};
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.invoiceId !== "") {
      obj.invoiceId = message.invoiceId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetInvoiceVersionsRequest>, I>>(base?: I): GetInvoiceVersionsRequest {
    return GetInvoiceVersionsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetInvoiceVersionsRequest>, I>>(object: I): GetInvoiceVersionsRequest {
    const message = createBaseGetInvoiceVersionsRequest();
    message.orgId = object.orgId ?? "";
    message.invoiceId = object.invoiceId ?? "";
    return message;
  },
};

function createBaseGetInvoiceVersionsResponse(): GetInvoiceVersionsResponse {
  return { versions: [] };
}

export const GetInvoiceVersionsResponse: MessageFns<GetInvoiceVersionsResponse> = {
  encode(message: GetInvoiceVersionsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.versions) {
      InvoiceVersion.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetInvoiceVersionsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetInvoiceVersionsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.versions.push(InvoiceVersion.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetInvoiceVersionsResponse {
    return {
      versions: globalThis.Array.isArray(object?.versions)
        ? object.versions.map((e: any) => InvoiceVersion.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetInvoiceVersionsResponse): unknown {
    const obj: any = {};
    if (message.versions?.length) {
      obj.versions = message.versions.map((e) => InvoiceVersion.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetInvoiceVersionsResponse>, I>>(base?: I): GetInvoiceVersionsResponse {
    return GetInvoiceVersionsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetInvoiceVersionsResponse>, I>>(object: I): GetInvoiceVersionsResponse {
    const message = createBaseGetInvoiceVersionsResponse();
    message.versions = object.versions?.map((e) => InvoiceVersion.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetInvoiceVersionRequest(): GetInvoiceVersionRequest {
  return { orgId: "", invoiceId: "", versionNumber: 0 };
}

export const GetInvoiceVersionRequest: MessageFns<GetInvoiceVersionRequest> = {
  encode(message: GetInvoiceVersionRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgId !== "") {
      writer.uint32(10).string(message.orgId);
    }
    if (message.invoiceId !== "") {
      writer.uint32(18).string(message.invoiceId);
    }
    if (message.versionNumber !== 0) {
      writer.uint32(24).int32(message.versionNumber);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetInvoiceVersionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetInvoiceVersionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.invoiceId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.versionNumber = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetInvoiceVersionRequest {
    return {
      orgId: isSet(object.orgId)
        ? globalThis.String(object.orgId)
        : isSet(object.org_id)
        ? globalThis.String(object.org_id)
        : "",
      invoiceId: isSet(object.invoiceId)
        ? globalThis.String(object.invoiceId)
        : isSet(object.invoice_id)
        ? globalThis.String(object.invoice_id)
        : "",
      versionNumber: isSet(object.versionNumber)
        ? globalThis.Number(object.versionNumber)
        : isSet(object.version_number)
        ? globalThis.Number(object.version_number)
        : 0,
    };
  },

  toJSON(message: GetInvoiceVersionRequest): unknown {
    const obj: any = {};
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.invoiceId !== "") {
      obj.invoiceId = message.invoiceId;
    }
    if (message.versionNumber !== 0) {
      obj.versionNumber = Math.round(message.versionNumber);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetInvoiceVersionRequest>, I>>(base?: I): GetInvoiceVersionRequest {
    return GetInvoiceVersionRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetInvoiceVersionRequest>, I>>(object: I): GetInvoiceVersionRequest {
    const message = createBaseGetInvoiceVersionRequest();
    message.orgId = object.orgId ?? "";
    message.invoiceId = object.invoiceId ?? "";
    message.versionNumber = object.versionNumber ?? 0;
    return message;
  },
};

function createBaseGetInvoiceVersionResponse(): GetInvoiceVersionResponse {
  return { version: undefined };
}

export const GetInvoiceVersionResponse: MessageFns<GetInvoiceVersionResponse> = {
  encode(message: GetInvoiceVersionResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.version !== undefined) {
      InvoiceVersion.encode(message.version, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetInvoiceVersionResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetInvoiceVersionResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.version = InvoiceVersion.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetInvoiceVersionResponse {
    return { version: isSet(object.version) ? InvoiceVersion.fromJSON(object.version) : undefined };
  },

  toJSON(message: GetInvoiceVersionResponse): unknown {
    const obj: any = {};
    if (message.version !== undefined) {
      obj.version = InvoiceVersion.toJSON(message.version);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetInvoiceVersionResponse>, I>>(base?: I): GetInvoiceVersionResponse {
    return GetInvoiceVersionResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetInvoiceVersionResponse>, I>>(object: I): GetInvoiceVersionResponse {
    const message = createBaseGetInvoiceVersionResponse();
    message.version = (object.version !== undefined && object.version !== null)
      ? InvoiceVersion.fromPartial(object.version)
      : undefined;
    return message;
  },
};

function createBaseNotifyInvoicePostRequestRequest(): NotifyInvoicePostRequestRequest {
  return { orgId: "", workspaceId: "", invoiceId: "", requestedByWorkspaceId: "" };
}

export const NotifyInvoicePostRequestRequest: MessageFns<NotifyInvoicePostRequestRequest> = {
  encode(message: NotifyInvoicePostRequestRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgId !== "") {
      writer.uint32(10).string(message.orgId);
    }
    if (message.workspaceId !== "") {
      writer.uint32(18).string(message.workspaceId);
    }
    if (message.invoiceId !== "") {
      writer.uint32(26).string(message.invoiceId);
    }
    if (message.requestedByWorkspaceId !== "") {
      writer.uint32(34).string(message.requestedByWorkspaceId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NotifyInvoicePostRequestRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNotifyInvoicePostRequestRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.workspaceId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.invoiceId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.requestedByWorkspaceId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NotifyInvoicePostRequestRequest {
    return {
      orgId: isSet(object.orgId)
        ? globalThis.String(object.orgId)
        : isSet(object.org_id)
        ? globalThis.String(object.org_id)
        : "",
      workspaceId: isSet(object.workspaceId)
        ? globalThis.String(object.workspaceId)
        : isSet(object.workspace_id)
        ? globalThis.String(object.workspace_id)
        : "",
      invoiceId: isSet(object.invoiceId)
        ? globalThis.String(object.invoiceId)
        : isSet(object.invoice_id)
        ? globalThis.String(object.invoice_id)
        : "",
      requestedByWorkspaceId: isSet(object.requestedByWorkspaceId)
        ? globalThis.String(object.requestedByWorkspaceId)
        : isSet(object.requested_by_workspace_id)
        ? globalThis.String(object.requested_by_workspace_id)
        : "",
    };
  },

  toJSON(message: NotifyInvoicePostRequestRequest): unknown {
    const obj: any = {};
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.workspaceId !== "") {
      obj.workspaceId = message.workspaceId;
    }
    if (message.invoiceId !== "") {
      obj.invoiceId = message.invoiceId;
    }
    if (message.requestedByWorkspaceId !== "") {
      obj.requestedByWorkspaceId = message.requestedByWorkspaceId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NotifyInvoicePostRequestRequest>, I>>(base?: I): NotifyInvoicePostRequestRequest {
    return NotifyInvoicePostRequestRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NotifyInvoicePostRequestRequest>, I>>(
    object: I,
  ): NotifyInvoicePostRequestRequest {
    const message = createBaseNotifyInvoicePostRequestRequest();
    message.orgId = object.orgId ?? "";
    message.workspaceId = object.workspaceId ?? "";
    message.invoiceId = object.invoiceId ?? "";
    message.requestedByWorkspaceId = object.requestedByWorkspaceId ?? "";
    return message;
  },
};

function createBaseNotifyAdvanceJEPostRequestRequest(): NotifyAdvanceJEPostRequestRequest {
  return { orgId: "", jeId: "", requestedByWorkspaceId: "" };
}

export const NotifyAdvanceJEPostRequestRequest: MessageFns<NotifyAdvanceJEPostRequestRequest> = {
  encode(message: NotifyAdvanceJEPostRequestRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgId !== "") {
      writer.uint32(10).string(message.orgId);
    }
    if (message.jeId !== "") {
      writer.uint32(18).string(message.jeId);
    }
    if (message.requestedByWorkspaceId !== "") {
      writer.uint32(26).string(message.requestedByWorkspaceId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NotifyAdvanceJEPostRequestRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNotifyAdvanceJEPostRequestRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.jeId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.requestedByWorkspaceId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NotifyAdvanceJEPostRequestRequest {
    return {
      orgId: isSet(object.orgId)
        ? globalThis.String(object.orgId)
        : isSet(object.org_id)
        ? globalThis.String(object.org_id)
        : "",
      jeId: isSet(object.jeId)
        ? globalThis.String(object.jeId)
        : isSet(object.je_id)
        ? globalThis.String(object.je_id)
        : "",
      requestedByWorkspaceId: isSet(object.requestedByWorkspaceId)
        ? globalThis.String(object.requestedByWorkspaceId)
        : isSet(object.requested_by_workspace_id)
        ? globalThis.String(object.requested_by_workspace_id)
        : "",
    };
  },

  toJSON(message: NotifyAdvanceJEPostRequestRequest): unknown {
    const obj: any = {};
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.jeId !== "") {
      obj.jeId = message.jeId;
    }
    if (message.requestedByWorkspaceId !== "") {
      obj.requestedByWorkspaceId = message.requestedByWorkspaceId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NotifyAdvanceJEPostRequestRequest>, I>>(
    base?: I,
  ): NotifyAdvanceJEPostRequestRequest {
    return NotifyAdvanceJEPostRequestRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NotifyAdvanceJEPostRequestRequest>, I>>(
    object: I,
  ): NotifyAdvanceJEPostRequestRequest {
    const message = createBaseNotifyAdvanceJEPostRequestRequest();
    message.orgId = object.orgId ?? "";
    message.jeId = object.jeId ?? "";
    message.requestedByWorkspaceId = object.requestedByWorkspaceId ?? "";
    return message;
  },
};

export interface PartyService {
  /** Create a new party */
  CreateParty(request: CreatePartyRequest): Promise<Party>;
  /** Get a party by ID */
  GetParty(request: GetPartyRequest): Promise<Party>;
  /**
   * Get the computed intelligence score for a party (the same score the
   * entity-detail Intelligence tab renders): overall 0-100 total + tier, the
   * six weighted dimensions, and any triggered risk alerts. Read-only; wraps
   * the existing ScoringService.ComputeScore. Consumed by elPOS to show the
   * gauge + radar on the credit-sale approval surface.
   */
  GetPartyScore(request: GetPartyScoreRequest): Promise<PartyScore>;
  /** Update a party */
  UpdateParty(request: UpdatePartyRequest): Promise<Party>;
  /** Delete a party (only if no active transactions) */
  DeleteParty(request: DeletePartyRequest): Promise<DeletePartyResponse>;
  /** List parties */
  ListParties(request: ListPartiesRequest): Promise<ListPartiesResponse>;
  /** Search parties */
  SearchParties(request: SearchPartiesRequest): Promise<ListPartiesResponse>;
  /** List all parties across all ledgers for an organization */
  ListAllParties(request: ListAllPartiesRequest): Promise<ListPartiesResponse>;
  /**
   * Get the next available party code for the given roles (server-authoritative).
   * Used by the create form to prefill the code without scanning a list client-side.
   */
  GetNextPartyCode(request: GetNextPartyCodeRequest): Promise<GetNextPartyCodeResponse>;
}

export interface InvoiceService {
  /** Create a new invoice */
  CreateInvoice(request: CreateInvoiceRequest): Promise<Invoice>;
  /** Get an invoice by ID */
  GetInvoice(request: GetInvoiceRequest): Promise<Invoice>;
  /** Update an invoice (draft only) */
  UpdateInvoice(request: UpdateInvoiceRequest): Promise<Invoice>;
  /** Post an invoice */
  PostInvoice(request: PostInvoiceRequest): Promise<Invoice>;
  /** Void an invoice */
  VoidInvoice(request: VoidInvoiceRequest): Promise<Invoice>;
  /** Edit a posted invoice (voids old JE, creates new one) */
  EditPostedInvoice(request: EditPostedInvoiceRequest): Promise<Invoice>;
  /**
   * Create-and-post an invoice from an existing active sales order. Server
   * derives line items from the sales order; the new invoice's sales_order_id
   * back-references it. If the customer has any posted customer-advance
   * balance, an adjustment JE moves it into AR (capped at invoice total;
   * residual stays in customer-advance for future invoices). Idempotent
   * via idempotency_key.
   */
  CreateInvoiceFromSO(request: CreateInvoiceFromSORequest): Promise<CreateInvoiceFromSOResponse>;
  /** List invoices */
  ListInvoices(request: ListInvoicesRequest): Promise<ListInvoicesResponse>;
  /** List invoices by party (cross-ledger) */
  ListInvoicesByParty(request: ListInvoicesByPartyRequest): Promise<ListInvoicesResponse>;
  /** Generate invoice PDF */
  GenerateInvoicePDF(request: GenerateInvoicePDFRequest): Promise<GenerateInvoicePDFResponse>;
  /** Get next invoice number */
  GetNextInvoiceNumber(request: GetNextInvoiceNumberRequest): Promise<GetNextInvoiceNumberResponse>;
  /** Get invoice version history */
  GetInvoiceVersions(request: GetInvoiceVersionsRequest): Promise<GetInvoiceVersionsResponse>;
  /** Get specific invoice version */
  GetInvoiceVersion(request: GetInvoiceVersionRequest): Promise<GetInvoiceVersionResponse>;
  /**
   * NotifyInvoicePostRequest is called by elPOS (via gRPC) when the cashier
   * clicks "Request Invoice". elBooks persists a notification row and pushes
   * it over SSE to any connected accountant browsers so they see the bell
   * light up in real time without polling.
   *
   * The RPC is intentionally backend-only (no grpc-gateway HTTP binding) — only
   * service-to-service callers (elPOS backend) may invoke it.
   */
  NotifyInvoicePostRequest(request: NotifyInvoicePostRequestRequest): Promise<Empty>;
  /**
   * NotifyAdvanceJEPostRequest is called by elPOS (via gRPC) after it creates
   * a draft customer-advance JE (require_elbooks_payment_approval=ON flow).
   * Pushes an SSE notification to the accountant role so they know a JE is
   * waiting to be posted in elBooks.
   *
   * Backend-only (no grpc-gateway HTTP binding).
   */
  NotifyAdvanceJEPostRequest(request: NotifyAdvanceJEPostRequestRequest): Promise<Empty>;
}

export interface CompanySettingsService {
  /** Get company settings */
  GetCompanySettings(request: GetCompanySettingsRequest): Promise<CompanySettings>;
  /** Update company settings */
  UpdateCompanySettings(request: UpdateCompanySettingsRequest): Promise<CompanySettings>;
  /** Upload company logo */
  UploadCompanyLogo(request: UploadCompanyLogoRequest): Promise<UploadCompanyLogoResponse>;
  /** Delete company logo */
  DeleteCompanyLogo(request: DeleteCompanyLogoRequest): Promise<DeleteCompanyLogoResponse>;
}

export interface DocumentNumberingService {
  /** Create a new numbering series */
  CreateNumberingSeries(request: CreateNumberingSeriesRequest): Promise<NumberingSeries>;
  /** Get a numbering series by ID */
  GetNumberingSeries(request: GetNumberingSeriesRequest): Promise<NumberingSeries>;
  /** Update a numbering series */
  UpdateNumberingSeries(request: UpdateNumberingSeriesRequest): Promise<NumberingSeries>;
  /** Set current sequence (for migration/admin operations) */
  SetCurrentSequence(request: SetCurrentSequenceRequest): Promise<NumberingSeries>;
  /** List all numbering series for a ledger */
  ListNumberingSeries(request: ListNumberingSeriesRequest): Promise<ListNumberingSeriesResponse>;
  /** Preview next number without incrementing */
  PreviewNextNumber(request: PreviewNextNumberRequest): Promise<PreviewNextNumberResponse>;
  /** Delete a numbering series (soft delete) */
  DeleteNumberingSeries(request: DeleteNumberingSeriesRequest): Promise<DeleteNumberingSeriesResponse>;
  /** Create any missing default numbering series for the ledger (idempotent). */
  RestoreDefaultNumberingSeries(
    request: RestoreDefaultNumberingSeriesRequest,
  ): Promise<RestoreDefaultNumberingSeriesResponse>;
  /**
   * List the series assignments (which series applies to each
   * role/category/doc-kind/draft combination) for a ledger.
   */
  ListNumberingAssignments(request: ListNumberingAssignmentsRequest): Promise<ListNumberingAssignmentsResponse>;
  /**
   * Create or update a single series assignment (point a
   * role/category/doc-kind/draft tuple at a series). Shared = two tuples point
   * at the same series_id.
   */
  UpsertNumberingAssignment(request: UpsertNumberingAssignmentRequest): Promise<NumberingAssignment>;
  /**
   * Create a full set of draft+final numbering series for a party role that
   * has none yet (Invoice/Credit Note, plus Debit Note for sales-direction
   * roles), from a single base prefix, plus the assignment rows pointing all
   * three GST categories at them. Fails without creating anything if any
   * computed prefix collides with an existing series.
   */
  QuickSetupRoleNumbering(request: QuickSetupRoleNumberingRequest): Promise<QuickSetupRoleNumberingResponse>;
}

function bytesFromBase64(b64: string): Uint8Array {
  if ((globalThis as any).Buffer) {
    return Uint8Array.from((globalThis as any).Buffer.from(b64, "base64"));
  } else {
    const bin = globalThis.atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i);
    }
    return arr;
  }
}

function base64FromBytes(arr: Uint8Array): string {
  if ((globalThis as any).Buffer) {
    return (globalThis as any).Buffer.from(arr).toString("base64");
  } else {
    const bin: string[] = [];
    arr.forEach((byte) => {
      bin.push(globalThis.String.fromCharCode(byte));
    });
    return globalThis.btoa(bin.join(""));
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000).toString();
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (globalThis.Number(t.seconds) || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
